webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var ver = __webpack_require__(580).version;
module.exports = {
  BASIC_AUTENTICATION_OAUTH_USER: "sellercenterclientid",
  BASIC_AUTENTICATION_OAUTH_PASS: "123456",
  API_END_POINT: "https://marti-qa.sellercenter.lafranciaph.com/sellercenter/api/v1",
  ORDER_DETAILS_TTL: 3000000,
  ORDER_LIST_TTL: 3000000,
  INACTIVITY_PERMITED_TIME: 3000000,
  MARKETPLACE_INVOICE: false,
  STATUS_MAPPING: {
    'ready-for-handling': 'Para manejo',
    'getting-guide': 'Esperando guía',
    'handling': 'Para facturación',
    'invoiced': 'Facturada',
    'partially-invoiced': 'Facturación incompleta',
    'partially-delivered': 'Parcialmente entregada',
    'delivered': 'Entregada',
    'canceled': 'Cancelada',
    'payment-pending': 'No pagada',
    'waiting-for-seller-decision': 'Esperando desición'
  },
  STATUS_MAPPING_COLORS: {
    'ready-for-handling': 'primary',
    'handling': 'success',
    'invoiced': 'success',
    'partially-invoiced': 'success',
    'partially-delivered': 'success',
    'delivered': 'success',
    'canceled': 'danger',
    'payment-pending': 'secondary',
    'waiting-for-seller-decision': 'secondary'
  },
  TAGS_MAPPING: {
    I: { text: 'Incidencia', description: 'Esta orden esta marcada con Incidencia', key: 'I', bg: 'bg-warning', isCt: false },
    DV: { text: 'Devolución (DV)', description: 'Esta orden esta marcada con Incidencia', key: 'DV', bg: 'bg-warning', isCt: false },
    CF: { text: 'Cambio físico (CF)', description: 'Esta orden esta marcada con Incidencia', key: 'CF', bg: 'bg-warning', isCt: false },
    VT: { text: 'Venta (VT)', description: 'Esta orden esta marcada con Incidencia', key: 'VT', bg: 'bg-warning', isCt: false },
    RC: { text: 'Recolección (RC)', description: 'Esta orden esta marcada con Incidencia', key: 'RC', bg: 'bg-warning', isCt: false },
    RV: { text: 'Reenvío (RV)', description: 'Esta orden esta marcada con Incidencia', key: 'RV', bg: 'bg-warning', isCt: false },
    CT: { text: 'Controversia', description: 'Esta orden esta marcada con Controversia', key: 'CT', bg: 'bg-warning', isCt: true },
    P: { text: 'Penalizacion', description: 'La orden fue Penalizada', key: 'P', bg: 'bg-danger', isCt: false },
    LQ: { text: 'Liquidado', description: 'La orden fue Liquidada', key: 'LQ', bg: 'bg-success', isCt: false },
    ET: { text: 'Entrega tardia', description: 'Orden marcada como entrega tardía', key: 'ET', bg: 'bg-warning', isCt: false },
    F: { text: 'Fallida', description: 'Orden cancelada marcada como fallida', key: 'F', bg: 'bg-danger', isCt: false },
    D: { text: 'Devolución', description: 'Orden marcada con devolución', key: 'D', bg: 'bg-danger', isCt: true },
    DR: { text: 'Solicitud de devolución', description: 'Orden con solicitud de devolución', key: 'DR', bg: 'bg-danger', isCt: true },
    PP: { text: 'No Pagado', description: 'Orden marcada como no pagada', key: 'PP', bg: 'bg-danger', isCt: true }
  },
  IMAGE_FILES_SUPPORTED: ['PNG', 'JPG', 'JPEG'],
  IMAGE_MAX_SIZE: 2000,
  IMAGE_MIN_SIZE: 500,
  IMAGE_MAX_KB: 1000,
  LOCALE: 'es-mx',
  DEFAULT_COUNTRY: 'MX',
  CURRENCY: '$',
  CSV_MIME_TYPES: ['text/csv', 'text/plain', 'text/x-csv', 'text/x-csv', 'application/vnd.ms-excel'],
  CARRIER_LIST: ['DHL', 'FEDEX'],
  SLA_LIST: ['Normal'],
  COUNTRY_CODES: [{
    'text': 'Seleccione un pais',
    'value': null,
    'country-code': null,
    disabled: true
  }, {
    'text': 'Afghanistan',
    'value': 'AFG',
    'country-code': '004'
  }, {
    'text': 'Åland Islands',
    'value': 'ALA',
    'country-code': '248'
  }, {
    'text': 'Albania',
    'value': 'ALB',
    'country-code': '008'
  }, {
    'text': 'Algeria',
    'value': 'DZA',
    'country-code': '012'
  }, {
    'text': 'American Samoa',
    'value': 'ASM',
    'country-code': '016'
  }, {
    'text': 'Andorra',
    'value': 'AND',
    'country-code': '020'
  }, {
    'text': 'Angola',
    'value': 'AGO',
    'country-code': '024'
  }, {
    'text': 'Anguilla',
    'value': 'AIA',
    'country-code': '660'
  }, {
    'text': 'Antarctica',
    'value': 'ATA',
    'country-code': '010'
  }, {
    'text': 'Antigua and Barbuda',
    'value': 'ATG',
    'country-code': '028'
  }, {
    'text': 'Argentina',
    'value': 'ARG',
    'country-code': '032'
  }, {
    'text': 'Armenia',
    'value': 'ARM',
    'country-code': '051'
  }, {
    'text': 'Aruba',
    'value': 'ABW',
    'country-code': '533'
  }, {
    'text': 'Australia',
    'value': 'AUS',
    'country-code': '036'
  }, {
    'text': 'Austria',
    'value': 'AUT',
    'country-code': '040'
  }, {
    'text': 'Azerbaijan',
    'value': 'AZE',
    'country-code': '031'
  }, {
    'text': 'Bahamas',
    'value': 'BHS',
    'country-code': '044'
  }, {
    'text': 'Bahrain',
    'value': 'BHR',
    'country-code': '048'
  }, {
    'text': 'Bangladesh',
    'value': 'BGD',
    'country-code': '050'
  }, {
    'text': 'Barbados',
    'value': 'BRB',
    'country-code': '052'
  }, {
    'text': 'Belarus',
    'value': 'BLR',
    'country-code': '112'
  }, {
    'text': 'Belgium',
    'value': 'BEL',
    'country-code': '056'
  }, {
    'text': 'Belize',
    'value': 'BLZ',
    'country-code': '084'
  }, {
    'text': 'Benin',
    'value': 'BEN',
    'country-code': '204'
  }, {
    'text': 'Bermuda',
    'value': 'BMU',
    'country-code': '060'
  }, {
    'text': 'Bhutan',
    'value': 'BTN',
    'country-code': '064'
  }, {
    'text': 'Bolivia (Plurinational State of)',
    'value': 'BOL',
    'country-code': '068'
  }, {
    'text': 'Bonaire, Sint Eustatius and Saba',
    'value': 'BES',
    'country-code': '535'
  }, {
    'text': 'Bosnia and Herzegovina',
    'value': 'BIH',
    'country-code': '070'
  }, {
    'text': 'Botswana',
    'value': 'BWA',
    'country-code': '072'
  }, {
    'text': 'Bouvet Island',
    'value': 'BVT',
    'country-code': '074'
  }, {
    'text': 'Brazil',
    'value': 'BRA',
    'country-code': '076'
  }, {
    'text': 'British Indian Ocean Territory',
    'value': 'IOT',
    'country-code': '086'
  }, {
    'text': 'Brunei Darussalam',
    'value': 'BRN',
    'country-code': '096'
  }, {
    'text': 'Bulgaria',
    'value': 'BGR',
    'country-code': '100'
  }, {
    'text': 'Burkina Faso',
    'value': 'BFA',
    'country-code': '854'
  }, {
    'text': 'Burundi',
    'value': 'BDI',
    'country-code': '108'
  }, {
    'text': 'Cabo Verde',
    'value': 'CPV',
    'country-code': '132'
  }, {
    'text': 'Cambodia',
    'value': 'KHM',
    'country-code': '116'
  }, {
    'text': 'Cameroon',
    'value': 'CMR',
    'country-code': '120'
  }, {
    'text': 'Canada',
    'value': 'CAN',
    'country-code': '124'
  }, {
    'text': 'Cayman Islands',
    'value': 'CYM',
    'country-code': '136'
  }, {
    'text': 'Central African Republic',
    'value': 'CAF',
    'country-code': '140'
  }, {
    'text': 'Chad',
    'value': 'TCD',
    'country-code': '148'
  }, {
    'text': 'Chile',
    'value': 'CHL',
    'country-code': '152'
  }, {
    'text': 'China',
    'value': 'CHN',
    'country-code': '156'
  }, {
    'text': 'Christmas Island',
    'value': 'CXR',
    'country-code': '162'
  }, {
    'text': 'Cocos (Keeling) Islands',
    'value': 'CCK',
    'country-code': '166'
  }, {
    'text': 'Colombia',
    'value': 'COL',
    'country-code': '170'
  }, {
    'text': 'Comoros',
    'value': 'COM',
    'country-code': '174'
  }, {
    'text': 'Congo',
    'value': 'COG',
    'country-code': '178'
  }, {
    'text': 'Congo (Democratic Republic of the)',
    'value': 'COD',
    'country-code': '180'
  }, {
    'text': 'Cook Islands',
    'value': 'COK',
    'country-code': '184'
  }, {
    'text': 'Costa Rica',
    'value': 'CRI',
    'country-code': '188'
  }, {
    'text': 'Côte d Ivoire',
    'value': 'CIV',
    'country-code': '384'
  }, {
    'text': 'Croatia',
    'value': 'HRV',
    'country-code': '191'
  }, {
    'text': 'Cuba',
    'value': 'CUB',
    'country-code': '192'
  }, {
    'text': 'Curaçao',
    'value': 'CUW',
    'country-code': '531'
  }, {
    'text': 'Cyprus',
    'value': 'CYP',
    'country-code': '196'
  }, {
    'text': 'Czechia',
    'value': 'CZE',
    'country-code': '203'
  }, {
    'text': 'Denmark',
    'value': 'DNK',
    'country-code': '208'
  }, {
    'text': 'Djibouti',
    'value': 'DJI',
    'country-code': '262'
  }, {
    'text': 'Dominica',
    'value': 'DMA',
    'country-code': '212'
  }, {
    'text': 'Dominican Republic',
    'value': 'DOM',
    'country-code': '214'
  }, {
    'text': 'Ecuador',
    'value': 'ECU',
    'country-code': '218'
  }, {
    'text': 'Egypt',
    'value': 'EGY',
    'country-code': '818'
  }, {
    'text': 'El Salvador',
    'value': 'SLV',
    'country-code': '222'
  }, {
    'text': 'Equatorial Guinea',
    'value': 'GNQ',
    'country-code': '226'
  }, {
    'text': 'Eritrea',
    'value': 'ERI',
    'country-code': '232'
  }, {
    'text': 'Estonia',
    'value': 'EST',
    'country-code': '233'
  }, {
    'text': 'Eswatini',
    'value': 'SWZ',
    'country-code': '748'
  }, {
    'text': 'Ethiopia',
    'value': 'ETH',
    'country-code': '231'
  }, {
    'text': 'Falkland Islands (Malvinas)',
    'value': 'FLK',
    'country-code': '238'
  }, {
    'text': 'Faroe Islands',
    'value': 'FRO',
    'country-code': '234'
  }, {
    'text': 'Fiji',
    'value': 'FJI',
    'country-code': '242'
  }, {
    'text': 'Finland',
    'value': 'FIN',
    'country-code': '246'
  }, {
    'text': 'France',
    'value': 'FRA',
    'country-code': '250'
  }, {
    'text': 'French Guiana',
    'value': 'GUF',
    'country-code': '254'
  }, {
    'text': 'French Polynesia',
    'value': 'PYF',
    'country-code': '258'
  }, {
    'text': 'French Southern Territories',
    'value': 'ATF',
    'country-code': '260'
  }, {
    'text': 'Gabon',
    'value': 'GAB',
    'country-code': '266'
  }, {
    'text': 'Gambia',
    'value': 'GMB',
    'country-code': '270'
  }, {
    'text': 'Georgia',
    'value': 'GEO',
    'country-code': '268'
  }, {
    'text': 'Germany',
    'value': 'DEU',
    'country-code': '276'
  }, {
    'text': 'Ghana',
    'value': 'GHA',
    'country-code': '288'
  }, {
    'text': 'Gibraltar',
    'value': 'GIB',
    'country-code': '292'
  }, {
    'text': 'Greece',
    'value': 'GRC',
    'country-code': '300'
  }, {
    'text': 'Greenland',
    'value': 'GRL',
    'country-code': '304'
  }, {
    'text': 'Grenada',
    'value': 'GRD',
    'country-code': '308'
  }, {
    'text': 'Guadeloupe',
    'value': 'GLP',
    'country-code': '312'
  }, {
    'text': 'Guam',
    'value': 'GUM',
    'country-code': '316'
  }, {
    'text': 'Guatemala',
    'value': 'GTM',
    'country-code': '320'
  }, {
    'text': 'Guernsey',
    'value': 'GGY',
    'country-code': '831'
  }, {
    'text': 'Guinea',
    'value': 'GIN',
    'country-code': '324'
  }, {
    'text': 'Guinea-Bissau',
    'value': 'GNB',
    'country-code': '624'
  }, {
    'text': 'Guyana',
    'value': 'GUY',
    'country-code': '328'
  }, {
    'text': 'Haiti',
    'value': 'HTI',
    'country-code': '332'
  }, {
    'text': 'Heard Island and McDonald Islands',
    'value': 'HMD',
    'country-code': '334'
  }, {
    'text': 'Holy See',
    'value': 'VAT',
    'country-code': '336'
  }, {
    'text': 'Honduras',
    'value': 'HND',
    'country-code': '340'
  }, {
    'text': 'Hong Kong',
    'value': 'HKG',
    'country-code': '344'
  }, {
    'text': 'Hungary',
    'value': 'HUN',
    'country-code': '348'
  }, {
    'text': 'Iceland',
    'value': 'ISL',
    'country-code': '352'
  }, {
    'text': 'India',
    'value': 'IND',
    'country-code': '356'
  }, {
    'text': 'Indonesia',
    'value': 'IDN',
    'country-code': '360'
  }, {
    'text': 'Iran (Islamic Republic of)',
    'value': 'IRN',
    'country-code': '364'
  }, {
    'text': 'Iraq',
    'value': 'IRQ',
    'country-code': '368'
  }, {
    'text': 'Ireland',
    'value': 'IRL',
    'country-code': '372'
  }, {
    'text': 'Isle of Man',
    'value': 'IMN',
    'country-code': '833'
  }, {
    'text': 'Israel',
    'value': 'ISR',
    'country-code': '376'
  }, {
    'text': 'Italy',
    'value': 'ITA',
    'country-code': '380'
  }, {
    'text': 'Jamaica',
    'value': 'JAM',
    'country-code': '388'
  }, {
    'text': 'Japan',
    'value': 'JPN',
    'country-code': '392'
  }, {
    'text': 'Jersey',
    'value': 'JEY',
    'country-code': '832'
  }, {
    'text': 'Jordan',
    'value': 'JOR',
    'country-code': '400'
  }, {
    'text': 'Kazakhstan',
    'value': 'KAZ',
    'country-code': '398'
  }, {
    'text': 'Kenya',
    'value': 'KEN',
    'country-code': '404'
  }, {
    'text': 'Kiribati',
    'value': 'KIR',
    'country-code': '296'
  }, {
    'text': 'Korea',
    'value': 'PRK',
    'country-code': '408'
  }, {
    'text': 'Korea (Republic of)',
    'value': 'KOR',
    'country-code': '410'
  }, {
    'text': 'Kuwait',
    'value': 'KWT',
    'country-code': '414'
  }, {
    'text': 'Kyrgyzstan',
    'value': 'KGZ',
    'country-code': '417'
  }, {
    'text': 'Lao Democratic Republic',
    'value': 'LAO',
    'country-code': '418'
  }, {
    'text': 'Latvia',
    'value': 'LVA',
    'country-code': '428'
  }, {
    'text': 'Lebanon',
    'value': 'LBN',
    'country-code': '422'
  }, {
    'text': 'Lesotho',
    'value': 'LSO',
    'country-code': '426'
  }, {
    'text': 'Liberia',
    'value': 'LBR',
    'country-code': '430'
  }, {
    'text': 'Libya',
    'value': 'LBY',
    'country-code': '434'
  }, {
    'text': 'Liechtenstein',
    'value': 'LIE',
    'country-code': '438'
  }, {
    'text': 'Lithuania',
    'value': 'LTU',
    'country-code': '440'
  }, {
    'text': 'Luxembourg',
    'value': 'LUX',
    'country-code': '442'
  }, {
    'text': 'Macao',
    'value': 'MAC',
    'country-code': '446'
  }, {
    'text': 'Macedonia (the former Yugoslav Republic of)',
    'value': 'MKD',
    'country-code': '807'
  }, {
    'text': 'Madagascar',
    'value': 'MDG',
    'country-code': '450'
  }, {
    'text': 'Malawi',
    'value': 'MWI',
    'country-code': '454'
  }, {
    'text': 'Malaysia',
    'value': 'MYS',
    'country-code': '458'
  }, {
    'text': 'Maldives',
    'value': 'MDV',
    'country-code': '462'
  }, {
    'text': 'Mali',
    'value': 'MLI',
    'country-code': '466'
  }, {
    'text': 'Malta',
    'value': 'MLT',
    'country-code': '470'
  }, {
    'text': 'Marshall Islands',
    'value': 'MHL',
    'country-code': '584'
  }, {
    'text': 'Martinique',
    'value': 'MTQ',
    'country-code': '474'
  }, {
    'text': 'Mauritania',
    'value': 'MRT',
    'country-code': '478'
  }, {
    'text': 'Mauritius',
    'value': 'MUS',
    'country-code': '480'
  }, {
    'text': 'Mayotte',
    'value': 'MYT',
    'country-code': '175'
  }, {
    'text': 'México',
    'value': 'MEX',
    'country-code': '484'
  }, {
    'text': 'Micronesia (Federated States of)',
    'value': 'FSM',
    'country-code': '583'
  }, {
    'text': 'Moldova (Republic of)',
    'value': 'MDA',
    'country-code': '498'
  }, {
    'text': 'Monaco',
    'value': 'MCO',
    'country-code': '492'
  }, {
    'text': 'Mongolia',
    'value': 'MNG',
    'country-code': '496'
  }, {
    'text': 'Montenegro',
    'value': 'MNE',
    'country-code': '499'
  }, {
    'text': 'Montserrat',
    'value': 'MSR',
    'country-code': '500'
  }, {
    'text': 'Morocco',
    'value': 'MAR',
    'country-code': '504'
  }, {
    'text': 'Mozambique',
    'value': 'MOZ',
    'country-code': '508'
  }, {
    'text': 'Myanmar',
    'value': 'MMR',
    'country-code': '104'
  }, {
    'text': 'Namibia',
    'value': 'NAM',
    'country-code': '516'
  }, {
    'text': 'Nauru',
    'value': 'NRU',
    'country-code': '520'
  }, {
    'text': 'Nepal',
    'value': 'NPL',
    'country-code': '524'
  }, {
    'text': 'Netherlands',
    'value': 'NLD',
    'country-code': '528'
  }, {
    'text': 'New Caledonia',
    'value': 'NCL',
    'country-code': '540'
  }, {
    'text': 'New Zealand',
    'value': 'NZL',
    'country-code': '554'
  }, {
    'text': 'Nicaragua',
    'value': 'NIC',
    'country-code': '558'
  }, {
    'text': 'Niger',
    'value': 'NER',
    'country-code': '562'
  }, {
    'text': 'Nigeria',
    'value': 'NGA',
    'country-code': '566'
  }, {
    'text': 'Niue',
    'value': 'NIU',
    'country-code': '570'
  }, {
    'text': 'Norfolk Island',
    'value': 'NFK',
    'country-code': '574'
  }, {
    'text': 'Northern Mariana Islands',
    'value': 'MNP',
    'country-code': '580'
  }, {
    'text': 'Norway',
    'value': 'NOR',
    'country-code': '578'
  }, {
    'text': 'Oman',
    'value': 'OMN',
    'country-code': '512'
  }, {
    'text': 'Pakistan',
    'value': 'PAK',
    'country-code': '586'
  }, {
    'text': 'Palau',
    'value': 'PLW',
    'country-code': '585'
  }, {
    'text': 'Palestine, State of',
    'value': 'PSE',
    'country-code': '275'
  }, {
    'text': 'Panama',
    'value': 'PAN',
    'country-code': '591'
  }, {
    'text': 'Papua New Guinea',
    'value': 'PNG',
    'country-code': '598'
  }, {
    'text': 'Paraguay',
    'value': 'PRY',
    'country-code': '600'
  }, {
    'text': 'Peru',
    'value': 'PER',
    'country-code': '604'
  }, {
    'text': 'Philippines',
    'value': 'PHL',
    'country-code': '608'
  }, {
    'text': 'Pitcairn',
    'value': 'PCN',
    'country-code': '612'
  }, {
    'text': 'Poland',
    'value': 'POL',
    'country-code': '616'
  }, {
    'text': 'Portugal',
    'value': 'PRT',
    'country-code': '620'
  }, {
    'text': 'Puerto Rico',
    'value': 'PRI',
    'country-code': '630'
  }, {
    'text': 'Qatar',
    'value': 'QAT',
    'country-code': '634'
  }, {
    'text': 'Réunion',
    'value': 'REU',
    'country-code': '638'
  }, {
    'text': 'Romania',
    'value': 'ROU',
    'country-code': '642'
  }, {
    'text': 'Russian Federation',
    'value': 'RUS',
    'country-code': '643'
  }, {
    'text': 'Rwanda',
    'value': 'RWA',
    'country-code': '646'
  }, {
    'text': 'Saint Barthélemy',
    'value': 'BLM',
    'country-code': '652'
  }, {
    'text': 'Saint Helena, Ascension and Tristan da Cunha',
    'value': 'SHN',
    'country-code': '654'
  }, {
    'text': 'Saint Kitts and Nevis',
    'value': 'KNA',
    'country-code': '659'
  }, {
    'text': 'Saint Lucia',
    'value': 'LCA',
    'country-code': '662'
  }, {
    'text': 'Saint Martin (French part)',
    'value': 'MAF',
    'country-code': '663'
  }, {
    'text': 'Saint Pierre and Miquelon',
    'value': 'SPM',
    'country-code': '666'
  }, {
    'text': 'Saint Vincent and the Grenadines',
    'value': 'VCT',
    'country-code': '670'
  }, {
    'text': 'Samoa',
    'value': 'WSM',
    'country-code': '882'
  }, {
    'text': 'San Marino',
    'value': 'SMR',
    'country-code': '674'
  }, {
    'text': 'Sao Tome and Principe',
    'value': 'STP',
    'country-code': '678'
  }, {
    'text': 'Saudi Arabia',
    'value': 'SAU',
    'country-code': '682'
  }, {
    'text': 'Senegal',
    'value': 'SEN',
    'country-code': '686'
  }, {
    'text': 'Serbia',
    'value': 'SRB',
    'country-code': '688'
  }, {
    'text': 'Seychelles',
    'value': 'SYC',
    'country-code': '690'
  }, {
    'text': 'Sierra Leone',
    'value': 'SLE',
    'country-code': '694'
  }, {
    'text': 'Singapore',
    'value': 'SGP',
    'country-code': '702'
  }, {
    'text': 'Sint Maarten (Dutch part)',
    'value': 'SXM',
    'country-code': '534'
  }, {
    'text': 'Slovakia',
    'value': 'SVK',
    'country-code': '703'
  }, {
    'text': 'Slovenia',
    'value': 'SVN',
    'country-code': '705'
  }, {
    'text': 'Solomon Islands',
    'value': 'SLB',
    'country-code': '090'
  }, {
    'text': 'Somalia',
    'value': 'SOM',
    'country-code': '706'
  }, {
    'text': 'South Africa',
    'value': 'ZAF',
    'country-code': '710'
  }, {
    'text': 'South Georgia and the South Sandwich Islands',
    'value': 'SGS',
    'country-code': '239'
  }, {
    'text': 'South Sudan',
    'value': 'SSD',
    'country-code': '728'
  }, {
    'text': 'Spain',
    'value': 'ESP',
    'country-code': '724'
  }, {
    'text': 'Sri Lanka',
    'value': 'LKA',
    'country-code': '144'
  }, {
    'text': 'Sudan',
    'value': 'SDN',
    'country-code': '729'
  }, {
    'text': 'Suritext',
    'value': 'SUR',
    'country-code': '740'
  }, {
    'text': 'Svalbard and Jan Mayen',
    'value': 'SJM',
    'country-code': '744'
  }, {
    'text': 'Sweden',
    'value': 'SWE',
    'country-code': '752'
  }, {
    'text': 'Switzerland',
    'value': 'CHE',
    'country-code': '756'
  }, {
    'text': 'Syrian Arab Republic',
    'value': 'SYR',
    'country-code': '760'
  }, {
    'text': 'Taiwan, Province of China',
    'value': 'TWN',
    'country-code': '158'
  }, {
    'text': 'Tajikistan',
    'value': 'TJK',
    'country-code': '762'
  }, {
    'text': 'Tanzania, United Republic of',
    'value': 'TZA',
    'country-code': '834'
  }, {
    'text': 'Thailand',
    'value': 'THA',
    'country-code': '764'
  }, {
    'text': 'Timor-Leste',
    'value': 'TLS',
    'country-code': '626'
  }, {
    'text': 'Togo',
    'value': 'TGO',
    'country-code': '768'
  }, {
    'text': 'Tokelau',
    'value': 'TKL',
    'country-code': '772'
  }, {
    'text': 'Tonga',
    'value': 'TON',
    'country-code': '776'
  }, {
    'text': 'Trinidad and Tobago',
    'value': 'TTO',
    'country-code': '780'
  }, {
    'text': 'Tunisia',
    'value': 'TUN',
    'country-code': '788'
  }, {
    'text': 'Turkey',
    'value': 'TUR',
    'country-code': '792'
  }, {
    'text': 'Turkmenistan',
    'value': 'TKM',
    'country-code': '795'
  }, {
    'text': 'Turks and Caicos Islands',
    'value': 'TCA',
    'country-code': '796'
  }, {
    'text': 'Tuvalu',
    'value': 'TUV',
    'country-code': '798'
  }, {
    'text': 'Uganda',
    'value': 'UGA',
    'country-code': '800'
  }, {
    'text': 'Ukraine',
    'value': 'UKR',
    'country-code': '804'
  }, {
    'text': 'United Arab Emirates',
    'value': 'ARE',
    'country-code': '784'
  }, {
    'text': 'United Kingdom of Great Britain and Northern Ireland',
    'value': 'GBR',
    'country-code': '826'
  }, {
    'text': 'United States of America',
    'value': 'USA',
    'country-code': '840'
  }, {
    'text': 'United States Minor Outlying Islands',
    'value': 'UMI',
    'country-code': '581'
  }, {
    'text': 'Uruguay',
    'value': 'URY',
    'country-code': '858'
  }, {
    'text': 'Uzbekistan',
    'value': 'UZB',
    'country-code': '860'
  }, {
    'text': 'Vanuatu',
    'value': 'VUT',
    'country-code': '548'
  }, {
    'text': 'Venezuela (Bolivarian Republic of)',
    'value': 'VEN',
    'country-code': '862'
  }, {
    'text': 'Viet Nam',
    'value': 'VNM',
    'country-code': '704'
  }, {
    'text': 'Virgin Islands (British)',
    'value': 'VGB',
    'country-code': '092'
  }, {
    'text': 'Virgin Islands (U.S.)',
    'value': 'VIR',
    'country-code': '850'
  }, {
    'text': 'Wallis and Futuna',
    'value': 'WLF',
    'country-code': '876'
  }, {
    'text': 'Western Sahara',
    'value': 'ESH',
    'country-code': '732'
  }, {
    'text': 'Yemen',
    'value': 'YEM',
    'country-code': '887'
  }, {
    'text': 'Zambia',
    'value': 'ZMB',
    'country-code': '894'
  }, {
    'text': 'Zimbabwe',
    'value': 'ZWE',
    'country-code': '716'
  }],
  VERSION: ver,
  SHIPPING_EXCLUDED: {}
};

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MoonLoader_vue__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1bb89629_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_MoonLoader_vue__ = __webpack_require__(659);
function injectStyle (ssrContext) {
  __webpack_require__(657)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_MoonLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1bb89629_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_MoonLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValidationsMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);

var ValidationsMixim = {
  methods: {
    validateUrl: function validateUrl(url, mandatory) {
      if (mandatory && this.isEmptyData(url)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(url)) {
        return true;
      }
      var res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
      return res !== null;
    },
    validateEmail: function validateEmail(email, mandatory) {
      if (mandatory && this.isEmptyData(email)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(email)) {
        return true;
      }

      var rx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return rx.test(String(email).toLowerCase());
    },
    validIntegerCompare: function validIntegerCompare(value, inicial, mandatory) {
      if (mandatory && this.isEmptyData(value)) {
        return 'No es un valor válido';
      }
      if (!mandatory && !this.isEmptyData(value)) {
        if (!this.isValidInteger(value)) {
          return 'No es un valor válido';
        }
      }

      if (!this.isValidInteger(value, mandatory, true)) {
        return 'No es un valor válido';
      }

      if (!this.isEmptyData(inicial) && this.isValidInteger(inicial)) {
        if (parseInt(value) <= parseInt(inicial)) {
          return 'El valor "Hasta" es menor o igual que "Desde"';
        }
      }
      return '';
    },
    validCPCompare: function validCPCompare(value, inicial, mandatory) {
      if (mandatory && this.isEmptyData(value)) {
        return 'No es un valor válido';
      }
      if (!mandatory && !this.isEmptyData(value)) {
        if (!this.isValidInteger(value)) {
          return 'No es un valor válido';
        }
      }

      if (!this.isValidCP(value, mandatory)) {
        return 'No es un valor válido';
      }

      if (!this.isEmptyData(inicial) && this.isValidCP(inicial)) {
        if (parseInt(value) < parseInt(inicial)) {
          return 'El valor "Hasta" es menor que "Desde"';
        }
      }
      return '';
    },
    isValidFloat: function isValidFloat(value, mandatory, noZero) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }
      if (String(value).indexOf('00') === 0) {
        return false;
      }
      if (/^-?\d+(\.?\d+)?$/.test(String(value)) === false) {
        return false;
      }
      if (noZero === true) {
        return parseFloat(value) !== 0;
      }

      if (value < 0) {
        return false;
      }

      return true;
    },
    isValidInteger: function isValidInteger(value, mandatory, noZero) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }
      if (String(value).indexOf('00') === 0) {
        return false;
      }
      if (String(value).indexOf('.') !== -1 || isNaN(String(value)) || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseFloat(value))) {
        return false;
      }
      if (noZero === true) {
        return parseInt(value) !== 0;
      }
      if (value < 0) {
        return false;
      }
      return true;
    },
    isValidInt32Integer: function isValidInt32Integer(value, mandatory, noZero) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }
      if (String(value).indexOf('00') === 0) {
        return false;
      }
      if (String(value).indexOf('.') !== -1 || String(value).indexOf(' ') !== -1 || isNaN(String(value)) || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseFloat(value))) {
        return false;
      }
      if (parseInt(value) > 2147483648) return false;
      if (value < 0) return false;
      if (noZero === true) {
        return parseInt(value) !== 0;
      }
      return true;
    },
    isValidUPC: function isValidUPC(value, mandatory, noZero) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }
      if (String(value).indexOf('.') !== -1 || isNaN(String(value)) || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseFloat(value))) {
        return false;
      }
      if (noZero === true) {
        return parseInt(value) !== 0;
      }
      if (value < 0) {
        return false;
      }
      return true;
    },
    isValidCP: function isValidCP(value, mandatory) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }
      if (String(value).indexOf('.') !== -1 || isNaN(String(value)) || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseFloat(value))) {
        return false;
      }
      return true;
    },
    isValidTextOneWord: function isValidTextOneWord(value, mandatory, size) {
      return this.isValidText(value, mandatory, size) && value.indexOf(' ') === -1;
    },
    isValidMinLength: function isValidMinLength(value, size) {
      if (size) {
        if (value.length < size) {
          return false;
        }
      }
    },
    isValidText: function isValidText(value, mandatory, size) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }

      if (size) {
        if (value.length > size) {
          return false;
        }
      }

      return (/^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9- ,_ !"·$%&/()=?¿¡'″^´,.-;:+*{}[\]º<>@]*$/.test(value)
      );
    },
    isValidTextWithoutAccents: function isValidTextWithoutAccents(value, mandatory, size) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }

      if (size) {
        if (value.length > size) {
          return false;
        }
      }
      return (/^[a-zA-Z1-9-+_@.\u00f1\u00d1]+(\s*[a-zA-Z1-9-+_@.\u00f1\u00d1]*)*[a-zA-Z1-9-+_@.\u00f1\u00d1]+$/.test(value)
      );
    },
    isValidTextArea: function isValidTextArea(value, mandatory, size) {
      if (mandatory && this.isEmptyData(value)) {
        return false;
      }
      if (!mandatory && this.isEmptyData(value)) {
        return true;
      }

      if (size) {
        if (value.length > size) {
          return false;
        }
      }

      return true;
    },
    validateCP: function validateCP(evt) {
      if (evt.keyCode !== 8 && evt.keyCode !== 37 && evt.keyCode !== 39 && evt.keyCode !== 46 && evt.keyCode !== 9) {
        if (isNaN(String(evt.key))) {
          evt.stopPropagation();
          evt.preventDefault();
        }
      }
    },
    _validateNumber: function _validateNumber(evt, float, preventCero) {
      var currentValue = String(evt.target.value);
      var newChar = String(evt.key);

      if (evt.ctrlKey === true) {
        if (newChar !== 'v' && newChar !== 'c') {
          evt.stopPropagation();
          evt.preventDefault();
        }
      } else {
        var nextValue = currentValue + newChar;

        if (!float) {
          if (newChar === '.') {
            evt.stopPropagation();
            evt.preventDefault();
            return;
          }
        }

        if (evt.keyCode !== 8 && evt.keyCode !== 37 && evt.keyCode !== 39 && evt.keyCode !== 46 && evt.keyCode !== 9) {
          if (isNaN(nextValue) || nextValue === '00' || preventCero && nextValue === '0' || currentValue === '0' && newChar !== '.') {
            evt.stopPropagation();
            evt.preventDefault();
            return;
          }

          if (evt.target.value.length > 19) {
            evt.stopPropagation();
            evt.preventDefault();
          }
        }
      }
    },
    validateNumber: function validateNumber(evt, preventCero) {
      return this._validateNumber(evt, false, preventCero);
    },
    validatePriceNumber: function validatePriceNumber(evt, preventCero) {
      return this._validateNumber(evt, true, preventCero);
    },
    textInputValidationSpecialChars: function textInputValidationSpecialChars(evt) {
      if (/^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9- ,_ !"·$%&/()=?¿¡^´,.-;:+*{}[\]º<>]*$/.test(evt.key) === false) {
        evt.stopPropagation();
        evt.preventDefault();
      }
    },
    textInputValidation: function textInputValidation(evt) {
      if (/^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9- ,_]*$/.test(evt.key) === false) {
        evt.stopPropagation();
        evt.preventDefault();
      }
    },
    isEmptyData: function isEmptyData(data) {
      if (typeof data === 'string') {
        data = data.trim();
        if (data === '') {
          return true;
        }
      }

      if (typeof data === 'number' || typeof data === 'boolean') {
        return false;
      }
      if (typeof data === 'undefined' || data === null) {
        return true;
      }
      if (typeof data.length !== 'undefined') {
        return data.length === 0;
      }

      var count = 0;
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          count++;
        }
      }
      return count === 0;
    }
  }
};

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PRODUCT_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRODUCT_STATES_EDITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductServiceMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__);





var PRODUCT_STATES = [{ value: 'APPROVED', text: 'Activo' }, { value: 'PENDING_APPROVAL', text: 'Pendiente' }, { value: 'REJECTED', text: 'Rechazado' }];

var PRODUCT_STATES_EDITION = [{ value: 'APPROVED', text: 'Activo' }, { value: 'PENDING_APPROVAL', text: 'Pendiente', disabled: true }, { value: 'REJECTED', text: 'Rechazado' }];

var ProductServiceMixim = {
  methods: {
    getProducts: function getProducts(tableInfo, filters, isCSVExport) {
      var url = null;
      if (isCSVExport) {
        url = new URL(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/downloadcsv');
      } else {
        url = new URL(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products');
      }

      var params = {};

      if (tableInfo) {
        if (tableInfo.sortBy) {
          if (tableInfo.sortBy === 'category') {
            params.sortBy = 'category.name.keyword';
          } else if (tableInfo.sortBy === 'upc') {
            params.sortBy = 'skus.upc.filter';
          } else if (tableInfo.sortBy === 'price') {
            params.sortBy = 'skus.price.price';
          } else if (tableInfo.sortBy === 'status') {
            params.sortBy = 'skus.status';
          } else if (tableInfo.sortBy === 'name') {
            params.sortBy = 'name.keyword';
          } else if (tableInfo.sortBy === 'quantity') {
            params.sortBy = 'skus.inventory.totalQuantity';
          } else {
            params.sortBy = tableInfo.sortBy;
          }
          params.sortOrder = tableInfo.sortDesc ? 'desc' : 'asc';
        }
        params.from = tableInfo.currentPage - 1;
        params.size = tableInfo.perPage;
      }

      params.fromQuantity = filters.fromQuantity;
      params.toQuantity = filters.toQuantity;
      params.accountName = filters.seller;
      params.fromSkuId = filters.sku.desde;
      params.toSkuId = filters.sku.hasta;
      params.fromUpc = filters.upc.desde;
      params.toUpc = filters.upc.hasta;
      params.status = filters.estado;
      params.categoryId = filters.category.id;
      params.name = filters.name;
      params.fromDate = filters.fecha.desde;
      params.toDate = filters.fecha.hasta;
      params.text = filters.text;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null && params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      });

      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };

      if (isCSVExport) {
        config.responseType = 'arraybuffer';
        config.headers.Accept = 'application/octet-stream; charset=ISO-8859-1';
      }

      return this.$http.get(url.href, config);
    },
    productsReport: function productsReport(tableInfo, filters, isCSVExport) {
      var url = null;
      if (isCSVExport) {
        url = new URL(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/downloadcsv');
      } else {
        url = new URL(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products');
      }

      var params = {};

      if (tableInfo) {
        if (tableInfo.sortBy) {
          if (tableInfo.sortBy === 'category') {
            params.sortBy = 'category.name.keyword';
          } else if (tableInfo.sortBy === 'upc') {
            params.sortBy = 'skus.upc.filter';
          } else if (tableInfo.sortBy === 'price') {
            params.sortBy = 'skus.price.price';
          } else if (tableInfo.sortBy === 'status') {
            params.sortBy = 'skus.status';
          } else if (tableInfo.sortBy === 'name') {
            params.sortBy = 'name.keyword';
          } else if (tableInfo.sortBy === 'quantity') {
            params.sortBy = 'skus.inventory.totalQuantity';
          } else {
            params.sortBy = tableInfo.sortBy;
          }
          params.sortOrder = tableInfo.sortDesc ? 'desc' : 'asc';
        }
        params.from = tableInfo.currentPage - 1;
        params.size = tableInfo.perPage;
      }
      if (filters.useFilters) {
        params.fromQuantity = filters.fromQuantity;
        params.toQuantity = filters.toQuantity;
        params.accountName = filters.seller;
        params.status = filters.estado;
        params.categoryId = filters.category.id;
        params.text = filters.text;
        params.fromDate = filters.fecha.desde;
        params.toDate = filters.fecha.hasta;
      }
      params.text = filters.text;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null && params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      });

      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };

      if (isCSVExport) {
        config.responseType = 'arraybuffer';
        config.headers.Accept = 'application/octet-stream; charset=ISO-8859-1';
      }

      return this.$http.get(url.href, config);
    },
    activateProducts: function activateProducts(products, areVariants, data) {
      var reference = '';
      var productModelArray = products.map(function (elem) {
        return {
          id: elem
        };
      });
      var endPoint = '';
      if (!areVariants) {
        endPoint = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/approve';
        reference = 'products';
      } else {
        endPoint = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/approve';
        reference = 'skus';
      }

      var withAcceptance = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        acceptance: data
      }, reference, productModelArray)];
      return this.$http.put(endPoint, withAcceptance[0], {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    rejectProducts: function rejectProducts(products, areVariants) {
      var productModelArray = products.map(function (elem) {
        return { id: elem };
      });

      var endPoint = '';
      if (!areVariants) {
        endPoint = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/reject';
      } else {
        endPoint = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/reject';
      }

      return this.$http.put(endPoint, productModelArray, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    deleteProducts: function deleteProducts(products, areVariants) {
      var productModelArray = products.map(function (elem) {
        return { id: elem };
      });

      var endPoint = '';
      if (!areVariants) {
        endPoint = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/delete';
      } else {
        endPoint = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/delete';
      }

      return this.$http.put(endPoint, productModelArray, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getProduct: function getProduct() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/' + this.productId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    createSku: function createSku(productId, skuPayload) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/' + productId + '/sku', skuPayload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).then(function (res) {
        return res.body;
      });
    },
    existRefId: function existRefId(refId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/refid/' + refId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    createProduct: function createProduct(productPayload) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products', productPayload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).then(function (res) {
        return res.body;
      });
    },
    updateProduct: function updateProduct(product) {
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/' + product.id, product, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    updateSku: function updateSku(skuId, skuPayload) {
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/' + skuId, skuPayload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getSkuHistory: function getSkuHistory(skuId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/' + skuId + '/historical?sortBy=date&sortOrder=asc', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).catch(function () {
        return null;
      });
    },
    getSku: function getSku(skuId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/' + skuId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    _getBrands: function _getBrands(from, size) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/brands/list?from=' + from + '&size=' + size, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).catch(function () {
        return null;
      });
    },
    getBrands: function getBrands() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this._getBrands(0, 1000), this._getBrands(1, 1000), this._getBrands(2, 1000), this._getBrands(3, 1000), this._getBrands(4, 1000)]).then(function (response) {
        var brandArray = [];
        for (var i = 0; i < 5; i++) {
          if (response[i]) {
            brandArray = brandArray.concat(response[i].body);
          }
        }
        return brandArray.sort(function (brand1, brand2) {
          return brand1.name.localeCompare(brand2.name);
        });
      });
    },
    getSearchBrands: function getSearchBrands(text) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/brands?text=' + text, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).catch(function () {
        return null;
      });
    },
    getCategories: function getCategories() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/categories/tree', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getProductAtributes: function getProductAtributes(categoryId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/specifications?categoryId=' + categoryId + '&isStockKeepingUnit=false', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getSKUAttributes: function getSKUAttributes(categoryId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/specifications?categoryId=' + categoryId + '&isStockKeepingUnit=true', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getSpecsFor: function getSpecsFor(categoryId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/specifications?categoryId=' + categoryId + '&size=50', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    addProduct: function addProduct(product) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products', product, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    findProductByUpc: function findProductByUpc(upc) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products/upc/' + upc, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (res) {
        return res.body;
      });
    },
    getPriceList: function getPriceList() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/prices/downloadcsv', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    uploadCsvPriceList: function uploadCsvPriceList(csvPriceFile, delimiter) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/prices/importcsv?delimiter=' + delimiter, csvPriceFile, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    getShippingRatesPriceList: function getShippingRatesPriceList() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/shippingrates/downloadcsv', {
        headers: {
          Accept: 'application/octet-stream; charset=ISO-8859-1',
          Authorization: 'Bearer ' + this.$store.state.access_token
        },
        responseType: 'arraybuffer'
      });
    },
    uploadCsvShippingRatesPriceList: function uploadCsvShippingRatesPriceList(csvPriceFile, delimiter) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/shippingrates/importcsv?delimiter=' + delimiter, csvPriceFile, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    deleteImageExec: function deleteImageExec(skuId, srcImage1, srcImage2, srcImage3, srcImage4, srcImage5) {
      var images = [];
      images.push({ 'imageUrl': srcImage1 });
      images.push({ 'imageUrl': srcImage2 });
      images.push({ 'imageUrl': srcImage3 });
      images.push({ 'imageUrl': srcImage4 });
      images.push({ 'imageUrl': srcImage5 });

      return this.$http.put(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/sku/' + skuId + '/images', {
        'images': images
      }, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getSearchProducts: function getSearchProducts(text) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/products');
      url.searchParams.append('text', text);
      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };
      return this.$http.get(url.href, config);
    },
    getSearchCategories: function getSearchCategories(text) {
      var filters = {
        text: text
      };
      return this.getFlatCategories(filters);
    },
    getFlatCategories: function getFlatCategories(filters) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/categories');
      var params = {};

      params.sortOrder = filters.sortOrder ? 'asc' : 'desc';
      params.sortBy = filters.sortBy + '.keyword';
      params.from = filters.from > 0 ? filters.from - 1 : filters.from;
      params.size = filters.size;
      params.text = filters.text;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null && params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    }
  }
};

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OrdersServiceMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__);




var OrdersServiceMixim = {
  methods: {
    getAllOrders: function getAllOrders(tableInfo, isCSVExport) {
      var url = null;
      var params = {};
      if (!isCSVExport) {
        url = new URL(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders');
        params.from = tableInfo.currentPage - 1;
        params.size = tableInfo.perPage;
      } else {
        url = new URL(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/downloadcsv');
      }

      if (tableInfo.sortBy) {
        params.sortBy = tableInfo.sortBy === 'clientProfileData' ? 'clientProfileData.lastName.keyword' : tableInfo.sortBy;
        params.sortOrder = tableInfo.sortDesc ? 'desc' : 'asc';
      } else {
        params.sortBy = 'creationDate';
        params.sortOrder = 'desc';
      }

      if (this.filter) params.text = this.filter;
      if (this.showFilters) {
        if (this.account) params.accountName = this.account;
        if (this.statusName) {
          params.status = this.statusName;
        }

        if (this.liquidationReport) {
          if (this.fromDate && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.fromDate) !== 'object') params.fromLiquidationDate = this.fromDate;
          if (this.toDate && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.toDate) !== 'object') params.toLiquidationDate = this.toDate;
        } else {
          if (this.fromDate && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.fromDate) !== 'object') params.fromDate = this.fromDate;
          if (this.toDate && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.toDate) !== 'object') params.toDate = this.toDate;
        }

        if (this.filterTags) {
          params.tags = this.filterTags.join(',');
        }
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });

      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };

      if (isCSVExport) {
        config.responseType = 'arraybuffer';
        config.headers.Accept = 'application/octet-stream; charset=ISO-8859-1';
      }
      return this.$http.get(url.href, config);
    },
    getOrderDetails: function getOrderDetails(orderId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    invoiceOrder: function invoiceOrder(orderId, courier, trackingUrl, trackingNumber, items, invoiceNumber) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/invoice', { courier: courier, trackingUrl: trackingUrl, trackingNumber: trackingNumber, items: items, invoiceNumber: invoiceNumber }, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    addTrackingInformation: function addTrackingInformation(orderId, invoiceNumber, courier, trackingUrl, trackingNumber) {
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/invoice/' + invoiceNumber, { courier: courier, trackingUrl: trackingUrl, trackingNumber: trackingNumber }, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    cancelOrder: function cancelOrder(orderId) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/canceled', '', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    startHandling: function startHandling(orderId) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/start-handling', '', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    deliverOrders: function deliverOrders(orderId, invoiceList) {
      var _this = this;

      function syncMagicPromisseCall() {
        var invoiceNumber = invoiceList.pop();
        return _this.deliverOrder(orderId, invoiceNumber).then(function () {
          if (invoiceList.length !== 0) {
            return syncMagicPromisseCall();
          }
        });
      }
      return syncMagicPromisseCall();
    },
    deliverOrder: function deliverOrder(orderId, invoiceNumber) {
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/invoice/' + invoiceNumber + '/tracking', '', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getStatusstatistics: function getStatusstatistics(accountName, dateFrom, dateTo) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/statusstatistics');
      var params = {};

      params.accountName = accountName;
      params.fromDate = dateFrom;
      params.toDate = dateTo;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    downloadSalesReport: function downloadSalesReport(accountName, dateFrom, dateTo) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/downloadsalesreportcsv');
      var params = {};

      params.accountName = accountName;
      params.fromDate = dateFrom;
      params.toDate = dateTo;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getSalesReport: function getSalesReport(filter, isCSVExport) {
      var url = null;
      if (!isCSVExport) {
        url = new URL(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/salesreport');
      } else {
        url = new URL(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/downloadsalesreportcsv');
      }
      var params = {};

      params.accountName = filter.account;
      params.fromDate = filter.fecha.desde;
      params.toDate = filter.fecha.hasta;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });

      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };

      if (isCSVExport) {
        config.responseType = 'arraybuffer';
        config.headers.Accept = 'application/octet-stream; charset=ISO-8859-1';
      }

      return this.$http.get(url.href, config);
    },
    intervalstatistics: function intervalstatistics(accountName, dateFrom, dateTo) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/intervalstatistics');
      var params = {};

      params.accountName = accountName;
      params.fromDate = dateFrom;
      params.toDate = dateTo;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getImputabilityCauses: function getImputabilityCauses() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/imputabilitycauses', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    cancelCDESeller: function cancelCDESeller(orderId, payload) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/cancelcde', payload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    cancelCAESeller: function cancelCAESeller(orderId, payload) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/cancelcae', payload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getSearchOrders: function getSearchOrders(text) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/orders?sortBy=creationDate&sortOrder=desc&text=' + text, { headers: { Authorization: 'Bearer ' + this.$store.state.access_token } });
    }
  }
};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminServiceMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RoleService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OrganizationService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__);





var AdminServiceMixin = {
  data: function data() {
    return {
      USER_ENDPOINT: __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/user',
      USER_HEADER: {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }
    };
  },

  methods: {
    getUsers: function getUsers(filter) {
      var endpoint = new URL(this.USER_ENDPOINT);
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(filter).forEach(function (key) {
        var value = filter[key];
        if (key === 'sortOrder') value = value ? 'asc' : 'desc';
        if (key === 'from') --value;
        if (value !== null) {
          endpoint.searchParams.append(key, value);
        }
      });
      return this.$http.get(endpoint.href, this.USER_HEADER);
    },
    getUser: function getUser(id) {
      return this.$http.get(this.USER_ENDPOINT + ('/' + id), this.USER_HEADER);
    },
    createUser: function createUser(user) {
      return this.$http.post(this.USER_ENDPOINT, user, this.USER_HEADER);
    },
    updateUser: function updateUser(user) {
      return this.$http.put(this.USER_ENDPOINT + ('/' + user.id), user, this.USER_HEADER);
    },
    deleteUser: function deleteUser(id) {
      return this.$http.delete(this.USER_ENDPOINT + ('/' + id), this.USER_HEADER);
    },
    resetPassword: function resetPassword(userId) {
      return this.$http.post(this.USER_ENDPOINT + ('/passwordreset/' + userId), {}, this.USER_HEADER);
    },
    changePassword: function changePassword(userId, body) {
      return this.$http.post(this.USER_ENDPOINT + ('/' + userId + '/newpassword'), body, this.USER_HEADER);
    },
    existEmail: function existEmail(email) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/emails/' + email, this.USER_HEADER);
    }
  }
};

var RoleService = {
  data: function data() {
    return {
      roleProperties: {
        'ADMIN_USER': { name: 'Administrador', variant: 'primary' },
        'STANDARD_USER': { name: 'Usuario Marketplace', variant: 'primary' },
        'ORGANIZATION_ADMIN_USER': { name: 'Administrador Seller', variant: 'dark' },
        'ORGANIZATION_STANDARD_USER': { name: 'Usuario Seller', variant: 'dark' },
        'CATALOG_USER': { name: 'Catálogo', variant: 'secondary' },
        'ORDERS_USER': { name: 'Pedidos', variant: 'secondary' },
        'INVENTORY_USER': { name: 'Inventario', variant: 'secondary' },
        'CARRIERS_USER': { name: 'Transportadoras', variant: 'secondary' },
        'REPORTS_USER': { name: 'Reportes', variant: 'secondary' }
      }
    };
  },
  methods: {
    getRoles: function getRoles() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/role', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getRole: function getRole(id) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/role/' + id, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    createRole: function createRole(role) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/role', role, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    updateRole: function updateRole(id, role) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/role/' + id, role, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    deleteRole: function deleteRole(id) {
      return this.$http.delete(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/role/' + id, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    sortValidRoles: function sortValidRoles(roles) {
      var response = ['ADMIN_USER', 'STANDARD_USER', 'ORGANIZATION_ADMIN_USER', 'ORGANIZATION_STANDARD_USER', 'CATALOG_USER', 'ORDERS_USER', 'INVENTORY_USER', 'CARRIERS_USER', 'REPORTS_USER'];
      return response.map(function (r) {
        return roles.find(function (role) {
          return role.roleName === r;
        });
      }).filter(function (r) {
        return r !== undefined;
      });
    }
  }
};

var OrganizationService = {
  data: function data() {
    return {
      ORGANIZATION_ENDPOINT: __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/admin/organization',
      HEADER: {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }
    };
  },

  methods: {
    getAllOrganizations: function getAllOrganizations() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var total, organizationArray, size, from, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                total = 0;
                organizationArray = [];
                size = 100;
                from = 1;

              case 4:
                _context.next = 6;
                return _this.getOrganizations({
                  'from': from,
                  'size': size
                });

              case 6:
                response = _context.sent;

                total = parseInt(response.headers.get('X-Total-Count'));
                organizationArray = organizationArray.concat(response.body);
                from = from + 1;

              case 10:
                if (total !== organizationArray.length) {
                  _context.next = 4;
                  break;
                }

              case 11:
                return _context.abrupt('return', organizationArray);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getSearchSeller: function getSearchSeller(text) {
      var endpoint = new URL(this.ORGANIZATION_ENDPOINT);
      if (text) {
        endpoint.searchParams.append('text', text);
      }
      return this.$http.get(endpoint.href, this.HEADER);
    },
    getOrganizations: function getOrganizations(filter) {
      var endpoint = new URL(this.ORGANIZATION_ENDPOINT);
      if (filter) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(filter).forEach(function (key) {
          var value = filter[key];
          if (key === 'sortOrder') value = value ? 'asc' : 'desc';
          if (key === 'from') value = value - 1;
          if (key === 'sortBy' && value !== 'accountName') value = value + '.keyword';
          if (value !== null) {
            endpoint.searchParams.append(key, value);
          }
        });
      }
      return this.$http.get(endpoint.href, this.HEADER);
    },
    searchOrganization: function searchOrganization(text) {
      var endpoint = new URL(this.ORGANIZATION_ENDPOINT);
      endpoint.searchParams.append('text', text);
      return this.$http.get(endpoint.href, this.HEADER);
    },
    saveOrganization: function saveOrganization(organization) {
      return this.$http.post(this.ORGANIZATION_ENDPOINT, organization, this.HEADER);
    }
  }
};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryTree_vue__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ed2cfd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryTree_vue__ = __webpack_require__(780);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78ed2cfd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_autocomplete_vue__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1991a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_autocomplete_vue__ = __webpack_require__(809);
function injectStyle (ssrContext) {
  __webpack_require__(806)
  __webpack_require__(807)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1991a3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationServiceMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__);





var NotificationServiceMixim = {
  methods: {
    getNotifications: function getNotifications(params, unread) {
      var from = params.from || 0;
      var size = params.size || 10;
      var url = '';
      if (unread) {
        url = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications?from=0&size=1&mode=INBOX&read=false';
      } else {
        url = __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications?from=' + from + '&size=' + size + '&mode=INBOX&sortBy=creationDate&sortOrder=desc';
      }

      return this.$http.get(url, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getNotificationsNotices: function getNotificationsNotices(tableInfo, filters) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications');
      var params = {};
      if (tableInfo) {
        params.sortBy = tableInfo.sortBy;
        params.sortOrder = tableInfo.sortDesc ? 'desc' : 'asc';
        params.from = tableInfo.currentPage - 1;
        params.size = tableInfo.perPage;
      }

      if (filters) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(filters).forEach(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          params[key] = value;
        });
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null && params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      });
      return this.$http.get(url.href, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    markNotificationsAllReaded: function markNotificationsAllReaded() {
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications/read-all', '', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    markNotificationRead: function markNotificationRead(notificationId) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications/' + notificationId + '/read', '', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    createNotification: function createNotification(notification) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications', notification, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    editNotification: function editNotification(notificationId, notification) {
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications/' + notificationId, notification, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    deleteNotification: function deleteNotification(notificationId) {
      return this.$http.delete(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.API_END_POINT + '/notifications/' + notificationId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    }
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7101d256_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(803);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7101d256_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncidentsServices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__);



var IncidentsServices = {
  data: function data() {
    return {
      ENDPOINT: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/incidents',
      HEADER: {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }
    };
  },

  methods: {
    getIncidents: function getIncidents(tableInfo, filters) {
      var url = new URL(this.ENDPOINT);
      url.searchParams.append('sortBy', 'creationDate');
      url.searchParams.append('sortOrder', 'desc');
      if (tableInfo) {
        url.searchParams.append('from', tableInfo.currentPage - 1);
        url.searchParams.append('size', tableInfo.perPage);
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filters).forEach(function (key) {
        if (filters[key] !== null) {
          url.searchParams.append(key, filters[key]);
        }
      });

      return this.$http.get(url.href, this.HEADER);
    },
    getIncidentDetail: function getIncidentDetail(incidentId) {
      return this.$http.get(this.CARRIERS_ENDPOINT + '/' + incidentId, this.HEADER);
    },
    createIncident: function createIncident(incidentDetail) {
      return this.$http.post(this.ENDPOINT, incidentDetail, this.HEADER);
    },
    updateIncident: function updateIncident(incidentId, incidentDetail) {
      return this.$http.put(this.ENDPOINT + '/' + incidentId, incidentDetail, this.HEADER);
    },
    addCommentToIncident: function addCommentToIncident(incidentId, incidentComment) {
      return this.$http.post(this.ENDPOINT + '/' + incidentId + '/comments', incidentComment, this.HEADER);
    }
  }
};

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ControversyServiceMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);


var ControversyServiceMixim = {
  methods: {
    getControversies: function getControversies(orderId) {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/controversies', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    createControversy: function createControversy(orderId, text, type) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/controversies', { text: text, type: type }, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    addControversyNote: function addControversyNote(orderId, controversyId, text) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/controversies/' + controversyId + '/comments', { text: text }, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    deleteControversy: function deleteControversy(orderId, controversyId) {
      return this.$http.delete(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/controversies/' + controversyId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    updateControversy: function updateControversy(orderId, controversyId, status) {
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/orders/' + orderId + '/controversies', { 'active': status, 'id': controversyId }, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    }
  }
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarrierServiceMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__);



var CarrierServiceMixin = {
  data: function data() {
    return {
      CARRIERS_ENDPOINT: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/carriers',
      SHIPPING_GRATES_ENDPOINT: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/shippingrates',
      HEADER: {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }
    };
  },

  methods: {
    getCarriers: function getCarriers(filter) {
      var endpoint = new URL(this.CARRIERS_ENDPOINT);
      if (filter) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filter).forEach(function (key) {
          if (filter[key] !== null) {
            endpoint.searchParams.append(key, filter[key]);
          }
        });
      }
      return this.$http.get(endpoint.href, this.HEADER);
    },
    getCarrier: function getCarrier(id) {
      return this.$http.get(this.CARRIERS_ENDPOINT + '/' + id, this.HEADER);
    },
    createCarrier: function createCarrier(carrier) {
      return this.$http.post(this.CARRIERS_ENDPOINT, carrier, this.HEADER);
    },
    updateCarrier: function updateCarrier(carrier) {
      return this.$http.put(this.CARRIERS_ENDPOINT + '/' + carrier.id, carrier, this.HEADER);
    },
    getShippinGrates: function getShippinGrates(tableInfo, filters) {
      var params = {};
      var url = new URL(this.SHIPPING_GRATES_ENDPOINT);

      params.from = tableInfo.currentPage - 1;
      params.size = tableInfo.perPage;

      if (tableInfo.sortBy) {
        params.sortBy = tableInfo.sortBy;
        params.sortOrder = tableInfo.sortDesc ? 'desc' : 'asc';
      }
      params.accountName = filters.accountName;
      params.zipCodeStart = filters.zipCode;
      params.zipCodeEnd = filters.zipCode;
      params.weightStart = filters.weight;
      params.weightEnd = filters.weight;
      params.maxVolume = filters.maxVolume;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, this.HEADER);
    },
    postShippingrates: function postShippingrates(shippingrateData) {
      return this.$http.post(this.SHIPPING_GRATES_ENDPOINT, shippingrateData, this.HEADER);
    },
    deleteShippingrates: function deleteShippingrates(shippingGrateId) {
      return this.$http.delete(this.SHIPPING_GRATES_ENDPOINT + '/' + shippingGrateId, this.HEADER);
    },
    addSellerToCarrier: function addSellerToCarrier(carrierId, carrierseller) {
      return this.$http.post(this.CARRIERS_ENDPOINT + '/' + carrierId + '/carrierseller', carrierseller, this.HEADER);
    },
    getSellersFromCarrier: function getSellersFromCarrier(carrierId, tableFilter) {
      var url = new URL(this.CARRIERS_ENDPOINT + '/' + carrierId + '/carrierseller');
      var params = {};
      params.from = tableFilter.currentPage - 1;
      params.size = tableFilter.perPage;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });
      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };
      return this.$http.get(url.href, config);
    },
    delSellerToCarrier: function delSellerToCarrier(carrierId, carriersellerId) {
      return this.$http.delete(this.CARRIERS_ENDPOINT + '/' + carrierId + '/carrierseller/' + carriersellerId, this.HEADER);
    },
    deleteMultipleShippingrates: function deleteMultipleShippingrates(ids) {
      var shippingrateData = { 'delete': ids };
      return this.$http.post(this.SHIPPING_GRATES_ENDPOINT + '/batch', shippingrateData, this.HEADER);
    },
    requestGuide: function requestGuide(idOrder) {
      return this.$http.get(this.CARRIERS_ENDPOINT + '/order/' + idOrder + '/guide', this.HEADER);
    }
  }
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromotionsServiceMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);




var PromotionsServiceMixim = {
  methods: {
    getPromotions: function getPromotions() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      return this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/commercialconditions?from=' + from + '&size=' + size + '&text=' + text, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    updatePromotionsAdmin: function updatePromotionsAdmin(payload) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/commercialconditions', payload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    updatePromotionSeller: function updatePromotionSeller(commercialConditionId) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/commercialconditions/' + commercialConditionId + '/activate', '', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    saveBulkDiscount: function saveBulkDiscount(discount, priceValidUntil) {
      var payload = { 'discount': discount, 'priceValidUntil': priceValidUntil };

      return this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/sku/prices/bulkdiscount', payload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    downloadCSV: function downloadCSV() {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.options.emulateHTTP = true;

      return this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/commercialconditions/downloadcsv', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          Accept: 'application/octet-stream; charset=ISO-8859-1'
        },
        responseType: 'arraybuffer'
      });
    },
    uploadCSV: function uploadCSV(delimiter, formData) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/commercialconditions/importcsv?delimiter=' + delimiter, formData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    uploadPDF: function uploadPDF(formData) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/commercialconditions/commission/import', formData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    downloadPDF: function downloadPDF() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/commercialconditions/commission/download', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        },
        responseType: 'arraybuffer'
      });
    },
    getPromotionsCatalog: function getPromotionsCatalog(tableInfo, filter) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/promotions');
      var params = {};
      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };

      params.text = this.filter.text;
      if (this.filter.isActive !== null) params.isActive = this.filter.isActive;
      params.beginDate = this.filter.range[0];
      params.endDate = this.filter.range[1];
      params.brandId = filter.brands.map(function (elem) {
        return elem.id;
      }).join(',');
      params.productId = filter.products.map(function (elem) {
        return elem.id;
      }).join(',');
      params.categoryId = filter.categories.map(function (elem) {
        return elem.id;
      }).join(',');
      params.accountName = filter.sellers.map(function (elem) {
        return elem.id;
      }).join(',');
      params.marketplace = filter.marketplaces.map(function (elem) {
        return elem.id;
      }).join(',');
      params.from = tableInfo.currentPage - 1;
      params.size = tableInfo.perPage;
      params.sortOrder = tableInfo.sortDesc ? 'desc' : 'asc';

      if (tableInfo.sortBy) {
        params.sortBy = tableInfo.sortBy;
      } else {
        params.sortBy = 'lastModified';
        params.sortOrder = 'desc';
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, config);
    },
    getPromotionByName: function getPromotionByName(name) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/promotions');
      var params = {
        text: name
      };
      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, config);
    },
    getPromotion: function getPromotion(promoId) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/promotions/' + promoId);
      var config = {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      };
      return this.$http.get(url.href, config);
    },
    savePromotion: function savePromotion(payload) {
      if (payload.id !== null) {
        return this.$http.put(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/promotions/' + payload.id, payload, {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.access_token
          }
        });
      } else {
        return this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/promotions', payload, {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.access_token
          }
        });
      }
    },
    deletePromotion: function deletePromotion(promoId) {
      return this.$http.delete(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/promotions/' + promoId, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    }
  }
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentsTable_vue__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2309dcdd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentsTable_vue__ = __webpack_require__(763);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2309dcdd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormActiveSku_vue__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0925e4e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormActiveSku_vue__ = __webpack_require__(804);
function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormActiveSku_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0925e4e4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormActiveSku_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CsvReportExportMixim; });
var CsvReportExportMixim = {
  methods: {
    _exportCSV: function _exportCSV(csvFile, filename) {
      var headers = csvFile.headers;
      var blob = new Blob([csvFile.body], {
        type: { type: headers.map['content-type'] }
      });
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
};

/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationsCheckbox_vue__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8a8e2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationsCheckbox_vue__ = __webpack_require__(1039);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationsCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8a8e2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationsCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e023b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(623);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21e023b0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d816119_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(628);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d816119_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserServiceMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);


var UserServiceMixim = {
  methods: {
    loginRequest: function loginRequest(userName, password) {
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/oauth/token', {
        username: userName,
        password: password
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
    },
    getUserData: function getUserData() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/admin/loggeduser', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getCarrierData: function getCarrierData() {
      return this.$http.get(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/carriers', {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    }
  }
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetail_vue__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286646cd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetail_vue__ = __webpack_require__(815);
function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-286646cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_286646cd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductAttributes_vue__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc13265_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductAttributes_vue__ = __webpack_require__(783);
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cc13265"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductAttributes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cc13265_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductAttributes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuModal_vue__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebc9c38_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuModal_vue__ = __webpack_require__(805);
function injectStyle (ssrContext) {
  __webpack_require__(784)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ebc9c38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebc9c38_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InventoryServiceMixim; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__);



var InventoryServiceMixim = {
  methods: {
    updateInventory: function updateInventory(skuId, totalQuantity, reservedQuantity, stockSecurity) {
      var payload = {
        'totalQuantity': totalQuantity,
        'reservedQuantity': reservedQuantity,
        'stockSecurity': parseInt(stockSecurity)
      };
      return this.$http.put(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/sku/inventories/' + skuId, payload, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      });
    },
    getInventoryCSV: function getInventoryCSV(userFilterSelections) {
      var url = new URL(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/sku/inventories/downloadcsv');
      var params = {};
      if (userFilterSelections) {
        params.accountName = userFilterSelections.account;
        params.fromSkuId = userFilterSelections.sku.desde;
        params.toSkuId = userFilterSelections.sku.hasta;
        params.fromUpc = userFilterSelections.upc.desde;
        params.toUpc = userFilterSelections.upc.hasta;
        params.categoryId = userFilterSelections.category.id;
        params.fromQuantity = userFilterSelections.fromQuantity;
        params.toQuantity = userFilterSelections.toQuantity;
        params.fromDate = userFilterSelections.fecha.desde;
        params.toDate = userFilterSelections.fecha.hasta;
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
        if (params[key] !== null) {
          url.searchParams.append(key, params[key]);
        }
      });

      return this.$http.get(url.href, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          Accept: 'application/octet-stream; charset=ISO-8859-1'
        },
        responseType: 'arraybuffer'
      });
    },
    addInventoryCSV: function addInventoryCSV(csvInventoryFile, delimiter) {
      var formData = new FormData();
      formData.append('file', csvInventoryFile);
      return this.$http.post(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.API_END_POINT + '/sku/inventories/importcsv?delimiter=' + delimiter, formData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      });
    }
  }
};

/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb2ebec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__ = __webpack_require__(1042);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fb2ebec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolesCheckbox_vue__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d58160_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RolesCheckbox_vue__ = __webpack_require__(1041);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RolesCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d58160_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RolesCheckbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_session__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales_Lang__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js__);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_session___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  i18n: __WEBPACK_IMPORTED_MODULE_7__locales_Lang__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* router */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.interceptors.push(function (request, next) {
  next(function (response) {
    if (response.status === 401) {
      this.$session.destroy();
      sessionStorage.clear();
      this.$store.dispatch('logout');
      return __WEBPACK_IMPORTED_MODULE_3__router_index__["a" /* router */].go('/pages/login');
    }
  });
});

console.log('Version: ', __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default.a.VERSION);

/***/ }),
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */,
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(448);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(454)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(456);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(473);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(474);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(496);
function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(497);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(502);
function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(503);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052ef8a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(522);
function injectStyle (ssrContext) {
  __webpack_require__(519)
  __webpack_require__(520)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_052ef8a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_DashboardView__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_OrdersView__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_OrderDetailsView__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_NewProductView__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_ActivableProductsView__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_ProductDetailView__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Pages_Login__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Pages_Page404__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Pages_Page500__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_PunishmentComponentView__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_LiquidationsComponentView__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_AddMasiveProductsComponentView__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_ChangePricesByCSVView__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_InventoryView__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_ReportsView__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_incidents_IncidentsView__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_UserAdminView__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_ProfileView__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_OrganizationsView__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_CarriersView__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_ShippingGratesView__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_AddPricesCSVView__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_CategoryAndBrandUpdaterView__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_AttributesUpdaterView__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_promotion_PromoList__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_NoticesView__ = __webpack_require__(1104);
































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/pages',
    redirect: '/pages/login',
    name: 'Pages',
    component: {
      render: function render(c) {
        return c('router-view');
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: __WEBPACK_IMPORTED_MODULE_10__views_Pages_Page404__["a" /* default */]
    }, {
      path: '500',
      name: 'Page500',
      component: __WEBPACK_IMPORTED_MODULE_11__views_Pages_Page500__["a" /* default */]
    }, {
      path: 'login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_9__views_Pages_Login__["a" /* default */]
    }]
  }, {
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_3__views_DashboardView__["a" /* default */]
    }]
  }, {
    path: '/orders',
    redirect: 'orders/list',
    name: 'Ventas',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'list',
      name: 'Ordenes',
      component: __WEBPACK_IMPORTED_MODULE_4__views_OrdersView__["a" /* default */]
    }, {
      path: 'addPunishmentCSV',
      name: 'Alta de Penalizaciones por CSV',
      component: __WEBPACK_IMPORTED_MODULE_12__views_PunishmentComponentView__["a" /* default */]
    }, {
      path: 'addLiquidationsCSV',
      name: 'Alta de Liquidacion por CSV',
      component: __WEBPACK_IMPORTED_MODULE_13__views_LiquidationsComponentView__["a" /* default */]
    }, {
      path: 'orderDetail/:orderId',
      name: 'Ordenes / Detalle',
      component: __WEBPACK_IMPORTED_MODULE_5__views_OrderDetailsView__["a" /* default */],
      props: true
    }]
  }, {
    path: '/catalog',
    redirect: '/catalog/list',
    name: 'Catálogo',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'new',
      name: 'Nuevo producto',
      component: __WEBPACK_IMPORTED_MODULE_6__views_NewProductView__["a" /* default */]
    }, {
      path: 'promotions',
      name: 'Promociones',
      component: __WEBPACK_IMPORTED_MODULE_27__components_promotion_PromoList__["a" /* default */]
    }, {
      path: 'list',
      name: 'Administrar Productos',
      component: __WEBPACK_IMPORTED_MODULE_7__views_ActivableProductsView__["a" /* default */]
    }, {
      path: 'details/:productId',
      name: 'Detalle',
      component: __WEBPACK_IMPORTED_MODULE_8__views_ProductDetailView__["a" /* default */],
      props: true
    }, {
      path: 'addProductsCSV',
      name: 'Alta masiva de productos',
      component: __WEBPACK_IMPORTED_MODULE_14__views_AddMasiveProductsComponentView__["a" /* default */]
    }, {
      path: 'changePricesCSV',
      name: 'Editar precios por CSV',
      component: __WEBPACK_IMPORTED_MODULE_15__views_ChangePricesByCSVView__["a" /* default */]
    }]
  }, {
    path: '/inventory',
    redirect: '/inventory/list',
    name: 'Inventario',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'list',
      name: 'Administrar Inventario',
      component: __WEBPACK_IMPORTED_MODULE_16__views_InventoryView__["a" /* default */]
    }]
  }, {
    path: '/carriers',
    redirect: '/carriers/carrierList',
    name: 'Gestión de envíos',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'carrierList',
      name: 'Transportadoras',
      component: __WEBPACK_IMPORTED_MODULE_22__views_CarriersView__["a" /* default */]
    }, {
      path: 'priceList',
      name: 'Precios',
      component: __WEBPACK_IMPORTED_MODULE_23__views_ShippingGratesView__["a" /* default */]
    }, {
      path: 'addPricesCSV',
      name: 'Alta masiva de Precios de Transportadoras',
      component: __WEBPACK_IMPORTED_MODULE_24__views_AddPricesCSVView__["a" /* default */]
    }]
  }, {
    path: '/incidents',
    redirect: '/incidents/list',
    name: 'Incidencias',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'list',
      name: 'Manejo de incidencias',
      component: __WEBPACK_IMPORTED_MODULE_18__views_incidents_IncidentsView__["a" /* default */]
    }]
  }, {
    path: '/reports',
    redirect: '/reports/list',
    name: 'Reportes',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'list',
      name: 'Ver Reportes',
      component: __WEBPACK_IMPORTED_MODULE_17__views_ReportsView__["a" /* default */]
    }]
  }, {
    path: '/admin',
    redirect: '/admin/users',
    name: 'Administración',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'users',
      name: 'Usuarios',
      component: __WEBPACK_IMPORTED_MODULE_19__views_UserAdminView__["a" /* default */]
    }, {
      path: 'sellers',
      name: 'Sellers',
      component: __WEBPACK_IMPORTED_MODULE_21__views_OrganizationsView__["a" /* default */]
    }, {
      path: 'notices',
      name: 'Avisos',
      component: __WEBPACK_IMPORTED_MODULE_28__views_NoticesView__["a" /* default */]
    }]
  }, {
    path: '/profile',
    redirect: '/profile/me',
    name: 'Perfil',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'me',
      name: 'Usuario',
      component: __WEBPACK_IMPORTED_MODULE_20__views_ProfileView__["a" /* default */]
    }]
  }, {
    path: '/updates',
    name: 'Actualizaciones',
    redirect: '/updates/catalogAndBrand',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'catalogAndBrand',
      name: 'Categorias y Marcas',
      component: __WEBPACK_IMPORTED_MODULE_25__views_CategoryAndBrandUpdaterView__["a" /* default */]
    }, {
      path: 'attributes',
      name: 'Atributos',
      component: __WEBPACK_IMPORTED_MODULE_26__views_AttributesUpdaterView__["a" /* default */]
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.name !== 'Login' && (sessionStorage.getItem('vue-session-key') === null || sessionStorage.getItem('vue-session-key') === '{}')) {
    next('/pages/login');
  } else {
    next();
  }
});

/***/ }),
/* 524 */,
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7055c44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(526)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7055c44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(529);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items(this.$store.getters.signedRoles)
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasAdminRoles = function hasAdminRoles(roles) {
  return roles.includes('ADMIN_USER') || roles.includes('STANDARD_USER');
};

var VentasItems = function VentasItems(roles) {
  var ORDER_LIST_ITEM = {
    name: 'Ordenes',
    url: '/orders/list',
    icon: 'fa fa-shopping-bag'
  };


  var result = [ORDER_LIST_ITEM];

  return result;
};

var CatalogItems = function CatalogItems(roles) {
  var PRODUCT_MANAGEMENT_ITEM = {
    name: 'Administrar Productos',
    url: '/catalog/list',
    icon: 'fa fa-list-alt'
  };
  var PRODUCT_CREATION_ITEM = {
    name: 'Alta manual de Productos',
    url: '/catalog/new',
    icon: 'fa fa-list-alt'
  };
  var MASIVE_PRODUCT_CREATION_ITEM = {
    name: 'Alta masiva de Productos',
    url: '/catalog/addProductsCSV',
    icon: 'fa fa-list-alt'
  };
  var MASIVE_UPDATE_PRICES_ITEM = {
    name: 'Actualización masiva de Precios',
    url: '/catalog/changePricesCSV',
    icon: 'fa fa-list-alt'
  };
  var INVENTORY_LIST_ITEM = {
    name: 'Administrar Inventario',
    url: '/inventory/list',
    icon: 'fa fa-list-alt'
  };
  var PROMOTIONS = {
    name: 'Promociones',
    url: '/catalog/promotions',
    icon: 'fa fa-tags'
  };
  var response = [PRODUCT_MANAGEMENT_ITEM];
  if (!hasAdminRoles(roles)) {
    response = response.concat([PRODUCT_CREATION_ITEM, MASIVE_PRODUCT_CREATION_ITEM, MASIVE_UPDATE_PRICES_ITEM, INVENTORY_LIST_ITEM, PROMOTIONS]);
  } else {
    response = response.concat([PROMOTIONS]);
  }
  return response;
};

var AdminItems = function AdminItems(roles) {
  var USER_LIST_ITEM = {
    name: 'Usuarios',
    url: '/admin/users',
    icon: 'fa fa-list-alt'
  };
  var SELLER_LIST_ITEM = {
    name: 'Sellers',
    url: '/admin/sellers',
    icon: 'fa fa-list-alt'
  };
  var NOTICES_ITEM = {
    name: 'Avisos',
    url: '/admin/notices',
    icon: 'fa fa-list-alt'
  };
  var response = [USER_LIST_ITEM];
  if (roles.includes('ADMIN_USER')) {
    response = response.concat([SELLER_LIST_ITEM, NOTICES_ITEM]);
  }

  return response;
};

var CarrierItems = function CarrierItems(roles) {
  var CARRIER_LIST_ITEM = {
    name: 'Transportadoras',
    url: '/carriers/carrierList',
    icon: 'fa fa-list-alt'
  };
  var PRICE_LIST_ITEM = {
    name: 'Precios',
    url: '/carriers/priceList',
    icon: 'fa fa-list-alt'
  };
  var MASIVE_PRICE_LIST_ITEM = {
    name: 'Alta masiva de Precios de Transportadoras',
    url: '/carriers/addPricesCSV',
    icon: 'fa fa-list-alt'
  };
  return [CARRIER_LIST_ITEM, PRICE_LIST_ITEM, MASIVE_PRICE_LIST_ITEM];
};

var UpdateItems = function UpdateItems(roles) {
  var BRAND_CATEOGIES_ITEM = {
    name: 'Catalogo y Marcas',
    url: '/updates/catalogAndBrand',
    icon: 'fa fa-list-alt'
  };
  var ATTRIBUTES_ITEM = {
    name: 'Atributos',
    url: '/updates/attributes',
    icon: 'fa fa-list-alt'
  };
  return [BRAND_CATEOGIES_ITEM, ATTRIBUTES_ITEM];
};

/* harmony default export */ __webpack_exports__["a"] = ({
  items: function items(roles) {
    var DASHBOARD_NAV = {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'fa fa-tachometer-alt'
    };
    var ORDERS_NAV = {
      name: 'Ventas',
      url: '/orders/',
      icon: 'fa fa-shopping-bag',
      children: VentasItems(roles)
    };
    var CATALOG_NAV = {
      name: 'Catálogo',
      url: '/catalog',
      icon: 'fa fa-list-alt',
      children: CatalogItems(roles)
    };
    var REPORTS_NAV = {
      name: 'Reportes',
      url: '/reports',
      icon: 'fa fa-list-alt'
    };
    var INCIDENTS_NAV = {
      name: 'Incidencias',
      url: '/incidents',
      icon: 'fa fa-bug'
    };
    var USERS_NAV = {
      name: 'Administración',
      url: '/admin',
      icon: 'fa fa-list-alt',
      children: AdminItems(roles)
    };
    var CARRIERS_NAV = {
      name: 'Gestión de envíos',
      url: '/carriers',
      icon: 'fa fa-list-alt',
      children: CarrierItems(roles)
    };
    var UPDATES = {
      name: 'Actualizaciónes',
      url: '/updates',
      icon: 'fa fa-list-alt',
      children: UpdateItems(roles)
    };

    var result = [DASHBOARD_NAV];
    if (roles.includes('ORDERS_USER')) result.push(ORDERS_NAV);
    if (roles.includes('CATALOG_USER')) result.push(CATALOG_NAV);
    if (roles.includes('CARRIERS_USER')) result.push(CARRIERS_NAV);
    if (roles.includes('REPORTS_USER')) result.push(REPORTS_NAV);
    result.push(INCIDENTS_NAV);
    if (roles.includes('ADMIN_USER') || roles.includes('ORGANIZATION_ADMIN_USER')) result.push(USERS_NAV);
    if (roles.includes('ADMIN_USER')) result.push(UPDATES);

    return result;
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2c0f710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(532);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2c0f710_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside'
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ecb27a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(535);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ecb27a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.$t(_vm.showName(item))))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.$t(_vm.showName(item))))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1febee05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(538);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1febee05_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ef7068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(541);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ef7068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer',
  data: function data() {
    return {
      currentDate: new Date()
    };
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"target":"blank","href":"https://www.infracommerce.lat"}},[_vm._v("Infracommerce")]),_vm._v(" © "+_vm._s(_vm.currentDate.getFullYear())+".")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25078514_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(596);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25078514_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notifications_Notifications_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderDropdownAccnt_vue__ = __webpack_require__(592);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  components: {
    HeaderDropdownAccnt: __WEBPACK_IMPORTED_MODULE_1__HeaderDropdownAccnt_vue__["a" /* default */],
    HeaderNotifications: __WEBPACK_IMPORTED_MODULE_0__Notifications_Notifications_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364bc2a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__(591);
function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364bc2a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Notification_timeCard_vue__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_NotificationServiceMixim_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading__);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderNotifications',
  components: {
    NotificationsTimeCard: __WEBPACK_IMPORTED_MODULE_2__Notification_timeCard_vue__["a" /* default */],
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_4_vue_infinite_loading___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_NotificationServiceMixim_js__["a" /* NotificationServiceMixim */]],
  data: function data() {
    return {
      loading: false,
      majorNumberAllowed: 10,
      params: { from: 0, size: 10 }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['notifications'])),
  mounted: function mounted() {
    this.getAllNotifications();
    this.getUnreadNotifications();
  },

  methods: {
    getAllNotifications: function getAllNotifications() {
      var _this = this;

      this.loading = true;
      this.getNotifications(this.params).then(function (response) {
        if (response.body !== null) {
          _this.$store.dispatch('setNotifications', response.body);
        }
        _this.loading = false;
      }, function (error) {
        console.log(error);
        _this.loading = false;
      });
    },
    getUnreadNotifications: function getUnreadNotifications() {
      var _this2 = this;

      this.loading = true;
      this.getNotifications(this.params, true).then(function (response) {
        if (response.body !== null) {
          var totalCount = parseInt(response.headers.get('X-Total-Count'));
          _this2.$store.dispatch('setNewNotifications', totalCount);
        }
        _this2.loading = false;
      }, function (error) {
        console.log(error);
        _this2.loading = false;
      });
    },
    markAllAsReaded: function markAllAsReaded() {
      var _this3 = this;

      if (this.notifications.actives === 0) return;
      this.loading = true;
      this.markNotificationsAllReaded().then(function (response) {
        _this3.$store.dispatch('setNotifications', _this3.notifications.items.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { read: true });
        }));
        _this3.getUnreadNotifications();
        _this3.loading = false;
      }, function (error) {
        console.log(error);
        _this3.loading = false;
      });
    },
    markAsReaded: function markAsReaded(id) {
      var _this4 = this;

      this.loading = true;
      this.markNotificationRead(id).then(function (response) {
        _this4.loading = false;
        _this4.getUnreadNotifications();
        _this4.$store.dispatch('markAsReaded', id);
      }, function (error) {
        console.log(error);
        _this4.loading = false;
      });
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this5 = this;

      this.loading = true;
      this.params.from += 1;
      this.getNotifications(this.params).then(function (response) {
        if (response.body && response.body.length && response.body !== null) {
          _this5.$store.dispatch('pushNotifications', response.body).then(function (success) {
            $state.loaded();
          });
        } else {
          $state.complete();
        }
        _this5.loading = false;
      }, function (error) {
        console.log(error);
        _this5.loading = false;
      });
    },
    hideNotifications: function hideNotifications() {
      this.$refs.notificationDropdown.hide();
    }
  }
});

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_timeCard_vue__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245f2e0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_timeCard_vue__ = __webpack_require__(581);
function injectStyle (ssrContext) {
  __webpack_require__(554)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_timeCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245f2e0c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_timeCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim_js__ = __webpack_require__(14);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotificationsTimeCard',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  data: function data() {
    return {};
  },

  props: ['notification'],
  methods: {
    routeFor: function routeFor(notification) {
      if (!notification.read) this.markLikeReaded(notification.id);

      if (notification.text.includes('pedido:') || notification.text.includes('Promocion:') || notification.text.includes('Incidencia:') || notification.text.includes('Incidencia cerrada:') || notification.text.includes('devolución:') || notification.text.includes('devuelto:')) {
        this.routeTo(notification);
        return;
      }
      if (notification.text.includes('sku:') || notification.text.includes('producto:')) {
        this.routeToSku(notification);
        return;
      }

      this.$emit('hideNotify');
    },
    markLikeReaded: function markLikeReaded(id) {
      this.$emit('markRead', id);
    },
    setupTitleForType: function setupTitleForType(value) {
      switch (value) {
        case 'CHANGE_ORDER_STATE_HANDLER':
          return this.$t('Cambio de estado de pedido');
        case 'LOW_SKU_INVENTARY':
          return this.$t('Inventario de sku bajo');
        case 'COMMERCIAL_CONDITION_COMMISSION':
          return this.$t('Comercial');
        case 'CREATE_NEW_CONTROVERSY':
          return this.$t('Controversia');
        case 'CREATE_NEW_INCIDENCE':
          return this.$t('Incidencia');
        case 'CHANGE_ORDER_STATE_RETURN':
          return this.$t('Devolución');
        case 'CHANGE_ORDER_STATE_PARTIAL_RETURN':
          return this.$t('Devolución parcial');
      }
    },
    routeTo: function routeTo(reference) {
      var route = '';
      if (reference.text.indexOf('pedido:') !== -1) route = '/orders/orderDetail/' + reference.reference;
      if (reference.text.indexOf('producto:') !== -1) route = '/catalog/details/' + reference.reference;
      if (reference.text.indexOf('Incidencia:') !== -1) route = '/incidents/list?ref=' + reference.reference;
      if (reference.text.indexOf('Incidencia cerrada:') !== -1) route = '/incidents/list?ref=' + reference.reference;
      if (reference.text.indexOf('devolución:') !== -1) route = '/orders/orderDetail/' + reference.reference;
      if (reference.text.indexOf('devuelto:') !== -1) route = '/orders/orderDetail/' + reference.reference;
      if (reference.text.indexOf('Promocion:') !== -1) {
        this.routeToPromo(reference);
        return;
      }
      if (!reference.read) this.markLikeReaded(reference.id);
      this.$router.push({ path: route }).catch(function () {});
      this.$emit('hideNotify');
    },
    routeToSku: function routeToSku(reference) {
      var _this = this;

      if (reference.text.indexOf('sku:') !== -1 || reference.text.indexOf('producto:') !== -1) {
        var filter = {
          sku: { desde: null, hasta: null },
          upc: { desde: null, hasta: null },
          fecha: { desde: null, hasta: null },
          category: { id: null, text: null },
          fromQuantity: null,
          toQuantity: null,
          account: null,
          text: reference.reference
        };
        var tableFilterInfo = { currentPage: 1, perPage: 2 };
        this.getProducts(tableFilterInfo, filter).then(function (response) {
          if (response.body && response.body[0] && response.body[0].id) {
            if (!reference.read) _this.markLikeReaded(reference.id);
            _this.$router.push({
              path: '/catalog/details/' + response.body[0].id,
              query: {
                sku: reference.reference
              }
            }).catch(function () {});
            _this.$emit('hideNotify');
          }
        }, function (error) {
          console.log(error);
          return [];
        });
      }
    },
    routeToPromo: function routeToPromo(reference) {
      if (!reference.read) this.markLikeReaded(reference.id);
      this.$router.push({ path: '/catalog/promotions', query: { promo: reference.reference } }).catch(function () {});
      this.$emit('hideNotify');
    }
  }
});

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */
/***/ (function(module, exports) {

module.exports = {"name":"@genesisui/vue","version":"2.0.0","description":"Bootstrap 4 Admin Template","author":"Łukasz Holeczek","homepage":"https://genesisui.com","copyright":"Copyright 2017 creativeLabs Łukasz Holeczek","license":"https://genesisui.com/license.html","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","lintFix":"eslint --fix --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"big.js":"^5.2.2","boostrap":"^2.0.0","bootstrap":"4.0.0-beta.2","bootstrap-vue":"^1.5.1","chart.js":"2.7.1","font-awesome":"^4.7.0","mini-toastr":"0.6.6","papaparse":"^4.6.2","sass":"^1.10.3","simple-line-icons":"^2.4.1","text-mask-addons":"3.7.1","v-treeview":"^0.1.4","vue":"2.5.9","vue-bootstrap-datetimepicker":"^4.1.4","vue-chartjs":"3.0.2","vue-codemirror":"3.1.8","vue-i18n":"^8.17.7","vue-infinite-loading":"^2.4.5","vue-input-tag":"^2.0.7","vue-multiselect":"^2.0.8","vue-notifications":"0.9.0","vue-picture-input":"^2.1.6","vue-quill-editor":"2.3.3","vue-resource":"^1.5.1","vue-router":"3.0.1","vue-scrollto":"^2.11.0","vue-select":"2.3.0","vue-session":"^1.0.0","vue-spinner":"^1.0.3","vue-text-mask":"5.2.0","vue2-datepicker":"^3.6.0","vue2-editor":"^2.10.2","vue2-google-maps":"0.8.4","vuetable":"^1.5.12","vuex":"^3.0.1","vuex-persistedstate":"^2.5.4","xlsx":"^0.14.1"},"devDependencies":{"autoprefixer":"7.2.1","babel-core":"6.26.0","babel-eslint":"8.0.3","babel-loader":"7.1.2","babel-plugin-istanbul":"4.1.5","babel-plugin-transform-runtime":"6.23.0","babel-preset-env":"1.6.1","babel-preset-stage-2":"6.24.1","babel-register":"6.26.0","chai":"4.1.2","chalk":"2.3.0","chromedriver":"2.33.2","connect-history-api-fallback":"1.5.0","copy-webpack-plugin":"4.2.3","cross-env":"5.1.1","cross-spawn":"5.1.0","css-loader":"0.28.7","dotenv":"^8.2.0","eslint":"4.12.1","eslint-config-standard":"10.2.1","eslint-friendly-formatter":"3.0.0","eslint-loader":"1.9.0","eslint-plugin-html":"4.0.1","eslint-plugin-import":"2.8.0","eslint-plugin-node":"5.2.1","eslint-plugin-promise":"3.6.0","eslint-plugin-standard":"3.0.1","eventsource-polyfill":"0.9.6","express":"4.16.2","extract-text-webpack-plugin":"3.0.2","file-loader":"1.1.5","friendly-errors-webpack-plugin":"1.6.1","html-webpack-plugin":"2.30.1","http-proxy-middleware":"0.17.4","inject-loader":"3.0.1","karma":"1.7.1","karma-coverage":"1.1.1","karma-mocha":"1.3.0","karma-phantomjs-launcher":"1.0.4","karma-phantomjs-shim":"1.5.0","karma-sinon-chai":"1.3.3","karma-sourcemap-loader":"0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"2.0.6","lolex":"2.3.1","mocha":"4.0.1","nightwatch":"0.9.19","node-sass":"^4.14.1","opn":"5.1.0","optimize-css-assets-webpack-plugin":"3.2.0","ora":"1.3.0","phantomjs-prebuilt":"2.1.16","rimraf":"2.6.2","sass-loader":"6.0.6","selenium-server":"3.8.1","semver":"5.4.1","shelljs":"0.7.8","sinon":"4.1.2","sinon-chai":"2.14.0","url-loader":"0.6.2","vue-image-zoom":"^1.0.5","vue-loader":"13.5.0","vue-style-loader":"3.0.3","vue-template-compiler":"2.5.9","webpack":"3.10.0","webpack-bundle-analyzer":"2.9.1","webpack-dev-middleware":"1.12.2","webpack-hot-middleware":"2.21.0","webpack-merge":"4.1.1"},"engines":{"node":">= 6.4.0","npm":">= 5.0.0"}}

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"notification-card",class:{ 'unread': !_vm.notification.read },on:{"click":function($event){$event.stopPropagation();_vm.routeFor(_vm.notification)}}},[_c('div',{staticClass:"notification-card--dot-indicator"}),_vm._v(" "),_c('div',{staticClass:"notification-card--content"},[_c('div',{staticClass:"notification-card--content-header"},[_c('h3',{staticClass:"notification-card--content-header-title"},[_vm._v(_vm._s(_vm.setupTitleForType(_vm.notification.type)))]),_vm._v(" "),_c('span',{staticClass:"notification-card--content-header-time"},[_vm._v(_vm._s(new Date(_vm.notification.creationDate).toLocaleDateString()))])]),_vm._v(" "),_c('p',{staticClass:"notification-card--content-text"},[_vm._v(_vm._s(_vm.notification.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"notifications"},[_c('b-nav-item-dropdown',{ref:"notificationDropdown",attrs:{"right":"","no-caret":"","toggle-class":"notifications--dropdown-as-btn"}},[_c('template',{staticClass:"image-dropdown",slot:"button-content"},[_c('button',{staticClass:"notifications--btn"},[(_vm.notifications.actives >= 1)?_c('div',{staticClass:"notifications--count"},[_vm._v("\n                "+_vm._s(_vm.notifications.actives >= _vm.majorNumberAllowed ? ((_vm.majorNumberAllowed-1) + "+") : _vm.notifications.actives)+"\n              ")]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"notifications--bell icon-bell"})])]),_vm._v(" "),_c('section',{staticClass:"notifications--dropdown"},[_c('header',{staticClass:"notifications--header"},[_c('div',{staticClass:"notifications--header-title"},[_vm._v(_vm._s(_vm.$t('Notificaciones')))]),_vm._v(" "),_c('button',{staticClass:"notifications--read-all",class:{'disabled': _vm.notifications.actives == 0 || _vm.loading },on:{"click":_vm.markAllAsReaded}},[_c('i',{staticClass:"fa fa-check mr-1"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.notifications.actives == 0 ? _vm.$t('Todas leídas') : _vm.$t('Marcar todas como leídas')))])])]),_vm._v(" "),(_vm.notifications.items.length >= 1)?_c('section',{staticClass:"notifications--list"},[_vm._l((_vm.notifications.items),function(notification){return _c('NotificationsTimeCard',{key:notification.id,attrs:{"notification":notification},on:{"markRead":_vm.markAsReaded,"hideNotify":_vm.hideNotifications}})}),_vm._v(" "),_c('infinite-loading',{ref:"InfiniteLoading",attrs:{"force-use-infinite-wrapper":".notifications-body","distance":0},on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"})])],2):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"notifications--footer"},[(_vm.loading)?_c('div',[_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw mr-1"}),_vm._v("\n          "+_vm._s(_vm.$t('Cargando...'))+"\n        ")]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.notifications.actives == 0)?_c('span',[_vm._v(_vm._s(_vm.$t('No hay nuevas notificaciones')))]):_vm._e(),_vm._v(" "),(!_vm.loading && _vm.notifications.actives > 0)?_c('span',[_vm._v("\n          "+_vm._s(_vm.notifications.actives)+" "+_vm._s(_vm.notifications.actives === 1 ? _vm.$t('Nueva notificación') : _vm.$t('Nuevas notificaciones'))+"\n        ")]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f860da2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f860da2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdownAccnt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown-accnt',
  data: function data() {
    return {
      itemsCount: 42
    };
  },
  computed: {
    userText: function userText() {
      return this.$store.state.user_data.firstName + ' ' + this.$store.state.user_data.lastName;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isAdminSeller: function isAdminSeller() {
      return this.$store.getters.isAdminSeller;
    }
  },
  methods: {
    logout: function logout() {
      this.$session.destroy();
      this.$store.dispatch('logout');
      this.$router.push('/pages/login');
    }
  }
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":"","toggle-class":"user-main-navbar"}},[_c('template',{slot:"button-content"},[_c('div',{staticClass:"userName"},[(_vm.isAdmin || _vm.isAdminSeller)?_c('b',{staticClass:"mr-2 adminAdvice"},[_vm._v("(Administrador)")]):_vm._e(),_vm._v(_vm._s(_vm.userText))]),_vm._v(" "),_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/user.png","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.$router.push('/profile/me')}}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Ver perfil")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-sign-out-alt"}),_vm._v(" Logout")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('HeaderDropdownAccnt'),_vm._v(" "),_c('HeaderNotifications',{staticClass:"mr-3"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8354ae2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8354ae2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__ = __webpack_require__(629);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */],
    SidebarNavLabel: __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d4fc96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(602);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d4fc96_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b81d956_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(605);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b81d956_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da48d316_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(608);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da48d316_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061be4a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(611);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061be4a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40823042_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(618);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40823042_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28fddf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(621);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a28fddf_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b32fdaa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b32fdaa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b22683d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__ = __webpack_require__(631);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b22683d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__ = __webpack_require__(183);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-label',
  components: {
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'fa fa-circle'
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      var classes = {
        navItem: ['hidden-cn'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getClasses(this.classes))).join(' '),
        navLink: 'nav-label',
        icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
      };
      return classes;
    }
  },
  methods: {
    getClasses: function getClasses(classes) {
      return classes ? classes.split(' ') : [];
    }
  }
});

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":_vm.$t(item.name),"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:(item.label)?[_c('SidebarNavLabel',{attrs:{"name":_vm.$t(item.name),"url":item.url,"icon":item.icon,"label":item.label,"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":_vm.$t(item.name),"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":_vm.$t(childL1.name),"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":_vm.$t(childL2.name),"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":_vm.$t(childL1.name),"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":_vm.$t(item.name),"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7d3eee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(635);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7d3eee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    name: {
      default: 'default'
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    inputType: {
      type: String,
      default: 'radio'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked ? 'checked' : '';
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":_vm.inputType,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main",class:_vm.isAdmin ? 'admin' : ''},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardView_vue__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e487292_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardView_vue__ = __webpack_require__(725);
function injectStyle (ssrContext) {
  __webpack_require__(638)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e487292"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e487292_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dashboard_OrdersReport__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_dashboard_MainLineChart__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_dashboard_MainPieChart__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixims_UserServiceMixim_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js__);













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard-view',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_8__mixims_UserServiceMixim_js__["a" /* UserServiceMixim */]],
  components: {
    OrdersReport: __WEBPACK_IMPORTED_MODULE_3__components_dashboard_OrdersReport__["a" /* default */],
    MainLineChart: __WEBPACK_IMPORTED_MODULE_4__components_dashboard_MainLineChart__["a" /* default */],
    MainPieChart: __WEBPACK_IMPORTED_MODULE_5__components_dashboard_MainPieChart__["a" /* default */],
    MoonLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  watch: {
    fromDate: function fromDate(val, oldVal) {
      if (this.muted || this.invalidDateFrom !== '' || this.invalidDateTo !== '') return;
      this._getGraphData();
      this._getStatusstatistics();
    },
    toDate: function toDate(val, oldVal) {
      if (this.muted || this.invalidDateTo !== '') return;
      this._getGraphData();
      this._getStatusstatistics();
    },
    account: function account(val, oldVal) {
      this._getGraphData();
      this._getStatusstatistics();
    }
  },
  data: function data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      props: ['graph'],
      datePickerConfig1: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        icons: {
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right'
        }
      },
      datePickerConfig2: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        icons: {
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right'
        }
      },
      fromDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toISOString().split('T')[0],
      toDate: new Date().toISOString().split('T')[0],
      account: null,
      locale: __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js___default.a.LOCALE,
      inactivityTime: __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js___default.a.INACTIVITY_PERMITED_TIME,
      errorText: '',
      totalPedidos: null,
      loading: false,
      muted: true,
      ordeStatus: '',
      cardStatistics: {
        readyForHandling: 0,
        paymentPending: 0,
        invoiced: 0,
        delivered: 0,
        canceled: 0,
        controversy: 0,
        incidence: 0,
        handling: 0
      },
      lines: {
        labels: [],
        datasets: [{
          label: this.$t('Ordenes creadas'),
          data: [],
          backgroundColor: 'rgba(0, 255, 17, 0.2)',
          pointBackgroundColor: 'white',
          borderWidth: 2,
          borderColor: 'rgba(0, 255, 17, 1)',
          pointBorderColor: 'rgba(0, 255, 17, 0)'
        }]
      },
      pie: {
        labels: [],
        datasets: [{
          label: this.$t('Estado de ordenes'),
          data: [],
          backgroundColor: [],
          hoverBackgroundColor: [],
          borderColor: 'rgba(255, 255, 255, 1)',
          hoverBorderColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 2
        }]
      }
    };
  },

  computed: {
    organizations: function organizations() {
      return this.$store.getters.organizations;
    },
    invalidDateTo: function invalidDateTo() {
      if (this.toDate) {
        var tDate = new Date(this.toDate);
        if (tDate > new Date()) {
          return this.$t('La fecha seleccionada es mayor al día de hoy');
        }
        if (this.fromDate) {
          var fDate = new Date(this.fromDate);
          return fDate > tDate ? this.$t('La fecha final es menor a la fecha inicial') : '';
        }
      }
      return '';
    },
    invalidDateFrom: function invalidDateFrom() {
      if (this.fromDate) {
        var fDate = new Date(this.fromDate);
        if (fDate > new Date()) {
          return this.$t('La fecha seleccionada es mayor al día de hoy');
        }
      }
      return '';
    }
  },
  methods: {
    startTimer: function startTimer() {
      window.timeoutId = window.setTimeout(this.doInactive, this.inactivityTime);
    },
    resetTimer: function resetTimer() {
      window.clearTimeout(window.timeoutId);
      this.startTimer();
    },
    doInactive: function doInactive() {
      this.$session.destroy();
      sessionStorage.clear();
      this.$store.dispatch('logout');
      return this.$router.go('/pages/login');
    },
    setupTimers: function setupTimers() {
      document.addEventListener('mousemove', this.resetTimer, false);
      document.addEventListener('mousedown', this.resetTimer, false);
      document.addEventListener('keypress', this.resetTimer, false);
      document.addEventListener('touchmove', this.resetTimer, false);
      this.startTimer();
    },
    changeOrderStatus: function changeOrderStatus(ordeStatus) {
      this.ordeStatus = ordeStatus;
      this.$refs.ordersReport.changeStatusExternally(ordeStatus);
    },
    setTotal: function setTotal(total) {
      this.totalPedidos = total;
    },
    showError: function showError(errorText) {
      this.errorText = errorText;
    },
    _getStatusstatistics: function _getStatusstatistics() {
      var _this = this;

      this.getStatusstatistics(this.account, this.fromDate, this.toDate).then(function (data) {
        _this.loading = false;
        _this.pie.datasets[0].data.splice(0, _this.pie.datasets[0].data.length);
        _this.pie.labels = [];

        _this.cardStatistics.readyForHandling = 0;
        _this.cardStatistics.paymentPending = 0;
        _this.cardStatistics.invoiced = 0;
        _this.cardStatistics.delivered = 0;
        _this.cardStatistics.canceled = 0;
        _this.cardStatistics.controversy = 0;
        _this.cardStatistics.incidence = 0;
        _this.cardStatistics.handling = 0;

        data.body.forEach(function (item) {
          _this.cardStatistics[_this._camelize(item.key)] = item.count;
        });
        _this.pie.labels.push(_this.$t('Entregada'));
        _this.pie.datasets[0].data.push(_this.cardStatistics['delivered']);
        _this.pie.datasets[0].backgroundColor.push('rgba(254, 208, 22, 0.2)');
        _this.pie.datasets[0].hoverBackgroundColor.push('rgba(254, 208, 22, 0.6)');

        _this.pie.labels.push(_this.$t('Cancelada'));
        _this.pie.datasets[0].data.push(_this.cardStatistics['canceled']);
        _this.pie.datasets[0].backgroundColor.push('rgba(252, 45, 22, 0.2)');
        _this.pie.datasets[0].hoverBackgroundColor.push('rgba(252, 45, 22, 0.6)');

        _this.pie.labels.push(_this.$t('Para envío'));
        _this.pie.datasets[0].data.push(_this.cardStatistics['handling']);
        _this.pie.datasets[0].backgroundColor.push('rgba(0, 255, 17, 0.2)');
        _this.pie.datasets[0].hoverBackgroundColor.push('rgba(0, 255, 17, 0.6)');

        _this.pie.labels.push(_this.$t('Enviada'));
        _this.pie.datasets[0].data.push(_this.cardStatistics['invoiced']);
        _this.pie.datasets[0].backgroundColor.push('rgba(149, 249, 191, 0.2)');
        _this.pie.datasets[0].hoverBackgroundColor.push('rgba(149, 249, 191, 0.6)');

        _this.pie.labels.push(_this.$t('No pagada'));
        _this.pie.datasets[0].data.push(_this.cardStatistics['paymentPending']);
        _this.pie.datasets[0].backgroundColor.push('rgba(22, 137, 252, 0.2)');
        _this.pie.datasets[0].hoverBackgroundColor.push('rgba(22, 137, 252, 0.6)');

        _this.pie.labels.push(_this.$t('Para manejo'));
        _this.pie.datasets[0].data.push(_this.cardStatistics['readyForHandling']);
        _this.pie.datasets[0].backgroundColor.push('rgba(225, 22, 252, 0.2)');
        _this.pie.datasets[0].hoverBackgroundColor.push('rgba(225, 22, 252, 0.6)');

        _this.$refs.graphPie.updateGraph();
      }, function (error) {
        _this.loading = false;
        _this.errorText = error.body.message || _this.$t('Error obteniendo las estadisticas');
      });
    },
    _getGraphData: function _getGraphData() {
      var _this2 = this;

      this.loading = true;
      this.intervalstatistics(this.account, this.fromDate, this.toDate).then(function (data) {
        _this2.lines.datasets[0].data.splice(0, _this2.lines.datasets[0].data.length);
        _this2.lines.labels = [];
        data.body.forEach(function (item) {
          _this2.lines.labels.push(new Date(item.key).toLocaleDateString(_this2.locale));
          _this2.lines.datasets[0].data.push(item.count);
        });
        _this2.$refs.graphLine.updateGraph();
      }, function (error) {
        _this2.errorText = error.body.message || _this2.$t('Error obteniendo las estadisticas');
      });
    },
    _camelize: function _camelize(str) {
      return str.replace(/\W+(.)/g, function (match, chr) {
        return chr.toUpperCase();
      });
    }
  },
  mounted: function mounted() {
    this._getStatusstatistics();
    this._getGraphData();

    this.muted = false;
  }
});

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 186,
	"./af.js": 186,
	"./ar": 187,
	"./ar-dz": 188,
	"./ar-dz.js": 188,
	"./ar-kw": 189,
	"./ar-kw.js": 189,
	"./ar-ly": 190,
	"./ar-ly.js": 190,
	"./ar-ma": 191,
	"./ar-ma.js": 191,
	"./ar-sa": 192,
	"./ar-sa.js": 192,
	"./ar-tn": 193,
	"./ar-tn.js": 193,
	"./ar.js": 187,
	"./az": 194,
	"./az.js": 194,
	"./be": 195,
	"./be.js": 195,
	"./bg": 196,
	"./bg.js": 196,
	"./bn": 197,
	"./bn.js": 197,
	"./bo": 198,
	"./bo.js": 198,
	"./br": 199,
	"./br.js": 199,
	"./bs": 200,
	"./bs.js": 200,
	"./ca": 201,
	"./ca.js": 201,
	"./cs": 202,
	"./cs.js": 202,
	"./cv": 203,
	"./cv.js": 203,
	"./cy": 204,
	"./cy.js": 204,
	"./da": 205,
	"./da.js": 205,
	"./de": 206,
	"./de-at": 207,
	"./de-at.js": 207,
	"./de-ch": 208,
	"./de-ch.js": 208,
	"./de.js": 206,
	"./dv": 209,
	"./dv.js": 209,
	"./el": 210,
	"./el.js": 210,
	"./en-au": 211,
	"./en-au.js": 211,
	"./en-ca": 212,
	"./en-ca.js": 212,
	"./en-gb": 213,
	"./en-gb.js": 213,
	"./en-ie": 214,
	"./en-ie.js": 214,
	"./en-nz": 215,
	"./en-nz.js": 215,
	"./eo": 216,
	"./eo.js": 216,
	"./es": 217,
	"./es-do": 218,
	"./es-do.js": 218,
	"./es.js": 217,
	"./et": 219,
	"./et.js": 219,
	"./eu": 220,
	"./eu.js": 220,
	"./fa": 221,
	"./fa.js": 221,
	"./fi": 222,
	"./fi.js": 222,
	"./fo": 223,
	"./fo.js": 223,
	"./fr": 224,
	"./fr-ca": 225,
	"./fr-ca.js": 225,
	"./fr-ch": 226,
	"./fr-ch.js": 226,
	"./fr.js": 224,
	"./fy": 227,
	"./fy.js": 227,
	"./gd": 228,
	"./gd.js": 228,
	"./gl": 229,
	"./gl.js": 229,
	"./gom-latn": 230,
	"./gom-latn.js": 230,
	"./he": 231,
	"./he.js": 231,
	"./hi": 232,
	"./hi.js": 232,
	"./hr": 233,
	"./hr.js": 233,
	"./hu": 234,
	"./hu.js": 234,
	"./hy-am": 235,
	"./hy-am.js": 235,
	"./id": 236,
	"./id.js": 236,
	"./is": 237,
	"./is.js": 237,
	"./it": 238,
	"./it.js": 238,
	"./ja": 239,
	"./ja.js": 239,
	"./jv": 240,
	"./jv.js": 240,
	"./ka": 241,
	"./ka.js": 241,
	"./kk": 242,
	"./kk.js": 242,
	"./km": 243,
	"./km.js": 243,
	"./kn": 244,
	"./kn.js": 244,
	"./ko": 245,
	"./ko.js": 245,
	"./ky": 246,
	"./ky.js": 246,
	"./lb": 247,
	"./lb.js": 247,
	"./lo": 248,
	"./lo.js": 248,
	"./lt": 249,
	"./lt.js": 249,
	"./lv": 250,
	"./lv.js": 250,
	"./me": 251,
	"./me.js": 251,
	"./mi": 252,
	"./mi.js": 252,
	"./mk": 253,
	"./mk.js": 253,
	"./ml": 254,
	"./ml.js": 254,
	"./mr": 255,
	"./mr.js": 255,
	"./ms": 256,
	"./ms-my": 257,
	"./ms-my.js": 257,
	"./ms.js": 256,
	"./my": 258,
	"./my.js": 258,
	"./nb": 259,
	"./nb.js": 259,
	"./ne": 260,
	"./ne.js": 260,
	"./nl": 261,
	"./nl-be": 262,
	"./nl-be.js": 262,
	"./nl.js": 261,
	"./nn": 263,
	"./nn.js": 263,
	"./pa-in": 264,
	"./pa-in.js": 264,
	"./pl": 265,
	"./pl.js": 265,
	"./pt": 266,
	"./pt-br": 267,
	"./pt-br.js": 267,
	"./pt.js": 266,
	"./ro": 268,
	"./ro.js": 268,
	"./ru": 269,
	"./ru.js": 269,
	"./sd": 270,
	"./sd.js": 270,
	"./se": 271,
	"./se.js": 271,
	"./si": 272,
	"./si.js": 272,
	"./sk": 273,
	"./sk.js": 273,
	"./sl": 274,
	"./sl.js": 274,
	"./sq": 275,
	"./sq.js": 275,
	"./sr": 276,
	"./sr-cyrl": 277,
	"./sr-cyrl.js": 277,
	"./sr.js": 276,
	"./ss": 278,
	"./ss.js": 278,
	"./sv": 279,
	"./sv.js": 279,
	"./sw": 280,
	"./sw.js": 280,
	"./ta": 281,
	"./ta.js": 281,
	"./te": 282,
	"./te.js": 282,
	"./tet": 283,
	"./tet.js": 283,
	"./th": 284,
	"./th.js": 284,
	"./tl-ph": 285,
	"./tl-ph.js": 285,
	"./tlh": 286,
	"./tlh.js": 286,
	"./tr": 287,
	"./tr.js": 287,
	"./tzl": 288,
	"./tzl.js": 288,
	"./tzm": 289,
	"./tzm-latn": 290,
	"./tzm-latn.js": 290,
	"./tzm.js": 289,
	"./uk": 291,
	"./uk.js": 291,
	"./ur": 292,
	"./ur.js": 292,
	"./uz": 293,
	"./uz-latn": 294,
	"./uz-latn.js": 294,
	"./uz.js": 293,
	"./vi": 295,
	"./vi.js": 295,
	"./x-pseudo": 296,
	"./x-pseudo.js": 296,
	"./yo": 297,
	"./yo.js": 297,
	"./zh-cn": 298,
	"./zh-cn.js": 298,
	"./zh-hk": 299,
	"./zh-hk.js": 299,
	"./zh-tw": 300,
	"./zh-tw.js": 300
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 640;

/***/ }),
/* 641 */,
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersReport_vue__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7231322_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersReport_vue__ = __webpack_require__(660);
function injectStyle (ssrContext) {
  __webpack_require__(643)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7231322"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7231322_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ordersReport',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */]],
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  props: ['fromDate', 'toDate', 'account'],
  watch: {
    statusName: function statusName(val, oldVal) {
      this.$refs.mainTable.refresh();
    },
    fromDate: function fromDate(val, oldVal) {
      if (!this.validRange()) return;
      this.$refs.mainTable.refresh();
    },
    toDate: function toDate(val, oldVal) {
      if (!this.validRange()) return;
      this.$refs.mainTable.refresh();
    },
    account: function account(val, oldVal) {
      this.$refs.mainTable.refresh();
    }
  },
  data: function data() {
    return {
      fields: [{ key: 'id', label: 'Número', 'class': 'text-left' }, { key: 'accountName', label: 'Seller', 'class': 'text-left' }, { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left' }, { key: 'creationDate', label: 'Fecha', 'class': 'text-left' }, { key: 'value', label: 'Total', 'class': 'text-left' }, { key: 'status', label: 'Estado', 'class': 'text-left' }],
      fieldsNotAdmin: [{ key: 'id', label: 'Número', 'class': 'text-left' }, { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left' }, { key: 'creationDate', label: 'Fecha', 'class': 'text-left' }, { key: 'value', label: 'Total', 'class': 'text-left' }, { key: 'status', label: 'Estado', 'class': 'text-left' }],
      locale: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.CURRENCY,
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      filter: null,
      showFilters: true,
      loading: false,
      filterTags: [],
      statusName: null,
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        icons: {
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right'
        }
      },
      statusMapping: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.STATUS_MAPPING,
      statusMappingColors: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.STATUS_MAPPING_COLORS
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    },
    invalidDateTo: function invalidDateTo() {
      if (this.fromDate && this.toDate) {
        var fDate = new Date(this.fromDate);
        var tDate = new Date(this.toDate);
        return fDate > tDate ? 'La fecha ingresada es anterior que la inicial' : '';
      }
      return '';
    }
  },
  methods: {
    getStatusColorClass: function getStatusColorClass(status) {
      return 'text-' + this.statusMappingColors[status] + ' h6';
    },
    validRange: function validRange() {
      if (this.fromDate && this.toDate) {
        var fDate = new Date(this.fromDate);
        var tDate = new Date(this.toDate);
        if (tDate > new Date()) {
          return false;
        }
        if (fDate > new Date()) {
          return false;
        }
        if (fDate >= tDate) {
          return false;
        }
        return true;
      }
      return false;
    },
    rowClick: function rowClick(item) {
      this.$router.push('/orders/orderDetail/' + item.id);
    },
    changeStatusExternally: function changeStatusExternally(newStatusName) {
      if (newStatusName === 'controversy') {
        this.filterTags = ['I'];
        this.statusName = null;
      } else {
        this.filterTags = [];
        this.statusName = newStatusName;
      }
      this.$refs.mainTable.refresh();
      document.getElementById('mainTable').scrollIntoView();
    },
    filterTable: function filterTable() {
      this.$refs.mainTable.refresh();
    },
    itemProvider: function itemProvider(tableComponentInfo) {
      var _this = this;

      this.loading = true;
      this.$emit('error', '');
      return this.getAllOrders(tableComponentInfo).then(function (response) {
        var items = response.body;
        _this.totalRows = parseInt(response.headers.get('X-Total-Count'));
        _this.$emit('total', _this.totalRows);
        _this.loading = false;
        return items;
      }, function (error) {
        _this.loading = false;
        var errorText = error.body.message || 'Error obteniendo el reporte de pedidos';
        _this.$emit('error', errorText);
        return [];
      });
    }
  }
});

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'MoonLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        height: this.size,
        width: this.size,
        borderRadius: this.radius
      }
    };
  },

  computed: {
    moonSize: function moonSize() {
      return parseFloat(this.size) / 7;
    },
    spinnerMoonStyle: function spinnerMoonStyle() {
      return {
        height: this.moonSize + 'px',
        width: this.moonSize + 'px',
        borderRadius: this.radius
      };
    },
    animationStyle2: function animationStyle2() {
      return {
        top: parseFloat(this.size) / 2 - this.moonSize / 2 + 'px',
        backgroundColor: this.color
      };
    },
    animationStyle3: function animationStyle3() {
      return {
        border: this.moonSize + 'px solid ' + this.color
      };
    }
  }

});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-moon v-moon1",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"v-moon v-moon2",style:([_vm.spinnerMoonStyle,_vm.animationStyle2])}),_c('div',{staticClass:"v-moon v-moon3",style:([_vm.spinnerStyle,_vm.animationStyle3])})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"order-list",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Estado","description":"Seleccione el estado del pedido"}},[_c('b-form-select',{attrs:{"options":_vm.statusMapping},model:{value:(_vm.statusName),callback:function ($$v) {_vm.statusName=$$v},expression:"statusName"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Listado de pedidos"}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","stacked":"xl","items":_vm.itemProvider,"fields":_vm.isAdmin ? _vm.fields: _vm.fieldsNotAdmin,"current-page":_vm.currentPage,"per-page":_vm.perPage,"filter":_vm.filter,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"empty-text":"No hay pedidos para mostrar","empty-filtered-text":"No hay pedidos para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-clicked":_vm.rowClick},scopedSlots:_vm._u([{key:"clientProfileData",fn:function(data){return [_vm._v("\n          "+_vm._s(data.value ? data.value.firstName : '')+" "+_vm._s(data.value ? data.value.lastName : '')+"\n        ")]}},{key:"status",fn:function(status){return [_c('span',{class:_vm.getStatusColorClass(status.value)},[_c('b',[_vm._v(_vm._s(_vm.statusMapping[status.value]))])])]}},{key:"creationDate",fn:function(creationDate){return [_vm._v("\n          "+_vm._s(new Date(creationDate.value).toLocaleDateString(_vm.locale))+"\n        ")]}},{key:"value",fn:function(value){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(value.value)+"\n        ")]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLineChart_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainLineChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(303);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  mixins: [reactiveProp],
  props: ['height'],
  data: function data() {
    return {
      graphOptions: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: this.$t('Ordenes')
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: 'rgb(0, 0, 0)'
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 1,
              suggestedMin: 0
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          line: {
            tension: 0
          },
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        }
      }
    };
  },

  methods: {
    updateGraph: function updateGraph() {
      this.renderChart(this.chartData, this.graphOptions);
    }
  }
});

/***/ }),
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"3.0.2","description":"Vue.js wrapper for chart.js for creating beautiful charts.","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","prepublishOnly":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash.merge":"^4.6.0"},"peerDependencies":{"chart.js":"2.7.x"},"devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.0.2.tgz","_integrity":"sha1-lg0LqcLzcguF/wJBdwetwC+VPek=","_from":"vue-chartjs@3.0.2"}

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPieChart_vue__ = __webpack_require__(724);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPieChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(303);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Doughnut */],
  mixins: [reactiveProp],
  props: ['height'],
  data: function data() {
    return {
      graphOptions: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true,
          text: this.$t('Estado de ordenes')
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: 'rgb(0, 0, 0)'
          }
        }
      }
    };
  },

  methods: {
    updateGraph: function updateGraph() {
      this.renderChart(this.chartData, this.graphOptions);
    }
  }
});

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.$t(_vm.errorText))+"\n  ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('strong',[_vm._v(_vm._s(_vm.$t('Fecha')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('Desde'),"description":_vm.$t('Fecha de inicio para filtrar datos'),"state":_vm.invalidDateFrom === '' ? true : false,"invalid-feedback":_vm.invalidDateFrom}},[_c('b-input-group',[_c('date-picker',{attrs:{"config":_vm.datePickerConfig1},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('Hasta'),"description":_vm.$t('Fecha final para filtrar datos'),"state":_vm.invalidDateTo === '' ? true : false,"invalid-feedback":_vm.invalidDateTo}},[_c('b-input-group',[_c('date-picker',{attrs:{"config":_vm.datePickerConfig2},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Seller"}},[_c('b-form-select',{attrs:{"options":_vm.organizations},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v(_vm._s(_vm.$t('Todos')))])])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"xl":"12"}},[_c('h4',{staticClass:"my-5"},[_vm._v(_vm._s(_vm.$t('Dashboard de ordenes'))+" ["+_vm._s(_vm.totalPedidos !== null ? _vm.totalPedidos : _vm.$t('espere..'))+"]")]),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}})],1),_vm._v(" "),_c('b-col',{attrs:{"xl":"12"}},[_c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{staticClass:"mt-3 cardCliqueable",class:{active: _vm.ordeStatus === 'ready-for-handling'},attrs:{"header-bg-variant":"primary","border-variant":"primary","align":"center","header":_vm.$t('Para manejo')},on:{"click":function($event){_vm.changeOrderStatus('ready-for-handling')}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"number",attrs:{"title":"Click para filtrar por pedidos pagos"}},[_vm._v(_vm._s(_vm.cardStatistics.readyForHandling))])]),_vm._v(" "),_c('b-card',{staticClass:"mt-3 cardCliqueable",class:{active: _vm.ordeStatus === 'payment-pending'},attrs:{"align":"center","header-bg-variant":"primary","border-variant":"primary","header":_vm.$t('No pagada')},on:{"click":function($event){_vm.changeOrderStatus('payment-pending')}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"number",attrs:{"title":"Click para filtrar por pedidos no pagados"}},[_vm._v(_vm._s(_vm.cardStatistics.paymentPending))])]),_vm._v(" "),_c('b-card',{staticClass:"mt-3  cardCliqueable",class:{active: _vm.ordeStatus === 'handling'},attrs:{"align":"center","header-bg-variant":"primary","border-variant":"primary","header":_vm.$t('Para envío')},on:{"click":function($event){_vm.changeOrderStatus('handling')}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"number",attrs:{"title":"Click para filtrar por pedidos listos para envio"}},[_vm._v(_vm._s(_vm.cardStatistics.handling))])]),_vm._v(" "),_c('b-card',{staticClass:"mt-3 cardCliqueable",class:{active: _vm.ordeStatus === 'invoiced'},attrs:{"xl":"3","align":"center","header-bg-variant":"primary","border-variant":"primary","header":_vm.$t('Enviada')},on:{"click":function($event){_vm.changeOrderStatus('invoiced')}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"number",attrs:{"title":"Click para filtrar por pedidos enviados"}},[_vm._v(_vm._s(_vm.cardStatistics.invoiced))])]),_vm._v(" "),_c('b-card',{staticClass:"mt-3 cardCliqueable",class:{active: _vm.ordeStatus === 'delivered'},attrs:{"align":"center","header-bg-variant":"primary","border-variant":"primary","header":_vm.$t('Entregada')},on:{"click":function($event){_vm.changeOrderStatus('delivered')}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"number",attrs:{"title":"Click para filtrar por pedidos entregados"}},[_vm._v(_vm._s(_vm.cardStatistics.delivered))])]),_vm._v(" "),_c('b-card',{staticClass:"mt-3 cardCliqueable",class:{active: _vm.ordeStatus === 'canceled'},attrs:{"align":"center","header-bg-variant":"primary","border-variant":"primary","header":_vm.$t('Cancelada')},on:{"click":function($event){_vm.changeOrderStatus('canceled')}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"number",attrs:{"title":"Click para filtrar por pedidos cancelados"}},[_vm._v(_vm._s(_vm.cardStatistics.canceled))])]),_vm._v(" "),_c('b-card',{staticClass:"mt-3 cardCliqueable",class:{active: _vm.ordeStatus === 'incidence'},attrs:{"align":"center","header-bg-variant":"primary","border-variant":"primary","header":_vm.$t('Incidencias')},on:{"click":function($event){_vm.changeOrderStatus('controversy')}}},[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.bottom",modifiers:{"hover":true,"bottom":true}}],staticClass:"number",attrs:{"title":"Click para filtrar por pedidos con Incidencias"}},[_vm._v(_vm._s(_vm.cardStatistics.incidence))])])],1)],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && (!_vm.totalPedidos || _vm.totalPedidos === 0)),expression:"!loading && (!totalPedidos || totalPedidos === 0)"}]},[_c('b-col',{staticClass:"mt-3",attrs:{"md":"12"}},[_c('p',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.$t('No hay informacion sobre ordenes disponible para graficar')))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('main-line-chart',{ref:"graphLine",staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"40px"},attrs:{"chart-data":_vm.lines,"height":"400"}})],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('main-pie-chart',{ref:"graphPie",staticClass:"chart-wrapper",staticStyle:{"height":"400px","margin-top":"40px"},attrs:{"chart-data":_vm.pie,"height":"400"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h4',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Listado de ordenes')))]),_vm._v(" "),_c('h6',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t('Se muestran las últimas 10 ordenes dentro del rango seleccionado.')))]),_vm._v(" "),_c('ordersReport',{ref:"ordersReport",attrs:{"account":_vm.account,"fromDate":_vm.fromDate,"toDate":_vm.toDate},on:{"total":_vm.setTotal,"error":_vm.showError}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersView_vue__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a772f19_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersView_vue__ = __webpack_require__(736);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a772f19_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_OrderList__ = __webpack_require__(728);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'orders-view',
  components: {
    OrderList: __WEBPACK_IMPORTED_MODULE_0__components_common_OrderList__["a" /* default */]
  }
});

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderList_vue__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af97713_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderList_vue__ = __webpack_require__(735);
function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7af97713"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af97713_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim_js__ = __webpack_require__(10);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'order-list',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  data: function data() {
    return {
      fields: [{ key: 'id', label: this.$t('Número'), 'class': 'text-left', sortable: true }, { key: 'accountName', label: this.$t('Seller'), 'class': 'text-left', sortable: true }, { key: 'clientProfileData', label: this.$t('Cliente'), 'class': 'text-left', sortable: true }, { key: 'creationDate', label: this.$t('Fecha'), 'class': 'text-left', sortable: true }, { key: 'value', label: this.$t('Total'), 'class': 'text-left', sortable: true }, { key: 'status', label: this.$t('Estado'), 'class': 'text-left', sortable: true }, { key: 'tags', label: this.$t('Etiquetas'), 'class': 'text-left' }],
      fieldsNotAdmin: [{ key: 'id', label: this.$t('Número'), 'class': 'text-left', sortable: true }, { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true }, { key: 'creationDate', label: 'Fecha', 'class': 'text-left', sortable: true }, { key: 'value', label: 'Total', 'class': 'text-left', sortable: true }, { key: 'status', label: 'Estado', 'class': 'text-left', sortable: true }, { key: 'tags', label: 'Etiquetas', 'class': 'text-left', sortable: false }],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      account: null,
      sortBy: null,
      sortDesc: false,
      filter: null,
      filterTags: [],
      errorText: '',
      statusName: null,
      fromDate: new Date(),
      toDate: new Date(),
      showFilters: false,
      loading: false,
      locale: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.CURRENCY,
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        icons: {
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right'
        }
      },
      statusMapping: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.STATUS_MAPPING,
      statusMappingColors: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.STATUS_MAPPING_COLORS,
      tagsMapping: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.TAGS_MAPPING
    };
  },

  computed: {
    disableFilter: function disableFilter() {
      return this.invalidDateTo !== '' || this.invalidDateFrom !== '' || !this.isValidText(this.filter);
    },
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    },
    organizations: function organizations() {
      return this.$store.getters.organizations;
    },
    invalidDateTo: function invalidDateTo() {
      if (this.toDate) {
        var tDate = new Date(this.toDate);
        if (tDate > new Date()) {
          return 'La fecha seleccionada es mayor al día de hoy';
        }
        if (this.fromDate) {
          var fDate = new Date(this.fromDate);
          return fDate > tDate ? 'La fecha final es menor a la fecha inicial' : '';
        }
      }
      return '';
    },
    invalidDateFrom: function invalidDateFrom() {
      if (this.fromDate) {
        var fDate = new Date(this.fromDate);
        if (fDate > new Date()) {
          return 'La fecha seleccionada es mayor al día de hoy';
        }
      }
      return '';
    }
  },
  methods: {
    getStatusColorClass: function getStatusColorClass(status) {
      return 'text-' + this.statusMappingColors[status] + ' h6';
    },
    controversyTagClass: function controversyTagClass(row) {
      var days = 0;
      if (row.controversies && row.controversies.length > 0) {
        var auxDays = 0;
        row.controversies.forEach(function (cont) {
          var timeDiff = new Date() - new Date(cont.updateDate);
          auxDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          days = auxDays >= days ? auxDays : days;
        });
      }
      if (days < 1) return 'green';
      if (days < 2) return 'yellow';
      return 'red';
    },
    showControversyTag: function showControversyTag(orderDesc) {
      if (orderDesc.controversies !== null && orderDesc.controversies.length > 0) {
        return orderDesc.controversies.find(function (item) {
          return item.state !== 'INVALID' && item.state !== 'DONE';
        }) !== undefined;
      }
      return false;
    },
    rowClick: function rowClick(item) {
      this.$router.push('/orders/orderDetail/' + item.id);
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterTable: function filterTable() {
      this.$refs.mainTable.refresh();
    },
    cleanFilters: function cleanFilters() {
      this.filter = null;
      this.filterTags = [];
      this.statusName = null;
      this.fromDate = '';
      this.toDate = '';
      this.filterTable();
    },
    itemProvider: function itemProvider(tableComponentInfo) {
      var _this = this;

      this.loading = true;
      this.errorText = '';
      return this.getAllOrders(tableComponentInfo).then(function (response) {
        var items = response.body;
        this.totalRows = parseInt(response.headers.get('X-Total-Count'));
        this.loading = false;
        return items;
      }, function (error) {
        _this.loading = false;
        _this.errorText = error.body.message || 'Error obteniendo el listado de pedidos';
        return [];
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.fromDate = '';
    this.toDate = '';

    setInterval(function () {
      _this2.$refs.mainTable.refresh();
    }, __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.ORDER_LIST_TTL);
  }
});

/***/ }),
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"order-list",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('b-row',{staticClass:"filter-row"},[_c('b-col',{attrs:{"lg":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('Buscar'),"invalid-feedback":!_vm.isValidText(_vm.filter, false)? 'No es un valor válido' : '',"state":_vm.isValidText(_vm.filter, false),"description":_vm.$t('Ingrese el texto a buscar')}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Texto a buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":_vm.filterTable}},[_vm._v("Buscar")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-4",attrs:{"lg-":"8"}},[_c('button',{staticClass:"btn btn-primary float-right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showFilters = !_vm.showFilters}}},[_c('i',{staticClass:"fa",class:{'fa-times': _vm.showFilters, 'fa-filter': !_vm.showFilters}}),_vm._v(_vm._s(_vm.$t('Filtros'))+"\n        ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"filters mt-3 p-3"},[_c('b-row',[_c('b-col',{attrs:{"lg":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('Desde'),"description":_vm.$t('Fecha de inicio para filtrar datos'),"state":_vm.invalidDateFrom === '' ? true : false,"invalid-feedback":_vm.invalidDateFrom}},[_c('b-input-group',[_c('date-picker',{attrs:{"config":_vm.config},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('Hasta'),"description":_vm.$t('Fecha final para filtrar datos'),"state":_vm.invalidDateTo === '' ? true : false,"invalid-feedback":_vm.invalidDateTo}},[_c('b-input-group',[_c('date-picker',{attrs:{"config":_vm.config},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"4"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":_vm.$t('Estado'),"description":_vm.$t('Seleccione el estado de la orden')}},[_c('b-form-select',{model:{value:(_vm.statusName),callback:function ($$v) {_vm.statusName=$$v},expression:"statusName"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v(_vm._s(_vm.$t('Todos')))]),_vm._v(" "),_vm._l((_vm.statusMapping),function(text,value){return _c('option',{key:value,domProps:{"value":value}},[_vm._v(_vm._s(_vm.$t(text)))])})],2)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"label":"Filtrar por TAGS","description":"Selecciones los tags de ordenes que desea filtrar en la busqueda"}},[_c('b-form-checkbox-group',{attrs:{"stacked":""},model:{value:(_vm.filterTags),callback:function ($$v) {_vm.filterTags=$$v},expression:"filterTags"}},[_vm._l((_vm.tagsMapping),function(tagElem){return [(!tagElem.isCt)?_c('b-form-checkbox',{key:tagElem.key,attrs:{"value":tagElem.key}},[_c('span',{staticClass:"tag-check p-1",class:tagElem.bg},[_vm._v(_vm._s(tagElem.text))])]):_vm._e()]})],2)],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('b-col',{attrs:{"lg":"4"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Seller"}},[_c('b-form-select',{attrs:{"options":_vm.organizations},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v(_vm._s(_vm.$t('Todos')))])])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-input-group-button',{staticClass:"float-right mt-3"},[_c('b-button',{attrs:{"disabled":_vm.loading || _vm.disableFilter,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('b-input-group-button',{staticClass:"float-right mt-3 mr-3"},[_c('b-button',{attrs:{"disabled":_vm.loading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Mostrar Todo")])],1)],1)],1)],1)]),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":_vm.$t('Mostrar por página')}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('b',[_vm._v(_vm._s(_vm.$tc('{count} ordenes encontradas', _vm.totalRows, { count: _vm.totalRows })))])])],1),_vm._v(" "),_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":_vm.$t('Listado de ordenes')}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","stacked":"xl","items":_vm.itemProvider,"foot-clone":"","fields":_vm.isAdmin ? _vm.fields: _vm.fieldsNotAdmin,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"empty-text":_vm.$t('No hay ordenes para mostrar'),"empty-filtered-text":_vm.$t('No hay ordenes para mostrar')},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-clicked":_vm.rowClick,"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"clientProfileData",fn:function(data){return [_vm._v("\n          "+_vm._s(data.value ? data.value.firstName : '')+" "+_vm._s(data.value ? data.value.lastName : '')+"\n        ")]}},{key:"status",fn:function(status){return [_c('span',{class:_vm.getStatusColorClass(status.value)},[_c('b',[_vm._v(_vm._s(_vm.$t(_vm.statusMapping[status.value])))])])]}},{key:"creationDate",fn:function(creationDate){return [_vm._v("\n          "+_vm._s(new Date(creationDate.value).toLocaleDateString(_vm.locale))+"\n        ")]}},{key:"value",fn:function(value){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(value.value)+"\n        ")]}},{key:"tags",fn:function(row){return _vm._l((row.item.tags),function(tagElemKey){return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"tag",class:_vm.tagsMapping[tagElemKey].bg,attrs:{"title":_vm.tagsMapping[tagElemKey].description}},[_vm._v("\n              "+_vm._s(tagElemKey)+"\n            ")])})}}])})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('order-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetailsView_vue__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba98ff8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetailsView_vue__ = __webpack_require__(765);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetailsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba98ff8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetailsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_OrderDetailsBoard__ = __webpack_require__(739);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'order-details-view',
  props: ['orderId'],
  components: {
    OrderDetailsBoard: __WEBPACK_IMPORTED_MODULE_0__components_common_OrderDetailsBoard__["a" /* default */]
  }
});

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetailsBoard_vue__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6425ef01_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetailsBoard_vue__ = __webpack_require__(764);
function injectStyle (ssrContext) {
  __webpack_require__(740)
  __webpack_require__(741)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6425ef01"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderDetailsBoard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6425ef01_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderDetailsBoard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_ControversyServiceMixim_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_CarrierServiceMixin_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_PromotionsServiceMixim__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InvoiceModal__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ControversyModal__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ControversyDetailModal__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_incidents_IncidentsTable__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue__ = __webpack_require__(18);


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'order-details-board',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_3__mixims_ControversyServiceMixim_js__["a" /* ControversyServiceMixim */], __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_6__mixims_PromotionsServiceMixim__["a" /* PromotionsServiceMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_CarrierServiceMixin_js__["a" /* CarrierServiceMixin */]],
  components: {
    InvoiceModal: __WEBPACK_IMPORTED_MODULE_7__InvoiceModal__["a" /* default */],
    ControversyModal: __WEBPACK_IMPORTED_MODULE_8__ControversyModal__["a" /* default */],
    ControversyDetailModal: __WEBPACK_IMPORTED_MODULE_9__ControversyDetailModal__["a" /* default */],
    MoonLoader: __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_MoonLoader_vue__["a" /* default */],
    incidentsTable: __WEBPACK_IMPORTED_MODULE_10__components_incidents_IncidentsTable__["a" /* default */]
  },
  computed: {
    controversyTagClass: function controversyTagClass() {
      var days = 0;
      if (this.orderDetail.controversies && this.orderDetail.controversies.length > 0) {
        var auxDays = 0;
        this.orderDetail.controversies.forEach(function (cont) {
          var timeDiff = new Date() - new Date(cont.updateDate);
          auxDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
          days = auxDays >= days ? auxDays : days;
        });
      }
      if (days < 1) return 'green';
      if (days < 2) return 'yellow';
      return 'red';
    },
    deliveryButtonVisible: function deliveryButtonVisible() {
      var _this2 = this;

      var isShippingExcluded = false;
      if (this.orderDetail.shippingData) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.shippingsExcluded).find(function (key) {
          return _this2.shippingsExcluded[key] === _this2.orderDetail.shippingData.logisticsInfo[0].deliveryCompany;
        })) {
          isShippingExcluded = true;
        }
      }

      if (!this.isAdmin && !isShippingExcluded && (this.orderDetail.status === 'invoiced' || this.orderDetail.status === 'partially-invoiced' || this.orderDetail.status === 'partially-delivered')) {
        if (this.orderDetail.packageAttachment.packages && this.orderDetail.packageAttachment.packages.length > 0) {
          return this.orderDetail.packageAttachment.packages.find(function (packItem) {
            return packItem.courierStatus.finished === false;
          }) !== undefined;
        }
      }
    }

  },
  props: ['orderId'],
  data: function data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      buttonsDisabled: false,
      statusVariantClass: 'primary',
      errorText: '',

      loading: false,
      contLoading: false,

      stateModalCallback: '',
      cancelStateCallback: '',
      stateModalText: '',

      statusHistoriesFields: [{ key: 'id', label: 'ID', sortable: false }, { key: 'date', label: 'Fecha', sortable: false }, { key: 'status', label: 'Estado', sortable: false }, { key: 'user', label: 'Usuario', sortable: false }],
      showHistorialStatus: false,

      invoiceButtonVisible: false,
      startHandlingButtonVisible: false,
      cancelButtonVisible: false,
      updateTagsButtonVisible: true,
      controversyButtonVisible: false,
      controversyModalVisible: false,
      controvercyDetailModalVisible: false,

      controversySelected: null,
      isGoingToAttend: false,
      orderDetail: {},
      orderPromos: [],
      toDeliveryArray: [],

      confirm: {
        title: '',
        callback: '',
        confirmBody: ''
      },

      itemsFields: [{ key: 'upc', label: 'UPC' }, { key: 'refId', label: 'Referencia' }, { key: 'name', label: 'Nombre' }, { key: 'quantity', label: 'Cantidad' }, { key: 'price', label: 'Precio' }],
      itemsFieldsAdmin: [{ key: 'upc', label: 'UPC' }, { key: 'refId', label: 'Referencia' }, { key: 'name', label: 'Nombre' }, { key: 'quantity', label: 'Cantidad' }, { key: 'price', label: 'Precio' }],
      devolutionFields: [{ key: 'date', label: 'Fecha' }, { key: 'name', label: 'Nombre' }, { key: 'id', label: 'SKU' }, { key: 'quantity', label: 'Cantidad' }, { key: 'price', label: 'Precio' }],
      devolutions: [],
      controversyStateListCDE: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.CONTROVERSY_STATES_CDE,
      controversyStateListCF: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.CONTROVERSY_STATES_CF,
      controversyFields: [{ key: 'date', label: 'Fecha de creación', _showDetails: false }, { key: 'text', label: 'Descripción', _showDetails: false }, { key: 'actions', label: 'Acciones', _showDetails: false, class: 'controversy-actions' }],
      statusMapping: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.STATUS_MAPPING,
      statusMappingBgColors: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.STATUS_MAPPING_COLORS,
      tagsMapping: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.TAGS_MAPPING,
      marketplaceInvoice: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.MARKETPLACE_INVOICE,
      locale: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.CURRENCY,
      promoLoaded: false,
      shippingsExcluded: __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.SHIPPING_EXCLUDED,
      filters: {
        fromDate: null,
        toDate: null,
        incidenceType: null,
        accountName: null,
        priority: null,
        status: null
      }
    };
  },

  methods: {
    print: function print() {
      window.print();
    },
    controversyStateChange: function controversyStateChange(row) {
      var _this3 = this;

      var allStates = __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.CONTROVERSY_STATES_CF.concat(__WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.CONTROVERSY_STATES_CDE);

      var from = allStates.find(function (elem) {
        return elem.value === row.value;
      }).text;

      var to = allStates.find(function (elem) {
        return elem.value === row.item.state;
      }).text;

      if (row.value === row.item.state) {
        return;
      }

      this.cancelStateCallback = function () {
        row.item.state = row.value;
      };

      this.stateModalCallback = function () {
        _this3.contLoading = true;
        _this3.updateControversy(_this3.orderDetail.id, row.item.id, row.item.state).then(function () {
          _this3.contLoading = false;
          _this3._getOrdersDetails();
        }, function (error) {
          row.item.state = row.value;
          _this3.contLoading = false;
          _this3.errorText = error.body.message || _this3.$t('error actualizando el estado de la controversia');
        });
      };

      if (row.item.state === 'DONE' || row.item.state === 'INVALID') {
        this.stateModalText = '\xBFSe cambiar\xE1 el estado de <b>"' + from + '"</b> a <b>"' + to + '"</b>, desea continuar?"';
        this.$refs.controversyStateModal.show();
        return;
      }
      this.stateModalCallback();
    },
    getDeliveredItemQuantity: function getDeliveredItemQuantity(id) {
      var quantity = 0;
      if (this.orderDetail.packageAttachment && this.orderDetail.packageAttachment.packages && this.orderDetail.packageAttachment.packages.length > 0) {
        this.orderDetail.packageAttachment.packages.forEach(function (packageItem) {
          packageItem.items.forEach(function (item) {
            if (item.id === id) {
              quantity = quantity + item.quantity;
            }
          });
        });
      }
      return quantity;
    },
    getProductNameById: function getProductNameById(id) {
      var name = '';
      this.orderDetail.items.forEach(function (item) {
        if (item.id === id) {
          name = item.name;
        }
      });
      return name;
    },
    showControversyModal: function showControversyModal(controversy, isGoingToAttend) {
      this.controversySelected = controversy ? controversy.item : null;
      this.controversyModalVisible = true;
      this.isGoingToAttend = isGoingToAttend;
    },
    showControversyDetailModal: function showControversyDetailModal(controversy) {
      this.controversySelected = controversy ? controversy.item : null;
      this.controvercyDetailModalVisible = true;
    },
    _controversyDetailsModalHideCallback: function _controversyDetailsModalHideCallback() {
      this.controvercyDetailModalVisible = false;
    },
    _controversyModalHideCallback: function _controversyModalHideCallback() {
      this.controversyModalVisible = false;
      this.isGoingToAttend = false;
    },
    _getControversies: function _getControversies() {
      var _this4 = this;

      this.contLoading = true;
      this.errorText = '';
      return this.getControversies(this.orderDetail.id).then(function (controversies) {
        controversies.body.forEach(function (controversy) {
          if (!controversy.active) {
            controversy._rowVariant = 'danger';
          } else {
            controversy._rowVariant = 'success';
          }
        });
        _this4.buttonsDisabled = false;
        _this4.contLoading = false;
        _this4.orderDetail.controversies = controversies.body;
      }, function (error) {
        _this4.errorText = error.body.message || 'error obteniendo las contriversias';
      });
    },
    deleteControversyAction: function deleteControversyAction(controversy) {
      var _this5 = this;

      this.showConfirm('Eliminar controversia', 'Confirma que desea eliminar la controvesia ' + controversy.item.id + '?', function () {
        _this5.$refs.confirm.hide();
        _this5.buttonsDisabled = true;
        _this5.loading = true;
        _this5.deleteControversy(_this5.orderDetail.id, controversy.item.id).then(function () {
          _this5.loading = false;
          return _this5._getOrdersDetails();
        }, function (error) {
          _this5.loading = false;
          _this5.errorText = error.body.message || 'error eliminando la controvesia';
        });
      });
    },
    deliverPackage: function deliverPackage(invoiceNumber) {
      var _this6 = this;

      this.showConfirm('Marcar como entregado', 'Confirma que desea marcar como entregado el paquete ' + invoiceNumber + '?', function () {
        _this6.loading = true;
        _this6.$refs.confirm.hide();
        _this6.buttonsDisabled = true;
        _this6.deliverOrders(_this6.orderDetail.id, [invoiceNumber]).then(function () {
          return _this6._getOrdersDetails();
        }, function (error) {
          _this6.errorText = error.body.message || 'error entregando el paquete';
        });
      });
    },
    showConfirm: function showConfirm(confirmTitle, confirmBody, callback) {
      this.confirm.title = confirmTitle;
      this.confirm.confirmBody = confirmBody;
      this.confirm.callback = callback;
      this.$refs.confirm.show();
    },
    _execDelivery: function _execDelivery() {
      var _this7 = this;

      var invoicesToMarkAsDelivered = this.toDeliveryArray.map(function (packageItem) {
        return packageItem.invoiceNumber;
      });
      this.$refs.deliveryModal.hide();
      this.buttonsDisabled = true;
      this.loading = true;

      this.deliverOrders(this.orderDetail.id, invoicesToMarkAsDelivered).then(function () {
        _this7.toDeliveryArray = [];
        return _this7._getOrdersDetails();
      }, function () {
        _this7.buttonsDisabled = false;
        _this7.loading = false;
      });
    },
    deliverAction: function deliverAction(e) {
      e.preventDefault();
      this.$refs.deliveryModal.show();
    },
    startHandlingAction: function startHandlingAction(e) {
      var _this8 = this;

      e.preventDefault();
      this.showConfirm('Iniciar Manejo', 'Confirma que desea iniciar el manejo del pedido ' + this.orderDetail.id + '?', function () {
        _this8.$refs.confirm.hide();
        _this8.buttonsDisabled = true;
        _this8.loading = true;
        _this8.startHandling(_this8.orderDetail.id).then(function () {
          return _this8._getOrdersDetails();
        }, function (error) {
          _this8.errorText = error.body.message || 'error iniciando el manejo';
          _this8.buttonsDisabled = false;
          _this8.loading = false;
        });
      });
    },
    cancelAction: function cancelAction(e) {
      var _this9 = this;

      this.showConfirm('Cancelar Orden', 'Confirma que desea cancelar el pedido ' + this.orderDetail.id + '?', function () {
        _this9.$refs.confirm.hide();
        _this9.loading = true;
        _this9.buttonsDisabled = true;
        _this9.cancelOrder(_this9.orderDetail.id).then(function () {
          _this9._getOrdersDetails();
        }, function (error) {
          _this9.errorText = error.body.message || 'error cancelando el pedido';
          _this9.buttonsDisabled = false;
          _this9.loading = false;
        });
      });
    },
    _getPackageItemCount: function _getPackageItemCount(packageItem) {
      var count = 0;
      packageItem.items.forEach(function (item) {
        count += item.quantity;
      });
      return count;
    },
    _getOrdersDetails: function _getOrdersDetails() {
      var _this10 = this;

      return this.getOrderDetails(this.orderId).then(function (response) {
        _this10.orderDetail = response.body;
        _this10.orderPromos.splice(0, _this10.orderPromos.length);
        _this10.promoLoaded = false;
        _this10.filters.text = _this10.orderDetail.id;

        if (_this10.orderDetail.controversies && _this10.orderDetail.controversies !== null) {
          _this10.orderDetail.controversies.forEach(function (controversy) {
            if (!controversy.active) {
              controversy._rowVariant = 'danger';
            } else {
              controversy._rowVariant = 'success';
            }
          });
        }

        var index = 0;
        var _this = _this10;
        function syncMagicPromisseCall() {
          var sku = _this.orderDetail.items[index];
          return _this.getSku(sku.id).then(function (data) {
            __WEBPACK_IMPORTED_MODULE_13_vue__["a" /* default */].set(_this.orderDetail.items[index], 'refId', data.body.refId);
            __WEBPACK_IMPORTED_MODULE_13_vue__["a" /* default */].set(_this.orderDetail.items[index], 'upc', data.body.upc);
            if (++index < _this.orderDetail.items.length) {
              return syncMagicPromisseCall();
            }
          }, function (error) {
            console.log(error);
          });
        }
        syncMagicPromisseCall();

        if (_this10.orderDetail.packageAttachment && _this10.orderDetail.packageAttachment.packages && _this10.orderDetail.packageAttachment.packages.length > 0) {
          _this10.orderDetail.packageAttachment.packages.forEach(function (packItem) {
            packItem.totalItems = _this10._getPackageItemCount(packItem);
          });
        }

        var promises = [];

        _this10.orderDetail.items.forEach(function (item) {
          if (item.priceTags && item.priceTags.length > 0) {
            item.priceTags.forEach(function (promo) {
              promises.push(_this10.updatePromoName(promo, item));
            });
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
          _this10.promoLoaded = true;
        });

        _this10.loading = false;
        _this10.buttonsDisabled = false;
        _this10._updateButtonsVisibility();
        console.log(_this10.orderDetail);
      }, function (error) {
        _this10.loading = false;
        _this10.orderDetail = '';
        _this10.errorText = error.body.message || 'error obteniendo el listado de pedidos';
      });
    },
    invoiceSucessCallback: function invoiceSucessCallback() {
      this._getOrdersDetails();
    },
    updatePromoName: function updatePromoName(promo, item) {
      var _this11 = this;

      return this.getPromotion(promo.identifier).then(function (promoData) {
        promo.scName = promoData.body.name;
        promo.nominalDiscountValue = promo.isPercentual === false ? promo.rawValue : 0;
        promo.percentualDiscountValue = promo.isPercentual === true ? promo.rawValue : 0;
        promo.description = promoData.body.description;
        promo.userType = promoData.body.userType;
        _this11.orderPromos.push({
          scName: promoData.body.name,
          nominalDiscountValue: promo.isPercentual === false ? promo.rawValue : 0,
          percentualDiscountValue: promo.isPercentual === true ? promo.rawValue : 0,
          description: promoData.body.description,
          userType: promoData.body.userType
        });
      }, function () {
        promo.nominalDiscountValue = promo.isPercentual === false ? promo.rawValue : 0;
        promo.percentualDiscountValue = promo.isPercentual === true ? promo.rawValue : 0;
        _this11.orderPromos.push({
          scName: 'Promo Ecommerce',
          nominalDiscountValue: promo.isPercentual === false ? promo.rawValue : 0,
          percentualDiscountValue: promo.isPercentual === true ? promo.rawValue : 0,
          description: 'Promo Ecommerce',
          userType: 'ECOMMERCE'
        });
      });
    },
    _updateButtonsVisibility: function _updateButtonsVisibility() {
      var _this12 = this;

      var isShippingExcluded = false;
      if (this.orderDetail.shippingData) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.shippingsExcluded).find(function (key) {
          return _this12.shippingsExcluded[key] === _this12.orderDetail.shippingData.logisticsInfo[0].deliveryCompany;
        })) {
          isShippingExcluded = true;
        }
      }

      this.statusVariantClass = this.statusMappingBgColors[this.orderDetail.status];

      this.invoiceButtonVisible = !this.isAdmin && !this.marketplaceInvoice && (this.orderDetail.status === 'handling' || this.orderDetail.status === 'partially-invoiced');

      this.startHandlingButtonVisible = !this.isAdmin && !this.marketplaceInvoice && this.orderDetail.status === 'ready-for-handling';

      this.cancelButtonVisible = !this.isAdmin && !isShippingExcluded && (this.orderDetail.status === 'ready-for-handling' || this.orderDetail.status === 'handling' || this.orderDetail.status === 'waiting-for-seller-decision');

      this.controversyButtonVisible = this.isAdmin;
    },
    createIncidence: function createIncidence() {
      this.$router.push({ path: '/incidents/list', query: { order: this.orderId } });
    }
  },
  mounted: function mounted() {
    var _this13 = this;

    this.loading = true;
    this._getOrdersDetails();
    setInterval(function () {
      _this13.loading = true;
      _this13._getOrdersDetails();
    }, __WEBPACK_IMPORTED_MODULE_11__config_applicationConfig_js___default.a.ORDER_DETAILS_TTL);
  }
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceModal_vue__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ec40f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceModal_vue__ = __webpack_require__(748);
function injectStyle (ssrContext) {
  __webpack_require__(744)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d7ec40f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7ec40f8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim__ = __webpack_require__(10);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'invoice-modal',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim__["a" /* ValidationsMixim */]],
  props: ['order', 'successCallback'],
  computed: {
    invoicedItems: function invoicedItems() {
      var invoicedItems = [];
      if (this.order.packageAttachment.packages && this.order.packageAttachment.packages.length > 0) {
        this.order.packageAttachment.packages.forEach(function (packageElem) {
          invoicedItems.concat(packageElem.items);
        });
      }
      return invoicedItems;
    },
    stateTrack: function stateTrack() {
      return {
        trackingUrl: this.validateUrl(this.invoiceData.trackingUrl, true),
        trackingNumber: this.isValidText(this.invoiceData.trackingNumber, true),
        courier: this.isValidText(this.invoiceData.courier, true)
      };
    },
    state: function state() {
      return {
        invoiceNumber: this.isValidFloat(this.invoiceData.invoiceNumber, true) && this.isValidInvoice(this.invoiceData.invoiceNumber)
      };
    },
    haveErrors: function haveErrors() {
      if (this.isCarrierIntegration || !this.haveDeliveryData) {
        return !this.state.invoiceNumber;
      }
      if (this.haveDeliveryData) {
        if (this.invoiceData.isAddingTrack) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.stateTrack).includes(false);
        }
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.stateTrack).includes(false) || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.state).includes(false);
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.state).includes(false);
    },
    isCarrierIntegration: function isCarrierIntegration() {
      var _this = this;

      if (this.order.shippingData) {
        if (this.order.shippingData.logisticsInfo) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.shippingsExcluded).find(function (key) {
            return _this.shippingsExcluded[key] === _this.order.shippingData.logisticsInfo[0].deliveryCompany;
          });
        }
      }
      return false;
    }
  },
  watch: {
    toInvoice: {
      handler: function handler(newVal, oldVal) {
        var _this2 = this;

        if (this.invoiceData.isAddingTrack) {
          return;
        }

        var quantity = 0;
        for (var prop in this.toInvoice) {
          if (this.toInvoice[prop].selected !== 0) {
            quantity += this.toInvoice[prop].selected;
          }
        }
        this.invoiceData.quantity = quantity;
        if (quantity > 0) {
          this.invoiceButtonText = 'Facturar (' + quantity + ')';
        } else {
          this.invoiceButtonText = 'Facturar';
        }
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.shippingsExcluded).find(function (key) {
          return _this2.shippingsExcluded[key] === _this2.order.shippingData.logisticsInfo[0].deliveryCompany;
        })) {
          this.invoiceButtonText = 'Solicitar guía';
        }
      },
      deep: true
    },
    invoiceData: {
      handler: function handler(newVal, oldVal) {
        if (this.invoiceData.isAddingTrack) {
          this.invoiceButtonText = 'Agregar tracking';
        }
      },
      deep: true
    }
  },
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  data: function data() {
    return {
      invoiceData: {
        isAddingTrack: false,
        trackingNumber: null,
        trackingUrl: null,
        courier: null,
        invoiceNumber: '',
        courierOptions: [],
        quantity: 0
      },
      errorText: '',
      loading: false,
      toInvoice: {},
      invoiceButtonText: 'Enviar',
      haveDeliveryData: false,
      shippingsExcluded: __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.SHIPPING_EXCLUDED
    };
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    var carriers = this.$store.getters.carriers;
    this.invoiceData.courierOptions.push({ value: null, text: 'Seleccione transportadora', disabled: true });
    carriers.forEach(function (carrier) {
      if (carrier.isActive) _this3.invoiceData.courierOptions.push({ value: carrier.name, text: carrier.name });
    });
  },

  methods: {
    isValidInvoice: function isValidInvoice(invoiceNumber) {
      if (this.order.packageAttachment && this.order.packageAttachment.packages) {
        return !this.order.packageAttachment.packages.find(function (pack) {
          if (pack.invoiceNumber === invoiceNumber) {
            return true;
          }
        });
      }
      return true;
    },
    show: function show(packageInvoiceNumber) {
      var _this4 = this;

      this.loading = false;
      if (!this.isEmptyData(packageInvoiceNumber)) {
        this.invoiceData.isAddingTrack = true;
        this.haveDeliveryData = true;
        this.invoiceData.invoiceNumber = packageInvoiceNumber;
      } else {
        this.invoiceData.isAddingTrack = false;
        this.invoiceData.invoiceNumber = '';
        this.haveDeliveryData = false;
      }
      this.invoiceData.quantity = 0;
      this.invoiceData.courier = null;
      this.order.items.forEach(function (item) {
        item.pendingInvoice = [];

        var pendingInvoice = item.quantity - _this4.getSentItemsQuantity(item.id);
        for (var i = 0; i <= pendingInvoice; i++) {
          item.pendingInvoice.push(i);
        }item.toInvoice = 0;
      });
      this.order.items.forEach(function (item) {
        _this4.$set(_this4.toInvoice, item.id, { values: item.pendingInvoice, selected: 0 });
      });
      this.errorText = '';
      this.invoiceData.trackingNumber = null;
      this.invoiceData.trackingUrl = null;
      for (var prop in this.toInvoice) {
        this.toInvoice[prop].selected = 0;
      }

      this.$refs.invoiceModal.show();
    },
    getSentItemsQuantity: function getSentItemsQuantity(id) {
      var quantity = 0;
      if (this.order.packageAttachment && this.order.packageAttachment.packages && this.order.packageAttachment.packages.length > 0) {
        this.order.packageAttachment.packages.forEach(function (packageItem) {
          packageItem.items.forEach(function (item) {
            if (item.id === id) {
              quantity = quantity + item.quantity;
            }
          });
        });
      }
      return quantity;
    },
    invoiceCall: function invoiceCall(e) {
      var _this5 = this;

      e.preventDefault();
      this.loading = true;

      if (this.invoiceData.isAddingTrack) {
        this.addTrackingInformation(this.order.id, this.invoiceData.invoiceNumber, this.invoiceData.courier, this.invoiceData.trackingUrl, this.invoiceData.trackingNumber).then(function () {
          _this5.loading = false;
          _this5.successCallback();
          _this5.$refs.invoiceModal.hide();
        }, function () {
          _this5.errorText = 'Se ha producido un error';
          _this5.loading = false;
        });
      } else {
        var toInvoice = [];
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.toInvoice).forEach(function (item) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this5.shippingsExcluded).find(function (key) {
            return _this5.shippingsExcluded[key] === _this5.order.shippingData.logisticsInfo[0].deliveryCompany;
          })) {
            _this5.toInvoice[item].selected = _this5.getMaxOfArray(_this5.toInvoice[item].values);
            _this5.invoiceData.courier = _this5.order.shippingData.logisticsInfo[0].deliveryCompany;
          }
          _this5.toInvoice[item].selected = _this5.getMaxOfArray(_this5.toInvoice[item].values);
          if (_this5.toInvoice[item].selected > 0) {
            toInvoice.push({
              'id': item,
              'quantity': _this5.toInvoice[item].selected
            });
          }
        });
        this.invoiceOrder(this.order.id, this.invoiceData.courier, this.invoiceData.trackingUrl, this.invoiceData.trackingNumber, toInvoice, this.invoiceData.invoiceNumber).then(function () {
          _this5.loading = false;
          _this5.successCallback();
          _this5.$refs.invoiceModal.hide();
        }, function (e) {
          _this5.errorText = 'Se ha producido un error, verifique que el número de factura es correcto y que no haya sido utilizado previamente en la orden.';
          _this5.loading = false;
        });
      }
    },
    getMaxOfArray: function getMaxOfArray(numArray) {
      return Math.max.apply(null, numArray);
    }
  }
});

/***/ }),
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',[_c('b-modal',{ref:"invoiceModal",attrs:{"ok-disabled":_vm.loading || _vm.haveErrors,"header-bg-variant":"primary","centered":"","id":"invoiceModal","size":"lg","title":_vm.isCarrierIntegration ? 'Solicitar guía' : 'Facturar',"cancel-title":"Cancelar","ok-title":_vm.invoiceButtonText},on:{"ok":_vm.invoiceCall}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.errorText !== '',"fade":"","variant":"danger","dismissible":""}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Error!")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errorText))])]),_vm._v(" "),_c('b-form',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[(!_vm.invoiceData.isAddingTrack && _vm.order.shippingData)?_c('b-card',{attrs:{"header":"Facturar productos"}},[_c('b-alert',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCarrierIntegration),expression:"!isCarrierIntegration"}],attrs:{"show":"","variant":"warning","dismissible":""}},[_vm._v("\n            En la primera factura se imputara el costo de envio automaticamente.\n          ")]),_vm._v(" "),_vm._l((_vm.order.items),function(item,index){return [(_vm.toInvoice[item.id] && _vm.toInvoice[item.id].values.length > 1)?_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('b-col',[_c('b-form-group',{attrs:{"id":"toInvoice","breakpoint":"md","label":item.name}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.toInvoice[item.id].values},model:{value:(_vm.toInvoice[item.id].selected),callback:function ($$v) {_vm.$set(_vm.toInvoice[item.id], "selected", $$v)},expression:"toInvoice[item.id].selected"}})],1)],1)],1):_vm._e()]}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Numero de factura","label-class":"text-sm-right","label-for":"invoiceNumber","invalid-feedback":!_vm.state.invoiceNumber ? 'Solo se permiten números en el campo de número de factura' : '',"state":_vm.state.invoiceNumber}},[_c('b-form-input',{attrs:{"id":"invoiceNumber","type":"text","placeholder":"Numero de factura"},model:{value:(_vm.invoiceData.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.invoiceData, "invoiceNumber", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"invoiceData.invoiceNumber"}})],1)],1)],1)],2):_vm._e(),_vm._v(" "),(!_vm.invoiceData.isAddingTrack && !_vm.isCarrierIntegration)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"horizontal":"","id":"toInvoice","breakpoint":"md","description":"Puedo facturar junto con los datos de seguimiento del paquete, de todas maneras una vez facturado es posible agregar esa informacion en el paquete","label":"Dispongo de datos de seguimiento"}},[_c('b-form-checkbox',{staticClass:"ml-4",nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.haveDeliveryData),callback:function ($$v) {_vm.haveDeliveryData=$$v},expression:"haveDeliveryData"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.haveDeliveryData),expression:"haveDeliveryData"}],attrs:{"header":!_vm.invoiceData.isAddingTrack ? 'Tracking del paquete' : 'Tracking del paquete (Factura: ' + _vm.invoiceData.invoiceNumber + ')'}},[_c('b-alert',{attrs:{"show":_vm.invoiceData.isAddingTrack,"variant":"warning","dismissible":""}},[_vm._v("\n            Usted esta a punto de agregar información de tracking al paquete que acompaña la factura "+_vm._s(_vm.invoiceData.invoiceNumber)+"\n          ")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Número Tracking","label-class":"text-sm-right","label-for":"trackingNumber","invalid-feedback":!_vm.stateTrack.trackingNumber? 'Numero de tracking inválido' : '',"state":_vm.stateTrack.trackingNumber}},[_c('b-form-input',{attrs:{"id":"trackingNumber","type":"text","placeholder":"Codigo de tracking"},model:{value:(_vm.invoiceData.trackingNumber),callback:function ($$v) {_vm.$set(_vm.invoiceData, "trackingNumber", $$v)},expression:"invoiceData.trackingNumber"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Url tracking","label-class":"text-sm-right","label-for":"urlTracking","invalid-feedback":!_vm.stateTrack.trackingUrl? 'Url de tracking inválido' : '',"state":_vm.stateTrack.trackingUrl}},[_c('b-form-input',{attrs:{"id":"urlTracking","title":"Este campo debe ser una url valida."},model:{value:(_vm.invoiceData.trackingUrl),callback:function ($$v) {_vm.$set(_vm.invoiceData, "trackingUrl", $$v)},expression:"invoiceData.trackingUrl"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Transporte","label-class":"text-sm-right","label-for":"transporte","invalid-feedback":!_vm.stateTrack.courier? 'Transportadora inválida' : '',"state":_vm.stateTrack.courier}},[_c('b-form-select',{attrs:{"options":_vm.invoiceData.courierOptions},model:{value:(_vm.invoiceData.courier),callback:function ($$v) {_vm.$set(_vm.invoiceData, "courier", $$v)},expression:"invoiceData.courier"}})],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControversyModal_vue__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206d3208_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControversyModal_vue__ = __webpack_require__(752);
function injectStyle (ssrContext) {
  __webpack_require__(750)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-206d3208"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControversyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_206d3208_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControversyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_ControversyServiceMixim_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim_js__ = __webpack_require__(10);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'controversy-modal',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_ControversyServiceMixim_js__["a" /* ControversyServiceMixim */], __WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  props: ['visible', 'controversySelected', 'isGoingToAttend', 'order'],
  data: function data() {
    return {
      title: null,
      okTitle: '',
      errorText: '',
      controversyData: {
        text: null,
        tag: __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default.a.TAGS_MAPPING['CT'].key,
        actionInProgress: false
      },
      tagsMapping: __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default.a.TAGS_MAPPING
    };
  },

  watch: {
    visible: function visible(newVal, oldVal) {
      if (this.visible === true) {
        this.$refs.controversyModal.show();
      }
    }
  },
  computed: {
    ctOptions: function ctOptions() {
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.tagsMapping);
      var options = [];

      for (var i = 0; i < data.length; i++) {
        if (data[i][1].isCt === true) {
          options.push({
            text: data[i][1].text + ' [' + data[i][1].key + ']',
            value: data[i][1].key
          });
        }
      }
      return options;
    }
  },
  methods: {
    onShown: function onShown(evt) {
      this.controversyData.text = null;
      this.controversyData.tag = __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default.a.TAGS_MAPPING['CT'].key;

      if (this.isGoingToAttend === true) {
        this.title = 'Atender controversia';
        this.okTitle = 'Atender Controvesia';
      } else {
        this.okTitle = this.controversySelected ? 'Agregar nota' : 'Crear Controversia';
        this.title = this.controversySelected ? 'Agregar Nota' : 'Crear controversia';
      }
    },
    onHide: function onHide(evt) {
      this.$emit('onControversyModalHide');
    },
    _performAction: function _performAction() {
      this.errorText = '';
      if (!this.controversySelected) {
        return this._createControversy();
      } else {
        if (this.isGoingToAttend === true) {
          return this._attendControversy();
        } else {
          return this._addNote();
        }
      }
    },
    _attendControversy: function _attendControversy() {
      var _this = this;

      this.controversyData.actionInProgress = true;

      this.updateControversy(this.order.id, this.controversySelected.id, true).then(function () {
        _this.controversySelected._rowVariant = 'success';
        _this.controversySelected.active = true;

        if (_this.controversyData.text === null) {
          _this.controversyData.actionInProgress = false;
          _this.controversyData.text = null;
          _this.$refs.controversyModal.hide();
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('Success');
        }

        return _this.addControversyNote(_this.order.id, _this.controversySelected.id, _this.controversyData.text).then(function (newComment) {
          _this.controversySelected.comments.push(newComment.body);
          _this.controversyData.actionInProgress = false;
          _this.controversyData.text = null;
          _this.$refs.controversyModal.hide();
        }, function (error) {
          _this.errorText = error.body.message || 'Controvercia atendida pero la nota de atencion no fue creada';
        });
      }, function (error) {
        _this.errorText = error.body.message || 'error atendiendo la controvercia';
      });
    },
    _addNote: function _addNote() {
      var _this2 = this;

      this.controversyData.actionInProgress = true;
      this.addControversyNote(this.order.id, this.controversySelected.id, this.controversyData.text).then(function (newComment) {
        _this2.controversySelected.comments.push(newComment.body);
        _this2.controversyData.actionInProgress = false;
        _this2.controversyData.text = null;
        _this2.$refs.controversyModal.hide();
      }, function (error) {
        _this2.errorText = error.body.message || 'error agregando la nota a la controvercia';
      });
    },
    _createControversy: function _createControversy() {
      var _this3 = this;

      this.controversyData.actionInProgress = true;
      var text = '<b>[' + this.tagsMapping[this.controversyData.tag].text + ']</b> ' + this.controversyData.text;
      this.createControversy(this.order.id, text, this.controversyData.tag).then(function (newControversy) {
        if (!_this3.order.controversies) {
          _this3.order.controversies = [];
        }
        newControversy.body._rowVariant = 'danger';
        _this3.order.controversies.push(newControversy.body);

        if (_this3.order.tags.indexOf(_this3.controversyData.tag) === -1) {
          _this3.order.tags.push(_this3.controversyData.tag);
        }

        _this3.controversyData.actionInProgress = false;
        _this3.$refs.controversyModal.hide();
      }, function (error) {
        _this3.errorText = error.body.message || 'error creando la controvercia';
      });
    },
    createControversyActionButton: function createControversyActionButton(e) {
      e.preventDefault();
      this.controversyData.actionInProgress = true;
      this._performAction();
    }
  }
});

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',[_c('b-modal',{ref:"controversyModal",attrs:{"header-bg-variant":"primary","centered":"","size":"lg","centered":"","id":"controversyModal","title":_vm.title,"o-close-on-backdrop":"true","cancel-title":"Cancelar","ok-disabled":!_vm.isValidTextArea(_vm.controversyData.text, true),"ok-title":_vm.okTitle},on:{"shown":_vm.onShown,"hide":_vm.onHide,"ok":_vm.createControversyActionButton}},[_c('moon-loader',{attrs:{"loading":_vm.controversyData.actionInProgress,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(_vm._s(_vm.errorText))]),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.controversyData.actionInProgress),expression:"!controversyData.actionInProgress"}],ref:"controversyForm"},[_c('b-form-group',{attrs:{"invalid-feedback":!_vm.isValidTextArea(_vm.controversyData.text, true) ? 'El campo esta vacío' : '',"state":_vm.isValidTextArea(_vm.controversyData.text, true)}},[_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Ingrese el texto de la controvesia.","rows":3,"max-rows":6},model:{value:(_vm.controversyData.text),callback:function ($$v) {_vm.$set(_vm.controversyData, "text", $$v)},expression:"controversyData.text"}})],1),_vm._v(" "),(!Boolean(_vm.controversySelected))?_c('b-form-group',{attrs:{"label":"Seleccione el tipo de controvesia"}},[_c('b-form-select',{attrs:{"options":_vm.ctOptions},model:{value:(_vm.controversyData.tag),callback:function ($$v) {_vm.$set(_vm.controversyData, "tag", $$v)},expression:"controversyData.tag"}})],1):_vm._e()],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControversyDetailModal_vue__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb1a26c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControversyDetailModal_vue__ = __webpack_require__(756);
function injectStyle (ssrContext) {
  __webpack_require__(754)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fb1a26c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControversyDetailModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb1a26c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControversyDetailModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_ControversyServiceMixim_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'controversy-detail-modal',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_ControversyServiceMixim_js__["a" /* ControversyServiceMixim */], __WEBPACK_IMPORTED_MODULE_1__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */]],
  props: ['visible', 'controversySelected', 'order'],
  data: function data() {
    return {
      title: null,
      errorText: '',
      controversyData: {
        text: null,
        actionInProgress: false
      },
      fileNotSupported: null,
      imageData: null,
      image: null,
      locale: __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.LOCALE
    };
  },

  watch: {
    visible: function visible(newVal, oldVal) {
      if (this.visible === true) {
        this.$refs.controversyModal.show();
      }
    }
  },
  methods: {
    onHide: function onHide(evt) {
      this.$emit('onControversyModalHide');
    }
  }
});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',[_c('b-modal',{ref:"controversyModal",attrs:{"header-bg-variant":"primary","centered":"","size":"lg","centered":"","id":"controversyModal","title":"Detalles Controversia","o-close-on-backdrop":"true","ok-title":"Cerrar","ok-only":""},on:{"hide":_vm.onHide}},[_c('moon-loader',{attrs:{"loading":_vm.controversyData.actionInProgress,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger"},[_c('i',{staticClass:"fa fa-exclamation-circle"}),_vm._v(_vm._s(_vm.errorText))]),_vm._v(" "),_c('b-card',{attrs:{"title":"Notas"}},[(_vm.controversySelected)?_c('ul',_vm._l((_vm.controversySelected.comments),function(comment){return _c('li',{staticClass:"controversy-note"},[_c('b',[_vm._v(_vm._s(new Date(comment.date).toLocaleDateString(_vm.locale)))]),_vm._v(" - "+_vm._s(comment.text)+"\n          ")])})):_vm._e()])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_incidents_incidentsCommentModal__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_IncidentsServices__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ProductServiceMixim_js__ = __webpack_require__(14);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'incidents-table',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__["a" /* default */], incidentsComments: __WEBPACK_IMPORTED_MODULE_3__components_incidents_incidentsCommentModal__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixims_IncidentsServices__["a" /* IncidentsServices */], __WEBPACK_IMPORTED_MODULE_5__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  props: ['data', 'filters', 'showIncidenceDetail', 'addReferenceLink'],
  data: function data() {
    return {
      currentRow: null,
      showIncidentsComments: false,
      fields: [{ key: 'creationDate', label: 'Fecha', 'class': 'text-left' }, { key: 'reference', label: 'Referencia', 'class': 'text-left' }, { key: 'author', label: 'Autor', 'class': 'text-left' }, { key: 'priority', label: 'Prioridad', 'class': 'text-left' }, { key: 'accountName', label: 'Asignado A', 'class': 'text-left' }, { key: 'status', label: 'Estado', 'class': 'text-left' }, { key: 'title', label: 'Título', 'class': 'text-left' }, { key: 'actions', label: 'Acciones', 'class': 'text-left' }],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      salesRows: [],
      disableFilterButton: false,
      tableFilterInfo: null,
      loading: true,
      locale: __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.CURRENCY,
      incidentToSolve: null
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    userType: function userType(accountName) {
      var organizationsKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$store.getters.organizations);
      if (organizationsKeys.indexOf(accountName) > 0) {
        return 'Seller';
      }

      return 'Admin';
    },
    mapPriority: function mapPriority(priority) {
      switch (priority) {
        case 'HIGH':
          return 'text-danger';
        case 'HALF':
          return 'text-warning';
        case 'LOW':
          return 'text-success';
      }
    },
    saveComment: function saveComment() {
      this.showIncidentsComments = false;
      this.refresh();
    },
    openModalComment: function openModalComment(incident) {
      this.currentRow = incident;
      this.showIncidentsComments = true;
    },
    editThisRow: function editThisRow(item) {
      this.$emit('selected', item);
    },
    itemProvider: function itemProvider(tableInfo) {
      var _this = this;

      this.showModal = false;
      this.loading = true;
      return this.getIncidents(tableInfo, this.filters).then(function (response) {
        _this.totalRows = parseInt(response.headers.get('X-Total-Count'));
        _this.loading = false;
        return response.body;
      }).catch(function (error) {
        _this.errorText = error.body.message || 'Error obteniendo el listado de transportadoras';
        _this.loading = false;
        return [];
      });
    },
    refresh: function refresh() {
      this.$refs.mainTable.refresh();
    },
    markAsSolved: function markAsSolved(incident) {
      this.incidentToSolve = incident;
      this.$refs.confirmationCloseIncidentModal.show();
    },
    solveIncident: function solveIncident(incident) {
      var _this2 = this;

      incident.status = 'CLOSE';
      this.updateIncident(incident.id, incident).then(function (response) {
        _this2.refresh();
      });
    },
    ViewIncidence: function ViewIncidence(incidence) {
      this.$router.push({ path: '/incidents/list', query: { ref: incidence.reference } });
    },
    routeTo: function routeTo(incidence) {
      var route = '';
      if (incidence.incidenceType === 'ORDER') route = '/orders/orderDetail/' + incidence.reference;
      if (incidence.incidenceType === 'PRODUCT') route = '/catalog/details/' + incidence.reference;
      return route;
    },
    routeToSku: function routeToSku(incidence) {
      var _this3 = this;

      if (incidence.incidenceType === 'SKU') {
        var filter = {
          sku: { desde: null, hasta: null },
          upc: { desde: null, hasta: null },
          fecha: { desde: null, hasta: null },
          category: { id: null, text: null },
          fromQuantity: null,
          toQuantity: null,
          account: null,
          text: incidence.reference
        };
        var tableFilterInfo = { currentPage: 1, perPage: 2 };
        this.getProducts(tableFilterInfo, filter).then(function (response) {
          _this3.$router.push({ path: '/catalog/details/' + response.body[0].id, query: { sku: incidence.reference } });
        }, function (error) {
          console.log(error);
          return [];
        });
      }
    },
    getPriorityText: function getPriorityText(priority) {
      switch (priority) {
        case 'HIGH':
          return 'Alta';
        case 'HALF':
          return 'Media';
        case 'LOW':
          return 'Baja';
      }
    },
    getStatusText: function getStatusText(priority) {
      switch (priority) {
        case 'CLOSE':
          return 'Cerrada';
        case 'INPROGRESS':
          return 'En progreso';
        case 'OPEN':
          return 'Abierta';
      }
    }
  }
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_incidentsCommentModal_vue__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059c1be3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_incidentsCommentModal_vue__ = __webpack_require__(762);
function injectStyle (ssrContext) {
  __webpack_require__(760)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_incidentsCommentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059c1be3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_incidentsCommentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_IncidentsServices__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'incidents-comment-modal',
  props: ['show', 'historical', 'incident'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixims_ValidationsMixim__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_2__mixims_IncidentsServices__["a" /* IncidentsServices */]],
  data: function data() {
    return {
      errorText: '',
      comment: {},
      limitComment: 1000,
      locale: __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.LOCALE
    };
  },

  watch: {
    show: function show() {
      if (this.show) {
        this.$refs.incidentsComments.show();
      } else if (!this.show) {
        this.$refs.incidentsComments.hide();
      }
    }
  },
  computed: {
    remainingCharcaters: function remainingCharcaters() {
      return this.comment.body !== undefined ? this.limitComment - this.comment.body.length : this.limitComment;
    },
    userText: function userText() {
      return this.$store.state.user_data.firstName + ' ' + this.$store.state.user_data.lastName;
    },
    state: function state() {
      return {
        comment: this.isValidTextArea(this.comment.body, true, this.limitComment)
      };
    }
  },
  methods: {
    commentReachLimit: function commentReachLimit() {
      return !this.state.comment ? this.comment.body !== undefined && this.comment.body.length > this.limitComment ? 'El máximo número de caracteres es: ' + this.limitComment : 'Ingrese un comentario' : '';
    },
    disableSave: function disableSave() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.state).includes(false);
    },
    resetModal: function resetModal() {
      this.comment = {};
    },
    cancel: function cancel() {
      this.resetModal();
      this.$emit('update:show', false);
    },
    modalOk: function modalOk() {
      var _this = this;

      var comment = {
        text: this.comment.body
      };

      this.addCommentToIncident(this.incident.id, comment).then(function (response) {
        _this.$refs.incidentsComments.hide();
        _this.$emit('saved');
      }).catch(function (error) {
        _this.errorText = error.body.message || 'Ocurrió un error al crear la incidencia';
      });
    }
  }
});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"incidentsComments",attrs:{"id":"incidentsComments","size":"lg","header-bg-variant":"primary","centered":"","hide-footer":false,"title":"Agregar comentario","cancel-title":"Cerrar","ok-title":"Seleccionar"},on:{"hide":_vm.cancel,"cancel":_vm.cancel,"ok":_vm.modalOk}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.errorText = ''}}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('section',{staticClass:"px-4"},[(_vm.incident)?_c('section',[_c('h6',{staticClass:"mt-2 mb-3"},[_vm._v("Historial")]),_vm._v(" "),_c('article',{staticClass:"historial-comments"},_vm._l((_vm.incident.comments),function(comments,index){return _c('div',{key:index,staticClass:"comment mb-2"},[_c('p',{staticClass:"my-0"},[_c('strong',[_vm._v(_vm._s(comments.author))])]),_vm._v(" "),_c('div',{staticClass:"message-blue"},[_c('p',{staticClass:"message-content"},[_vm._v(_vm._s(comments.text))]),_vm._v(" "),_c('div',{staticClass:"message-timestamp-left"},[_c('i',{staticClass:"far fa-calendar-check calendar-history-incidents text-primary"}),_vm._v(_vm._s(new Date(comments.date).toLocaleDateString(_vm.locale)))])])])}))]):_vm._e(),_vm._v(" "),_c('section',[_c('b-form',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('label',{attrs:{"for":"comment"}},[_vm._v("Nuevo comentario:")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"name":"comment","rows":3,"max-rows":6},model:{value:(_vm.comment.body),callback:function ($$v) {_vm.$set(_vm.comment, "body", $$v)},expression:"comment.body"}}),_vm._v(" "),_c('b-row',{attrs:{"align-h":"between"}},[_c('b-col',{staticClass:"limit--reached",attrs:{"cols":"6"}},[_vm._v(_vm._s(_vm.commentReachLimit()))]),_vm._v(" "),_c('b-col',{staticClass:"limit text-right",class:{'no-characters': _vm.remainingCharcaters < 1},attrs:{"cols":"6"}},[_vm._v("\n                      "+_vm._s(_vm.remainingCharcaters)+"\n                    ")])],1)],1)],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"w-100"},[_c('b-button',{staticClass:"float-right mx-1",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.cancel()}}},[_vm._v("\n            Cancelar\n        ")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mx-1",attrs:{"disabled":_vm.disableSave(),"variant":"primary"},on:{"click":_vm.modalOk}},[_vm._v("\n            Agregar\n        ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-modal',{ref:"confirmationCloseIncidentModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationCloseIncidentModal","centered":"","title":_vm.$t('Cerrar incidencia'),"cancel-title":_vm.$t('Cancelar')},on:{"ok":function($event){_vm.solveIncident(_vm.incidentToSolve)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('¿Confirma que desea marcar la incidencia como CERRADA?')))])]),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"md":"10"}},[_c('b',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" "+_vm._s(_vm.$t('incidencias encontradas'))+"\n    ")])],1),_vm._v(" "),_c('b-card',{attrs:{"border-variant":"primary"}},[_c('incidentsComments',{attrs:{"show":_vm.showIncidentsComments,"incident":_vm.currentRow},on:{"update:show":function($event){_vm.showIncidentsComments=$event},"saved":_vm.saveComment}}),_vm._v(" "),_c('moon-loader',{attrs:{"loading":false,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","stacked":"xl","items":_vm.itemProvider,"fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":"true","empty-text":_vm.$t('No hay incidencias para mostrar'),"empty-filtered-text":_vm.$t('No hay incidencias para mostrar')},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-clicked":_vm.editThisRow},scopedSlots:_vm._u([{key:"reference",fn:function(row){return [(_vm.addReferenceLink && (row.item.incidenceType === 'ORDER' || row.item.incidenceType === 'PRODUCT'))?_c('div',[_c('router-link',{attrs:{"to":{ path: _vm.routeTo(row.item)}}},[_vm._v(_vm._s(row.item.reference))])],1):(row.item.incidenceType === 'SKU')?_c('div',[_c('b-button',{staticClass:"primary p-0",attrs:{"variant":"link"},on:{"click":function($event){$event.stopPropagation();_vm.routeToSku(row.item)}}},[_vm._v(_vm._s(row.item.reference))])],1):_c('div',[_vm._v("\n          "+_vm._s(row.item.reference)+"\n        ")])]}},{key:"creationDate",fn:function(row){return [_c('span',[_vm._v(_vm._s(new Date(row.item.creationDate).toLocaleDateString(_vm.locale)))])]}},{key:"author",fn:function(row){return [_vm._v("\n        "+_vm._s(row.item.author.name)+" "+_vm._s(row.item.author.lastName)+"\n      ")]}},{key:"priority",fn:function(row){return [_c('span',{class:_vm.mapPriority(row.item.priority)},[_vm._v(_vm._s(_vm.getPriorityText(row.item.priority)))])]}},{key:"accountName",fn:function(row){return [(!row.item.author.accountName)?_c('span',[_vm._v(_vm._s(row.item.accountName))]):_c('span',{staticClass:"tag Admin"},[_vm._v("Admin")])]}},{key:"status",fn:function(row){return [_vm._v("\n        "+_vm._s(_vm.getStatusText(row.item.status))+"\n      ")]}},{key:"actions",fn:function(row){return [_c('div',{staticClass:"d-flex justify-content-center"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(row.item.status !== 'CLOSE'),expression:"row.item.status !== 'CLOSE'"},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Agregar comentario"},on:{"click":function($event){$event.stopPropagation();_vm.openModalComment(row.item)}}},[_c('i',{staticClass:"fas fa-comment cursor-pointer"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(row.item.status !== 'CLOSE'),expression:"row.item.status !== 'CLOSE'"},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Marcar como resuelto"},on:{"click":function($event){$event.stopPropagation();_vm.markAsSolved(row.item)}}},[_c('i',{staticClass:"fas fa-check-circle cursor-pointer ml-2"})]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIncidenceDetail),expression:"showIncidenceDetail"},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Ver incidencia"},on:{"click":function($event){$event.stopPropagation();_vm.ViewIncidence(row.item)}}},[_c('i',{staticClass:"fas fa-eye cursor-pointer ml-2"})])])]}}])})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"col-md-auto",attrs:{"cols":"12","sm":"6","md":"6"}},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page",attrs:{"cols":"12","sm":"6","md":"6"}},[_c('b-form-group',{staticClass:"form-page-custom",attrs:{"id":"perPage","horizontal":""}},[_c('label',{attrs:{"for":"perPage"}},[_vm._v("Mostrar por página")]),_vm._v(" "),_c('b-form-select',{attrs:{"options":_vm.pageOptions,"for":"perPage","label-cols":12},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('invoice-modal',{ref:"invoiceModalComponent",attrs:{"centered":"","order":_vm.orderDetail,"successCallback":_vm.invoiceSucessCallback}}),_vm._v(" "),_c('controversy-modal',{attrs:{"isGoingToAttend":_vm.isGoingToAttend,"order":_vm.orderDetail,"visible":_vm.controversyModalVisible,"controversySelected":_vm.controversySelected,"successCallback":_vm._updateButtonsVisibility},on:{"onControversyModalHide":_vm._controversyModalHideCallback}}),_vm._v(" "),_c('controversy-detail-modal',{attrs:{"order":_vm.orderDetail,"visible":_vm.controvercyDetailModalVisible,"controversySelected":_vm.controversySelected},on:{"onControversyModalHide":_vm._controversyDetailsModalHideCallback}}),_vm._v(" "),_c('b-modal',{ref:"deliveryModal",attrs:{"centered":"","headerBgVariant":"primary","id":"deliveryModal","size":"lg","title":_vm.$t('Confirmar entrega'),"o-close-on-backdrop":"true","cancel-title":_vm.$t('Cancelar'),"ok-title":_vm.$t('Confirmar'),"ok-disabled":_vm.toDeliveryArray.length === 0 || _vm.loading},on:{"ok":_vm._execDelivery}},[(_vm.orderDetail.packageAttachment && _vm.orderDetail.packageAttachment.packages && _vm.orderDetail.packageAttachment.packages.length > 0)?[_vm._l((_vm.orderDetail.packageAttachment.packages),function(item,index){return [(item.courierStatus && item.courierStatus.finished)?_c('div',{staticClass:"package-container"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('Factura'))+": "+_vm._s(item.invoiceNumber)),_c('span',{staticClass:"package-finished-label"},[_vm._v(_vm._s(_vm.$t('Entrega confirmada')))])])]),_vm._v(" "),_c('ul',_vm._l((item.items),function(product,index){return _c('li',{staticClass:"mb-1"},[_vm._v("\n                "+_vm._s(_vm.getProductNameById(product.id))+" ("+_vm._s(product.quantity)+" items)\n              ")])}))]):_vm._e(),_vm._v(" "),(item.courierStatus && !item.courierStatus.finished)?_c('div',{staticClass:"package-container"},[_c('b-form-checkbox',{staticClass:"ml-4",attrs:{"disabled":!item.trackingNumber,"value":item},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.toDeliveryArray),callback:function ($$v) {_vm.toDeliveryArray=$$v},expression:"toDeliveryArray"}},[_c('b',[_vm._v("Factura: "+_vm._s(item.invoiceNumber)+" "+_vm._s(!item.trackingNumber ? '(No es posinle entregar ya que no tiene datos de tracking)' : ''))])]),_vm._v(" "),_c('div',{staticClass:"ml-4"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('Productos'))+" ")]),_vm._v(_vm._s(_vm.$tc('{count} items', item.totalItems,{count: item.totalItems})))]),_vm._v(" "),_c('ul',_vm._l((item.items),function(product,index){return _c('li',{staticClass:"mb-1 textControl"},[_vm._v("\n                "+_vm._s(product.name ? product.name : _vm.getProductNameById(product.id))+" ("+_vm._s(product.quantity)+" items) - "+_vm._s(_vm.currency)+" "+_vm._s(product.price)+"\n              ")])}))])],1):_vm._e()]}),_vm._v(" "),_c('h5',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.$t('Paquetes que seran confirmados de entrega')))]),_vm._v(" "),_vm._l((_vm.toDeliveryArray),function(pack,index){return _c('p',[_c('b',[_vm._v("Paquete "+_vm._s(parseInt(index) + 1))]),_vm._v(" - Factura ("+_vm._s(pack.invoiceNumber)+")\n      ")])})]:_vm._e()],2),_vm._v(" "),_c('b-modal',{ref:"confirm",attrs:{"centered":"","headerBgVariant":"primary","id":"confirm","size":"lg","title":_vm.confirm.title,"o-close-on-backdrop":"true","cancel-title":_vm.$t('Cancelar'),"ok-title":_vm.$t('Aceptar')},on:{"ok":_vm.confirm.callback}},[[_c('div',{staticClass:"warning-text"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.confirm.confirmBody)}},[_vm._v(_vm._s(_vm.confirm.confirmBody))])])]],2),_vm._v(" "),_c('b-row',[_c('b-col',[_c('moon-loader',{staticClass:"topLoading",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"md":"7"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('Orden {orderId} ({accountName})', {'orderId': _vm.orderId, 'accountName': _vm.orderDetail.accountName }))),_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.print}},[_c('i',{staticClass:"fas fa-print mr-1"}),_vm._v("Imprimir")])],1),_vm._v(" "),_c('p',{staticClass:"order-date"},[(_vm.orderDetail.creationDate)?_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(new Date(_vm.orderDetail.creationDate).toLocaleDateString(_vm.locale)))]):_vm._e(),_vm._v(" "),_vm._l((_vm.orderDetail.tags),function(tagElemKey,index){return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],key:index,staticClass:"tag",class:_vm.tagsMapping[tagElemKey].bg,attrs:{"title":_vm.tagsMapping[tagElemKey].description}},[_vm._v("\n          "+_vm._s(tagElemKey)+"\n        ")])})],2)]),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.buttonsDisabled,"to":"/orders/list"}},[_c('i',{staticClass:"fas fa-undo-alt mr-1"}),_vm._v(_vm._s(_vm.$t('Regresar')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.invoiceButtonVisible),expression:"invoiceButtonVisible"}],staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.buttonsDisabled,"type":"button"},on:{"click":function($event){_vm.$refs.invoiceModalComponent.show()}}},[_c('i',{staticClass:"far fa-money-bill-alt mr-1"}),_vm._v(_vm._s(_vm.$t('Facturar')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.startHandlingButtonVisible),expression:"startHandlingButtonVisible"}],staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.buttonsDisabled,"type":"button"},on:{"click":_vm.startHandlingAction}},[_c('i',{staticClass:"fas fa-play mr-1"}),_vm._v(_vm._s(_vm.$t('Iniciar Manejo')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.cancelButtonVisible),expression:"cancelButtonVisible"}],staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.buttonsDisabled,"type":"button"},on:{"click":_vm.cancelAction}},[_c('i',{staticClass:"far fa-times-circle mr-1"}),_vm._v(_vm._s(_vm.$t('Cancelar')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.deliveryButtonVisible),expression:"deliveryButtonVisible"}],staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.buttonsDisabled,"type":"button"},on:{"click":_vm.deliverAction}},[_c('i',{staticClass:"fas fa-truck mr-1"}),_vm._v(_vm._s(_vm.$t('Entregar')))])],1)],1),_vm._v(" "),(_vm.orderDetail.shippingData)?_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(Object.keys(_vm.shippingsExcluded).find(function (key) { return _vm.shippingsExcluded[key] === _vm.orderDetail.shippingData.logisticsInfo[0].deliveryCompany; }) && _vm.orderDetail.status !== 'order-handling'),expression:"Object.keys(shippingsExcluded).find(key => shippingsExcluded[key] === orderDetail.shippingData.logisticsInfo[0].deliveryCompany) && orderDetail.status !== 'order-handling'"}]},[_c('b-col',[_c('div',{staticClass:"alert alert-info",attrs:{"role":"alert"}},[_vm._v("El pedido tiene asignado el carrier "+_vm._s(_vm.orderDetail.shippingData.logisticsInfo[0].deliveryCompany)+", el cual administra la generación de guía, se podrá descargar una guía de envío desde la sección de datos de envío")])])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-card',{attrs:{"header":_vm.$t('Cliente')}},[(_vm.orderDetail.clientProfileData)?[_c('p'),_c('h5',[_vm._v(_vm._s(_vm.orderDetail.clientProfileData.firstName)+" "+_vm._s(_vm.orderDetail.clientProfileData.lastName))]),_c('p'),_vm._v(" "),_c('p',{staticClass:"user-email"},[_c('i',{staticClass:"fa fa-envelope-square"}),_vm._v(" "),_c('a',{attrs:{"href":("mailto:" + (_vm.orderDetail.clientProfileData.email))}},[_vm._v(_vm._s(_vm.orderDetail.clientProfileData.email))])]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-phone"}),_vm._v(" "+_vm._s(_vm.orderDetail.clientProfileData.phone))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('DNI'))+" "+_vm._s(_vm.orderDetail.clientProfileData.document))])]:_vm._e()],2)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-card',{attrs:{"header":_vm.$t('Dirección de entrega')}},[(_vm.orderDetail.shippingData)?[_c('p'),_c('h5',[_vm._v(_vm._s(_vm.orderDetail.shippingData.address.receiverName))]),_c('p'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderDetail.shippingData.address.street)+", "+_vm._s(_vm.orderDetail.shippingData.address.number)),(_vm.orderDetail.shippingData.address.complement)?[_vm._v(", "+_vm._s(_vm.orderDetail.shippingData.address.complement))]:_vm._e()],2),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderDetail.shippingData.address.neighborhood))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderDetail.shippingData.address.city)+" / "+_vm._s(_vm.orderDetail.shippingData.address.state))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.orderDetail.shippingData.address.postalCode)+" - "+_vm._s(_vm.orderDetail.shippingData.address.country))]),_vm._v(" "),(_vm.orderDetail.shippingData.address.reference)?_c('p',[_vm._v("Punto de referencia: "+_vm._s(_vm.orderDetail.shippingData.address.reference))]):_vm._e()]:_vm._e()],2)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-card',{attrs:{"header":'Total (' + (_vm.orderDetail.status === 'payment-pending' ? 'Pedido no pagado)' : 'Pedido pagado)')}},[_c('h4',[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.orderDetail.value))]),_vm._v(" "),_vm._l((_vm.orderDetail.totals),function(item){return _c('p',[_vm._v("\n          "+_vm._s(item.name)+" - "),_c('b',[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(item.value))])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"my-3"},[(_vm.promoLoaded)?_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse-promos",modifiers:{"collapse-promos":true}}],staticClass:"p-0",attrs:{"variant":"link","size":"md"}},[_c('span',[_c('b',[_vm._v("Promociones aplicadas ("+_vm._s(_vm.orderPromos.length)+")")])])]):_vm._e(),_vm._v(" "),(!_vm.promoLoaded)?_c('span',[_vm._v("Obteniendo las promociones...")]):_vm._e()],1),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":"collapse-promos"}},_vm._l((_vm.orderPromos),function(promo){return _c('p',[_c('span',[_c('i',{staticClass:"fas fa-tag mr-2"}),_vm._v(_vm._s(promo.scName)+"\n              "),_c('span',{staticClass:"usertype-tag"},[_vm._v(_vm._s(promo.userType))])]),_vm._v(" "),_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse-' + promo.scName),expression:"'collapse-' + promo.scName"}],attrs:{"variant":"link","size":"sm"}},[_c('span',[_vm._v("ver")])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt-2",attrs:{"id":'collapse-' + promo.scName}},[_c('b-card',[_c('p',[_vm._v(_vm._s(promo.description))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(promo.percentualDiscountValue !== 0 ? promo.percentualDiscountValue + '%' : promo.nominalDiscountValue + ' ' +_vm.currency))])])])],1)],1)}))],2)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_c('b-card',{staticClass:"status-card",attrs:{"header-bg-variant":_vm.statusVariantClass,"border-variant":_vm.statusVariantClass},on:{"click":function($event){_vm.showHistorialStatus= !_vm.showHistorialStatus}}},[_c('template',{slot:"header"},[_c('div',{staticClass:"d-flex"},[_c('p',{staticClass:"col-10 p-0 card-title"},[_vm._v(_vm._s(_vm.$t('Estado')))]),_vm._v(" "),_c('p',{staticClass:"col-2 p-0 text-center btn-light btn-history",attrs:{"title":"Ver historial"}},[_c('i',{staticClass:"fas fa-history"})])])]),_vm._v(" "),_c('p'),_c('h4',[_vm._v(_vm._s(_vm.$t(_vm.statusMapping[_vm.orderDetail.status])))]),_c('p')],2)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.showHistorialStatus),expression:"showHistorialStatus"}]},[_c('b-card',{attrs:{"header":_vm.$t('Historial de estados')}},[_c('b-table',{attrs:{"striped":"","fields":_vm.statusHistoriesFields,"items":_vm.orderDetail.statusHistories,"hover":"","outlined":"","head-variant":"light","small":true,"empty-text":"No hay historial de estados"},scopedSlots:_vm._u([{key:"user",fn:function(row){return [(row.item.user)?_c('span',[_vm._v(_vm._s(row.item.user.lastName)+", "+_vm._s(row.item.user.firstName)+" ("+_vm._s(row.item.user.email)+")")]):_c('span',[_vm._v("-")])]}},{key:"status",fn:function(row){return [_c('span',[_vm._v(_vm._s(_vm.statusMapping[row.item.status]))])]}},{key:"date",fn:function(row){return [_c('span',[_vm._v("\n              "+_vm._s(new Date(row.item.creationDate).toLocaleDateString(_vm.locale))+"\n              "+_vm._s(new Date(row.item.creationDate).toLocaleTimeString(_vm.locale, { hour12: false }))+"\n            ")])]}}])})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"7"}},[_c('b-card',{attrs:{"header":_vm.$t('Items')}},[_c('b-table',{attrs:{"striped":"","items":_vm.orderDetail.items,"hover":"","outlined":"","head-variant":"light","fields":_vm.isAdmin? _vm.itemsFieldsAdmin : _vm.itemsFields,"small":true},scopedSlots:_vm._u([{key:"price",fn:function(row){return [_c('span',[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(row.item.price))])]}},{key:"actions",fn:function(row){return [(row.item.priceTags && row.item.priceTags.length > 0)?[_c('b-button',{staticClass:"mr-2",attrs:{"variant":"link","size":"sm"},on:{"click":row.toggleDetails}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v("\n                Promociones\n              ")])]:_vm._e()]}},{key:"row-details",fn:function(row){return [_c('div',{staticClass:"p-2"},_vm._l((row.item.priceTags),function(promo){return _c('div',{key:promo.identifier},[(promo.description)?_c('p',[_c('span',[_c('i',{staticClass:"fas fa-tag mr-2"}),_vm._v(_vm._s(promo.scName))]),_vm._v(" "),_c('span',[_vm._v("("),_c('b',[_vm._v(_vm._s(promo.percentualDiscountValue !== 0 ? promo.percentualDiscountValue + '%' : promo.nominalDiscountValue + ' ' +_vm.currency))]),_vm._v(")")]),_vm._v(" "),_c('span',{staticClass:"usertype-tag"},[_vm._v(_vm._s(promo.userType))])]):_c('p',[_c('span',[_c('i',{staticClass:"fas fa-tag mr-2"}),_vm._v("Promo Ecommerce")]),_vm._v(" "),_c('span',[_vm._v("("),_c('b',[_vm._v(_vm._s(promo.percentualDiscountValue !== 0 ? promo.percentualDiscountValue + '%' : promo.nominalDiscountValue + ' ' +_vm.currency))]),_vm._v(")")]),_vm._v(" "),_c('span',{staticClass:"usertype-tag"},[_vm._v("ECOMMERCE")])])])}))]}}])}),_vm._v(" "),_c('div',{staticClass:"table-total"},[_vm._v(_vm._s(_vm.$t('Total de los items'))+": "),_c('b',[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.orderDetail.totals !== undefined? _vm.orderDetail.totals[0].value : '0'))])]),_vm._v(" "),_c('div',{staticClass:"table-total"},[_vm._v("Total con descuentos: "),_c('b',[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.orderDetail.value !== undefined? _vm.orderDetail.value : '0'))])])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"5"}},[_c('b-card',{staticClass:"shipping",attrs:{"header":_vm.$t('Datos de envío')}},[(_vm.orderDetail.packageAttachment && _vm.orderDetail.packageAttachment.packages && _vm.orderDetail.packageAttachment.packages.length > 0)?[_c('p',[_c('b',[_c('i',{staticClass:"fas fa-truck mr-2"}),_vm._v(_vm._s(_vm.$t('Forma de entrega'))+": ")]),_vm._v(" "+_vm._s(_vm.orderDetail.shippingData.logisticsInfo[0].selectedSla)+" - "+_vm._s(_vm.orderDetail.shippingData.logisticsInfo[0].deliveryCompany)+" ")]),_vm._v(" "),_c('p',{staticClass:"mb-4"},[_c('b',[_c('i',{staticClass:"far fa-clock mr-2"}),_vm._v(_vm._s(_vm.$t('Tiempo Estimado'))+": ")]),_vm._v(" "+_vm._s(_vm.orderDetail.shippingData.logisticsInfo[0].shippingEstimate.replace('bd', _vm.$t('días hábiles'))))]),_vm._v(" "),_vm._l((_vm.orderDetail.packageAttachment.packages),function(item,index){return _c('div',{staticClass:"package-container"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('Paquete'))+" "+_vm._s(parseInt(index) + 1)+" - Factura ("+_vm._s(item.invoiceNumber)+") "),(item.courierStatus.finished)?_c('span',{staticClass:"package-finished-label"},[_vm._v("entregado")]):_vm._e()])]),_vm._v(" "),(!item.trackingNumber && !Object.keys(_vm.shippingsExcluded).find(function (key) { return _vm.shippingsExcluded[key] === _vm.orderDetail.shippingData.logisticsInfo[0].deliveryCompany; }))?_c('p',[_c('i',[_vm._v("(Faltan datos de tracking, ver detalles)")])]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Fecha de emisión: "+_vm._s(new Date(item.issuanceDate).toLocaleDateString(_vm.locale)))]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v("Total: "+_vm._s(_vm.currency)+" "+_vm._s(item.invoiceValue))]),_vm._v(" "),(!_vm.isAdmin && !item.trackingNumber && !Object.keys(_vm.shippingsExcluded).find(function (key) { return _vm.shippingsExcluded[key] === _vm.orderDetail.shippingData.logisticsInfo[0].deliveryCompany; }))?_c('b-button',{attrs:{"disabled":_vm.buttonsDisabled,"variant":"outline-primary"},on:{"click":function($event){_vm.$refs.invoiceModalComponent.show(item.invoiceNumber)}}},[_vm._v("Datos de Tracking")]):_vm._e(),_vm._v(" "),(!_vm.isAdmin && item.courierStatus && !item.courierStatus.finished && !Object.keys(_vm.shippingsExcluded).find(function (key) { return _vm.shippingsExcluded[key] === _vm.orderDetail.shippingData.logisticsInfo[0].deliveryCompany; }))?_c('b-button',{attrs:{"disabled":!item.trackingNumber || _vm.buttonsDisabled,"variant":"outline-primary"},on:{"click":function($event){_vm.deliverPackage(item.invoiceNumber)}}},[_vm._v("Entregar")]):_vm._e(),_vm._v(" "),_c('div',[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('collapse-' + item.invoiceNumber),expression:"'collapse-' + item.invoiceNumber"}],staticClass:"p-0 my-2",attrs:{"variant":"link","size":"sm"}},[_vm._v("(Trancking y Productos)")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":'collapse-' + item.invoiceNumber}},[(item.trackingNumber)?[_c('p',[_vm._v(_vm._s(_vm.$t('Empresa de mensajería'))+" "),_c('b',[_vm._v(_vm._s(item.courier))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('Número guía'))+" "),_c('b',[_vm._v(_vm._s(item.trackingNumber))])]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$t('URL guía'))+" "),_c('b',[_vm._v(_vm._s(item.trackingUrl))])]),_vm._v(" "),(Boolean(item.urlTrackingLabel))?_c('p',[_c('a',{attrs:{"target":"_blank","href":item.urlTrackingLabel}},[_vm._v("Descargar Guia")])]):_vm._e()]:_vm._e(),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_c('b',[_vm._v(_vm._s(_vm.$t('Productos')))])]),_vm._v(" "),_c('ul',_vm._l((item.items),function(product,index){return _c('li',[_c('span',{staticClass:"quantity"},[_vm._v(_vm._s(product.quantity))]),_vm._v(" "+_vm._s(_vm.getProductNameById(product.id)))])}))],2)],1)})]:[_c('p',[_vm._v(_vm._s(_vm.$t('El estado de la orden es'))+" "),_c('b',[_vm._v(_vm._s(_vm.statusMapping[_vm.orderDetail.status]))]),_vm._v(", "+_vm._s(_vm.$t('no dispone en este estado datos de envío.')))]),_vm._v(" "),_c('hr'),_vm._v(" "),(Boolean(_vm.orderDetail.shippingData))?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$t('Transportadora que fue asignada en el checkout de VTEX con el cual se calculó y se cobro el envío, el Seller puede cambiar luego el courier.')}},[_c('p',[_c('b',[_c('i',{staticClass:"fas fa-truck mr-1"}),_vm._v(_vm._s(_vm.$t('Forma de entrega'))+": ")]),_vm._v("\n              "+_vm._s(_vm.orderDetail.shippingData ? _vm.orderDetail.shippingData.logisticsInfo[0].selectedSla : '')+" -\n              "+_vm._s(_vm.orderDetail.shippingData.logisticsInfo[0].deliveryCompany)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"mb-3"},[_c('b',[_c('i',{staticClass:"far fa-clock mr-1"}),_vm._v(_vm._s(_vm.$t('Tiempo Estimado'))+": ")]),_vm._v(" "+_vm._s(_vm.orderDetail.shippingData ? _vm.orderDetail.shippingData.logisticsInfo[0].shippingEstimate.replace('bd', _vm.$t('días hábiles')) : '')+"\n            ")])]):_vm._e()]],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-3 mt-3"},[(false)?_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{staticClass:"controversy-card",attrs:{"title":"Controversias"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.controversyButtonVisible),expression:"controversyButtonVisible"}],staticClass:"add-controversy btn btn-primary float-right mr-2",attrs:{"disabled":_vm.buttonsDisabled,"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showControversyModal(null, false)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v("Crear controvesia")]),_vm._v(" "),_c('b-table',{attrs:{"items":_vm.orderDetail.controversies,"hover":"","fields":_vm.controversyFields,"outlined":"","small":true,"stacked":"md","head-variant":"light"},scopedSlots:_vm._u([{key:"row-details",fn:function(row){return [_c('ul',_vm._l((row.item.comments),function(comment){return _c('li',{staticClass:"controversy-note"},[_c('b',[_vm._v(_vm._s(new Date(comment.date).toLocaleDateString(_vm.locale)))]),_vm._v(" - "+_vm._s(comment.text)+"\n              ")])}))]}},{key:"date",fn:function(date){return [_vm._v("\n            "+_vm._s(new Date(date.value).toLocaleDateString(_vm.locale))+"\n          ")]}},{key:"actions",fn:function(row){return [_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdmin && !row.item.active),expression:"!isAdmin && !row.item.active"}],staticClass:"float-right ml-1",attrs:{"disabled":_vm.buttonsDisabled,"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.showControversyModal(row, true)}}},[_vm._v(_vm._s(_vm.$t('Atender')))]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin),expression:"isAdmin"}],staticClass:"float-right ml-1",attrs:{"disabled":_vm.buttonsDisabled,"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.deleteControversyAction(row)}}},[_vm._v(_vm._s(_vm.$t('Eliminar')))]),_vm._v(" "),_c('b-button',{staticClass:"float-right ml-1",attrs:{"disabled":_vm.buttonsDisabled,"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.showControversyModal(row, false)}}},[_vm._v(_vm._s(_vm.$t('Agregar Nota')))]),_vm._v(" "),_c('b-button',{staticClass:"float-right ml-1",attrs:{"disabled":_vm.buttonsDisabled,"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.showControversyDetailModal(row, false)}}},[_vm._v(_vm._s(_vm.$t('Detalles')))])]}}])})],1)],1):_vm._e(),_vm._v(" "),(false)?_c('b-col',{attrs:{"md":"2"}},[_c('b-card',{staticClass:"tags-card",attrs:{"title":_vm.$t('Etiquetas')}},[_c('b-row',{staticClass:"d-flex justify-content-center"},_vm._l((_vm.orderDetail.tags),function(tagElemKey){return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"tag",class:_vm.tagsMapping[tagElemKey].bg,attrs:{"title":_vm.tagsMapping[tagElemKey].description}},[_vm._v("\n              "+_vm._s(tagElemKey)+"\n            ")])}))],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[(_vm.orderDetail.id)?_c('b-card',{staticClass:"controversy-card",attrs:{"title":"Incidencias"}},[_c('button',{staticClass:"add-controversy btn btn-primary float-right mr-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.createIncidence()}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v("Crear incidencia")]),_vm._v(" "),_c('b-col',[_c('incidents-table',{ref:"indicentsTable",attrs:{"filters":_vm.filters,"showIncidenceDetail":true}})],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('order-details-board',{attrs:{"orderId":_vm.orderId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewProductView_vue__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1212e616_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewProductView_vue__ = __webpack_require__(816);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewProductView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1212e616_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewProductView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_catalog_ProductDetail__ = __webpack_require__(308);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new-product-view',
  components: {
    ProductDetail: __WEBPACK_IMPORTED_MODULE_0__components_catalog_ProductDetail__["a" /* default */]
  }
});

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CategoryTree__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProductAttributes__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SkuModal__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_incidents_IncidentsTable__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_vue_autocomplete__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_editor__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_FormActiveSku__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixims_ProductServiceMixim__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixims_ValidationsMixim_js__ = __webpack_require__(10);


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'productDetail',
  mixins: [__WEBPACK_IMPORTED_MODULE_13__mixims_ProductServiceMixim__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_14__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__["a" /* default */],
    CategoryTree: __WEBPACK_IMPORTED_MODULE_5__CategoryTree__["a" /* default */],
    ProductAttributes: __WEBPACK_IMPORTED_MODULE_6__ProductAttributes__["a" /* default */],
    SkuModal: __WEBPACK_IMPORTED_MODULE_8__SkuModal__["a" /* default */],
    autocomplete: __WEBPACK_IMPORTED_MODULE_10__components_common_vue_autocomplete__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_11_vue2_editor__["a" /* VueEditor */],
    FormActiveSku: __WEBPACK_IMPORTED_MODULE_12__components_common_FormActiveSku__["a" /* default */],
    incidentsTable: __WEBPACK_IMPORTED_MODULE_9__components_incidents_IncidentsTable__["a" /* default */]
  },
  props: ['productId'],
  watch: {
    '$route.params.productId': {
      handler: function handler(newProductId, oldProductId) {
        if (newProductId && newProductId !== oldProductId) {
          this.successText = '';
          this.errorText = '';
          this.variantsSelected = [];
          this.selectedItems = [];
          this.cleanFilters();

          if (this.$route.query.sku) {
            this.tabIndex = 1;
            this.showFilters = true;
            this.filter.sku = this.$route.query.sku;
          }

          this.handleMount();
        }
      },

      immediate: false
    },
    '$route.query.sku': {
      handler: function handler(newSku, oldSku) {
        if (newSku && newSku !== oldSku) {
          this.tabIndex = 1;
          this.showFilters = true;
          this.filter.sku = newSku;
        }
      },

      immediate: false
    }
  },
  data: function data() {
    return {
      productGroupSelection: {
        options: [{ text: 'Seleccione una opción', value: null, disabled: true }, { text: 'Ninguno', value: 'Ninguno' }, { text: 'Todos', value: 'Todos' }],
        current: null
      },
      currentState: '',
      activateProductData: [],
      showModalFooter: false,
      showFilters: false,
      loading: false,
      variantGroupAction: null,
      saveResult: {},
      isAdmin: this.$store.getters.isAdmin,
      product: {
        id: null,
        skus: [],
        category: null,
        brand: null,
        productSpecifications: []
      },
      customToolbar: [[{ font: [] }], [{ header: [false, 1, 2, 3, 4, 5, 6] }], [{ size: ['small', false, 'large', 'huge'] }], ['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }], ['link'], [{ color: [] }, { background: [] }], [{ header: 1 }, { header: 2 }], ['clean']],
      productBrand: [],
      tabIndex: 0,
      specifications: [],
      selectedItems: [],
      successText: '',
      errorText: '',
      confirmationModalData: {
        confirmationModalOkHandler: '',
        confirmationModalCancelHandler: '',
        confirmationModalText: '',
        confirmationModalTitle: ''
      },
      locale: __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.CURRENCY,
      variantCurrentPage: 1,
      variantPerPage: 10,
      variantTotalRows: 0,
      variantPageOptions: [10, 15, 25, 50, 100],

      variantsSelected: [],
      filter: {
        sku: null,
        upc: null,
        estado: null
      },
      fieldsVariant: [{ key: 'selected', label: 'Selección' }, { key: 'upc', label: 'UPC', 'class': 'text-left' }, { key: 'id', label: 'SKU', 'class': 'text-left' }, { key: 'skuName', label: 'Nombre', 'class': 'text-left' }, { key: 'refId', label: 'Identificador', 'class': 'text-left' }, { key: 'price', label: 'Precio con descuento', class: 'priceCol' }, { key: 'inventory', label: 'Inventario', 'class': 'text-left' }, { key: 'status', label: 'Estado', 'class': 'text-left' }, { key: 'actions', label: 'Acciones', 'class': 'text-right' }],
      estados: __WEBPACK_IMPORTED_MODULE_13__mixims_ProductServiceMixim__["a" /* PRODUCT_STATES */],
      incidenceFilters: {
        fromDate: null,
        toDate: null,
        incidenceType: null,
        accountName: null,
        priority: null,
        status: null
      }
    };
  },

  methods: {
    isvalidForm: function isvalidForm(stateForm) {
      this.activateProductData = stateForm.data;
      this.showModalFooter = stateForm.state;
    },
    cleanFilters: function cleanFilters() {
      this.filter.sku = null;
      this.filter.upc = null;
      this.filter.estado = null;
    },
    productGroupSelectionHandler: function productGroupSelectionHandler(selectionType) {
      var _this = this;

      this.variantsSelected.splice(0, this.variantsSelected.length);
      switch (selectionType) {
        case 'Ninguno':
          break;
        case 'Todos':
          this.product.skus.forEach(function (sku) {
            if (!_this.isCheckboxDisabled(sku)) {
              _this.variantsSelected.push(sku.id);
              _this.selectedItems.push(sku);
            }
          });
          break;
        default:
          break;
      }
    },
    showActionModal: function showActionModal(action) {
      this.currentState = action;
      this.confirmationModalData.confirmationModalTitle = 'Confirmar ' + this.currentState;
      this.confirmationModalData.confirmationModalText = this.variantsSelected.length > 1 ? 'Se procedera a ' + this.currentState + ' las ' + this.variantsSelected.length + ' variantes' : 'Se procedera a ' + this.currentState + ' la variante';
      this.$refs.confirmationModal.show();
    },
    handleSaveModal: function handleSaveModal() {
      var _this2 = this;

      var actionFunction = null;
      var errorVerv = '';
      this.successText = '';
      this.errorText = '';
      var _acceptances = null;
      if (this.currentState === 'EliminarProducto') {
        this.loading = true;
        this.errorText = '';
        this.successText = '';
        this.deleteProducts([this.product.id], false).then(function () {
          _this2.loading = false;
          _this2.successText = 'El producto fue eliminado con éxito';
          _this2.$refs.confirmationModal.hide();
          _this2.product = {
            id: null,
            skus: [],
            productSpecifications: []
          };
          _this2.currentState = '';
        }, function (error) {
          _this2.loading = false;
          if (error.status === 409) {
            _this2.errorText = 'Algunos productos/skus no se lograron eliminar. Por favor verifique el estado de los skus.';
            _this2.reloadInformation();
          } else {
            _this2.errorText = error.body.message || 'Error eliminando los productos';
          }
          _this2.currentState = '';
        });
      } else {
        switch (this.currentState) {
          case 'Aprobar':
            actionFunction = this.activateProducts;
            _acceptances = this.activateProductData;
            errorVerv = 'aprobando';
            break;
          case 'Rechazar':
            actionFunction = this.rejectProducts;
            errorVerv = 'rechazando';
            break;
          case 'Eliminar':
            actionFunction = this.deleteProducts;
            errorVerv = 'eliminando';
            break;
        }
        this.confirmationModalData.confirmationModalTitle = 'Confirmar ' + this.currentState;
        this.confirmationModalData.confirmationModalText = this.variantsSelected.length > 1 ? 'Se procedera a ' + this.currentState + ' las ' + this.variantsSelected.length + ' variantes' : 'Se procedera a ' + this.currentState + ' la variante';
        this.loading = '';
        actionFunction(this.variantsSelected, true, _acceptances).then(function () {
          _this2.variantsSelected.splice(0, _this2.variantsSelected.length);
          _this2.successText = 'Se completó la tarea con éxito';
          _this2.loading = false;
          _this2.reloadInformation();
        }, function (error) {
          if (error.status === 409) {
            _this2.errorText = 'Algunos productos/skus no se lograron ' + _this2.currentState.toLowerCase() + '. Por favor verifique el estado de los skus.';
          } else {
            _this2.errorText = error.body.message || 'Error ' + errorVerv + ' los productos';
          }
          _this2.loading = false;
          _this2.reloadInformation();
        });
      }
    },
    handleRowCheckbox: function handleRowCheckbox(sku) {
      var index = this.selectedItems.findIndex(function (selectedItem) {
        return selectedItem.id === sku.id;
      });
      if (index === -1) this.selectedItems.push(sku);else this.selectedItems.splice(index, 1);
    },
    isCheckboxDisabled: function isCheckboxDisabled(item) {
      if (!this.isAdmin) return item.status === 'APPROVED';
    },
    deleteVariant: function deleteVariant(variant) {
      var _this3 = this;

      this.confirmationModalData.confirmationModalTitle = 'Eliminar SKU';
      this.confirmationModalData.confirmationModalText = 'Se procedera a eliminar la variante ' + variant.skuName;
      this.confirmationModalData.confirmationModalOkHandler = function () {
        _this3.loading = true;
        _this3.errorText = '';
        _this3.successText = '';
        _this3.deleteProducts([variant.id], true).then(function () {
          _this3.$refs.confirmationModal.hide();
          _this3.successText = 'La variante fue eliminada con éxito';
          _this3.handleMount();
        }, function (error) {
          _this3.loading = false;
          _this3.errorText = error.body.message || 'Error eliminando la variante';
        });
      };
      this.$refs.confirmationModal.show();
    },
    deleteProduct: function deleteProduct() {
      this.currentState = 'EliminarProducto';
      this.confirmationModalData.confirmationModalTitle = 'Eliminar Producto';
      this.confirmationModalData.confirmationModalText = 'Se procedera a eliminar el producto ' + this.product.id;
      this.$refs.confirmationModal.show();
    },
    reloadInformation: function reloadInformation(response) {
      if (response) {
        if (response.status) {
          this.successText = response.text;
          this.currentState = '';
        } else {
          this.currentState = '';
          this.errorText = response.text;
        }
      }
      this.handleMount();
      this.tabIndex = 1;
    },
    createSku: function createSku() {
      this.errorText = '';
      this.successText = '';
      this.$refs.skuModal.show({
        id: null,
        price: {},
        dimension: {},
        images: [],
        inventory: {},
        commercialCondition: {},
        skuSpecifications: []
      }, this.product);
    },
    variantDbClicked: function variantDbClicked(item) {
      this.errorText = '';
      this.successText = '';
      this.$refs.skuModal.show(JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item)), this.product);
    },
    _pendingProps: function _pendingProps() {
      return this.specificationsComputedMap.some(function (prop) {
        if (prop.value.isRequired) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(prop.value.specificationFieldValues[0]).length === 0 || !prop.value.specificationFieldValues[0].value;
        }
      });
    },
    selectCategory: function selectCategory(category) {
      var _this4 = this;

      this.loading = true;
      this.errorText = '';
      this.product.category = category;
      return this.getProductAtributes(category.id).then(function (res) {
        _this4.product.productSpecifications.splice(0, _this4.product.productSpecifications.length);
        _this4.specifications = res.body;
        _this4.loading = false;
      }, function (error) {
        _this4.loading = false;
        _this4.errorText = error.body.message || 'Error obteniendo los atributos del producto';
      });
    },
    handleMount: function handleMount() {
      var _this5 = this;

      if (this.productId) {
        this.loading = true;
        return this.getProduct().then(function (res) {
          _this5.product = res.body;
          _this5.incidenceFilters.text = _this5.product.id;
          if (_this5.product.productSpecifications === null) {
            _this5.product.productSpecifications = [];
          }
          _this5.variantTotalRows = _this5.product.skus.length;

          if (_this5.product.brand.name) {
            _this5.productBrand.push(_this5.product.brand);
          }
          _this5.$refs.variantTable.refresh();
          return _this5.getProductAtributes(_this5.product.category.id).then(function (specifications) {
            _this5.loading = false;
            _this5.specifications = specifications.body;
          }, function (error) {
            _this5.loading = false;
            _this5.errorText = error.body.message || 'Error obteniendo las especificaciones del producto';
          });
        }, function (error) {
          _this5.loading = false;
          _this5.errorText = error.body.message || 'Error obteniendo el producto';
        });
      }
    },
    handleSave: function handleSave(evt) {
      window.scrollTo(0, 0);
      this.$refs.creationModal.show();
    },
    _createProduct: function _createProduct() {
      var _this6 = this;

      this.errorText = '';
      this.successText = '';

      if (this.product.productSpecifications) {
        this.product.productSpecifications.forEach(function (spec) {
          if (spec.specificationFieldValues && spec.specificationFieldValues.length > 0) {
            var valorActual = spec.specificationFieldValues[0];
            if (valorActual === false || valorActual !== null && (typeof valorActual === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(valorActual)) !== 'object') {
              spec.specificationFieldValues[0] = {
                fieldValueId: null,
                value: null,
                isActive: null
              };
            }
          }
        });
      }
      this.loading = true;
      this.product.brand = this.productBrand[0];
      if (this.product.id) {
        return this.updateProduct(this.product).then(function (res) {
          _this6.successText = 'El producto fue actualizado con exito';
          _this6.loading = false;
        }, function (error) {
          _this6.errorText = error.body.message || 'Error actualizando el producto';
          _this6.loading = false;
        });
      }

      return this.createProduct(this.product).then(function (res) {
        _this6.product.id = res.id;
        _this6.successText = 'El producto fue creado con exito';
        _this6.loading = false;
        _this6.createSku();
      }, function (error) {
        _this6.errorText = error.body.message || 'Error creando el producto';
        _this6.loading = false;
      });
    },
    createIncidence: function createIncidence() {
      this.$router.push({ path: '/incidents/list', query: { product: this.productId } });
    },
    createSkuIncidence: function createSkuIncidence(sku) {
      this.$router.push({ path: '/incidents/list', query: { sku: sku } });
    },
    scrollToIncidence: function scrollToIncidence() {
      var el = this.$refs.IncidenceContainer;
      if (el) {
        el.scrollIntoView();
      }
    }
  },
  mounted: function mounted() {
    if (this.$route.query.sku) {
      this.tabIndex = 1;
      this.showFilters = true;
      this.filter.sku = this.$route.query.sku;
    }
    this.handleMount();
  },

  computed: {
    disableFilterButton: function disableFilterButton() {
      if (!this.isValidInteger(this.filter.sku, false) || !this.isValidInteger(this.filter.upc, false)) {
        return true;
      }
    },
    disableDeleteButtonAdmin: function disableDeleteButtonAdmin() {
      if (this.isAdmin && this.selectedItems.length > 0) {
        return this.selectedItems.some(function (sku) {
          return sku.status === 'PENDING_APPROVAL' || sku.status === 'REJECTED';
        });
      } else {
        return false;
      }
    },
    disableDeleteBtnProdSeller: function disableDeleteBtnProdSeller() {
      if (!this.isAdmin) {
        return this.product.skus.some(function (sku) {
          return sku.status === 'APPROVED';
        });
      }
      return false;
    },
    variantItemProvider: function variantItemProvider() {
      var _this7 = this;

      var items = this.product.skus.filter(function (sku) {
        var value = true;
        if (_this7.filter.sku && value) {
          if (!String(sku.id).includes(_this7.filter.sku)) {
            value = false;
          }
        }
        if (_this7.filter.upc && value) {
          if (!String(sku.upc).includes(_this7.filter.upc)) {
            value = false;
          }
        }
        if (_this7.filter.estado && value) {
          if (sku.status !== _this7.filter.estado) {
            value = false;
          }
        }
        return value;
      });
      var start = (this.variantCurrentPage - 1) * this.variantPerPage;
      var end = this.variantPerPage * this.variantCurrentPage;
      return items.slice(start, end);
    },

    editionDisabled: function editionDisabled() {
      if (this.isAdmin) {
        return true;
      }

      return this.product.skus.some(function (sku) {
        return sku.status === 'APPROVED';
      });
    },
    specificationsComputedMap: function specificationsComputedMap() {
      var _this8 = this;

      var attributes = this.product.productSpecifications;
      return this.specifications.map(function (spec) {
        var newAttr = void 0;
        var foundAttr = attributes.find(function (attr) {
          return attr && attr.name === spec.name;
        });
        if (!foundAttr) {
          newAttr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, spec, {
            specificationFieldValues: [{}]
          });
          _this8.product.productSpecifications.push(newAttr);
        }
        return {
          spec: spec,
          value: foundAttr !== undefined ? foundAttr : newAttr };
      });
    },
    saveButtonDisabled: function saveButtonDisabled() {
      if (!this.isValidText(this.product.name, true) || this.isEmptyData(this.product.category) || this.isEmptyData(this.product.description) || !this.productBrand.length > 0) {
        return true;
      }
      if (this._pendingProps()) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 770 */,
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_v_treeview_VTreeview_vue__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__ = __webpack_require__(14);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'category-tree',
  props: ['editable', 'categorySelected', 'button', 'buttonTitle', 'boostrapClasses', 'rootIneligible'],
  components: {
    VTreeview: __WEBPACK_IMPORTED_MODULE_1__components_common_v_treeview_VTreeview_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  data: function data() {
    return {
      categorySelectOptions: [],
      categoryAllSelectOptions: [],
      searching: false,
      searchText: '',
      treeTypes: [{
        type: '#',
        max_children: 20,
        max_depth: 4,
        valid_children: ['CATEGORY_CONTAINER', 'CATEGORY_ITEM']
      }, {
        type: 'CATEGORY_CONTAINER',
        icon: '',
        valid_children: ['CATEGORY_CONTAINER', 'CATEGORY_ITEM']
      }, {
        type: 'CATEGORY_ITEM',
        icon: '',
        valid_children: []
      }],
      name: '',
      selectedNode: null
    };
  },

  computed: {
    treeData: function treeData() {
      return this.createNodeList([{
        id: null,
        text: 'Raiz',
        name: 'Raiz',
        namePath: '/',
        type: this.rootIneligible ? 'CATEGORY_CONTAINER' : 'CATEGORY_ITEM',
        count: 0,
        children: this.$store.getters.categories
      }]);
    },
    text: function text() {
      return this.categorySelected ? this.categorySelected.namePath : '';
    },
    isEditable: function isEditable() {
      return this.editable === null || this.editable === undefined ? true : this.editable;
    }
  },
  methods: {
    performSearch: function performSearch(text) {
      var _this = this;

      if (text === null) {
        return;
      }
      this.searching = true;
      this.categorySelectOptions.splice(0, this.categorySelectOptions.length);
      this.categorySelectOptions.push({
        text: 'Seleccione una categoria',
        value: null,
        disabled: true
      });
      this.categoryAllSelectOptions.forEach(function (categoryOption) {
        if (categoryOption.text && categoryOption.text.toLowerCase().indexOf(text.toLowerCase()) !== -1) {
          _this.categorySelectOptions.push(categoryOption);
        }
      });
      this.searching = false;
    },
    openCategoryModal: function openCategoryModal() {
      this.$refs.category.show();
    },
    resetModal: function resetModal() {
      this.selectedNode = null;
      this.searchText = null;
      this.categorySelectOptions.splice(0, this.categorySelectOptions.length);
    },
    performOk: function performOk() {
      if (this.selectedNode) {
        this.$emit('onCategorySelected', this.selectedNode);
      }
    },
    onDropdownSelect: function onDropdownSelect(elem) {
      this.$emit('onCategorySelected', { id: elem.id, name: elem.text, namePath: elem.namePath });
      this.$refs.category.hide();
    },
    select: function select(elem) {
      if (elem.model.type === 'CATEGORY_ITEM') {
        this.$emit('onCategorySelected', { id: elem.model.id, name: elem.model.text, namePath: elem.model.namePath });
        this.$refs.category.hide();
      }
    },
    createNodeList: function createNodeList(items) {
      var _this2 = this;

      return items.map(function (item) {
        _this2.categoryAllSelectOptions.push({
          text: item.namePath,
          value: {
            id: item.id,
            text: item.name,
            namePath: item.namePath
          }
        });
        var newItem = {
          id: item.id,
          text: item.name,
          namePath: item.namePath,
          type: 'CATEGORY_ITEM',
          count: 0,
          children: []
        };
        if (item.children && item.children.length > 0) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newItem, { children: _this2.createNodeList(item.children) });
        } else {
          return newItem;
        }
      });
    }
  }
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ab58174_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeview_vue__ = __webpack_require__(779);
function injectStyle (ssrContext) {
  __webpack_require__(773)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ab58174"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ab58174_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTreeviewItem_vue__ = __webpack_require__(775);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'treeTypes', 'openAll'],
  name: 'v-treeview',
  created: function created() {},

  methods: {
    selected: function selected(node) {
      this.$emit('selected', node);
    }
  },
  components: {
    VTreeviewItem: __WEBPACK_IMPORTED_MODULE_0__VTreeviewItem_vue__["a" /* default */]
  }
});

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8f7144_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeviewItem_vue__ = __webpack_require__(778);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f8f7144"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VTreeviewItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8f7144_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VTreeviewItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-treeview-item',
  props: ['model', 'treeTypes', 'openAll'],
  data: function data() {
    return {
      open: false
    };
  },

  computed: {
    isFolder: function isFolder() {
      return this.model.children && this.model.children.length;
    },
    icon: function icon() {
      return this.getTypeRule(this.model.type).icon;
    }
  },
  methods: {
    getTypeRule: function getTypeRule(type) {
      var typeRule = this.treeTypes.filter(function (t) {
        return t.type === type;
      })[0];
      return typeRule;
    },
    selected: function selected(node) {
      this.$emit('selected', node);
    },
    addNode: function addNode(newNode) {
      var typeRule = this.getTypeRule(this.model.type);

      if (typeRule.valid_children.indexOf(newNode.type) > -1) {
        this.model.children.push(newNode);
      }
    },
    performSelect: function performSelect() {
      if (this.model.id) {
        this.selected(this);
      }
    },
    toggle: function toggle() {
      if (this.isFolder) {
        this.open = !this.open;
      }
    }
  },
  created: function created() {
    this.open = this.openAll;
  },

  watch: {
    openAll: function openAll(_openAll) {
      this.open = _openAll;
    }
  }
});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tree-node"},[_c('div',{staticClass:"toggle",on:{"click":_vm.toggle}},[_c('span',{key:_vm.open,staticClass:"toggle-icon",class:{ 'empty-toggle': !_vm.isFolder }},[(_vm.isFolder)?_c('i',{class:{'fas fa-caret-down' : this.open, 'fas fa-caret-right' : !this.open}}):_vm._e()]),_vm._v(" "),_c('span',{key:_vm.icon,staticClass:"tree-icon",class:{ 'empty-toggle': !_vm.icon }},[(_vm.icon)?_c('i',{staticClass:"far",class:_vm.icon}):_vm._e()])]),_vm._v(" "),_c('div',{key:"label",staticClass:"tree-text label",attrs:{"for":_vm.model.id},on:{"click":_vm.performSelect}},[_vm._v(_vm._s(_vm.model.text))]),_vm._v(" "),_c('div',{staticClass:"tree-children"},[(_vm.isFolder)?_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}]},_vm._l((_vm.model.children),function(child){return _c('v-treeview-item',{key:child.id,attrs:{"model":child,"treeTypes":_vm.treeTypes,"openAll":_vm.openAll},on:{"addNode":_vm.addNode,"selected":_vm.selected}})})):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.value),function(item){return _c('v-treeview-item',{key:item.id,staticClass:"v-treeview-item",attrs:{"model":item,"treeTypes":_vm.treeTypes,"openAll":_vm.openAll},on:{"selected":_vm.selected}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[(!_vm.button)?_c('b-form-input',{attrs:{"id":"categoryFormatterHelp","oncontextmenu":"return false;","disabled":!_vm.isEditable,"value":_vm.text},nativeOn:{"click":function($event){_vm.openCategoryModal($event)}}}):_vm._e()],_vm._v(" "),(_vm.button)?[_c('b-button',{class:_vm.boostrapClasses,attrs:{"variant":"primary"},on:{"click":_vm.openCategoryModal}},[_vm._v(_vm._s(_vm.buttonTitle? _vm.buttonTitle : 'Categorías'))])]:_vm._e(),_vm._v(" "),_c('b-modal',{ref:"category",attrs:{"header-bg-variant":"primary","centered":"","size":"lg","title":"Seleccione categoría","o-close-on-backdrop":"true","cancel-title":"Cerrar","ok-title":"Seleccionar"},on:{"show":_vm.resetModal,"ok":_vm.performOk}},[[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{attrs:{"id":"buscadorInput","label-cols":4,"breakpoint":"md","label":"Buscar categoria","description":_vm.searching? 'Espere...': 'Se mostraran las categorias que contengan el texto buscado',"label-for":"buscador"}},[_c('b-form-input',{attrs:{"id":"buscador","disabled":_vm.searching,"placeholder":"Ingrese la categoria a buscar","name":"buscador"},on:{"input":_vm.performSearch},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"id":"categoryInput","label-cols":4,"breakpoint":"md","label":"Categorias","label-for":"categoriesSelect"}},[_c('b-form-select',{attrs:{"options":_vm.categorySelectOptions},on:{"change":_vm.onDropdownSelect},model:{value:(_vm.selectedNode),callback:function ($$v) {_vm.selectedNode=$$v},expression:"selectedNode"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('h4',[_vm._v("Arbol de categorias")]),_vm._v(" "),_c('v-treeview',{attrs:{"treeTypes":_vm.treeTypes,"openAll":false},on:{"selected":_vm.select},model:{value:(_vm.treeData),callback:function ($$v) {_vm.treeData=$$v},expression:"treeData"}})],1)],1)]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_ValidationsMixim_js__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-attributes',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_1__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  props: ['mergedInfo', 'disabled'],
  watch: {
    mergedInfo: function mergedInfo(newVal, oldVal) {
      this.props = newVal;
    }
  },
  data: function data() {
    return {
      props: null
    };
  },

  computed: {
    noSpecs: function noSpecs() {
      if (!this.props) {
        return true;
      }

      if (this.props.length === 0) {
        return true;
      }

      if (this.props.length > 0) {
        return this.props.every(function (info) {
          return info.value.specificationFieldValues.length === 0;
        });
      }
    }
  },
  methods: {
    convertToOptions: function convertToOptions(specificationFieldValues) {
      return specificationFieldValues.map(function (sfv) {
        return { text: sfv.value, value: sfv };
      });
    }
  }
});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.noSpecs)?_c('b-row',[_c('b-col',[_vm._v("\n        No hay especificaciones para seleccionar.\n    ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.props),function(info){return _c('div',{key:info.name},[(info.value.specificationFieldValues.length > 0)?_c('b-row',{staticClass:"mt-3 attr-row"},[_c('b-col',{attrs:{"md":"6"}},[(['Texto', 'Texto Grande', 'Texto Indexado', 'Texto Grande Indexado'].includes(info.spec.specificationFieldType.fieldTypeName))?_c('b-form-group',{attrs:{"label-cols":4,"description":info.spec.description,"label":info.spec.name,"invalid-feedback":!_vm.isValidText(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired)) && !_vm.disabled? ("El atributo " + (info.spec.name) + " es inválido"): '',"state":_vm.isValidText(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired))}},[(['Texto', 'Texto Grande', 'Texto Indexado', 'Texto Grande Indexado'].includes(info.spec.specificationFieldType.fieldTypeName))?_c('b-form-input',{attrs:{"disabled":_vm.disabled},model:{value:(info.value.specificationFieldValues[0].value),callback:function ($$v) {_vm.$set(info.value.specificationFieldValues[0], "value", $$v)},expression:"info.value.specificationFieldValues[0].value"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(info.spec.specificationFieldType.fieldTypeName === 'Número')?_c('b-form-group',{attrs:{"label-cols":4,"description":info.spec.description,"label":info.spec.name,"invalid-feedback":!_vm.isValidInteger(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired))? ("El atributo " + (info.spec.name) + " es inválido"): '',"state":_vm.isValidInteger(info.value.specificationFieldValues[0].value, Boolean(info.value.isRequired))}},[(info.spec.specificationFieldType.fieldTypeName === 'Número')?_c('b-form-input',{attrs:{"disabled":_vm.disabled,"type":"number"},model:{value:(info.value.specificationFieldValues[0].value),callback:function ($$v) {_vm.$set(info.value.specificationFieldValues[0], "value", $$v)},expression:"info.value.specificationFieldValues[0].value"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(info.spec.specificationFieldType.fieldTypeName === 'Combo')?_c('b-form-group',{attrs:{"label-cols":4,"description":info.spec.description,"label":info.spec.name,"invalid-feedback":info.value.isRequired && !Boolean(Object.keys(info.value.specificationFieldValues[0]).length) && !_vm.disabled ? (" " + (info.spec.name) + " es obligatorio"): '',"state":info.value.isRequired && Boolean(Object.keys(info.value.specificationFieldValues[0]).length)}},[_c('b-form-select',{attrs:{"options":_vm.convertToOptions(info.spec.specificationFieldValues),"disabled":_vm.disabled},model:{value:(info.value.specificationFieldValues[0]),callback:function ($$v) {_vm.$set(info.value.specificationFieldValues, 0, $$v)},expression:"info.value.specificationFieldValues[0]"}})],1):_vm._e(),_vm._v(" "),(info.spec.specificationFieldType.fieldTypeName === 'Radio')?_c('b-form-group',{attrs:{"label-cols":4,"description":info.spec.description,"label":info.spec.name,"invalid-feedback":info.value.isRequired && !Boolean(Object.keys(info.value.specificationFieldValues[0]).length) && !_vm.disabled ? ("El atributo " + (info.spec.name) + " es obligatorio"): '',"state":info.value.isRequired && Boolean(Object.keys(info.value.specificationFieldValues[0]).length)}},[_c('b-form-radio-group',{attrs:{"options":_vm.convertToOptions(info.spec.specificationFieldValues),"disabled":_vm.disabled},model:{value:(info.value.specificationFieldValues[0]),callback:function ($$v) {_vm.$set(info.value.specificationFieldValues, 0, $$v)},expression:"info.value.specificationFieldValues[0]"}})],1):_vm._e(),_vm._v(" "),(info.spec.specificationFieldType.fieldTypeName === 'CheckBox')?_c('b-form-group',{attrs:{"label-cols":4,"description":info.spec.description,"label":info.spec.name,"invalid-feedback":info.value.isRequired && !Boolean(Object.keys(info.value.specificationFieldValues[0]).length) && !_vm.disabled ? ("El atributo " + (info.spec.name) + " es obligatorio"): '',"state":info.value.isRequired && Boolean(Object.keys(info.value.specificationFieldValues[0]).length)}},[_c('b-form-checkbox-group',{attrs:{"options":_vm.convertToOptions(info.spec.specificationFieldValues),"disabled":_vm.disabled},model:{value:(info.value.specificationFieldValues[0]),callback:function ($$v) {_vm.$set(info.value.specificationFieldValues, 0, $$v)},expression:"info.value.specificationFieldValues[0]"}})],1):_vm._e()],1)],1):_vm._e()],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PriceAndDimencion__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductAttributes__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SkuHistory__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_ImageLoader__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_FormActiveSku__ = __webpack_require__(122);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sku-modal',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__["a" /* default */],
    PriceAndDimencion: __WEBPACK_IMPORTED_MODULE_4__PriceAndDimencion__["a" /* default */],
    ProductAttributes: __WEBPACK_IMPORTED_MODULE_5__ProductAttributes__["a" /* default */],
    SkuHistory: __WEBPACK_IMPORTED_MODULE_6__SkuHistory__["a" /* default */],
    ImageLoader: __WEBPACK_IMPORTED_MODULE_8__components_common_ImageLoader__["a" /* default */],
    FormActiveSku: __WEBPACK_IMPORTED_MODULE_9__components_common_FormActiveSku__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_7__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  data: function data() {
    return {
      activateProductData: [],
      showModalFooter: false,
      isAdmin: this.$store.getters.isAdmin,
      title: '',
      loading: false,
      specifications: [],
      successText: '',
      mute: true,
      errorText: '',
      currentStatus: '',
      estados: __WEBPACK_IMPORTED_MODULE_7__mixims_ProductServiceMixim_js__["b" /* PRODUCT_STATES_EDITION */],
      confirmationModalData: {
        confirmationModalOkHandler: '',
        confirmationModalCancelHandler: '',
        confirmationModalText: '',
        confirmationModalTitle: ''
      },
      sku: {
        price: {},
        dimension: {},
        inventory: {},
        images: [],
        skuSpecifications: [],
        refId: ''
      },
      product: {},
      history: [],
      refIdFeedback: '',
      refIdValidation: true,
      timeout: null,
      prev: '',
      oldRefId: '',
      verifyInProgress: false
    };
  },

  watch: {
    sku: {
      handler: function handler(newVal) {
        if (newVal.refId !== this.prev) {
          this.prev = this.sku.refId;
          this.handleInvalidFeedback();
        }
      },

      deep: true
    }
  },
  computed: {
    okTitle: function okTitle() {
      return this.sku.id ? 'Guardar' : 'Crear Variante';
    },
    editionDisabled: function editionDisabled() {
      if (!this.sku.upc || !this.isValidUPC(this.sku.upc, true, false) || this.isAdmin) {
        return true;
      }
      return false;
    },
    createButtonDisabled: function createButtonDisabled() {
      if (!this.isValidText(this.sku.skuName, true)) {
        return true;
      }

      if (!this.isValidInt32Integer(this.sku.refId, true, false) || this.refIdFeedback) {
        return true;
      }

      if (!this.isValidFloat(this.sku.dimension.height, true, true) || !this.isValidFloat(this.sku.dimension.length, true, true) || !this.isValidFloat(this.sku.dimension.weight, true, true) || !this.isValidFloat(this.sku.dimension.width, true, true)) {
        return true;
      }

      if (!this.isValidFloat(this.sku.price.listPrice, true, true)) {
        return true;
      }

      if (this.isValidFloat(this.sku.price.price, true) && !this.isValidFloat(this.sku.price.listPrice, true, true)) {
        return true;
      }

      if (!this.isValidInt32Integer(this.sku.inventory.totalQuantity, false, true)) {
        return true;
      }

      if (!this.isValidInt32Integer(this.sku.inventory.stockSecurity, true, false)) {
        return true;
      }

      if (this.isValidFloat(this.sku.price.price, true) && this.isValidFloat(this.sku.price.listPrice, true, true)) {
        if (parseFloat(this.sku.price.price) > parseFloat(this.sku.price.listPrice)) {
          return true;
        }
      }

      if (parseFloat(this.sku.price.price) < parseFloat(this.sku.price.listPrice)) {
        if (this.isEmptyData(this.sku.price.priceValidUntil)) return true;

        var dateSelected = new Date(this.sku.price.priceValidUntil);
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        if (today > dateSelected) return true;
      }

      if (this._pendingProps()) {
        return true;
      }
      return !this.$refs.imageLoader.hasImages();
    },
    specificationsComputedMap: function specificationsComputedMap() {
      var _this2 = this;

      if (!this.sku.skuSpecifications) {
        this.sku.skuSpecifications = [];
      }
      var attributes = this.sku.skuSpecifications;
      return this.specifications.map(function (spec) {
        var newAttr = void 0;
        var foundAttr = attributes.find(function (attr) {
          return attr && attr.name === spec.name;
        });
        if (!foundAttr) {
          newAttr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, spec, {
            specificationFieldValues: [{}]
          });
          _this2.sku.skuSpecifications.push(newAttr);
        }
        return {
          spec: spec,
          value: foundAttr !== undefined ? foundAttr : newAttr };
      });
    }
  },
  methods: {
    isvalidForm: function isvalidForm(stateForm) {
      this.activateProductData = stateForm.data;
      this.showModalFooter = stateForm.state;
    },
    changeStatusModal: function changeStatusModal(status) {
      var _this3 = this;

      this.confirmationModalData.confirmationModalTitle = 'Cambio de estado de ' + this.sku.skuName;
      this.confirmationModalData.confirmationModalText = '\xBFCambiar el estado a ' + (status === 'REJECTED' ? 'rechazado' : 'activado') + '?';
      this.currentStatus = status;
      this.$refs.confirmationModal.show();
      this.confirmationModalData.confirmationModalCancelHandler = function () {
        _this3.sku.status = 'PENDING_APPROVAL';
        _this3.hurryShow();
      };
    },
    handleSaveModal: function handleSaveModal() {
      this.execChangeStatus();
    },
    execChangeStatus: function execChangeStatus() {
      var _this4 = this;

      this.hurryShow();
      this.loading = true;
      this.errorText = '';
      this.successText = '';
      var errorVerv = '';
      var actionFunction = '';
      var _acceptances = null;
      switch (this.currentStatus) {
        case 'APPROVED':
          actionFunction = this.activateProducts;
          errorVerv = 'aprobando';
          _acceptances = this.activateProductData;
          break;
        case 'REJECTED':
          actionFunction = this.rejectProducts;
          errorVerv = 'rechazando';
          break;
      }
      actionFunction([this.sku.id], true, _acceptances).then(function () {
        _this4.successText = ' El estado fue modificado con éxito';
        _this4.loading = false;
        _this4.mute = false;
      }, function (error) {
        console.log(error);
        _this4.loading = false;
        _this4.sku.status = 'PENDING_APPROVAL';
        _this4.errorText = 'Error ' + errorVerv + ' el producto ' + _this4.sku.id;
        if (_this4.currentStatus === 'APPROVED') {
          if (_this4.sku.images.length === 0) {
            _this4.errorText += '<ul>';
            _this4.errorText += '  <li>El producto no tiene imagenes cargadas.</li>';
            _this4.errorText += '</ul>';
          }
        }
      });
    },
    deleteSku: function deleteSku() {
      var _this5 = this;

      this.confirmationModalData.confirmationModalTitle = 'Eliminar SKU';
      this.confirmationModalData.confirmationModalText = 'Se procedera a eliminar la  variante ' + this.sku.skuName;
      this.confirmationModalData.confirmationModalOkHandler = function () {
        _this5.loading = true;
        _this5.deleteProducts([_this5.sku.id], true).then(function () {
          _this5.loading = false;
          _this5.$emit('needReload', { status: true, text: 'Se elimino la variante' });
          _this5.$refs.confirmationModal.hide();
        }, function (error) {
          _this5.loading = false;
          _this5.$emit('needReload', { status: false, text: error.body.message || 'Error eliminando la variante' });
          _this5.$refs.confirmationModal.hide();
        });
      };
      this.confirmationModalData.confirmationModalCancelHandler = function () {
        _this5.hurryShow();
      };
      this.mute = true;
      this.$refs.confirmationModal.show();
    },
    _addImagesAndFinishCreation: function _addImagesAndFinishCreation(successText, isCreation) {
      var _this6 = this;

      var _this = this;

      var temp = this.sku.dimension.height;
      this.sku.dimension.height = 0;
      this.sku.dimension.height = temp;
      this.$refs.imageLoader.uploadImages(this.sku.id).then(function (images) {
        _this.sku.images = images;

        _this6.updateSku(_this.sku.id, _this.sku).then(function (skuJustCreated) {
          if (isCreation) {
            _this.product.skus.push(skuJustCreated.body);
          } else {
            _this6.mute = false;
          }
          _this6.successText = successText || 'Imagen eliminada con éxito';
          _this6.loading = false;
        }, function (error) {
          console.log(error);
          if (error.status === 500) {
            _this6.errorText = 'Error al guardar la variante. Revise los campos ingresados.';
          } else {
            _this6.errorText = 'Error al guardar la variante.';
          }
          _this6.loading = false;
        });
      }, function (error) {
        if (error.message === '413') {
          _this6.errorText = 'La imagen que intentaste subir supera el límite permitido por imagen.';
        } else {
          _this6.errorText = 'Error ejecutando el servicio para subir las imágenes';
        }
        _this6.loading = false;
      });
    },
    _pendingProps: function _pendingProps() {
      return this.specificationsComputedMap.some(function (prop) {
        if (prop.value.isRequired && prop.value.specificationFieldValues.length > 0) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(prop.value.specificationFieldValues).length === 0 || !prop.value.specificationFieldValues[0].value;
        }
      });
    },
    _createSku: function _createSku() {
      var _this7 = this;

      this.loading = true;
      if (!this.$refs.imageLoader.hasImages()) {
        this.loading = false;
        this.errorText = 'No hay ninguna imagen seleccionada';
        return;
      }

      this.createSku(this.product.id, this.sku).then(function (res) {
        _this7.sku.id = res.id;
        _this7.sku.status = res.status;

        _this7._addImagesAndFinishCreation('La variante fue creada con exito', true);
      }, function (error) {
        console.log(error);
        _this7.errorText = 'Error ejecutando el servicio de creacion de variantes';
        _this7.loading = false;
      });
    },
    _updateSku: function _updateSku() {
      this.loading = true;
      if (!this.$refs.imageLoader.hasImages()) {
        this.loading = false;
        this.errorText = 'No hay ninguna imagen seleccionada';
        return;
      }

      this._addImagesAndFinishCreation('La variante fue actualizado con exito');
    },
    handleOk: function handleOk(evt) {
      var _this8 = this;

      evt.preventDefault();
      this.errorText = '';
      this.successText = '';
      if (!this.sku.id) {
        this.confirmationModalData.confirmationModalTitle = 'Procesar alta de Variante: ' + this.sku.skuName;
      } else {
        this.confirmationModalData.confirmationModalTitle = 'Procesar modificacion de Variante: ' + this.sku.skuName;
      }
      this.confirmationModalData.confirmationModalText = '¿Desea continuar?';
      this.confirmationModalData.confirmationModalOkHandler = function () {
        _this8.hurryShow();
        if (!_this8.sku.id) {
          _this8._createSku();
        } else {
          _this8._updateSku();
        }
      };
      this.confirmationModalData.confirmationModalCancelHandler = function () {
        _this8.hurryShow();
      };
      this.$refs.confirmationModal.show();
    },
    handleHide: function handleHide() {
      if (!this.mute) {
        this.$emit('needReload');
      }
      this.$refs.skuModal.hide();
    },
    imageJustLoaded: function imageJustLoaded() {
      this.errorText = '';
      var temp = this.sku.dimension.height;
      this.sku.dimension.height = 0;
      this.sku.dimension.height = temp;
    },
    hurryShow: function hurryShow() {
      this.$refs.skuModal.show();
    },
    show: function show(sku, product) {
      var _this9 = this;

      this.refIdFeedback = '';
      this.prev = '';
      this.sku = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, sku);
      this.product = product;
      this.specifications.splice(0, this.specifications.length);
      this.mute = true;
      if (this.sku.id) {
        this.oldRefId = sku.refId;
        this.title = 'Editar variante para el producto: ' + this.product.name;
      } else {
        this.title = 'Crear variante para el producto: ' + this.product.name;
      }

      this.errorText = '';
      this.successText = '';
      this.loading = true;
      this.getSKUAttributes(this.product.category.id).then(function (specifications) {
        _this9.loading = false;
        _this9.specifications = specifications.body;
      }, function (error) {
        console.log(error);
        _this9.loading = false;
        _this9.errorText = 'Error obteniendo las especificaciones de la variante';
      });
      this.getSkuHistory(this.sku.id).then(function (response) {
        _this9.history = response.body || [];
      }, function (error) {
        console.log(error);
        _this9.errorText = 'Error obteniendo el historial de la variante';
      });
      this.$refs.skuModal.show();
    },
    handleInvalidFeedback: function handleInvalidFeedback() {
      var _this10 = this;

      if (!this.sku.refId || this.sku.refId === '') this.refIdFeedback = 'El refId es obligatorio';else if (!this.isValidInt32Integer(this.sku.refId, true, false)) this.refIdFeedback = 'refId inválido';else {
        this.refIdValidation = false;
        if (this.isValidInt32Integer(this.sku.refId, true, false)) {
          this.verifyInProgress = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            if (_this10.sku.id && _this10.oldRefId === _this10.sku.refId) {
              _this10.refIdFeedback = '';
              _this10.verifyInProgress = false;
            } else {
              _this10.existRefId(_this10.sku.refId).then(function (res) {
                _this10.refIdValidation = !res.body;
                _this10.verifyInProgress = false;
                if (!_this10.refIdValidation) {
                  _this10.refIdFeedback = 'el refId ingresado se encuentra en uso';
                } else _this10.refIdFeedback = '';
              });
            }
          }, 2000);
        }
      }
    }
  }
});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAndDimencion_vue__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e9bc236_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAndDimencion_vue__ = __webpack_require__(790);
function injectStyle (ssrContext) {
  __webpack_require__(787)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e9bc236"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAndDimencion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e9bc236_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAndDimencion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 787 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_big_js__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_big_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_big_js__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'price-and-dimencion',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  component: { datePicker: __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a },
  props: ['priceData', 'dimension', 'pricesDisabled', 'sizesDisabled'],
  computed: {
    cubicWeight: {
      get: function get() {
        if (this.isValidFloat(this.dimension.length, true) && this.isValidFloat(this.dimension.width, true) && this.isValidFloat(this.dimension.height, true)) {
          return new __WEBPACK_IMPORTED_MODULE_4_big_js___default.a(this.dimension.length).times(this.dimension.width).times(this.dimension.height);
        }
        return '';
      },
      set: function set(newValue) {
        this.dimension.cubicWeight = newValue;
      }
    },
    validPrecioRegularInput: function validPrecioRegularInput() {
      if (this.pricesDisabled || !this.priceData) return '';
      if (!this.isValidFloat(this.priceData.listPrice, true, true)) {
        return 'El precio es inválido';
      }
      return '';
    },
    precioDescuentoInput: function precioDescuentoInput() {
      if (this.pricesDisabled) return '';
      if (!this.isEmptyData(this.priceData.price)) {
        if (!this.isValidFloat(this.priceData.price, true)) {
          return 'El precio es inválido';
        }
        if (this.isValidFloat(this.priceData.listPrice, true, true)) {
          if (parseFloat(this.priceData.listPrice) < parseFloat(this.priceData.price)) {
            return 'El precio de descuento debe ser menor o igual que el precio regular';
          }
        }
      }
      return '';
    },
    validPriceUntil: function validPriceUntil() {
      if (!this.priceData.priceValidUntil || this.pricesDisabled) return true;
      var dateSelected = new Date(this.priceData.priceValidUntil);
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      return today < dateSelected;
    },
    priceOff: function priceOff() {
      if (this.priceData.price && this.priceData.listPrice) {
        var discount = 0;
        discount = 100 - this.priceData.price * 100 / this.priceData.listPrice;
        return discount > 0 ? discount.toFixed() : '0';
      } else {
        return '0';
      }
    }
  },
  data: function data() {
    return {
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        icons: {
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right'
        }
      }
    };
  }
});

/***/ }),
/* 789 */,
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"p-0"},[_c('b-card',{staticClass:"my-3",attrs:{"header":"Precios","header-bg-variant":"primary"}},[_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"precioRegularInput","label-cols":2,"breakpoint":"md","invalid-feedback":_vm.validPrecioRegularInput,"state":_vm.validPrecioRegularInput === '',"label":"Precio regular","label-for":"precioRegularFormatterHelp"}},[_c('b-form-input',{attrs:{"id":"precioRegularFormatterHelp","disabled":_vm.pricesDisabled},model:{value:(_vm.priceData.listPrice),callback:function ($$v) {_vm.$set(_vm.priceData, "listPrice", $$v)},expression:"priceData.listPrice"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"precioDescuentoInput","label-cols":2,"breakpoint":"md","label":"Precio con descuento","invalid-feedback":_vm.precioDescuentoInput,"state":_vm.precioDescuentoInput === '',"label-for":"precioDescuentoFormatterHelp"}},[_c('b-form-input',{attrs:{"id":"precioDescuentoFormatterHelp","disabled":_vm.pricesDisabled},model:{value:(_vm.priceData.price),callback:function ($$v) {_vm.$set(_vm.priceData, "price", $$v)},expression:"priceData.price"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.priceOff !== '0'),expression:"priceOff !== '0'"}],staticClass:"priceOff"},[_vm._v("\n          "+_vm._s(_vm.priceOff)+"% de descuento.\n        ")])],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"válidoHastaFromGroup","label-cols":2,"breakpoint":"md","oncontextmenu":"return false;","label":"Válido hasta","invalid-feedback":!_vm.validPriceUntil? 'Fecha seleccionada inválida' : '',"state":_vm.validPriceUntil,"label-for":"válidoHastaFormatterHelp"}},[_c('date-picker',{attrs:{"id":"válidoHasta","disabled":_vm.pricesDisabled,"config":_vm.config},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.priceData.priceValidUntil),callback:function ($$v) {_vm.$set(_vm.priceData, "priceValidUntil", $$v)},expression:"priceData.priceValidUntil"}})],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"my-3",attrs:{"header":"Medidas con empaque","header-bg-variant":"primary"}},[_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"height","label-cols":2,"oncontextmenu":"return false;","breakpoint":"md","label":"Ancho cm","invalid-feedback":!_vm.isValidFloat(_vm.dimension.height, true, true) && !_vm.sizesDisabled? 'No es un valor válido' : '',"state":_vm.isValidFloat(_vm.dimension.height, true, true),"label-for":"heightInput"}},[_c('b-form-input',{attrs:{"id":"heightInput","disabled":_vm.sizesDisabled},model:{value:(_vm.dimension.height),callback:function ($$v) {_vm.$set(_vm.dimension, "height", $$v)},expression:"dimension.height"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"width","label-cols":2,"oncontextmenu":"return false;","breakpoint":"md","label":"Alto cm","invalid-feedback":!_vm.isValidFloat(_vm.dimension.width, true, true) && !_vm.sizesDisabled? 'No es un valor válido' : '',"state":_vm.isValidFloat(_vm.dimension.width, true, true),"label-for":"widthInput"}},[_c('b-form-input',{attrs:{"id":"widthInput","disabled":_vm.sizesDisabled},model:{value:(_vm.dimension.width),callback:function ($$v) {_vm.$set(_vm.dimension, "width", $$v)},expression:"dimension.width"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"length","label-cols":2,"oncontextmenu":"return false;","breakpoint":"md","label":"Largo cm","invalid-feedback":!_vm.isValidFloat(_vm.dimension.length, true, true) && !_vm.sizesDisabled? 'No es un valor válido' : '',"state":_vm.isValidFloat(_vm.dimension.length, true, true),"label-for":"lengthInput"}},[_c('b-form-input',{attrs:{"id":"lengthInput","disabled":_vm.sizesDisabled},model:{value:(_vm.dimension.length),callback:function ($$v) {_vm.$set(_vm.dimension, "length", $$v)},expression:"dimension.length"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"weight","label-cols":2,"breakpoint":"md","oncontextmenu":"return false;","label":"Peso gr","invalid-feedback":!_vm.isValidFloat(_vm.dimension.weight, true, true) && !_vm.sizesDisabled? 'No es un valor válido' : '',"state":_vm.isValidFloat(_vm.dimension.weight, true, true),"label-for":"weightInput"}},[_c('b-form-input',{attrs:{"id":"weightInput","disabled":_vm.sizesDisabled},model:{value:(_vm.dimension.weight),callback:function ($$v) {_vm.$set(_vm.dimension, "weight", $$v)},expression:"dimension.weight"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"cubicWeight","label-cols":2,"oncontextmenu":"return false;","breakpoint":"md","description":"Este valor es el volumen calculado del tamaño del empaque","label":"Volumen cm3 (Alto x Largo x Ancho)","label-for":"cubicWeightInput"}},[_c('b-form-input',{attrs:{"type":"number","id":"cubicWeightInput","disabled":true},model:{value:(_vm.cubicWeight),callback:function ($$v) {_vm.cubicWeight=$$v},expression:"cubicWeight"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuHistory_vue__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4fa500_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuHistory_vue__ = __webpack_require__(794);
function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd4fa500"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SkuHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd4fa500_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SkuHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SkuHistory',
  props: ['history'],
  data: function data() {
    return {
      fields: [{ key: 'user', label: 'Usuario', 'class': 'text-left' }, { key: 'date', label: 'Fecha', 'class': 'text-left' }, { key: 'type', label: 'Cambio', 'class': 'text-left' }, { key: 'oldValue', label: 'Valor ant.', 'class': 'text-left' }, { key: 'newValue', label: 'Nuevo valor', 'class': 'text-left' }],
      sortBy: 'date',
      sortDesc: false,
      locale: __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.LOCALE,
      timeOptions: { timeZone: 'UTC', timeZoneName: 'short' },
      types: {
        'INVENTORY': 'Inventario',
        'PRICE': 'Precio'
      }
    };
  },

  computed: {
    currency: function currency() {
      return __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.CURRENCY;
    }
  }
});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"p-0 history-wrapper"},[_c('b-card',{staticClass:"my-3",attrs:{"header":"Historial de Cambios","header-bg-variant":"primary"}},[_c('b-table',{staticClass:"history-table",attrs:{"striped":"","items":_vm.history,"hover":"","outlined":"","head-variant":"light","fields":_vm.fields,"small":true,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"show-empty":"","empty-text":"No hay historial para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event}},scopedSlots:_vm._u([{key:"user",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.user ? row.item.user.firstName : '')+" "+_vm._s(row.item.user ? row.item.user.lastName: '')+"\n        ")]}},{key:"date",fn:function(row){return [_vm._v("\n          "+_vm._s(new Date(row.item.date).toLocaleDateString(_vm.locale))+"\n          "+_vm._s(new Date(row.item.date).toLocaleTimeString(_vm.locale))+"\n        ")]}},{key:"type",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.types[row.item.type])+"\n        ")]}},{key:"oldValue",fn:function(row){return [(row.item.type === 'PRICE')?_c('div',[_vm._v("\n            "+_vm._s(_vm.currency)+" "+_vm._s(row.item.oldValue.price.price)+"\n          ")]):_vm._e(),_vm._v(" "),(row.item.type === 'INVENTORY')?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"inventoryContainer",attrs:{"title":_vm.$t('La cantidad entre parentesis es stock reservado')}},[_c('span',{staticClass:"inventoryTotal"},[_vm._v(_vm._s(row.item.oldValue.inventory.totalQuantity))]),_vm._v(" "),_c('span',{staticClass:"inventoryReserved"},[_vm._v("("+_vm._s(row.item.oldValue.inventory.reservedQuantity ? row.item.oldValue.inventory.reservedQuantity : 0)+")")])]):_vm._e()]}},{key:"newValue",fn:function(row){return [(row.item.type === 'PRICE')?_c('div',[_vm._v("\n            "+_vm._s(_vm.currency)+" "+_vm._s(row.item.newValue.price.price)+"\n          ")]):_vm._e(),_vm._v(" "),(row.item.type === 'INVENTORY')?_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"inventoryContainer",attrs:{"title":_vm.$t('La cantidad entre parentesis es stock reservado')}},[_c('span',{staticClass:"inventoryTotal"},[_vm._v(_vm._s(row.item.newValue.inventory.totalQuantity))]),_vm._v(" "),_c('span',{staticClass:"inventoryReserved"},[_vm._v("("+_vm._s(row.item.newValue.inventory.reservedQuantity ? row.item.newValue.inventory.reservedQuantity : 0)+")")])]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLoader_vue__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_447869ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageLoader_vue__ = __webpack_require__(799);
function injectStyle (ssrContext) {
  __webpack_require__(796)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_447869ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_image_zoom_dist_vue_image_zoom_css__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_image_zoom_dist_vue_image_zoom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_image_zoom_dist_vue_image_zoom_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_image_zoom__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_image_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_image_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);









__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_image_zoom___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-loader',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  props: ['productImages', 'disabled', 'skuId'],
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  watch: {
    productImages: function productImages(newVal, oldVal) {
      var _this = this;

      this.images = [];
      this.success = false;
      newVal.forEach(function (elem) {
        _this.images.push({ imageUrl: elem.imageUrl });
      });
      this.radioChange(0);
    }
  },
  data: function data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      fileNotSupported: null,
      imageData: null,
      imageSelected: 0,
      images: [],
      errorText: '',
      success: false,
      loading: false,
      errorImg: false,
      errorImages: '',
      countValidImages: 0
    };
  },

  methods: {
    zoomImage: function zoomImage() {
      this.$zoom(this.imageData, {
        allowZoom: true,
        autoScale: true,
        closeOnClickModal: true
      });
    },
    deleteImage: function deleteImage() {
      var _this2 = this;

      this.$refs.fileinput.reset();
      this.success = false;
      this.errorText = '';
      this.loading = true;
      if (this.images[this.imageSelected] && this.images[this.imageSelected].imageUrl) {
        var image1 = '';
        var image2 = '';
        var image3 = '';
        var image4 = '';
        var image5 = '';
        if (this.imageSelected === 0) {
          image2 = this.images[1] ? this.images[1].imageUrl : '';
          image3 = this.images[2] ? this.images[2].imageUrl : '';
          image4 = this.images[3] ? this.images[3].imageUrl : '';
          image5 = this.images[4] ? this.images[4].imageUrl : '';
        } else if (this.imageSelected === 1) {
          image1 = this.images[0] ? this.images[0].imageUrl : '';
          image3 = this.images[2] ? this.images[2].imageUrl : '';
          image4 = this.images[3] ? this.images[3].imageUrl : '';
          image5 = this.images[4] ? this.images[4].imageUrl : '';
        } else if (this.imageSelected === 2) {
          image1 = this.images[0] ? this.images[0].imageUrl : '';
          image2 = this.images[1] ? this.images[1].imageUrl : '';
          image4 = this.images[3] ? this.images[3].imageUrl : '';
          image5 = this.images[4] ? this.images[4].imageUrl : '';
        } else if (this.imageSelected === 3) {
          image1 = this.images[0] ? this.images[0].imageUrl : '';
          image2 = this.images[1] ? this.images[1].imageUrl : '';
          image3 = this.images[2] ? this.images[2].imageUrl : '';
          image5 = this.images[4] ? this.images[4].imageUrl : '';
        } else {
          image1 = this.images[0] ? this.images[0].imageUrl : '';
          image2 = this.images[1] ? this.images[1].imageUrl : '';
          image3 = this.images[2] ? this.images[2].imageUrl : '';
          image4 = this.images[3] ? this.images[3].imageUrl : '';
        }
        this.deleteImageExec(this.skuId, image1, image2, image3, image4, image5).then(function () {
          _this2.images[_this2.imageSelected] = null;
          _this2.imageData = null;
          _this2.success = true;
          _this2.loading = false;
          _this2.$emit('imageDeleted');
          _this2.hasImages();
        }, function (error) {
          _this2.errorText = error.body.message || 'Error eliminando la imagen';
          _this2.loading = false;
        });
      } else {
        this.images[this.imageSelected] = null;
        this.imageData = null;
        this.loading = false;
        this.hasImages();
      }
    },
    radioChange: function radioChange(selected) {
      this.$refs.fileinput.reset();
      this.imageSelected = selected;
      this.fileNotSupported = null;
      this.errorImages = '';
      var image = this.images[this.imageSelected];
      if (image) {
        if (image.imageUrl) {
          this.imageData = image.imageUrl;
        } else {
          this.readFile(this.images[this.imageSelected]);
        }
      } else {
        this.imageData = null;
      }
    },
    readFile: function readFile(file) {
      var self = this;
      self.errorImages = '';
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          var sizeInKB = file.size / 1024;
          if (sizeInKB > __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.IMAGE_MAX_KB) {
            self.success = false;
            self.error = true;
            self.errorImages = 'El tama\xF1o de la im\xE1gen no debe superar los 1000KB (1MB).';
            self.images[self.imageSelected] = null;
            self.imageData = null;
            self.loading = false;
            return;
          }
          if (this.width > __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.IMAGE_MAX_SIZE || this.width < __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.IMAGE_MIN_SIZE || this.height > __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.IMAGE_MAX_SIZE || this.height < __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.IMAGE_MIN_SIZE) {
            self.success = false;
            self.errorText = 'Tamaño de imagen incorrecto, el alto y el ancho deben ser mayores a 500px y menores a 2000px';
            self.images[self.imageSelected] = null;
            self.imageData = null;
            self.loading = false;
          } else {
            self.imageData = e.target.result;
            self.$emit('imageJustLoaded');
          }
        };
      };
      reader.readAsDataURL(file);
    },
    previewImage: function previewImage(event) {
      var input = event.target;
      this.success = false;
      this.errorText = '';

      if (input.files && input.files[0]) {
        var imageSrc = input.files[0].name;
        var extencion = /[.]/.exec(imageSrc) ? /[^.]+$/.exec(imageSrc)[0] : undefined;
        if (extencion !== undefined) {
          if (__WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.IMAGE_FILES_SUPPORTED.indexOf(extencion.toUpperCase()) === -1) {
            this.fileNotSupported = true;
          } else {
            this.images[this.imageSelected] = input.files[0];
            this.readFile(input.files[0]);
          }
        }
      }
    },
    _filterImages: function _filterImages() {
      return this.images.map(function (e) {
        return e ? { imageUrl: e.imageUrl } : null;
      }).filter(function (e) {
        return e !== null;
      });
    },
    uploadImages: function uploadImages(id) {
      var _this3 = this;

      this.fileNotSupported = null;
      var endPoint = __WEBPACK_IMPORTED_MODULE_2__config_applicationConfig_js___default.a.API_END_POINT + '/sku/' + id + '/images';
      if (!this.hasImagesToUpload()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this._filterImages());
      }
      var uploadPromises = this.images.map(function (im, index) {
        if (im instanceof File) {
          var formData = new FormData();
          formData.append('file', im);
          return _this3.$http.post(endPoint, formData, {
            headers: {
              Authorization: 'Bearer ' + _this3.$store.state.access_token
            }
          }).then(function (newImage) {
            if (_this3.images[index] && _this3.images[index].name) {
              _this3.images[index] = newImage.body[0];
            }
          }, function (error) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new Error(error.status || 'Error asociando las imagenes al producto'));
          });
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(im);
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(uploadPromises).then(function () {
        return _this3._filterImages();
      });
    },
    hasImagesToUpload: function hasImagesToUpload() {
      this.success = false;
      this.errorText = '';
      return this.images.some(function (image) {
        return image !== null && image.name;
      });
    },
    hasImages: function hasImages() {
      this.success = false;
      if (this.images.length >= 1) {
        this.countValidImages = this.images.length - this.images.filter(function (elem) {
          return elem === null;
        }).length;
        if (this.countValidImages < 1) {
          return false;
        }
        this.errorText = '';
        return true;
      }
      return false;
    },
    imageError: function imageError() {
      this.errorImg = true;
    },
    imageSuccess: function imageSuccess() {
      this.errorImg = false;
    }
  }
});

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"p-0",attrs:{"md":"12"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),(_vm.errorImages !== '')?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.errorImages)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n    La imagen fue eliminada con éxito\n  ")]),_vm._v(" "),_c('moon-loader',{staticClass:"my-3",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Seleccionar la imagen"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasImages()),expression:"!hasImages()"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      Se requiere un mínimo de 1 imagen\n    ")]),_vm._v(" "),_c('b-row',{staticClass:"mb-3 search-row"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdmin),expression:"!isAdmin"}]},[_c('b-form-group',{attrs:{"id":"imageToUpload","label-cols":2,"breakpoint":"md","label":"Imagen","invalid-feedback":_vm.fileNotSupported ? 'Tipo de archivo no soportado' : '',"state":!_vm.fileNotSupported,"label-for":"categoryFormatterHelp"}},[_c('b-form-file',{ref:"fileinput",attrs:{"disabled":_vm.disabled,"no-drop":true,"accept":"image/*","placeholder":"Seleccione una imagen..."},on:{"change":_vm.previewImage},nativeOn:{"click":function($event){_vm.fileNotSupported = null}}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-radio-group',{staticClass:"mb-4",attrs:{"disabled":_vm.disabled,"id":"image-radios","name":"radioSubComponent"},on:{"change":_vm.radioChange},model:{value:(_vm.imageSelected),callback:function ($$v) {_vm.imageSelected=$$v},expression:"imageSelected"}},[_c('b-form-radio',{attrs:{"value":"0"}},[_vm._v("Imagen 1")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"1"}},[_vm._v("Imagen 2")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"2"}},[_vm._v("Imagen 3")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"3"}},[_vm._v("Imagen 4")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"4"}},[_vm._v("Imagen 5")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdmin),expression:"!isAdmin"}],staticClass:"btn btn-primary float-left mt-3",attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":_vm.deleteImage}},[_vm._v("Eliminar imagen "+_vm._s(parseInt(_vm.imageSelected) + 1))])])],1),_vm._v(" "),_c('b-col',{staticClass:"imgCount",attrs:{"md":"4","data-count":_vm.images.length}},[(_vm.imageData)?_c('div',{staticClass:"image-preview",on:{"click":_vm.zoomImage}},[_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}},{name:"show",rawName:"v-show",value:(!_vm.errorImg),expression:"!errorImg"}],staticClass:"preview",attrs:{"title":"Click para zoom de la imagen","src":_vm.imageData},on:{"error":_vm.imageError,"load":_vm.imageSuccess}})]):_c('div',[_c('p',[_vm._v("No hay imagen cargada")])]),_vm._v(" "),(_vm.errorImg && _vm.imageData)?_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"#485b65","width":"54px","height":"54px"}},[_c('path',{attrs:{"d":"M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2","fill":"none"}}),_c('path',{attrs:{"d":"M0 0h24v24H0z","fill":"none"}}),_c('path',{attrs:{"d":"M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"}})]),_vm._v(" "),_c('p',{staticClass:"text-danger pl-2"},[_vm._v("Error con la URL asociada a la imagen")])]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Switch__ = __webpack_require__(68);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_common_Switch__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  data: function data() {
    return {
      activeProduct: {
        fee: 0,
        vendible: false,
        comisionable: false,
        inventariable: false,
        marketplace: false
      }
    };
  },

  props: {
    products: {
      type: Number,
      default: 1
    }
  },
  watch: {
    state: function state() {
      this.activeProduct.fee = !isNaN(this.activeProduct.fee) ? parseInt(this.activeProduct.fee) : 0;
      this.$emit('showbtns', {
        state: this.state.fee,
        data: this.activeProduct
      });
    },
    products: function products() {
      this.activeProduct = {
        fee: 0,
        vendible: false,
        comisionable: false,
        inventariable: false,
        marketplace: false
      };
    }
  },
  computed: {
    state: function state() {
      return {
        fee: this.activeProduct.fee >= 1,
        vendible: this.activeProduct.vendible,
        comisionable: this.activeProduct.comisionable,
        inventariable: this.activeProduct.inventariable,
        marketplace: this.activeProduct.marketplace
      };
    }
  }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      default: true
    },
    disabled: {
      default: false
    },
    name: {
      default: 'default'
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    inputType: {
      type: String,
      default: 'radio'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked ? 'checked' : '';
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(e) {
      var checked = e.target.checked;
      this.$emit('change', checked);
    },
    handleInput: function handleInput(e) {
      var checked = e.target.checked;
      this.$emit('input', checked);
    }
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":_vm.inputType,"disabled":_vm.disabled,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.value},on:{"input":_vm.handleInput,"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2),_vm._v(" "),(_vm.disabled)?_c('i',[_vm._v("No es posible cambiar el estado")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-modal-attr-sku"},[(_vm.products > 1)?_c('p',{staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("\n        Recuerda que estos ajustes se verán reflejados en "),_c('b',[_vm._v("TODOS")]),_vm._v(" los productos que selecciones\n    ")]):_vm._e(),_vm._v(" "),_c('h6',{staticClass:"mb-3"},[_vm._v("\n        Para activar "),_c('b',[_vm._v(_vm._s(_vm.products > 1 ? 'los productos seleccionados' : 'el producto seleccionado'))]),_vm._v(", primero valide los siguientes datos:\n    ")]),_vm._v(" "),_c('b-row',{},[_c('b-col',{attrs:{"xs":"12","sm":"12","md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":"% de Fee *","invalid-feedback":!_vm.state.fee ? 'Ingrese un porcentaje': '',"state":_vm.state.fee}},[_c('b-form-input',{attrs:{"placeholder":"% de Fee","type":"number"},model:{value:(_vm.activeProduct.fee),callback:function ($$v) {_vm.$set(_vm.activeProduct, "fee", $$v)},expression:"activeProduct.fee"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"b-col-form pb-2",attrs:{"xs":"12","sm":"6","md":"6","lg":"6","xl":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":8,"label":"Vendible"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.activeProduct.vendible),callback:function ($$v) {_vm.$set(_vm.activeProduct, "vendible", $$v)},expression:"activeProduct.vendible"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"b-col-form",attrs:{"xs":"12","sm":"6","md":"6","lg":"6","xl":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":8,"label":"Comisionable"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.activeProduct.comisionable),callback:function ($$v) {_vm.$set(_vm.activeProduct, "comisionable", $$v)},expression:"activeProduct.comisionable"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"b-col-form",attrs:{"xs":"12","sm":"6","md":"6","lg":"6","xl":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":8,"label":"Inventariable"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.activeProduct.inventariable),callback:function ($$v) {_vm.$set(_vm.activeProduct, "inventariable", $$v)},expression:"activeProduct.inventariable"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"b-col-form",attrs:{"xs":"12","sm":"6","md":"6","lg":"6","xl":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":8,"label":"Marketplace"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.activeProduct.marketplace),callback:function ($$v) {_vm.$set(_vm.activeProduct, "marketplace", $$v)},expression:"activeProduct.marketplace"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('div',[(_vm.isAdmin)?_c('div',[_c('b-modal',{ref:"confirmationModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationModal","centered":"","title":_vm.confirmationModalData.confirmationModalTitle,"hide-footer":_vm.currentStatus == 'APPROVED' ? !_vm.showModalFooter: false,"cancel-title":"Cancelar"},on:{"ok":_vm.handleSaveModal,"cancel":_vm.confirmationModalData.confirmationModalCancelHandler}},[_c('moon-loader',{staticClass:"mb-2",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading && _vm.currentStatus != 'APPROVED'),expression:"!loading && currentStatus != 'APPROVED'"}]},[_vm._v(_vm._s(_vm.confirmationModalData.confirmationModalText))]),_vm._v(" "),(_vm.currentStatus == 'APPROVED')?_c('FormActiveSku',{attrs:{"products":1},on:{"showbtns":_vm.isvalidForm}}):_vm._e()],1)],1):_c('div',[_c('b-modal',{ref:"confirmationModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationModal","centered":"","title":_vm.confirmationModalData.confirmationModalTitle,"cancel-title":"Cancelar"},on:{"ok":_vm.confirmationModalData.confirmationModalOkHandler,"cancel":_vm.confirmationModalData.confirmationModalCancelHandler}},[_c('moon-loader',{staticClass:"mb-2",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_vm._v(_vm._s(_vm.confirmationModalData.confirmationModalText))])],1)],1),_vm._v(" "),_c('b-modal',{ref:"skuModal",attrs:{"ok-disabled":_vm.createButtonDisabled || _vm.isAdmin,"header-bg-variant":"primary","centered":"","size":"lg","centered":"","id":"skuModal","title":_vm.title,"o-close-on-backdrop":"true","cancel-title":"Cerrar","ok-title":_vm.okTitle},on:{"hidden":_vm.handleHide,"ok":_vm.handleOk,"cancel":_vm.handleHide}},[_c('moon-loader',{staticClass:"mb-2",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.product.skus && _vm.product.skus.length === 0),expression:"product.skus && product.skus.length === 0"}],staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" Es obligatorio crear un SKU para que el producto sea vendible en el marketplace")])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v("\n        "+_vm._s(_vm.errorText)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"w-100 text-right"},[_c('router-link',{attrs:{"to":{ path: '/incidents/list', query: { sku: _vm.sku.id }}}},[_vm._v(_vm._s(_vm.$t('Crear incidencia')))])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.successText !== ''),expression:"successText !== ''"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n        "+_vm._s(_vm.successText)+"\n      ")]),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[(_vm.isAdmin)?_c('b-col',[_c('b-form-group',{attrs:{"id":"estadoSelectGroup","label-cols":2,"breakpoint":"md","label":"Estado","label-for":"estadoSelectInput"}},[_c('b-form-select',{attrs:{"id":"estadoSelectInput","options":_vm.estados,"required":"","disabled":_vm.sku.status !== 'PENDING_APPROVAL'},on:{"change":_vm.changeStatusModal},model:{value:(_vm.sku.status),callback:function ($$v) {_vm.$set(_vm.sku, "status", $$v)},expression:"sku.status"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isAdmin)?_c('b-col',[_c('button',{staticClass:"btn btn-primary float-right",attrs:{"disabled":!_vm.product.id,"type":"button"},on:{"click":_vm.deleteSku}},[_c('i',{staticClass:"far fa-trash-alt"}),_vm._v(" Eliminar Variante\n          ")])]):_vm._e()],1),_vm._v(" "),_c('b-row',{staticClass:"border my-3 pt-3"},[_c('b-col',[_c('b-form-group',{attrs:{"id":"upcInput","label-cols":2,"breakpoint":"md","invalid-feedback":!_vm.isValidUPC(_vm.sku.upc, true, false)? 'No es un valor válido' : '',"state":_vm.isValidUPC(_vm.sku.upc, true, false),"label":"UPC"}},[_c('b-form-input',{attrs:{"disabled":Boolean(_vm.sku.id)},model:{value:(_vm.sku.upc),callback:function ($$v) {_vm.$set(_vm.sku, "upc", $$v)},expression:"sku.upc"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"skuInput","label-cols":2,"breakpoint":"md","description":"Generado automáticamente por Vtex una vez aprobado","label":"SKU","label-for":"skuFormatterHelp"}},[_c('b-form-input',{attrs:{"type":"number","id":"skuFormatterHelp","disabled":""},model:{value:(_vm.sku.id),callback:function ($$v) {_vm.$set(_vm.sku, "id", $$v)},expression:"sku.id"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"nombreInput","label-cols":2,"breakpoint":"md","label":"Nombre","description":"Máximo 100 caracteres","invalid-feedback":!_vm.isValidText(_vm.sku.skuName, true) && !_vm.editionDisabled ? 'El nombre no es válido' : '',"state":_vm.isValidText(_vm.sku.skuName, true),"label-for":"nombreFormatterHelp"}},[_c('b-form-input',{attrs:{"id":"nombreFormatterHelp","disabled":_vm.editionDisabled || _vm.sku.status === 'APPROVED',"maxlength":"100"},model:{value:(_vm.sku.skuName),callback:function ($$v) {_vm.$set(_vm.sku, "skuName", $$v)},expression:"sku.skuName"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-3 pt-3"},[_c('b-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('b-form-group',{attrs:{"id":"inventoryInput","label-cols":2,"breakpoint":"md","invalid-feedback":!_vm.isValidInt32Integer(_vm.sku.inventory.totalQuantity, false, false)? 'No es un inventario valido' : '',"state":_vm.isValidInt32Integer(_vm.sku.inventory.totalQuantity, false, false),"description":"Ingrese un valor de inventario valido","label":"Inventario"}},[_c('b-form-input',{attrs:{"disabled":_vm.editionDisabled},model:{value:(_vm.sku.inventory.totalQuantity),callback:function ($$v) {_vm.$set(_vm.sku.inventory, "totalQuantity", $$v)},expression:"sku.inventory.totalQuantity"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('b-form-group',{attrs:{"id":"inventorySecurityStock","label-cols":2,"breakpoint":"md","invalid-feedback":!_vm.isValidInt32Integer(_vm.sku.inventory.stockSecurity, true, false)? 'No es un número válido' : '',"state":_vm.isValidInt32Integer(_vm.sku.inventory.stockSecurity, true, false),"description":"Ingrese un valor de stock válido","label":"Stock de seguridad"}},[_c('b-form-input',{attrs:{"name":"security-stock","autocomplete":"off"},model:{value:(_vm.sku.inventory.stockSecurity),callback:function ($$v) {_vm.$set(_vm.sku.inventory, "stockSecurity", $$v)},expression:"sku.inventory.stockSecurity"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('b-form-group',{attrs:{"id":"refId","label-cols":4,"breakpoint":"md","description":Boolean(_vm.verifyInProgress) ? 'Verificando el refId, espere...' : 'Ingrese el código de referencia',"invalid-feedback":!_vm.editionDisabled ? _vm.refIdFeedback : '',"state":!Boolean(_vm.refIdFeedback),"label":"Código de referencia","label-for":"refId"}},[_c('b-form-input',{attrs:{"disabled":_vm.editionDisabled || _vm.sku.status === 'APPROVED',"type":"text","id":"refId"},model:{value:(_vm.sku.refId),callback:function ($$v) {_vm.$set(_vm.sku, "refId", $$v)},expression:"sku.refId"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('price-and-dimencion',{attrs:{"pricesDisabled":_vm.editionDisabled,"sizesDisabled":_vm.editionDisabled || _vm.sku.status === 'APPROVED',"priceData":_vm.sku.price,"dimension":_vm.sku.dimension}})],1),_vm._v(" "),_c('b-row',[_c('image-loader',{ref:"imageLoader",attrs:{"disabled":_vm.editionDisabled,"skuId":_vm.sku.id,"productImages":_vm.sku.images},on:{"imageJustLoaded":_vm.imageJustLoaded,"imageDeleted":_vm._addImagesAndFinishCreation}})],1),_vm._v(" "),_c('b-row',[_c('product-attributes',{attrs:{"disabled":_vm.editionDisabled || _vm.sku.status === 'APPROVED',"mergedInfo":_vm.specificationsComputedMap}})],1),_vm._v(" "),_c('b-row',[_c('sku-history',{attrs:{"history":_vm.history}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim__["c" /* ProductServiceMixim */]],
  props: ['disabled', 'value', 'maxElements', 'provider', 'showSelectAll', 'seletecAll', 'selectLabel', 'label', 'multiple', 'manualItems'],
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  data: function data() {
    return {
      items: [],
      isLoading: false,
      isAllSelected: false
    };
  },

  watch: {
    value: function value(vl) {
      this.handleSelect();
    }
  },
  methods: {
    onInput: function onInput(value) {
      this.$emit('input', value);
    },
    limitText: function limitText(count) {
      return 'y ' + count + ' otros items';
    },
    asyncFind: function asyncFind(text) {
      var _this = this;

      this.isLoading = true;
      if (!this.manualItems) {
        this.provider(text).then(function (response) {
          _this.items = response.body;
          _this.isLoading = false;
        });
      } else {
        if (text) {
          this.items = this.manualItems.filter(function (item) {
            return item.indexOf(text) > -1;
          });
          this.isLoading = false;
        } else {
          this.items = this.manualItems;
          this.isLoading = false;
        }
      }
    },
    selectAll: function selectAll() {
      this.$refs.autocomplete.deactivate();
      this.$emit('input', this.items);
    },
    deselectAll: function deselectAll() {
      this.$refs.autocomplete.deactivate();
      this.$emit('input', []);
    },
    handleSelect: function handleSelect() {
      this.isAllSelected = Array.isArray(this.value) ? this.value.length === this.items.length : false;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (!this.manualItems) {
      this.isLoading = true;
      this.provider('').then(function (response) {
        _this2.items = response.body;
        _this2.isLoading = false;
      });
    } else {
      this.isLoading = true;
      this.items = this.manualItems;
      this.isLoading = false;
    }
  }
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multiselect',{ref:"autocomplete",attrs:{"value":_vm.value,"label":_vm.label !== undefined ? _vm.label : 'name',"track-by":"id","open-direction":"bottom","options":_vm.items,"multiple":_vm.multiple !== undefined ? _vm.multiple : true,"searchable":true,"loading":_vm.isLoading,"internal-search":false,"clear-on-select":true,"close-on-select":true,"options-limit":300,"limit":100,"placeholder":_vm.$t('Ingrese el texto para buscar'),"disabled":_vm.disabled,"limit-text":_vm.limitText,"max-height":600,"selectLabel":_vm.selectLabel !== undefined ? _vm.selectLabel : _vm.$t('Enter para agregar marca'),"show-no-results":true,"showPointer":true,"hideSelected":true,"max":_vm.maxElements,"hide-selected":true},on:{"input":_vm.onInput,"search-change":_vm.asyncFind,"select":_vm.handleSelect},scopedSlots:_vm._u([{key:"tag",fn:function(ref){
var option = ref.option;
var remove = ref.remove;
return [_c('span',{staticClass:"custom__tag"},[_c('span',[_vm._v(_vm._s(_vm.label && _vm.label !== undefined ? option[_vm.label] : _vm.manualItems !== undefined ? option : option.name))]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"custom__remove",attrs:{"title":_vm.$t('Eliminar')},on:{"click":function($event){remove(option)}}},[_c('i',{staticClass:"text-danger fas fa-minus-circle"})])])]}}])},[(_vm.showSelectAll && _vm.seletecAll)?_c('template',{slot:"beforeList"},[(_vm.showSelectAll && _vm.seletecAll)?_c('section',{staticClass:"select-all",on:{"click":function($event){_vm.isAllSelected ? _vm.deselectAll() : _vm.selectAll()}}},[_c('b-form-checkbox',{staticClass:"select-all--checkbox",attrs:{"name":"check-button","switch":"","checked":_vm.isAllSelected}}),_vm._v(" "),(!_vm.isAllSelected)?_c('span',{staticClass:"select-all--title"},[_vm._v(_vm._s(_vm.$t('Seleccionar todo')))]):_vm._e(),_vm._v(" "),(_vm.isAllSelected)?_c('span',{staticClass:"select-all--title"},[_vm._v(_vm._s(_vm.$t('Deseleccionar todo')))]):_vm._e()],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('template',{slot:"maxElements"},[_vm._v("No se pueden seleccionar mas elementos")]),_vm._v(" "),_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("No hay elementos para mostrar")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[(_vm.product.name)?_c('h5',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.product.name)),(_vm.product.category)?_c('span',[_vm._v(" ("+_vm._s(_vm.product.category.name)+") - "+_vm._s(_vm.product.id))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.product.id && _vm.product.skus.length === 0),expression:"product.id && product.skus.length === 0"}],staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" Este producto no contiene SKUs creados")])])],1),_vm._v(" "),_c('div',[_c('b-alert',{attrs:{"show":_vm.errorText !== '',"fade":"","dismissible":"","variant":"danger"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("Se ha producido un error!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v(_vm._s(_vm.errorText))])]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.successText !== '',"variant":"success","dismissible":""}},[_vm._v("\n      "+_vm._s(_vm.successText)+"\n    ")])],1),_vm._v(" "),_c('b-modal',{ref:"confirmationModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationModal","centered":"","title":_vm.confirmationModalData.confirmationModalTitle,"hide-footer":_vm.currentState == 'Aprobar' ? !_vm.showModalFooter: false,"cancel-title":"Cancelar"},on:{"ok":_vm.handleSaveModal}},[(_vm.currentState != 'Aprobar')?_c('span',[_vm._v("\n      "+_vm._s(_vm.confirmationModalData.confirmationModalText)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.currentState == 'Aprobar' && _vm.isAdmin)?_c('FormActiveSku',{attrs:{"products":this.variantsSelected.length},on:{"showbtns":_vm.isvalidForm}}):_vm._e()],1),_vm._v(" "),_c('b-modal',{ref:"creationModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"creationModal","centered":"","title":!this.product.id? ("Procesar alta de Producto: " + (this.product.name)) : ("Procesar modificacion de Producto: " + (this.product.name)),"cancel-title":"Cancelar"},on:{"ok":_vm._createProduct}},[_c('span',[_vm._v("\n      ¿Desea continuar?\n    ")])]),_vm._v(" "),_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('moon-loader',{staticClass:"mt-3",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-tab',{attrs:{"title":"Datos del producto","active":""}},[_c('b-row',{staticClass:"mt-4"},[_c('div',{staticClass:"w-100 text-right px-3 mb-3",class:!_vm.isAdmin ? 'mr-3' : ''},[(false)?_c('router-link',{attrs:{"to":{ path: '/incidents/list', query: { product: _vm.product.id }}}},[_vm._v(_vm._s(_vm.$t('Crear incidencia')))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.scrollToIncidence()}}},[_vm._v("Incidencias")])],1),_vm._v(" "),_c('b-col',[(_vm.disableDeleteBtnProdSeller)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"float-right mr-3 text-primary",attrs:{"title":"No puedes eliminar el producto porque uno de sus SKU está activo, si quieres eliminarlo debes contactarte con el administrador del sitio"}},[_c('i',{staticClass:"fas fa-question-circle"})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right mr-3",attrs:{"disabled":!_vm.product.id || _vm.loading || _vm.disableDeleteBtnProdSeller,"type":"button"},on:{"click":_vm.deleteProduct}},[_c('i',{staticClass:"far fa-trash-alt"}),_vm._v(" Eliminar Producto\n          ")]),_vm._v(" "),(!_vm.isAdmin)?_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":!_vm.product.id || _vm.loading,"type":"button"},on:{"click":_vm.createSku}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Crear Variante\n          ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"my-3",attrs:{"header":"Datos generales","header-bg-variant":"success"}},[_c('b-col',[_c('b-form-group',{attrs:{"id":"idInput","label-cols":2,"breakpoint":"md","label":"ID","label-for":"idInput"}},[_c('b-form-input',{attrs:{"id":"idInṕut","disabled":true},model:{value:(_vm.product.id),callback:function ($$v) {_vm.$set(_vm.product, "id", $$v)},expression:"product.id"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"nombreInput","label-cols":2,"breakpoint":"md","label":"Nombre","description":"Máximo 100 caracteres","invalid-feedback":!_vm.isValidText(_vm.product.name, true) ? 'El nombre no es válido' : '',"state":_vm.isValidText(_vm.product.name, true),"label-for":"nombreFormatterHelp"}},[_c('b-form-input',{attrs:{"id":"nombreFormatterHelp","disabled":_vm.editionDisabled,"maxlength":"100"},model:{value:(_vm.product.name),callback:function ($$v) {_vm.$set(_vm.product, "name", $$v)},expression:"product.name"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"categoriaInput","label-cols":2,"breakpoint":"md","label":"Categoría","invalid-feedback":!Boolean(_vm.product.category) ? 'Seleccione una categoria' : '',"state":Boolean(_vm.product.category),"label-for":"categoryFormatterHelp"}},[_c('category-tree',{attrs:{"editable":!_vm.editionDisabled,"id":"categoryFormatterHelp","categorySelected":_vm.product.category},on:{"onCategorySelected":_vm.selectCategory}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"marcaInput","label-cols":2,"breakpoint":"md","label":"Marca","invalid-feedback":_vm.productBrand.length == 0 ? 'Seleccione una marca' : '',"state":_vm.productBrand.length > 0,"label-for":"marcaFormatterHelp"}},[_c('autocomplete',{staticClass:"input_class optional",attrs:{"v-if":_vm.product.brand,"id":"inputBrand","name":"inputBrand","maxElements":1,"placeholder":"Ingrese una marca...","provider":_vm.getSearchBrands,"disabled":_vm.editionDisabled},model:{value:(_vm.productBrand),callback:function ($$v) {_vm.productBrand=$$v},expression:"productBrand"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"textLinkInput","label-cols":2,"breakpoint":"md","label":"Descripción","invalid-feedback":!_vm.isValidTextArea(_vm.product.description, true) ? 'La descripción no es un texto / html válido' : '',"state":_vm.isValidTextArea(_vm.product.description, true),"label-for":"textlinkFormatterHelp"}},[_c('vue-editor',{attrs:{"editorToolbar":_vm.customToolbar,"disabled":_vm.editionDisabled,"name":"Description"},model:{value:(_vm.product.description),callback:function ($$v) {_vm.$set(_vm.product, "description", $$v)},expression:"product.description"}})],1)],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"my-3",attrs:{"header":"Especificaciones","header-bg-variant":"success"}},[_c('product-attributes',{attrs:{"disabled":_vm.isAdmin,"mergedInfo":_vm.specificationsComputedMap}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[(_vm.product.id)?_c('b-card',{ref:"IncidenceContainer",staticClass:"controversy-card",attrs:{"title":"Incidencias"}},[_c('button',{staticClass:"add-controversy btn btn-primary float-right mr-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.createIncidence()}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(_vm._s(_vm.$t('Crear incidencia')))]),_vm._v(" "),_c('b-col',[_c('incidents-table',{ref:"indicentsTable",attrs:{"filters":_vm.incidenceFilters,"showIncidenceDetail":true}})],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"SKUs"}},[_c('b-row',{staticClass:"row m-0 mb-2"},[_c('b-col',{staticClass:"p-0"},[(!_vm.isAdmin)?_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"disabled":!_vm.product.id || _vm.loading,"type":"button"},on:{"click":_vm.createSku}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Crear Variante\n          ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showFilters = !_vm.showFilters}}},[_c('i',{staticClass:"fa",class:{'fa-times': _vm.showFilters, 'fa-filter': !_vm.showFilters}}),_vm._v(" Filtros\n          ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"filters p-3"},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"filterSku","horizontal":"","label-cols":4,"breakpoint":"md","label":"SKU","invalid-feedback":!_vm.isValidInteger(_vm.filter.sku, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filter.sku, false),"label-for":"skuDesdeFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"filterSkuInput"},model:{value:(_vm.filter.sku),callback:function ($$v) {_vm.$set(_vm.filter, "sku", $$v)},expression:"filter.sku"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"filterUpc","horizontal":"","label-cols":4,"breakpoint":"md","label":"UPC","invalid-feedback":!_vm.isValidInteger(_vm.filter.upc, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filter.upc, false),"label-for":"skuDesdeFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"filterUpcInput"},model:{value:(_vm.filter.upc),callback:function ($$v) {_vm.$set(_vm.filter, "upc", $$v)},expression:"filter.upc"}})],1)],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"stateInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Estado","label-for":"stateFormatter"}},[_c('b-form-select',{attrs:{"id":"stateFormatter","options":_vm.estados},model:{value:(_vm.filter.estado),callback:function ($$v) {_vm.$set(_vm.filter, "estado", $$v)},expression:"filter.estado"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-input-group-button',{staticClass:"float-right mt-3 mr-3"},[_c('b-button',{attrs:{"disabled":_vm.loading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Limpiar")])],1)],1)],1)],1)]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin),expression:"isAdmin"}],staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button","disabled":_vm.variantsSelected.length === 0},on:{"click":function($event){_vm.showActionModal('Aprobar')}}},[_vm._v("Activar")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin),expression:"isAdmin"}],staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button","disabled":_vm.variantsSelected.length === 0},on:{"click":function($event){_vm.showActionModal('Rechazar')}}},[_vm._v("Rechazar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button","disabled":_vm.variantsSelected.length === 0 || _vm.disableDeleteButtonAdmin},on:{"click":function($event){_vm.showActionModal('Eliminar')}}},[_vm._v("Eliminar")])]),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.variantTotalRows,"per-page":_vm.variantPerPage},model:{value:(_vm.variantCurrentPage),callback:function ($$v) {_vm.variantCurrentPage=$$v},expression:"variantCurrentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.variantPageOptions},model:{value:(_vm.variantPerPage),callback:function ($$v) {_vm.variantPerPage=$$v},expression:"variantPerPage"}})],1)],1)],1),_vm._v(" "),(_vm.product.skus.length > 0)?_c('b-row',[_c('b-col',{staticClass:"my-2",attrs:{"md":"3"}},[_c('b-form-select',{staticClass:"action-form-select",attrs:{"id":"selectProductGroup","options":_vm.productGroupSelection.options,"required":""},on:{"change":_vm.productGroupSelectionHandler},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.productGroupSelection.current),callback:function ($$v) {_vm.$set(_vm.productGroupSelection, "current", $$v)},expression:"productGroupSelection.current"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-table',{ref:"variantTable",attrs:{"id":"mainTable","show-empty":"","hover":"","current-page":_vm.variantCurrentPage,"per-page":_vm.variantPerPage,"items":_vm.variantItemProvider,"fields":_vm.fieldsVariant,"responsive":"true","stacked":"xl","empty-text":"No hay variantes para mostrar","empty-filtered-text":"No hay variantes para mostrar"},on:{"row-dblclicked":_vm.variantDbClicked},scopedSlots:_vm._u([{key:"selected",fn:function(row){return [_c('b-form-checkbox',{staticClass:"ml-4",class:{ 'disabled-checkbox': _vm.isCheckboxDisabled(row.item) },attrs:{"disabled":_vm.isCheckboxDisabled(row.item),"value":row.item.id},on:{"change":function($event){_vm.handleRowCheckbox(row.item)}},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.variantsSelected),callback:function ($$v) {_vm.variantsSelected=$$v},expression:"variantsSelected"}})]}},{key:"price",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.listPrice)),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"discount",attrs:{"title":"Precio con descuento"}},[_vm._v("("+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.price)+")")]),_c('br'),_vm._v("\n          "+_vm._s(row.item.price.priceValidUntil)+"\n        ")]}},{key:"inventory",fn:function(row){return [_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"inventoryContainer",attrs:{"title":"La cantidad entre parentesis es stock reservado"}},[_c('span',{staticClass:"inventoryTotal"},[_vm._v(_vm._s(row.item.inventory.totalQuantity))]),_vm._v(" "),_c('span',{staticClass:"inventoryReserved"},[_vm._v("("+_vm._s(row.item.inventory.reservedQuantity ? row.item.inventory.reservedQuantity : 0)+")")])])]}},{key:"status",fn:function(data){return [(data.value === 'APPROVED')?_c('b',{staticClass:"text-success"},[_vm._v("\n            "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n          ")]):_vm._e(),_vm._v(" "),(data.value === 'REJECTED')?_c('b',{staticClass:"text-danger"},[_vm._v("\n            "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n          ")]):_vm._e(),_vm._v(" "),(data.value === 'PENDING_APPROVAL')?_c('b',{staticClass:"text-warning"},[_vm._v("\n            "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n          ")]):_vm._e()]}},{key:"actions",fn:function(row){return [_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdmin && row.item.status !== 'APPROVED'),expression:"!isAdmin && row.item.status !== 'APPROVED'"}],staticClass:"mr-2",on:{"click":function($event){_vm.deleteVariant(row.item)}}},[_c('i',{staticClass:"fas fa-trash cursor-pointer"})]),_vm._v(" "),_c('b-button',{staticClass:"primary",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v("\n              "+_vm._s(_vm.$t('Incidencias'))+"\n          ")])]}},{key:"row-details",fn:function(row){return [_c('div',[_c('div',{staticClass:"row position-relative"},[_c('button',{staticClass:"add-controversy-sku btn btn-primary mr-1 mb-3 float-right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.createSkuIncidence(row.item.id)}}},[_c('i',{staticClass:"fa fa-plus mr-2"}),_vm._v(_vm._s(_vm.$t('Crear incidencia')))])]),_vm._v(" "),_c('incidents-table',{attrs:{"filters":{
                fromDate: null,
                toDate: null,
                incidenceType: 'SKU',
                accountName: null,
                priority: null,
                status: null,
                text: row.item.id
              },"showIncidenceDetail":true}})],1)]}}])})],1)],1),_vm._v(" "),(!_vm.isAdmin && _vm.tabIndex === 0)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('div',{staticClass:"d-flex justify-content-end"},[_c('b-button',{staticClass:"mr-4",attrs:{"disabled":_vm.loading},on:{"click":_vm.handleMount}},[_vm._v("Cancelar")]),_vm._v(" "),_c('b-button',{attrs:{"disabled":_vm.saveButtonDisabled || _vm.loading},on:{"click":_vm.handleSave}},[_vm._v("Guardar")])],1)])],1):_vm._e(),_vm._v(" "),_c('sku-modal',{ref:"skuModal",on:{"needReload":_vm.reloadInformation}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('productDetail',{attrs:{"productId":null}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivableProductsView_vue__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b51073d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivableProductsView_vue__ = __webpack_require__(823);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivableProductsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b51073d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivableProductsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_catalog_ActivableProductList__ = __webpack_require__(819);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'activable-products-view',
  components: {
    ActivableProductsList: __WEBPACK_IMPORTED_MODULE_0__components_catalog_ActivableProductList__["a" /* default */]
  }
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivableProductList_vue__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e03e0a7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivableProductList_vue__ = __webpack_require__(822);
function injectStyle (ssrContext) {
  __webpack_require__(820)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e03e0a7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActivableProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e03e0a7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActivableProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_FormActiveSku__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CategoryTree__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SkuModal__ = __webpack_require__(310);














__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'activable-product-list',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_MoonLoader_vue__["a" /* default */], CategoryTree: __WEBPACK_IMPORTED_MODULE_7__CategoryTree__["a" /* default */], SkuModal: __WEBPACK_IMPORTED_MODULE_10__SkuModal__["a" /* default */], FormActiveSku: __WEBPACK_IMPORTED_MODULE_6__components_common_FormActiveSku__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  data: function data() {
    return {
      showModalFooter: false,
      activateProductData: [],
      locale: __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_9__config_applicationConfig_js___default.a.CURRENCY,
      fieldsProduct: [{ key: 'selected', label: 'Selección' }, { key: 'id', label: 'Id', 'class': 'text-left', sortable: true }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'category', label: 'Categoría', 'class': 'text-left', sortable: true }, { key: 'brand', label: 'Marca', 'class': 'text-left', sortable: true }, { key: 'action', label: ' ', 'class': 'text-right', sortable: false }],
      fieldsProductAdmin: [{ key: 'selected', label: 'Selección' }, { key: 'id', label: 'Id', 'class': 'text-left', sortable: true }, { key: 'accountName', label: 'Seller', 'class': 'text-left' }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'category', label: 'Categoría', 'class': 'text-left', sortable: true }, { key: 'brand', label: 'Marca', 'class': 'text-left', sortable: true }, { key: 'action', label: ' ', 'class': 'text-right', sortable: false }],
      fieldsVariant: [{ key: 'skuName', label: 'Nombre', 'class': 'text-left' }, { key: 'upc', label: 'UPC', 'class': 'text-left' }, { key: 'id', label: 'SKU', 'class': 'text-left' }, { key: 'refId', label: 'Identificador', 'class': 'text-left' }, { key: 'price', label: 'Precio', class: 'priceCol' }, { key: 'inventory', label: 'Inventario', 'class': 'text-left' }, { key: 'status', label: 'Estado', 'class': 'text-left' }],
      estados: __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__["a" /* PRODUCT_STATES */],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      errorText: '',
      successText: '',
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      account: null,
      sortBy: 'id',
      sortDesc: true,
      filter: {
        text: null,
        cuenta: null,
        seller: null,
        name: null,
        estado: null,
        sku: { desde: null, hasta: null },
        upc: { desde: null, hasta: null },
        fecha: { desde: null, hasta: null },
        category: { id: null, text: null },
        useFilters: false
      },
      showFilters: false,
      allSelected: false,
      productsSelected: [],
      currentPageElement: [],
      groupAction: null,
      productGroupSelection: {
        options: [{ text: 'Seleccione una opción', value: null, disabled: true }, { text: 'Ninguno', value: 'Ninguno' }, { text: 'Todos en esta pagina', value: 'Todos en esta pagina' }, { text: 'Todos', value: 'Todos' }],
        current: null
      },
      loading: false,
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        icons: {
          previous: 'fa fa-chevron-left',
          next: 'fa fa-chevron-right'
        }
      }
    };
  },

  computed: {
    hasOnlyProductsWithoutVariants: function hasOnlyProductsWithoutVariants() {
      var _this2 = this;

      if (this.productsSelected.length === 0) return false;
      var selectedProducts = this.currentPageElement.filter(function (product) {
        return _this2.productsSelected.includes(product.id);
      });
      return selectedProducts.every(function (product) {
        return product.skus.length === 0;
      });
    },
    hasMixedProducts: function hasMixedProducts() {
      var _this3 = this;

      if (this.productsSelected.length === 0) return false;
      var selectedProducts = this.currentPageElement.filter(function (product) {
        return _this3.productsSelected.includes(product.id);
      });
      var hasWithVariants = selectedProducts.some(function (product) {
        return product.skus.length > 0;
      });
      var hasWithoutVariants = selectedProducts.some(function (product) {
        return product.skus.length === 0;
      });
      return hasWithVariants && hasWithoutVariants;
    },
    canActivateOrReject: function canActivateOrReject() {
      var _this4 = this;

      if (this.productsSelected.length === 0) return false;
      var selectedProducts = this.currentPageElement.filter(function (product) {
        return _this4.productsSelected.includes(product.id);
      });
      var allHaveVariants = selectedProducts.every(function (product) {
        return product.skus.length > 0;
      });
      if (!allHaveVariants) return false;

      var allPending = selectedProducts.every(function (product) {
        return _this4.haveAllPending(product);
      });
      return allPending;
    },
    disableFilterButton: function disableFilterButton() {
      if (!this.isValidText(this.filter.text, false)) {
        return true;
      }

      if (this.invalidDateTo !== '' || this.invalidDateFrom !== '') {
        return true;
      }

      return false;
    },
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    },
    organizations: function organizations() {
      return this.$store.getters.organizations;
    },
    invalidDateTo: function invalidDateTo() {
      if (this.filter.fecha.hasta) {
        var hDate = new Date(this.filter.fecha.hasta);
        if (hDate > new Date()) {
          return 'La fecha seleccionada es mayor al da de hoy';
        }
        if (this.filter.fecha.desde) {
          var dDate = new Date(this.filter.fecha.desde);
          return dDate > hDate ? 'La fecha final es menor a la fecha inicial' : '';
        }
      }
      return '';
    },
    invalidDateFrom: function invalidDateFrom() {
      if (this.filter.fecha.desde) {
        var dDate = new Date(this.filter.fecha.desde);
        if (dDate > new Date()) {
          return 'La fecha seleccionada es mayor al dia de hoy';
        }
      }
      return '';
    }
  },
  methods: {
    isvalidForm: function isvalidForm(stateForm) {
      this.activateProductData = stateForm.data;
      this.showModalFooter = stateForm.state;
    },
    haveAllPending: function haveAllPending(item) {
      if (item.skus.length === 0) return false;
      return !item.skus.some(function (sku) {
        return sku.status === 'APPROVED' || sku.status === 'REJECTED';
      });
    },
    reloadInformation: function reloadInformation(response) {
      this.$refs.productTable.refresh();
      if (response) {
        if (response.status) {
          this.successText = response.text;
        } else {
          this.errorText = response.text;
        }
      }
    },
    variantDbClicked: function variantDbClicked(item) {
      this.errorText = '';
      this.successText = '';
      var product = this.currentPageElement.find(function (productItem) {
        return productItem.skus.some(function (skuItem) {
          return skuItem.id === item.id;
        });
      });
      this.$refs.skuModal.show(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item)), product);
    },
    productDbClicked: function productDbClicked(item) {
      this.$router.push('/catalog/details/' + item.id);
    },
    goToCreateProduct: function goToCreateProduct() {
      this.$router.push('/catalog/new');
    },
    cleanFilters: function cleanFilters() {
      this.filter = {
        cuenta: null,
        seller: null,
        name: null,
        estado: null,
        sku: { desde: null, hasta: null },
        upc: { desde: null, hasta: null },
        fecha: { desde: null, hasta: null },
        category: { id: null, text: null }
      };
      this.$refs.productTable.refresh();
    },
    selectCategory: function selectCategory(res) {
      this.filter.category = res;
    },
    confirmationModalCancelHandler: function confirmationModalCancelHandler() {
      this.currentActionGroupSelection = null;
    },
    showActionModal: function showActionModal(action) {
      this.groupAction = action;
      this.$refs.confirmationModal.show();
    },
    confirmationModalOkHandler: function confirmationModalOkHandler() {
      this.successText = '';
      this.errorText = '';
      this.loading = true;
      switch (this.groupAction) {
        case 'Eliminar':
          this.deleteSelectedItems();
          break;
        case 'Activar':
          this.activateSelectedItems();
          break;
        case 'Rechazar':
          this.rejectSelectedItems();
          break;
        default:
          break;
      }
      this.currentActionGroupSelection = null;
    },
    productGroupSelectionHandler: function productGroupSelectionHandler(selectionType) {
      var _this5 = this;

      this.productsSelected.splice(0, this.productsSelected.length);
      var _this = this;
      switch (selectionType) {
        case 'Ninguno':
          break;
        case 'Todos en esta pagina':
          this.currentPageElement.forEach(function (item) {
            _this5.productsSelected.push(item.id);
          });
          break;
        case 'Todos':
          this.loading = true;
          this.getProducts(null, this.filter).then(function (response) {
            response.body.forEach(function (item) {
              _this.productsSelected.push(item.id);
            });
            _this5.loading = false;
          });
          break;
        default:
          break;
      }
    },
    _execRejectApprove: function _execRejectApprove(action) {
      var _this6 = this;

      var actionFunction = null;
      var errorVerv = '';
      var _acceptances = {};
      switch (action) {
        case 'aprobar':
          actionFunction = this.activateProducts;
          errorVerv = 'aprobando';
          _acceptances = this.activateProductData;
          break;
        case 'rechazar':
          actionFunction = this.rejectProducts;
          errorVerv = 'rechazando';
          break;
        case 'eliminar':
          actionFunction = this.deleteProducts;
          errorVerv = 'eliminando';
          break;
      }
      actionFunction(this.productsSelected, false, _acceptances).then(function (response) {
        _this6.loading = false;
        _this6.productsSelected.splice(0, _this6.productsSelected.length);
        _this6.$refs.productTable.refresh();
        _this6.successText = 'Se completó la tarea con éxito';
      }, function (error) {
        _this6.loading = false;
        if (error.status === 409) {
          _this6.errorText = 'Algunos productos/skus no se lograron ' + action + '. Por favor verifique el estado de los skus.';
        } else {
          _this6.errorText = error.body.message || 'Error ' + errorVerv + ' los productos';
        }
        _this6.filterTable();
      });
    },
    rejectSelectedItems: function rejectSelectedItems() {
      this._execRejectApprove('rechazar');
    },
    activateSelectedItems: function activateSelectedItems() {
      this._execRejectApprove('aprobar');
    },
    deleteSelectedItems: function deleteSelectedItems() {
      this._execRejectApprove('eliminar');
    },
    handleRowCheckbox: function handleRowCheckbox() {
      this.productGroupSelection.current = null;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.productGroupSelection.current = null;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    sortClick: function sortClick() {
      this.productsSelected.splice(0, this.productsSelected.length);
      this.productGroupSelection.current = null;
    },
    filterTable: function filterTable() {
      this.productsSelected.splice(0, this.productsSelected.length);
      this.productGroupSelection.current = 'Ninguno';
      this.$refs.productTable.refresh();
    },
    itemProvider: function itemProvider(tableComponentInfo) {
      var _this7 = this;

      this.loading = true;
      this.filter.useFilters = this.showFilters;
      return this.getProducts(tableComponentInfo, this.filter).then(function (response) {
        _this7.loading = false;
        _this7.totalRows = parseInt(response.headers.get('X-Total-Count'));
        _this7.currentPageElement = response.body;
        return response.body;
      }, function (error) {
        _this7.errorText = error.body.message || 'Error obteniendo el listado de productos';
        _this7.loading = false;
        return [];
      });
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"product-list",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.successText !== ''),expression:"successText !== ''"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.successText)+"\n    ")]),_vm._v(" "),_c('sku-modal',{ref:"skuModal",on:{"needReload":_vm.reloadInformation}}),_vm._v(" "),_c('b-row',{staticClass:"filter-row"},[_c('b-col',{staticClass:"mb-3",attrs:{"md":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"id":"nombre","horizontal":"","label-cols":4,"breakpoint":"md","label":"Buscar","invalid-feedback":!_vm.isValidText(_vm.filter.text, false)? 'No es un valor válido' : '',"state":_vm.isValidText(_vm.filter.text, false),"description":"Este campo de filtro realizará la busqueda en los nombres, id, UPC y SKU de los productos","label-for":"nameFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"state":_vm.isValidText(_vm.filter.text, false),"id":"nameFormatter","placeholder":"Texto a buscar"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"disabled":!_vm.isValidText(_vm.filter.text, false)},on:{"click":_vm.filterTable}},[_vm._v("Buscar")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md-":"8"}},[_c('button',{staticClass:"btn btn-primary float-right",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showFilters = !_vm.showFilters}}},[_c('i',{staticClass:"fa",class:{'fa-times': _vm.showFilters, 'fa-filter': !_vm.showFilters}}),_vm._v(" Filtros\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.isAdmin,"type":"button"},on:{"click":_vm.goToCreateProduct}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Crear Producto\n        ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"filters mt-3 p-3"},[_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"estadoInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Estado","label-for":"estadoFormatter"}},[_c('b-form-select',{attrs:{"id":"categoryFormatter","options":_vm.estados},model:{value:(_vm.filter.estado),callback:function ($$v) {_vm.$set(_vm.filter, "estado", $$v)},expression:"filter.estado"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"categoryInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Categoría","label-for":"categoryFormatter"}},[_c('category-tree',{attrs:{"id":"selectCategory","categorySelected":_vm.filter.category},on:{"onCategorySelected":_vm.selectCategory}})],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"sellerInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Seller","label-for":"sellerFormatter"}},[_c('b-form-select',{attrs:{"options":_vm.organizations},model:{value:(_vm.filter.seller),callback:function ($$v) {_vm.$set(_vm.filter, "seller", $$v)},expression:"filter.seller"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todas")])])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"12"}},[_c('label',{staticClass:"float-left"},[_c('strong',[_vm._v("Fecha creación")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"desdeInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Desde","label-for":"desdeInputFormatter","state":_vm.invalidDateFrom === '' ? true : false,"invalid-feedback":_vm.invalidDateFrom}},[_c('date-picker',{attrs:{"id":"desdeInputFormatter","config":_vm.config},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.filter.fecha.desde),callback:function ($$v) {_vm.$set(_vm.filter.fecha, "desde", $$v)},expression:"filter.fecha.desde"}})],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"hastaInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Hasta","label-for":"hastaInputFormatter","state":_vm.invalidDateTo === '' ?  true : false,"invalid-feedback":_vm.invalidDateTo}},[_c('date-picker',{attrs:{"id":"hastaInputFormatter","config":_vm.config},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.filter.fecha.hasta),callback:function ($$v) {_vm.$set(_vm.filter.fecha, "hasta", $$v)},expression:"filter.fecha.hasta"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-input-group-button',{staticClass:"float-right mt-3"},[_c('b-button',{attrs:{"disabled":_vm.loading || _vm.disableFilterButton,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('b-input-group-button',{staticClass:"float-right mt-3 mr-3"},[_c('b-button',{attrs:{"disabled":_vm.loading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Mostrar Todos")])],1)],1)],1)],1)]),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin),expression:"isAdmin"}],staticClass:"btn btn-primary float-right",attrs:{"type":"button","disabled":!_vm.canActivateOrReject},on:{"click":function($event){_vm.showActionModal('Activar')}}},[_vm._v("Activar")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin),expression:"isAdmin"}],staticClass:"btn btn-primary float-right mr-2",attrs:{"type":"button","disabled":!_vm.canActivateOrReject},on:{"click":function($event){_vm.showActionModal('Rechazar')}}},[_vm._v("Rechazar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"type":"button","disabled":_vm.productsSelected.length === 0},on:{"click":function($event){_vm.showActionModal('Eliminar')}}},[_vm._v("Eliminar")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-modal',{ref:"confirmationModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationModal","centered":"","title":"Confirmación","hide-footer":_vm.groupAction == 'Activar' ? !_vm.showModalFooter: false,"cancel-title":"Cancelar"},on:{"ok":_vm.confirmationModalOkHandler,"cancel":_vm.confirmationModalCancelHandler}},[(_vm.productsSelected.length > 0)?[(_vm.groupAction == 'Activar')?_c('FormActiveSku',{attrs:{"products":_vm.productsSelected.length},on:{"showbtns":_vm.isvalidForm}}):_vm._e(),_vm._v(" "),(_vm.productsSelected.length > 1 && _vm.groupAction !== 'Activar')?_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.groupAction)+" los "+_vm._s(_vm.productsSelected.length)+" productos seleccionados?")]):_vm._e(),_vm._v(" "),(_vm.productsSelected.length == 1 && _vm.groupAction !== 'Activar')?_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.groupAction)+" el producto seleccionado?")]):_vm._e()]:_vm._e()],2),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"align-self":"start"}},[_c('b',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" productos encontrados "+_vm._s(_vm.productsSelected.length != 0 ? ("(" + (_vm.productsSelected.length) + " seleccionados)") : "")+"\n      ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(Boolean(_vm.productsSelected.length === 0)),expression:"Boolean(productsSelected.length === 0)"}],staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("No hay productos de la lista seleccionados para ejecutar acción")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasOnlyProductsWithoutVariants),expression:"hasOnlyProductsWithoutVariants"}],staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("No se puede activar o rechazar productos sin variantes")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasMixedProducts),expression:"hasMixedProducts"}],staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("No se puede activar o rechazar una mezcla de productos con y sin variantes. Por favor seleccione solo productos con variantes")])])],1),_vm._v(" "),_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Lista de productos"}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-col',{staticClass:"my-2 pl-0",attrs:{"md":"3"}},[_c('b-form-select',{staticClass:"action-form-select",attrs:{"id":"selectProductGroup","options":_vm.productGroupSelection.options,"required":""},on:{"change":_vm.productGroupSelectionHandler},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.productGroupSelection.current),callback:function ($$v) {_vm.$set(_vm.productGroupSelection, "current", $$v)},expression:"productGroupSelection.current"}})],1),_vm._v(" "),_c('b-table',{ref:"productTable",attrs:{"id":"productTable","show-empty":"","hover":"","items":_vm.itemProvider,"foot-clone":"","fields":_vm.isAdmin ? _vm.fieldsProductAdmin : _vm.fieldsProduct,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":"true","skuModal":"","stacked":"xl","empty-text":"No hay productos para mostrar","empty-filtered-text":"No hay productos para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered,"sort-changed":_vm.sortClick,"row-dblclicked":_vm.productDbClicked},scopedSlots:_vm._u([{key:"selected",fn:function(row){return [_c('b-form-checkbox',{staticClass:"ml-4",attrs:{"value":row.item.id},on:{"change":_vm.handleRowCheckbox},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.productsSelected),callback:function ($$v) {_vm.productsSelected=$$v},expression:"productsSelected"}})]}},{key:"category",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.category.name)+"\n        ")]}},{key:"brand",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.brand.name)+"\n        ")]}},{key:"action",fn:function(row){return [(row.item.skus.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v("\n            "+_vm._s(row.detailsShowing ? 'Ocultar' : 'Ver')+" Variantes ("+_vm._s(row.item.skus.length)+")\n          ")]):_c('span',[_c('b',[_vm._v("No contiene variantes")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',{attrs:{"header":"Listado de SKUs","border-variant":"primary","header-bg-variant":"primary","header-text-variant":"white"}},[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"variantTable",attrs:{"id":"productTable","show-empty":"","hover":"","items":row.item.skus,"fields":_vm.fieldsVariant,"responsive":"true","stacked":"xl","empty-text":"No hay variantes para mostrar","empty-filtered-text":"No hay variantes para mostrar"},on:{"row-dblclicked":_vm.variantDbClicked},scopedSlots:_vm._u([{key:"listPrice",fn:function(row){return [_vm._v("\n                "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.listPrice)+"\n              ")]}},{key:"inventory",fn:function(row){return [_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"inventoryContainer",attrs:{"title":"La cantidad entre parentesis es stock reservado"}},[_c('span',{staticClass:"inventoryTotal"},[_vm._v(_vm._s(row.item.inventory.totalQuantity))]),_vm._v(" "),_c('span',{staticClass:"inventoryReserved"},[_vm._v("("+_vm._s(row.item.inventory.reservedQuantity ? row.item.inventory.reservedQuantity : 0)+")")])])]}},{key:"price",fn:function(row){return [_vm._v("\n                "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.listPrice)),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"discount",attrs:{"title":"Precio con descuento"}},[_vm._v("("+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.price)+")")]),_c('br'),_vm._v("\n                "+_vm._s(row.item.price.priceValidUntil)+"\n              ")]}},{key:"status",fn:function(data){return [(data.value === 'APPROVED')?_c('b',{staticClass:"text-success"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e(),_vm._v(" "),(data.value === 'REJECTED')?_c('b',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e(),_vm._v(" "),(data.value === 'PENDING_APPROVAL')?_c('b',{staticClass:"text-warning"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e()]}}])})],1)]}}])})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('activable-products-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetailView_vue__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07734b15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetailView_vue__ = __webpack_require__(826);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetailView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07734b15_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetailView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_catalog_ProductDetail__ = __webpack_require__(308);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'product-details-view',
  props: ['productId'],
  components: {
    ProductDetail: __WEBPACK_IMPORTED_MODULE_0__components_catalog_ProductDetail__["a" /* default */]
  }
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('product-detail',{attrs:{"productId":_vm.productId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae5b920c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(830);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae5b920c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae5b920c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_UserServiceMixim_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_NotificationServiceMixim_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixims_UserServiceMixim_js__["a" /* UserServiceMixim */], __WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_3__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_4__mixims_NotificationServiceMixim_js__["a" /* NotificationServiceMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim__["a" /* ValidationsMixim */]],
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  computed: {
    userState: function userState() {
      return this.validateEmail(this.username, true);
    },
    passwordState: function passwordState() {
      return this.password.length > 0;
    },
    loginDisabled: function loginDisabled() {
      return this.waitingLogin || !this.passwordState || !this.userState;
    }
  },
  data: function data() {
    return {
      username: '',
      password: '',
      waitingLogin: false,
      errorText: ''
    };
  },

  methods: {
    login: function login(e) {
      var _this2 = this;

      e.preventDefault();
      if (!this.userState || !this.passwordState || this.waitingLogin) return;
      localStorage.setItem('timer', false);
      this.waitingLogin = true;
      this.loginRequest(this.username, this.password).then(function (response) {
        var loginData = response.body;

        _this2.$session.start();
        _this2.$session.set('token', loginData.access_token);
        _this2.$store.dispatch('setLoginData', loginData);
        var _this = _this2;
        _this2.getUserData().then(function (response) {
          _this2.$session.set('userData', response.body);
          _this2.$store.dispatch('setUserData', response.body);
          var hasCatalogAccess = response.body.roles.find(function (e) {
            return e.roleName === 'CATALOG_USER';
          });
          var hasCarrierAccess = response.body.roles.find(function (e) {
            return e.roleName === 'CARRIERS_USER';
          });

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([hasCatalogAccess ? _this2.getCategories() : null, hasCarrierAccess ? _this2.getCarrierData() : null]).then(function (response) {
            if (response[0] !== null) {
              _this.$store.dispatch('setCategoryData', response[0].body);
            }
            if (response[1] !== null) {
              _this.$store.dispatch('setCarrierData', response[1].body);
            }
            _this2.waitingLogin = false;
            _this2.$router.push('/dashboard');
          });
        }, function (error) {
          _this2.waitingLogin = false;
          _this2.errorText = error.body.message || 'Error obteniendo datos de la aplicacion';
        });
      }, function (error) {
        _this2.waitingLogin = false;
        _this2.loginError = true;
        _this2.errorText = error.body.message || 'Error al autenticar al usuario';
      });
    }
  }
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-bg app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-form',{attrs:{"id":"userLogin","name":"userLogin","autocomplete":"on"},on:{"submit":_vm.login}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('h5',{directives:[{name:"show",rawName:"v-show",value:(_vm.waitingLogin),expression:"waitingLogin"}]},[_vm._v(_vm._s(_vm.$t('Ingresando a Seller Center...')))]),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.waitingLogin,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-card-body',{directives:[{name:"show",rawName:"v-show",value:(!_vm.waitingLogin),expression:"!waitingLogin"}]},[_c('h2',[_vm._v(_vm._s(_vm.$t('Bienvenido a Seller Center')))]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.errorText !== '',"fade":"","dismissible":"","variant":"danger"}},[_vm._v(_vm._s(_vm.errorText))]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('Ingrese sus datos para ingresar a Seller Center.')))]),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('Nombre'),"label-for":"userEmail","invalid-feedback":!_vm.userState? 'Debe ingresar un email valido': '',"state":_vm.userState,"description":_vm.$t('Ingrese el email con que fue creada su cuenta')}},[_c('b-form-input',{attrs:{"trim":"","id":"userEmail","name":"userEmail","type":"email","state":_vm.userState,"placeholder":"mail@dominio.com","required":"","title":"Ingrese un email válido","autocomplete":"userEmail"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":_vm.$t('Contraseña'),"label-for":"password","invalid-feedback":!_vm.passwordState? 'Ingrese su password': '',"state":_vm.passwordState}},[_c('b-form-input',{attrs:{"id":"password","trim":"","name":"password","type":"password","state":_vm.passwordState,"placeholder":"Password","required":"","autocomplete":"password","title":"Ingrese su password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-4",attrs:{"type":"submit","variant":"primary","disabled":_vm.loginDisabled}},[_vm._v("Login")])],1)],1)],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f784ef_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(833);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07f784ef_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65bf1d69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(836);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65bf1d69_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page500'
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Houston, we have a problem!")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for is temporarily unavailable.")])]),_vm._v(" "),_c('div',{staticClass:"input-prepend input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"prependedInput","size":"16","type":"text","placeholder":"What are you looking for?"}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Search")])],1)])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PunishmentComponentView_vue__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc264b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PunishmentComponentView_vue__ = __webpack_require__(839);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PunishmentComponentView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dc264b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PunishmentComponentView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_papaparse__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'punishment-component-view',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  methods: {
    resetFile: function resetFile() {
      this.$refs.fileinput.reset();
    },
    uploadFile: function uploadFile(evt) {
      var _this = this;

      this.inProgress = true;
      this.success = false;
      var endPoint = __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/orders/punishments?delimiter=' + this.delimiter;
      var formData = new FormData();
      formData.append('file', this.csvFile);
      return this.$http.post(endPoint, formData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function () {
        _this.inProgress = false;
        _this.success = true;
      }, function (error) {
        _this.inProgress = false;
        _this.errorText = error.body.message || 'Se produjo un error al procesar el archivo CSV.';
      });
    },
    onFileChanged: function onFileChanged(evt) {
      var _this2 = this;

      var self = this;
      this.errorText = '';
      this.success = false;
      this.csvElements = [];
      var file = evt.target.files[0];
      if (!file) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (evt) {
        try {
          var rowError = false;
          var parsedData = __WEBPACK_IMPORTED_MODULE_2_papaparse___default.a.parse(evt.target.result.trim(), { skipEmptyLines: true, encoding: 'UTF-8' });

          if (parsedData.errors.length > 0) {
            self.errorText = 'El archivo tiene un formato que no es soportado';
            self.$refs.fileinput.reset();
            return;
          }

          self.delimiter = parsedData.meta.delimiter;

          var header = parsedData.data.shift();
          if (header.length !== 2) {
            self.errorText += 'La cabecera del archivo CSV debe tener 2 columnas.';
            self.errorText += '<ul>';
            self.errorText += '<li>Verificar que la cabecera es "Id Orden"; "Fecha".</li>';
            self.errorText += '</ul>';
            return;
          }
          _this2.ordersCount = parsedData.data.length;
          parsedData.data.forEach(function (elem, index) {
            rowError = false;
            var newRowElem = {
              'orderId': elem[0],
              'date': elem[1],
              '_cellVariants': null
            };
            if (elem.length !== 2) {
              rowError = true;
              newRowElem = { '_cellVariants': null };
              newRowElem.orderId = 'Faltan ' + (2 - elem.length) + ' campos';
            } else {
              newRowElem._cellVariants = {};
              var myRegExp = /^\d{4}-\d{2}-\d{2}$/;
              if (!myRegExp.test(elem[1])) {
                self.errorText = 'Hay filas con errores en el archivo CSV';
                self.errorText += '<ul>';
                self.errorText += '<li>Verifique que las filas tengan la misma cantidad de items que la cabecera (2).</li>';
                self.errorText += '<li>Verifique que las fechas tengan formato YYYY-MM-DD.</li>';
                self.errorText += '</ul>';
                newRowElem._cellVariants.date = 'danger';
                rowError = true;
              }
            }
            if (rowError) {
              if (newRowElem._cellVariants === null) {
                newRowElem._rowVariant = 'danger';
              }
            } else {
              newRowElem._rowVariant = 'success';
            }
            self.csvElements.push(newRowElem);
          });
          _this2.inProgress = false;
        } catch (err) {
          _this2.errorText = 'El archivo CSV tiene fallas';
        }
      };
      reader.readAsText(file, 'UTF-8');
    }
  },
  data: function data() {
    return {
      success: false,
      inProgress: false,
      ordersCount: 0,
      errorText: '',
      csvFile: null,
      delimiter: null,
      csvElements: [],
      csvFields: [{ key: 'orderId', label: 'Id Orden' }, { key: 'date', label: 'Fecha' }]
    };
  }
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"ml-3 alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v("\n   "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"ml-3 alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n    Las penalizaciones fueron cargadas con éxito\n  ")]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Seleccionar Archivo CSV"}},[_c('h5',[_vm._v("Archivo seleccionado: "+_vm._s(_vm.csvFile && _vm.csvFile.name))]),_vm._v(" "),_c('h6',[_vm._v("Cantidad pedidos: "+_vm._s(_vm.ordersCount))]),_vm._v(" "),_c('b-form-file',{ref:"fileinput",staticClass:"mt-3",attrs:{"accept":".csv","no-drop":true,"placeholder":"Archivo CSV..."},on:{"change":_vm.onFileChanged},nativeOn:{"click":function($event){_vm.resetFile($event)}},model:{value:(_vm.csvFile),callback:function ($$v) {_vm.csvFile=$$v},expression:"csvFile"}}),_vm._v(" "),_c('b-button',{staticClass:"mt-5",attrs:{"disabled":!Boolean(_vm.csvFile) || _vm.errorText !== '',"variant":"primary"},on:{"click":_vm.uploadFile}},[_vm._v("Subir CSV")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Previsualizacion Archivo CSV"}},[_c('moon-loader',{attrs:{"loading":_vm.inProgress,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inProgress),expression:"!inProgress"}],attrs:{"items":_vm.csvElements,"hover":"","fields":_vm.csvFields,"small":true,"show-empty":"","empty-text":"No hay penalizaciones para mostrar","striped":"","hover":"","stacked":"md","foot-clone":""}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiquidationsComponentView_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b60e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiquidationsComponentView_vue__ = __webpack_require__(842);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiquidationsComponentView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a5b60e0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiquidationsComponentView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_papaparse__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'liquidations-component-view',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  methods: {
    resetFile: function resetFile() {
      this.$refs.fileinput.reset();
    },
    uploadFile: function uploadFile(evt) {
      var _this = this;

      this.inProgress = true;
      this.errorText = '';
      this.success = false;
      var endPoint = __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/orders/liquidations?delimiter=' + this.delimiter;
      var formData = new FormData();
      formData.append('file', this.csvFile);
      return this.$http.post(endPoint, formData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function () {
        _this.inProgress = false;
        _this.success = true;
      }, function (error) {
        _this.inProgress = false;
        _this.errorText = error.body.message || 'Se produjo un error al procesar el archivo CSV.';
      });
    },
    onFileChanged: function onFileChanged(evt) {
      var _this2 = this;

      var self = this;
      this.errorText = '';
      this.success = false;
      this.csvElements = [];
      var file = evt.target.files[0];
      if (!file) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (evt) {
        try {
          var rowError = false;
          var parsedData = __WEBPACK_IMPORTED_MODULE_2_papaparse___default.a.parse(evt.target.result.trim(), { skipEmptyLines: true, encoding: 'UTF-8' });

          if (parsedData.errors.length > 0) {
            self.errorText = 'El archivo tiene un formato que no es soportado';
            self.$refs.fileinput.reset();
            return;
          }

          _this2.delimiter = parsedData.meta.delimiter;

          var header = parsedData.data.shift();
          if (header.length !== 4) {
            self.errorText += 'La cabecera del archivo CSV debe tener 4 columnas.';
            self.errorText += '<ul>';
            self.errorText += '<li>Verificar que la cabecera es "OrderId"; "Date"; "Value"; "InvoiceNumber".</li>';
            self.errorText += '</ul>';
            return;
          }
          self.ordersCount = parsedData.data.length;
          parsedData.data.forEach(function (elem, index) {
            rowError = false;
            var newRowElem = {
              'orderId': elem[0],
              'date': elem[1],
              'ammount': elem[2],
              'invoiceNumber': elem[3],
              '_cellVariants': null
            };
            if (elem.length !== 4) {
              rowError = true;
              newRowElem = { '_cellVariants': null };
              newRowElem.orderId = 'Faltan ' + (4 - elem.length) + ' campos';
            } else {
              newRowElem._cellVariants = {};
              var myRegExp = /^\d{4}-\d{2}-\d{2}$/;
              if (!elem[1].match(myRegExp)) {
                rowError = true;
                newRowElem._cellVariants.date = 'danger';
              }
              if (isNaN(elem[2])) {
                rowError = true;
                newRowElem._cellVariants.ammount = 'danger';
              }
            }
            if (rowError) {
              self.errorText = 'Hay filas con errores en el archivo CSV';
              self.errorText += '<ul>';
              self.errorText += '<li>Verifique que las filas tengan la misma cantidad de items que la cabecera(4).</li>';
              self.errorText += '<li>Verifique que las fechas tengan formato YYYY-MM-DD.</li>';
              self.errorText += '<li>Verifique que los valores numericos sean válidos.</li>';
              self.errorText += '</ul>';
              if (newRowElem._cellVariants === null) {
                newRowElem._rowVariant = 'danger';
              }
            } else {
              newRowElem._rowVariant = 'success';
            }

            self.csvElements.push(newRowElem);
          });
        } catch (err) {
          _this2.errorText = 'El archivo CSV tiene fallas';
        }
      };
      reader.readAsText(file, 'UTF-8');
    }
  },
  data: function data() {
    return {
      success: false,
      inProgress: false,
      ordersCount: 0,
      errorText: '',
      csvFile: null,
      delimiter: null,
      csvElements: [],
      csvFields: [{ key: 'orderId', label: 'Id Orden' }, { key: 'date', label: 'Fecha' }, { key: 'ammount', label: 'Monto' }, { key: 'invoiceNumber', label: 'Factura' }]
    };
  }
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"ml-3 alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v("\n   "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"ml-3 alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n    Las liquidaciones fueron cargadas con éxito\n  ")]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Seleccionar Archivo CSV"}},[_c('h5',[_vm._v("Archivo seleccionado: "+_vm._s(_vm.csvFile && _vm.csvFile.name))]),_vm._v(" "),_c('h6',[_vm._v("Cantidad pedidos liquidados: "+_vm._s(_vm.ordersCount))]),_vm._v(" "),_c('b-form-file',{ref:"fileinput",staticClass:"mt-3",attrs:{"no-drop":true,"accept":".csv","placeholder":"Archivo CSV"},on:{"change":_vm.onFileChanged},nativeOn:{"click":function($event){_vm.$refs.fileinput.reset()}},model:{value:(_vm.csvFile),callback:function ($$v) {_vm.csvFile=$$v},expression:"csvFile"}}),_vm._v(" "),_c('b-button',{staticClass:"mt-5",attrs:{"disabled":!Boolean(_vm.csvFile) || _vm.errorText !== '',"variant":"primary"},on:{"click":_vm.uploadFile}},[_vm._v("Subir CSV")])],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Previsualizacion Archivo CSV"}},[_c('moon-loader',{attrs:{"loading":_vm.inProgress,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inProgress),expression:"!inProgress"}],attrs:{"items":_vm.csvElements,"hover":"","fields":_vm.csvFields,"small":true,"show-empty":"","striped":"","empty-text":"No hay liquidaciones para mostrar","hover":"","stacked":"md","foot-clone":""}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMasiveProductsComponentView_vue__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94d94172_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddMasiveProductsComponentView_vue__ = __webpack_require__(850);
function injectStyle (ssrContext) {
  __webpack_require__(844)
  __webpack_require__(845)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94d94172"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddMasiveProductsComponentView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94d94172_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddMasiveProductsComponentView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_treeview__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_treeview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_treeview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_catalog_CategoryTree__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_papaparse__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_image_zoom__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_image_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_image_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixims_ValidationsMixim_js__ = __webpack_require__(10);














__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_image_zoom___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-masive-products-component-view',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_MoonLoader_vue__["a" /* default */],
    VTreeview: __WEBPACK_IMPORTED_MODULE_4_v_treeview___default.a,
    CategoryTree: __WEBPACK_IMPORTED_MODULE_6__components_catalog_CategoryTree__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_10__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  methods: {
    selectCategory: function selectCategory(data) {
      this.categorySelected.id = data.id;
      this.categorySelected.text = data.name;
      this.categorySelected.namePath = data.namePath;
    },

    zoomImage: function zoomImage(src) {
      this.$zoom(src, {
        allowZoom: true,
        autoScale: true,
        closeOnClickModal: true
      });
    },
    errorImage: function errorImage() {
      if (!this.productFeedback.errorText) this.productFeedback.errorText = 'Se encontraron errores.';
      this.asyncErrorObj['brokenimg'] = 'El archivo contiene imágenes erróneas.';
      this.csvElements.forEach(function (elem, index) {
        console.log(elem);
        elem._cellVariants.image = 'danger';
      });
      this.$forceUpdate();
      this.$refs.productsTable.refresh();
    },
    resetInputProduct: function resetInputProduct() {
      this.xlsAlert = false;
      this.$refs.fileProductInput.reset();
    },
    resetInputAttr: function resetInputAttr() {
      this.$refs.fileProductAttrInput.reset();
    },
    resetInputAttrVar: function resetInputAttrVar() {
      this.$refs.fileProductVarAttrInput.reset();
    },
    itemProvider: function itemProvider(tableComponentInfo) {
      var start = (tableComponentInfo.currentPage - 1) * tableComponentInfo.perPage;
      var end = tableComponentInfo.perPage * tableComponentInfo.currentPage;
      this.productsCount = this.csvElements.length;
      return this.csvElements.slice(start, end);
    },
    _downloadFileExec: function _downloadFileExec(endPoint, fileName) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.options.emulateHTTP = true;

      return this.$http.get(endPoint, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          Accept: 'application/octet-stream; charset=ISO-8859-1'
        },
        responseType: 'arraybuffer'
      }).then(function (csvFile) {
        var headers = csvFile.headers;
        var blob = new Blob([csvFile.body], {
          type: { type: headers.map['content-type'] }
        });
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', fileName);
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      });
    },
    downloadVarSpecificationsCSVExampleFile: function downloadVarSpecificationsCSVExampleFile() {
      var endPoint = __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.API_END_POINT + '/specifications/downloadcsv?isStockKeepingUnit=true&categoryId=' + this.categorySelected.id;
      var fileName = 'modeloAtributosVariants.csv';
      return this._downloadFileExec(endPoint, fileName);
    },
    downloadSpecificationsCSVExampleFile: function downloadSpecificationsCSVExampleFile() {
      var endPoint = __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.API_END_POINT + '/specifications/downloadcsv?isStockKeepingUnit=false&categoryId=' + this.categorySelected.id;
      var fileName = 'modeloAtributos.csv';
      return this._downloadFileExec(endPoint, fileName);
    },
    downloadProductCSVExampleFile: function downloadProductCSVExampleFile() {
      var endPoint = __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.API_END_POINT + '/products/downloadcsv?categoryId=' + this.categorySelected.id;
      var fileName = 'modeloProductos.csv';
      return this._downloadFileExec(endPoint, fileName);
    },
    _uploadFile: function _uploadFile(endPoint, file, refInput, feedback) {
      var _this = this;

      this.inProgress = true;
      feedback.errorText = '';
      feedback.success = false;
      var formData = new FormData();
      formData.append('file', file);
      return this.$http.post(endPoint, formData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function () {
        _this.inProgress = false;
        feedback.success = true;
        _this.success = true;
        refInput.reset();
      }, function (error) {
        _this.inProgress = false;
        feedback.errorText = error.body.message || 'Error procesando el archivo CSV - ' + file.name;

        _this.csvElements.forEach(function (elem, index) {
          elem._rowVariant = 'danger';
        });
        _this.$refs.productsTable.refresh();
        refInput.reset();
      });
    },
    uploadSpecificationsFile: function uploadSpecificationsFile(evt) {
      var endPoint = __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.API_END_POINT + '/specifications/importcsv?isStockKeepingUnit=false&categoryId=' + this.categorySelected.id + '&delimiter=' + this.delimiterAttr;
      return this._uploadFile(endPoint, this.csvProductAttrFile, this.$refs.fileProductAttrInput, this.attrFeedback);
    },
    uploadVarSpecificationsFile: function uploadVarSpecificationsFile(evt) {
      var endPoint = __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.API_END_POINT + '/specifications/importcsv?isStockKeepingUnit=true&categoryId=' + this.categorySelected.id + '&delimiter=' + this.delimiterAttrVar;
      return this._uploadFile(endPoint, this.csvProductVarAttrFile, this.$refs.fileProductVarAttrInput, this.attrVarFeedback);
    },
    uploadProductFile: function uploadProductFile(evt) {
      var endPoint = __WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.API_END_POINT + '/products/importcsv?categoryId=' + this.categorySelected.id + '&delimiter=' + this.delimiterProduct;
      return this._uploadFile(endPoint, this.csvProductFile, this.$refs.fileProductInput, this.productFeedback);
    },
    onFileAttrChanged: function onFileAttrChanged(evt) {
      var self = this;
      this.attrFeedback.errorText = '';
      this.attrFeedback.success = false;
      var file = evt.target.files[0];
      if (!file) {
        return;
      }
      var reader = new FileReader();
      reader.onload = function (evt) {
        var parsedData = __WEBPACK_IMPORTED_MODULE_8_papaparse___default.a.parse(evt.target.result.trim(), {
          skipEmptyLines: true,
          encoding: 'ISO-8859-1'
        });
        self.delimiterAttr = parsedData.meta.delimiter;
        if (parsedData.errors.length > 0) {
          self.attrFeedback.errorText = 'El archivo tiene un formato que no es soportado';
          self.$refs.fileProductAttrInput.reset();
        }

        var headerError = '';
        var data = parsedData.data;
        var header = parsedData.data.shift();

        if (data.length === 0) {
          headerError = 'No hay filas para procesar en el archivo.';
          self.attrFeedback.errorText = headerError;
          self.inProgress = false;
          return;
        }

        if (header.length !== 5) {
          headerError = 'La cabecera del archivo debe tener 5 columnas.';
          headerError += '<ul>';
          headerError += '  <li>Verificar que la cabecera es "ID producto; Nombre del atributo; Tipo de atributo; Opciones de atributo; Valor de atributo"</li>';
          headerError += '</ul>';
          self.attrFeedback.errorText = headerError;
          self.inProgress = false;
          return;
        }

        data.forEach(function (elem, index) {
          elem.forEach(function (elem2, index2) {
            if (!elem[index2] && index2 !== 3 && index2 !== 4) {
              self.attrFeedback.errorText = 'Verifique que no existan campos faltantes.';
            }
          });
          if (elem.length !== 5) {
            self.attrFeedback.errorText = 'Verifique que existan 5 columnas.';
          }
        });
      };
      reader.readAsText(file, 'ISO-8859-1');
    },
    onFileAttrVarChanged: function onFileAttrVarChanged(evt) {
      var self = this;
      this.attrVarFeedback.errorText = '';
      this.attrVarFeedback.success = false;
      var file = evt.target.files[0];
      if (!file) {
        return;
      }
      var reader = new FileReader();
      reader.onload = function (evt) {
        var parsedData = __WEBPACK_IMPORTED_MODULE_8_papaparse___default.a.parse(evt.target.result.trim(), {
          skipEmptyLines: true,
          encoding: 'ISO-8859-1'
        });
        self.delimiterAttrVar = parsedData.meta.delimiter;
        if (parsedData.errors.length > 0) {
          self.attrVarFeedback.errorText = 'El archivo tiene un formato que no es soportado';
          self.$refs.fileProductVarAttrInput.reset();
        }

        var headerError = '';
        var data = parsedData.data;
        var header = parsedData.data.shift();

        if (data.length === 0) {
          headerError = 'No hay filas para procesar en el archivo.';
          self.attrVarFeedback.errorText = headerError;
          self.inProgress = false;
          return;
        }

        if (header.length !== 7) {
          headerError = 'La cabecera del archivo debe tener 7 columnas.';
          headerError += '<ul>';
          headerError += '  <li>Verificar que la cabecera es "UPC; ID producto; SKU; Nombre del atributo; Tipo de atributo; Opciones de atributo; Valor de atributo"</li>';
          headerError += '</ul>';
          self.attrVarFeedback.errorText = headerError;
          self.inProgress = false;
          return;
        }

        data.forEach(function (elem, index) {
          elem.forEach(function (elem2, index2) {
            if (!elem[index2] && index2 !== 6) {
              self.attrVarFeedback.errorText = 'Verifique que no existan campos faltantes.';
            }
          });

          if (elem.length !== 7) {
            self.attrVarFeedback.errorText = 'Verifique que existan 7 columnas.';
          }
        });
      };
      reader.readAsText(file, 'ISO-8859-1');
    },
    _getDelimiter: function _getDelimiter(str) {
      var semiColon = str.match(new RegExp(';', 'g'));
      var colon = str.match(new RegExp(',', 'g'));

      if (!semiColon) {
        return ',';
      }

      if (!colon) {
        return ';';
      }

      return semiColon.length > colon.length ? ';' : ',';
    },
    onFileChanged: function onFileChanged(evt) {
      var _this2 = this;

      var self = this;
      self.inProgress = true;
      self.productFeedback.errorText = '';
      self.productFeedback.success = false;
      self.xlsAlert = false;
      self.csvElements = [];
      this.asyncErrorObj = {};
      self.$refs.productsTable.refresh();
      var file = evt.type === 'drop' ? evt.dataTransfer.files[0] : evt.target.files[0];
      if (!file) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (evt) {
        var headerError = '';
        _this2.productFeedback.errorArray = {};
        try {
          var parsedData = __WEBPACK_IMPORTED_MODULE_8_papaparse___default.a.parse(evt.target.result.trim(), {
            delimiter: ';',
            skipEmptyLines: true,
            encoding: 'ISO-8859-1'
          });
          self.delimiterProduct = parsedData.meta.delimiter;
          console.log('Guess Delimiter from Papa: ' + self.delimiterProduct);

          if (parsedData.errors.length > 0) {
            console.log('There are some errors in the parsing, the file format is not supported');
            console.log(parsedData);
            self.productFeedback.errorText = 'El archivo tiene un formato que no es soportado';
            self.$refs.fileinput.reset();
            return;
          }

          var data = parsedData.data;
          var header = parsedData.data.shift();
          console.log('------------ Header ------------');
          console.log(header);
          console.log('------------ Data ------------');
          console.log(data);

          if (data.length === 0) {
            headerError = 'No hay filas para procesar en el archivo.';
            self.productFeedback.errorText = headerError;
            self.inProgress = false;
            return;
          }

          if (header.length !== 18) {
            headerError = 'La cabecera del archivo debe tener 18 columnas.';
            headerError += '<ul>';
            headerError += '  <li>Verificar que la cabecera es "Id Producto; SKU ; Nombre UPC; Nombre SKU; Descripción del producto; Marca; UPC; Indentificador; Precio regular; Precio con descuento; Precio válido hasta; URL de imágenes; Alto; Largo; Peso; Ancho; Inventario; Stock de seguridad"</li>';
            headerError += '</ul>';
            self.productFeedback.errorText = headerError;
            self.inProgress = false;
            return;
          }

          data.forEach(function (elem, index) {
            var newRowElem = {
              'row': index,
              'idProd': elem[0],
              'sku': elem[1],
              'name': elem[2],
              'nameSku': elem[3],
              'description': elem[4],
              'brand': elem[5],
              'upc': elem[6],
              'refId': elem[7],
              'listPrice': elem[8],
              'price': elem[9],
              'priceValidUntil': elem[10],
              'image': elem[11],
              'height': elem[12],
              'length': elem[13],
              'weight': elem[14],
              'width': elem[15],
              'inventory': elem[16],
              'securityStock': elem[17],
              '_cellVariants': null
            };

            if (elem.length !== 18) {
              newRowElem = { '_cellVariants': null };
              newRowElem.sku = 18 - elem.length > 0 ? 'Faltan ' + (18 - elem.length) + ' campos' : 'Sobran ' + (elem.length - 18) + ' campos';
              _this2.productFeedback.errorArray['columns'] = '<li>Verifique que existan 18 columnas.</li>';
            } else {
              newRowElem._cellVariants = {};
              var testUPC = _this2.testUPC(elem[6], newRowElem);
              var brandTestResult = _this2.testBrand(elem[5], newRowElem);
              var testName = _this2.testName(elem[2], newRowElem);
              var testNameSku = _this2.testNameSku(elem[3], newRowElem);
              var testIdentifier = _this2.testIdentifier(elem[7], newRowElem);
              var testDescription = _this2.testDescription(elem[4]);
              var testPriceResult = _this2.testPrice(elem[8], elem[9], newRowElem);
              var testImageResult = _this2.testImages(elem[11], newRowElem);
              var testPriceValidUntil = _this2.testPriceValidUntil(elem[10], elem[9], elem[8], newRowElem);
              var testSizes = _this2.testSizes(elem[12], elem[13], elem[14], elem[15], newRowElem);
              var testInventory = _this2.testInventory(elem[16], newRowElem);
              var testSecurityStock = _this2.testSecurityStock(elem[17], newRowElem);
              if (testName || testDescription || testUPC || testImageResult || brandTestResult || testPriceResult || testPriceValidUntil || testSizes || testIdentifier || testInventory || testNameSku || testSecurityStock) {
                newRowElem._cellVariants.row = 'danger';
              } else {
                newRowElem._cellVariants.row = 'success';
              }
            }
            self.csvElements.push(newRowElem);
          });

          console.log(_this2.productFeedback.errorArray);
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.productFeedback.errorArray).length > 0) {
            _this2.productFeedback.errorText += '<ul class="mb-0">';
            for (var errorKey in _this2.productFeedback.errorArray) {
              console.log(errorKey);
              _this2.productFeedback.errorText += _this2.productFeedback.errorArray[errorKey];
            }
            _this2.productFeedback.errorText += '</ul>';
          }
          _this2.inProgress = false;
          _this2.$refs.productsTable.refresh();
        } catch (err) {
          console.log(err);
          _this2.inProgress = false;
          _this2.productFeedback.errorText = 'El archivo CSV de productos tiene fallas.';
        }
      };
      var extencion = this._getFileExtencion(file.name);
      console.log(file);
      console.log('File extencion: ' + extencion);
      if (__WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.CSV_MIME_TYPES.includes(file.type)) {
        console.log('CSV File mime type recognized ---------------------');
        console.log(file.type);
        reader.readAsText(file, 'ISO-8859-1');
      } else {
        if (['csv', 'txt'].includes(extencion)) {
          console.log('Mime type non recognized, tried with file extencion');
          reader.readAsText(file, 'ISO-8859-1');
        }
      }
    },
    testDescription: function testDescription(description) {
      if (this.isEmptyData(description.trim())) {
        this.productFeedback.errorArray['description'] = '<li>Verificar que la Descripción no esta vacía y es un texto válido.</li>';
        return true;
      }
      return false;
    },
    testName: function testName(name, newRowElem) {
      if (name.length > 100 || this.isEmptyData(name.trim()) || !this.isValidText(name, true)) {
        newRowElem._cellVariants.name = 'danger';
        this.productFeedback.errorArray['name'] = '<li>Verificar que el Nombre no esté vacío, sea válido y contenga menos de 100 caracteres.</li>';
        return true;
      }
      return false;
    },
    testNameSku: function testNameSku(name, newRowElem) {
      if (name.length > 100 || this.isEmptyData(name.trim()) || !this.isValidText(name, true)) {
        newRowElem._cellVariants.nameSku = 'danger';
        this.productFeedback.errorArray['nameSku'] = '<li>Verificar que el Nombre de SKU no esté vacío, sea válido y contenga menos de 100 caracteres.</li>';
        return true;
      }
      return false;
    },
    testInventory: function testInventory(inventory, newRowElem) {
      if (!this.isValidInteger(inventory, false)) {
        newRowElem._cellVariants.inventory = 'danger';
        this.productFeedback.errorArray['inventory'] = '<li>Verificar que el inventario sea válido.</li>';
        return true;
      }
      return false;
    },
    testSecurityStock: function testSecurityStock(stock, newRowElem) {
      if (!this.isValidInteger(stock, true)) {
        newRowElem._cellVariants.securityStock = 'danger';
        this.productFeedback.errorArray['securityStock'] = '<li>Verificar que el stock de seguridad sea válido.</li>';
        return true;
      }
      return false;
    },
    testIdentifier: function testIdentifier(_testIdentifier, newRowElem) {
      if (!this.isValidText(_testIdentifier, false)) {
        newRowElem._cellVariants.refId = 'danger';
        this.productFeedback.errorArray['indentifier'] = '<li>Verificar que el identificador es válido.</li>';
        return true;
      }
      return false;
    },
    _getFileExtencion: function _getFileExtencion(fileName) {
      return (/[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)[0] : undefined
      );
    },
    testImages: function testImages(imagesSrc, newRowElem) {
      var _this3 = this;

      var images = imagesSrc.split('|');
      if (imagesSrc.trim() === '') {
        newRowElem._cellVariants.image = 'danger';
        this.productFeedback.errorArray['images'] = '<li>Verificar que hay imágenes seleccionadas.</li>';
        return true;
      }

      if (images.length > 5) {
        newRowElem._cellVariants.image = 'danger';
        this.productFeedback.errorArray['images'] = '<li>Verificar la extensión de las imágenes, que la cantidad no sea mayor a 5 y que cada imagen tenga el tamaño adecuado (Min 500 x 500, max 2,000 x 2,000).</li>';
        return true;
      }

      if (images.length < 1) {
        newRowElem._cellVariants.image = 'danger';
        this.productFeedback.errorArray['images'] = '<li>Verificar que la cantidad de imágenes no sea menor a 1</li>';
        return true;
      }

      images.forEach(function (imageSrc) {
        var extencion = _this3._getFileExtencion(imageSrc.split('?')[0]);
        if (extencion !== undefined) {
          if (__WEBPACK_IMPORTED_MODULE_7__config_applicationConfig_js___default.a.IMAGE_FILES_SUPPORTED.indexOf(extencion.toUpperCase()) === -1) {
            newRowElem._cellVariants.image = 'danger';
            _this3.productFeedback.errorArray['images'] = '<li>Verificar la extensión de las imágenes, que la cantidad no sea mayor a 5 y que cada imagen tenga el tamaño adecuado (Min 500 x 500, max 2,000 x 2,000).</li>';
            return true;
          }
        }
      });
      return false;
    },
    testPriceValidUntil: function testPriceValidUntil(date, price, listPrice, newRowElem) {
      if (price === listPrice && this.isEmptyData(date)) {
        return false;
      }

      if (price) {
        var myRegExp = /^\d{4}-\d{2}-\d{2}$/;
        if (!date.match(myRegExp)) {
          newRowElem._cellVariants.priceValidUntil = 'danger';
          this.productFeedback.errorArray['priceValidUntil'] = '<li>Verificar que las fechas sean válidas y no menores al día de hoy.</li>';
          return true;
        }

        var d = new Date(date);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(d.getTime())) {
          this.productFeedback.errorArray['priceValidUntil'] = '<li>Verificar que las fechas sean válidas y no menores al día de hoy.</li>';
          newRowElem._cellVariants.priceValidUntil = 'danger';
          return true;
        }

        if (new Date(date) <= new Date()) {
          this.productFeedback.errorArray['priceValidUntil'] = '<li>Verificar que las fechas sean válidas y no menores al día de hoy.</li>';
          newRowElem._cellVariants.priceValidUntil = 'danger';
          return true;
        }
      }
      return false;
    },
    testSizes: function testSizes(height, length, weight, width, newRowElem) {
      var fail = false;
      if (isNaN(height) || isNaN(length) || isNaN(weight) || isNaN(width)) {
        newRowElem._cellVariants.size = 'danger';
        this.productFeedback.errorArray['sizes'] = '<li>Verificar que los valores para tamaño sean numéricos y distintos de 0.</li>';
        fail = true;
      }

      if (Number(height) < 1 || Number(length) < 1 || Number(weight) < 1 || Number(width) < 1) {
        newRowElem._cellVariants.size = 'danger';
        this.productFeedback.errorArray['sizes'] = '<li>Verificar que los valores para tamaño sean numéricos y distintos de 0.</li>';
        fail = true;
      }

      return fail;
    },
    testPrice: function testPrice(listPrice, price, newRowElem) {
      if (isNaN(listPrice) || Number(listPrice) === 0) {
        newRowElem._cellVariants.listPrice = 'danger';
        this.productFeedback.errorArray['price'] = '<li>Verificar que el precio regular y precio con descuento sean números válidos</li>';
        return true;
      }

      if (price) {
        if (isNaN(price) || Number(price) === 0) {
          newRowElem._cellVariants.price = 'danger';
          this.productFeedback.errorArray['price'] = '<li>Verificar que el precio regular y precio con descuento sean números válidos.</li>';
          return true;
        }
      }

      if (Number(listPrice) < Number(price)) {
        newRowElem._cellVariants.price = 'danger';
        newRowElem._cellVariants.listPrice = 'danger';
        this.productFeedback.errorArray['price'] = '<li>Verificar que el precio regular y precio con descuento sean números válidos.</li>';
        return true;
      }

      return false;
    },
    testUPC: function testUPC(upc, newRowElem) {
      var fail = this.isEmptyData(upc.trim()) || isNaN(upc) || upc.toString().toUpperCase().includes('E') || upc.trim().length > 20;
      if (fail) {
        newRowElem._cellVariants.upc = 'danger';
        this.productFeedback.errorArray['upc'] = '<li>Verificar que el UPC no está vacío y es un valor numérico no mayor de 20 caracteres.</li>';
        return true;
      }
      return false;
    },
    testBrand: function testBrand(brand, newRowElem) {
      var _this4 = this;

      var fail = true;

      if (this.$store.getters.cacheBrands.indexOf(brand) > -1) {
        return false;
      }
      var self = this;
      this.getSearchBrands(brand).then(function (response) {
        console.log(response.data);
        if (response.data.length > 0) {
          if (response.data.find(function (brnd) {
            return brnd.name === brand;
          })) {
            fail = false;
            self.$store.dispatch('addBrand', brand);
          }
        }
        if (fail) {
          if (!_this4.productFeedback.errorText) _this4.productFeedback.errorText = 'Se encontraron errores.';
          _this4.asyncErrorObj['brand'] = 'Verificar que las marcas sean válidas.';
          newRowElem._cellVariants.brand = 'danger';
          _this4.$refs.productsTable.refresh();
          _this4.$forceUpdate();
          return true;
        }
        return false;
      }, function (error) {
        console.log(error.body.message || 'Error obteniendo datos de la aplicacion');
      });
    },
    replaceUl: function replaceUl(text) {
      return text.replace('<ul class="mb-0">', '').replace('</ul>', '');
    }
  },

  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 70, 100, 1000],

      productFeedback: {
        success: false,
        errorText: '',
        errorArray: {}
      },

      asyncErrorObj: {},

      attrFeedback: {
        success: false,
        errorText: ''
      },

      attrVarFeedback: {
        success: false,
        errorText: ''
      },

      inProgress: false,
      productsCount: 0,
      fileTypeSelected: 'CSV',
      tabIndex: 0,
      csvProductFile: null,
      delimiterProduct: null,
      delimiterAttr: null,
      delimiterAttrVar: null,
      csvProductAttrFile: null,
      csvProductVarAttrFile: null,
      xlsAlert: false,
      csvElements: [],
      csvFields: [{ key: 'row', label: 'Fila', class: 'rowNumber' }, { key: 'idProd', label: 'Id del producto' }, { key: 'sku', label: 'Sku' }, { key: 'upc', label: 'Upc' }, { key: 'refId', label: 'Identificador' }, { key: 'name', label: 'Nombre del producto', class: 'previewNameField' }, { key: 'nameSku', label: 'Nombre del SKU', class: 'previewNameField' }, { key: 'brand', label: 'Marca' }, { key: 'listPrice', label: 'Precio regular' }, { key: 'price', label: 'Precio con descuento' }, { key: 'priceValidUntil', label: 'Fecha' }, { key: 'image', label: 'Imágenes' }, { key: 'size', label: 'Tamaño' }, { key: 'inventory', label: 'Inventario' }, { key: 'securityStock', label: 'Stock de seguridad' }],
      csvAttrFields: [{ key: 'fieldId', label: 'Id Atributo' }, { key: 'fieldName', label: 'Atributo' }, { key: 'fieldType', label: 'Tipo de campo' }, { key: 'attrId', label: 'Id Valor seleccionado' }, { key: 'attrValue', label: 'Valor ingresado' }],
      categorySelected: {
        id: null,
        text: 'No hay categoría seleccionada'
      }
    };
  }
});

/***/ }),
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"productsModal",attrs:{"header-bg-variant":"primary","centered":"","id":"productsModal","size":"lg","title":"Procesar alta de productos","o-close-on-backdrop":"true","cancel-title":"Cancelar"},on:{"ok":_vm.uploadProductFile}},[_vm._v("\n    ¿Desea continuar?\n  ")]),_vm._v(" "),_c('b-modal',{ref:"attrModal",attrs:{"header-bg-variant":"primary","centered":"","id":"attrModal","size":"lg","title":"Procesar alta de atributos","o-close-on-backdrop":"true","cancel-title":"Cancelar"},on:{"ok":_vm.uploadSpecificationsFile}},[_vm._v("\n    ¿Desea continuar?\n  ")]),_vm._v(" "),_c('b-modal',{ref:"attrModalVar",attrs:{"header-bg-variant":"primary","centered":"","id":"attrModalVar","size":"lg","title":"Procesar alta de atributos de variantes","o-close-on-backdrop":"true","cancel-title":"Cancelar"},on:{"ok":_vm.uploadVarSpecificationsFile}},[_vm._v("\n    ¿Desea continuar?\n  ")]),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.inProgress,"color":"#666","size":"30px"}}),_vm._v(" "),_c('b-row',{staticClass:"mb-5"},[_c('b-col',[_c('category-tree',{attrs:{"id":"selectCategoryProduct","boostrapClasses":"float-left","button":true,"buttonTitle":"Selecciona una Categoría"},on:{"onCategorySelected":_vm.selectCategory}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(Boolean(_vm.categorySelected.id)),expression:"Boolean(categorySelected.id)"}],staticClass:"categorySelected"},[_vm._v("Categoría seleccionada: "),_c('strong',[_vm._v(_vm._s(_vm.categorySelected.text))]),_vm._v(" ("+_vm._s(_vm.categorySelected.namePath)+")")])],1)],1),_vm._v(" "),_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"active":"","title":"Alta de productos y variantes"}},[(!Object.keys(_vm.asyncErrorObj).length)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.productFeedback.errorText),expression:"productFeedback.errorText"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.productFeedback.errorText)}},[_vm._v("\n        "+_vm._s(_vm.productFeedback.errorText)+"\n      ")]):_vm._e(),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(Object.keys(_vm.asyncErrorObj).length),expression:"Object.keys(asyncErrorObj).length"}],staticClass:"alert alert-danger",staticStyle:{"padding-left":"60px"},attrs:{"role":"alert"}},[(_vm.productFeedback.errorText !== 'Se encontraron errores.')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.replaceUl(_vm.productFeedback.errorText))}}):_vm._e(),_vm._v(" "),_vm._l((_vm.asyncErrorObj),function(error){return _c('li',{key:error},[_vm._v(_vm._s(error))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.productFeedback.success),expression:"productFeedback.success"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n        Los Productos fueron creados / actualizados con éxito\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"float-left mt-3",attrs:{"disabled":!Boolean(_vm.categorySelected.id),"variant":"primary"},on:{"click":_vm.downloadProductCSVExampleFile}},[_vm._v("Obtener formato para alta de productos")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"mb-2",attrs:{"md":"12"}},[_vm._v("Archivo Productos seleccionado: "),_c('strong',[_vm._v(_vm._s(_vm.csvProductFile && _vm.csvProductFile.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label-for":"productFileInput"}},[_c('b-form-file',{ref:"fileProductInput",attrs:{"id":"productFileInput","disabled":!Boolean(_vm.categorySelected.id),"accept":".csv,.txt","placeholder":"Productos CSV"},on:{"change":_vm.onFileChanged},nativeOn:{"click":function($event){_vm.resetInputProduct($event)}},model:{value:(_vm.csvProductFile),callback:function ($$v) {_vm.csvProductFile=$$v},expression:"csvProductFile"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.productsCount,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"overflow-x-auto"},[_c('p',[_vm._v("Cantidad de Productos: "),_c('strong',[_vm._v(_vm._s(_vm.productsCount))])]),_vm._v(" "),_c('b-table',{ref:"productsTable",attrs:{"items":_vm.itemProvider,"current-page":_vm.currentPage,"per-page":_vm.perPage,"hover":"","fields":_vm.csvFields,"small":true,"show-empty":"","striped":"","empty-text":"No hay productos para mostrar","stacked":"md","foot-clone":""},scopedSlots:_vm._u([{key:"sku",fn:function(sku){return [_c('b',[_vm._v(_vm._s(sku.value === '' ? '(new)' : sku.value))])]}},{key:"image",fn:function(image){return [_vm._l((image.value.split('|')),function(imageItem){return [_c('img',{key:imageItem,staticClass:"imageItem",attrs:{"src":imageItem},on:{"click":function($event){_vm.zoomImage(imageItem)},"error":_vm.errorImage}})]})]}},{key:"size",fn:function(row){return [_vm._v("\n                "+_vm._s(row.item.weight * row.item.height * row.item.length)+"cm3, "+_vm._s(row.item.weight)+"gr, "+_vm._s(row.item.height)+"x"+_vm._s(row.item.width)+"x"+_vm._s(row.item.length)+"cm\n              ")]}}])})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"md":"12"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.productsModal",modifiers:{"productsModal":true}}],staticClass:"float-right",attrs:{"disabled":!Boolean(_vm.csvProductFile) || !_vm.categorySelected || _vm.productFeedback.errorText !== '' || _vm.inProgress,"variant":"primary"}},[_vm._v("Procesar Productos")])],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.perPage > 100),expression:"perPage > 100"}],staticClass:"mt-5"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.productsCount,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Alta de atributos"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.attrFeedback.errorText),expression:"attrFeedback.errorText"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.attrFeedback.errorText)}},[_vm._v("\n        "+_vm._s(_vm.attrFeedback.errorText)+"\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.attrFeedback.success),expression:"attrFeedback.success"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n        Los atributos fueron actualizados con éxito\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"float-left mt-3",attrs:{"disabled":!Boolean(_vm.categorySelected.id),"variant":"primary"},on:{"click":_vm.downloadSpecificationsCSVExampleFile}},[_vm._v("Obtener formato para alta de atributos")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"mb-2",attrs:{"md":"12"}},[_vm._v("Archivo de Atributos seleccionado: "),_c('strong',[_vm._v(_vm._s(_vm.csvProductAttrFile && _vm.csvProductAttrFile.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-file',{ref:"fileProductAttrInput",attrs:{"accept":".csv,.txt","disabled":!Boolean(_vm.categorySelected.id),"placeholder":"Atributos CSV"},on:{"change":_vm.onFileAttrChanged},nativeOn:{"click":function($event){_vm.$refs.fileProductAttrInput.reset()}},model:{value:(_vm.csvProductAttrFile),callback:function ($$v) {_vm.csvProductAttrFile=$$v},expression:"csvProductAttrFile"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"md":"12"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.attrModal",modifiers:{"attrModal":true}}],staticClass:"float-left",attrs:{"disabled":!Boolean(_vm.csvProductAttrFile) || !_vm.categorySelected  || _vm.attrFeedback.errorText !== '' || _vm.inProgress,"variant":"primary"}},[_vm._v("Procesar Atributos")])],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Alta de atributos variantes"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.attrVarFeedback.errorText),expression:"attrVarFeedback.errorText"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.attrVarFeedback.errorText)}},[_vm._v("\n        "+_vm._s(_vm.attrVarFeedback.errorText)+"\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.attrVarFeedback.success),expression:"attrVarFeedback.success"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n        Los atributos fueron actualizados con éxito\n      ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"float-left mt-3",attrs:{"disabled":!Boolean(_vm.categorySelected.id),"variant":"primary"},on:{"click":_vm.downloadVarSpecificationsCSVExampleFile}},[_vm._v("Obtener formato para alta de atributos")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"mb-2",attrs:{"md":"12"}},[_vm._v("Archivo de Atributos seleccionado: "),_c('strong',[_vm._v(_vm._s(_vm.csvProductVarAttrFile && _vm.csvProductVarAttrFile.name))])]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-file',{ref:"fileProductVarAttrInput",attrs:{"accept":".csv,.txt","disabled":!Boolean(_vm.categorySelected.id),"placeholder":"Atributos CSV"},on:{"change":_vm.onFileAttrVarChanged},nativeOn:{"click":function($event){_vm.$refs.fileProductVarAttrInput.reset()}},model:{value:(_vm.csvProductVarAttrFile),callback:function ($$v) {_vm.csvProductVarAttrFile=$$v},expression:"csvProductVarAttrFile"}})],1),_vm._v(" "),_c('b-col',{staticClass:"mt-3",attrs:{"md":"12"}},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.attrModalVar",modifiers:{"attrModalVar":true}}],staticClass:"float-left",attrs:{"disabled":!Boolean(_vm.csvProductVarAttrFile) || !_vm.categorySelected  || _vm.attrVarFeedback.errorText !== '' || _vm.inProgress,"variant":"primary"}},[_vm._v("Procesar Atributos")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePricesByCSVView_vue__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6a111c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePricesByCSVView_vue__ = __webpack_require__(857);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePricesByCSVView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6a111c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePricesByCSVView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_catalog_ChangePricesCsv__ = __webpack_require__(853);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-prices-view',
  components: {
    ChangePricesCsv: __WEBPACK_IMPORTED_MODULE_0__components_catalog_ChangePricesCsv__["a" /* default */]
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePricesCsv_vue__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45539e33_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePricesCsv_vue__ = __webpack_require__(856);
function injectStyle (ssrContext) {
  __webpack_require__(854)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45539e33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePricesCsv_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45539e33_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePricesCsv_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_papaparse__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_papaparse__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-prices-csv',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  methods: {
    resetCSVPricesFile: function resetCSVPricesFile() {
      this.$refs.filePricestInput.reset();
    },
    itemProvider: function itemProvider(tableComponentInfo) {
      var start = (tableComponentInfo.currentPage - 1) * tableComponentInfo.perPage;
      var end = tableComponentInfo.perPage * tableComponentInfo.currentPage;
      return this.csvElements.slice(start, end);
    },
    showProcessConfirm: function showProcessConfirm() {
      this.$refs.processCSVModal.show();
    },
    processAltaPrecios: function processAltaPrecios() {
      this.uploadPricesFile();
    },
    downloadPriceFile: function downloadPriceFile() {
      var _this = this;

      this.errorText = '';
      this.getPriceList().then(function (csvFile) {
        var headers = csvFile.headers;
        var blob = new Blob([csvFile.body], {
          type: { type: headers.map['content-type'] }
        });
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', 'priceList.csv');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      }, function () {
        _this.errorText = 'Error procesando la descarga';
      });
    },
    uploadPricesFile: function uploadPricesFile() {
      var _this2 = this;

      this.inProgress = true;
      this.success = false;
      this.errorText = '';
      var formData = new FormData();
      formData.append('file', this.csvPricesFile);
      this.uploadCsvPriceList(formData, this.delimiter).then(function () {
        _this2.inProgress = false;
        _this2.success = true;
      }, function (error) {
        _this2.inProgress = false;
        _this2.errorText = error.body.message || 'Error procesando el archivo CSV - ' + _this2.csvPricesFile.name;

        _this2.csvElements.forEach(function (elem, index) {
          elem._rowVariant = 'danger';
        });
        _this2.$refs.productsTable.refresh();
      });
    },
    onFileAttrChanged: function onFileAttrChanged(evt) {
      this.errorText = '';
      this.success = false;
    },
    onFileChanged: function onFileChanged(evt) {
      var _this3 = this;

      var self = this;
      this.errorText = '';
      this.success = false;
      this.csvElements = [];
      self.$refs.productsTable.refresh();
      var file = evt.target.files[0];
      if (!file) {
        return;
      }

      var reader = new FileReader();

      reader.onload = function (evt) {
        try {
          self.tabIndex = 1;
          var rowError = false;
          var parsedData = __WEBPACK_IMPORTED_MODULE_3_papaparse___default.a.parse(evt.target.result.trim(), {
            delimiter: '',
            skipEmptyLines: true,
            encoding: 'ISO-8859-1'
          });

          if (parsedData.errors.length > 0) {
            self.errorText = 'El archivo tiene un formato que no es soportado';
            self.$refs.fileProductInput.reset();
            return;
          }

          self.delimiter = parsedData.meta.delimiter;

          var header = parsedData.data.shift();
          if (header.length !== 6) {
            self.errorText += 'La cabecera del archivo CSV debe tener 6 columnas.';
            self.errorText += '<ul>';
            self.errorText += '<li>Verificar que la cabecera es "Nombre del producto","SKU","UPC","Precio regular",Precio con descuento","Fecha de validez del descuento"</li>';
            self.errorText += '</ul>';
            return;
          }
          if (parsedData.data.length === 0) {
            self.errorText = 'El archivo CSV está vacío. Debe contener al menos un producto.';
            self.$refs.filePricestInput.reset();
            return;
          }

          _this3.productsCount = parsedData.data.length;
          parsedData.data.forEach(function (elem, index) {
            var newRowElem = {
              'productName': elem[0],
              'sku': elem[1],
              'upc': elem[2],
              'listPrice': elem[3],
              'price': elem[4],
              'priceValidUntil': elem[5],
              '_cellVariants': null
            };
            if (elem.length !== 6) {
              rowError = true;
              newRowElem = { '_cellVariants': null };
              newRowElem.productName = 'Faltan ' + (6 - elem.length) + ' campos';
            } else {
              newRowElem._cellVariants = {};
              rowError = _this3.testPrices(elem, newRowElem) || _this3.testDates(elem, newRowElem);
            }
            if (rowError) {
              self.errorText = 'Hay filas con errores en el archivo CSV';
              self.errorText += '<ul>';
              self.errorText += '<li>Verifique que las filas tengan 6 items igual que la cabecera.</li>';
              self.errorText += '<li>Verifique que las fechas tengan formtato YYYY-MM-DD.</li>';
              self.errorText += '<li>Verifique que los precios sean números válidos.</li>';
              self.errorText += '<li>Verifique que el precio con descuento va acompañado por una fecha valida';
              self.errorText += '</ul>';

              if (newRowElem._cellVariants === null) {
                newRowElem._rowVariant = 'danger';
              }
            } else {
              newRowElem._rowVariant = 'success';
            }
            self.csvElements.push(newRowElem);
          });
          _this3.$refs.productsTable.refresh();
        } catch (err) {
          console.log(err);
          _this3.errorText = 'El archivo CSV de precios tiene fallas';
        }
      };
      reader.readAsText(file, 'ISO-8859-1');
    },
    testDates: function testDates(elements, newRowElem) {
      var date = elements[5];
      var price = elements[4];
      var listPrice = elements[3];

      if (isNaN(price) || Number(price) === 0) {
        return false;
      }

      if (Number(listPrice) <= Number(price)) {
        return false;
      }

      var myRegExp = /^\d{4}-\d{2}-\d{2}$/;
      if (!date.match(myRegExp)) {
        newRowElem._cellVariants.priceValidUntil = 'danger';
        return true;
      }

      var d = new Date(date);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(d.getTime())) {
        newRowElem._cellVariants.priceValidUntil = 'danger';
        return true;
      }

      if (new Date(date) <= new Date()) {
        newRowElem._cellVariants.priceValidUntil = 'danger';
        return true;
      }
      return false;
    },
    testPrices: function testPrices(elements, newRowElem) {
      var listPrice = elements[3];
      var price = elements[4];

      if (isNaN(listPrice) || Number(listPrice) === 0) {
        newRowElem._cellVariants.listPrice = 'danger';
        return true;
      }

      if (price) {
        if (isNaN(price) || Number(price) === 0) {
          newRowElem._cellVariants.price = 'danger';
          return true;
        }
      }

      if (Number(listPrice) < Number(price)) {
        newRowElem._cellVariants.price = 'danger';
        newRowElem._cellVariants.listPrice = 'danger';
        return true;
      }

      return false;
    }
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 70, 100, 1000],
      tabIndex: 0,
      success: false,
      inProgress: false,
      productsCount: 0,
      errorText: '',
      debugFileExtencion: '',
      delimiter: null,
      csvPricesFile: null,
      csvElements: [],
      csvFields: [{ key: 'productName', label: 'Nombre' }, { key: 'sku', label: 'SKU' }, { key: 'upc', label: 'UPC' }, { key: 'listPrice', label: 'Precio regular' }, { key: 'price', label: 'Precio con descuento' }, { key: 'priceValidUntil', label: 'Vencimiento descuento' }]
    };
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":_vm.errorText !== '',"fade":"","dismissible":"","variant":"danger"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("¡Error!")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v(_vm._s(_vm.errorText))])]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.success,"variant":"success","dismissible":""}},[_vm._v("La acción fue completada con éxito")]),_vm._v(" "),_c('b-modal',{ref:"processCSVModal",attrs:{"header-bg-variant":"primary","centered":"","id":"processCSVModal","size":"lg","title":"Guardar los cambios de precio","o-close-on-backdrop":"true","cancel-title":"Cancelar"},on:{"ok":_vm.processAltaPrecios}},[_vm._v("\n    ¿Desea guardar los cambios de precios para los productos seleccionados?\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Actualización masiva de precios")]),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":!Boolean(_vm.csvPricesFile) || _vm.errorText !== '',"variant":"primary"},on:{"click":_vm.showProcessConfirm}},[_vm._v("Procesar")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"variant":"primary"},on:{"click":_vm.downloadPriceFile}},[_vm._v("Obtener listado actual de precios CSV")])],1)],1),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.inProgress,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"Seleccione un archivo","active":""}},[_c('h5',[_vm._v("Subir archivo CSV a procesar")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!Boolean(_vm.csvPricesFile)),expression:"!Boolean(csvPricesFile)"}],staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("Se debe seleccionar un CSV para continuar.")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(Boolean(_vm.csvPricesFile)),expression:"Boolean(csvPricesFile)"}]},[_vm._v("Archivo CSV seleccionado: "),_c('strong',[_vm._v(_vm._s(_vm.csvPricesFile && _vm.csvPricesFile.name))])]),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-file',{ref:"filePricestInput",attrs:{"id":"csvPricesFile","no-drop":true,"accept":".csv","placeholder":"Lista Precios CSV"},on:{"change":_vm.onFileChanged},nativeOn:{"click":function($event){_vm.$refs.filePricestInput.reset()}},model:{value:(_vm.csvPricesFile),callback:function ($$v) {_vm.csvPricesFile=$$v},expression:"csvPricesFile"}})],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Previsualización de datos","disabled":!Boolean(_vm.csvPricesFile)}},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.productsCount,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Previsualizacion"}},[_c('h5',[_vm._v("Previsualización de precios a actualizar")]),_vm._v(" "),_c('p',[_vm._v("Cantidad de Productos: "),_c('strong',[_vm._v(_vm._s(_vm.productsCount))])]),_vm._v(" "),_c('b-table',{ref:"productsTable",attrs:{"items":_vm.itemProvider,"current-page":_vm.currentPage,"per-page":_vm.perPage,"hover":"","fields":_vm.csvFields,"small":true,"show-empty":"","striped":"","empty-text":"No hay productos para mostrar","hover":"","stacked":"lg","foot-clone":""},scopedSlots:_vm._u([{key:"sku",fn:function(sku){return [_vm._v("\n              "+_vm._s(sku.value === '' ? '(new)' : sku.value)+"\n            ")]}}])})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('change-prices-csv')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryView_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787316aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryView_vue__ = __webpack_require__(864);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787316aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_inventory_InventoryList__ = __webpack_require__(860);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory-view',
  components: {
    InventoryList: __WEBPACK_IMPORTED_MODULE_0__components_inventory_InventoryList__["a" /* default */]
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryList_vue__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_accbde2a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryList_vue__ = __webpack_require__(863);
function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-accbde2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_accbde2a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker_build_css_bootstrap_datetimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__catalog_CategoryTree__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_InventoryServiceMixim_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_papaparse__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_papaparse__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_bootstrap_datetimepicker___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory-list',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__["a" /* default */], CategoryTree: __WEBPACK_IMPORTED_MODULE_3__catalog_CategoryTree__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixims_InventoryServiceMixim_js__["a" /* InventoryServiceMixim */], __WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_6__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  data: function data() {
    return {
      locale: __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default.a.CURRENCY,
      fields: [{ key: 'id', label: 'Id', 'class': 'text-left', sortable: true }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'category', label: 'Categoría', 'class': 'text-left', sortable: true }, { key: 'brand', label: 'Marca', 'class': 'text-left', sortable: true }, { key: 'action', label: ' ', 'class': 'text-right', sortable: false }],
      fieldsCSV: [{ key: 'sku', label: 'SKU', 'class': 'text-left' }, { key: 'upc', label: 'UPC', 'class': 'text-left' }, { key: 'name', label: 'Nombre', 'class': 'text-left' }, { key: 'indentify', label: 'Número identificador', 'class': 'text-left' }, { key: 'quantity', label: 'Cantidad', 'class': 'text-left' }, { key: 'reservedQuantity', label: 'Reservado', 'class': 'text-left' }, { key: 'security', label: 'Seguridad', 'class': 'text-left' }],
      fieldsVariant: [{ key: 'skuName', label: 'Nombre', 'class': 'text-left' }, { key: 'upc', label: 'UPC', 'class': 'text-left' }, { key: 'id', label: 'SKU', 'class': 'text-left' }, { key: 'listPrice', label: 'Precio regular', 'class': 'text-left' }, { key: 'price', label: 'Precio con descuento', 'class': 'text-left' }, { key: 'inventory', label: 'Inventario', 'class': 'text-left' }, { key: 'status', label: 'Estado', 'class': 'text-left' }],
      estados: __WEBPACK_IMPORTED_MODULE_6__mixims_ProductServiceMixim_js__["a" /* PRODUCT_STATES */],
      edition: {
        sku: '',
        upc: '',
        name: '',
        newQuantity: '',
        stockSecurity: '',
        reservedQuantity: ''
      },
      csvInventoryFile: null,
      csvInventoryElements: [],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      currentPageCSV: 1,
      perPageCSV: 10,
      totalRowsCSV: 0,
      delimiter: null,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      pageOptionsCSV: [10, 15, 25, 50, 100],
      sortBy: 'id',
      sortDesc: true,
      errorText: '',
      successText: '',
      tabIndex: 0,
      filter: {
        sku: { desde: null, hasta: null },
        upc: { desde: null, hasta: null },
        category: { id: null, text: null },
        fromQuantity: null,
        toQuantity: null,
        fecha: {
          desde: null,
          hasta: null
        }
      },
      showFilters: false,
      tableFilterInfo: null,
      manualEditionInProgress: false,
      csvEditionInProgress: false,
      inventoryListLoading: false
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    confirmationInventoryEdition: function confirmationInventoryEdition(evt) {
      var _this = this;

      this.successText = '';
      this.errorText = '';
      evt.preventDefault();
      this.manualEditionInProgress = true;
      this.updateInventory(this.edition.sku, this.edition.newQuantity, this.edition.newReservedQuantity, this.edition.newReservedQuantity).then(function () {
        _this.$refs.manualInventoryEdition.hide();
        _this.manualEditionInProgress = false;
        _this.$refs.mainTable.refresh();
        _this.successText = 'Se actualizo correctamente el inventario para ' + _this.edition.sku;
      }, function (error) {
        _this.$refs.manualInventoryEdition.hide();
        _this.manualEditionInProgress = false;
        _this.errorText = error.body.message || 'Error actualizando el inventario de ' + _this.edition.sku;
      });
    },
    onInventoryFileChanged: function onInventoryFileChanged(evt) {
      var _this2 = this;

      var self = this;
      this.successText = '';
      this.errorText = '';
      this.csvInventoryElements = [];
      this.$refs.inventoryTable.refresh();
      var file = evt.target.files[0];
      if (!file) {
        return;
      }

      var fileName = file.name.toLowerCase();
      var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
      if (fileExtension !== '.csv') {
        self.errorText = 'El archivo seleccionado no es un CSV válido. Por favor, seleccione únicamente archivos con extensión .csv';
        self.$refs.inventoryCSVInput.reset();
        self.csvInventoryFile = null;
        return;
      }

      var reader = new FileReader();

      reader.onload = function (evt) {
        try {
          var rowError = false;
          var parsedData = __WEBPACK_IMPORTED_MODULE_9_papaparse___default.a.parse(evt.target.result.trim(), {
            skipEmptyLines: true,
            encoding: 'ISO-8859-1'
          });

          if (parsedData.errors.length > 0) {
            self.errorText = 'El archivo tiene un formato que no es soportado';
            self.$refs.inventoryCSVInput.reset();
            return;
          }

          self.delimiter = parsedData.meta.delimiter;
          if (parsedData.data.length === 0) {
            self.errorText = 'El archivo CSV no contiene datos';
            _this2.$refs.selectInventoryCSV.hide();
            return;
          }

          var header = parsedData.data.shift();
          if (parsedData.data.length === 0) {
            self.errorText = 'El archivo CSV está vacío. Debe contener al menos un producto además de las cabeceras.';
            self.$refs.inventoryCSVInput.reset();
            self.csvInventoryFile = null;
            return;
          }
          if (header.length !== 7) {
            self.errorText += 'La cabecera del archivo CSV debe tener 7 columnas.';
            self.errorText += '<ul>';
            self.errorText += '<li>Verificar que la cabecera es SKU; UPC; Número identificador; Nombre Producto; Total; Reservado; Seguridad</li>';
            self.errorText += '</ul>';
            return;
          }

          parsedData.data.forEach(function (elem, index) {
            var newRowElem = {
              'sku': elem[0],
              'upc': elem[1],
              'indentify': elem[2],
              'name': elem[3],
              'quantity': elem[4],
              'reservedQuantity': elem[5],
              'security': elem[6],
              '_cellVariants': null
            };
            if (elem.length !== 7) {
              rowError = true;
              newRowElem = { '_cellVariants': null };
              newRowElem.sku = 'Faltan ' + (7 - elem.length) + ' campos';
            } else {
              newRowElem._cellVariants = {};
              rowError = _this2.testQuantity(elem[4], newRowElem);
            }

            if (rowError) {
              self.errorText = 'Hay filas con errores en el archivo CSV';
              self.errorText += '<ul>';
              self.errorText += '<li>Verifique que las filas tengan la cantidad de items del header (7).</li>';
              self.errorText += '<li>Verifique que los valores numericos sean correctos.</li>';
              self.errorText += '</ul>';

              if (newRowElem._cellVariants === null) {
                newRowElem._rowVariant = 'danger';
              }
            } else {
              newRowElem._rowVariant = 'success';
            }
            self.csvInventoryElements.push(newRowElem);
          });
          _this2.totalRowsCSV = _this2.csvInventoryElements.length;
          _this2.tabIndex = 1;
          _this2.$refs.inventoryTable.refresh();
        } catch (err) {
          _this2.errorText = 'El archivo CSV de precios tiene fallas';
        }
      };
      this.$refs.selectInventoryCSV.hide();
      reader.readAsText(file, 'ISO-8859-1');
    },
    testQuantity: function testQuantity(quantity, newRowElem) {
      if (isNaN(quantity)) {
        newRowElem._cellVariants.quantity = 'danger';
        return true;
      }
      return false;
    },
    showDownloadCSVFileModal: function showDownloadCSVFileModal() {
      this.$refs.downloadInventoryCSV.show();
    },
    downloadCSVFile: function downloadCSVFile() {
      var _this3 = this;

      this.getInventoryCSV().then(function (csvFile) {
        var headers = csvFile.headers;
        var blob = new Blob([csvFile.body], {
          type: { type: headers.map['content-type'] }
        });
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', 'inventarioCSV.csv');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      }, function (error) {
        _this3.errorText = error.body.message || 'Error obteniendo el inventario';
      });
    },
    resetCSVList: function resetCSVList() {
      this.csvInventoryElements = [];
      this.totalRowsCSV = this.csvInventoryElements.length;
      this.errorText = '';
      this.successText = '';
      this.$refs.inventoryTable.refresh();
    },
    processCSVFile: function processCSVFile() {
      var _this4 = this;

      this.csvEditionInProgress = true;
      this.success = false;
      this.errorText = '';

      this.addInventoryCSV(this.csvInventoryFile, this.delimiter).then(function () {
        _this4.$refs.mainTable.refresh();
        _this4.csvEditionInProgress = false;
        _this4.successText = 'El archivo ' + _this4.csvInventoryFile.name + ' fue procesado con \xE9xito';
      }, function (error) {
        _this4.csvEditionInProgress = false;
        _this4.errorText = error.body.message || 'Error procesando el archivo CSV - ' + _this4.csvInventoryFile.name;

        _this4.csvInventoryElements.forEach(function (elem, index) {
          elem._rowVariant = 'danger';
        });
        _this4.$refs.inventoryTable.refresh();
      });
    },
    goToImportFilePage: function goToImportFilePage() {
      this.successText = '';
      this.errorText = '';
      this.tabIndex = 1;
      this.$refs.inventoryCSVInput.reset();
      this.$refs.selectInventoryCSV.show();
    },
    cleanFilters: function cleanFilters() {
      this.tabIndex = 0;
      this.filter = {
        cuenta: null,
        seller: null,
        name: null,
        estado: null,
        sku: { desde: null, hasta: null },
        upc: { desde: null, hasta: null },
        fecha: { desde: null, hasta: null },
        category: { id: null, text: null },
        fromQuantity: null,
        toQuantity: null
      };
      this.$refs.mainTable.refresh();
    },
    selectCategory: function selectCategory(res) {
      this.filter.category = res;
    },
    variantClicked: function variantClicked(item) {
      this.edition.sku = item.id;
      this.edition.upc = item.upc;
      this.edition.name = item.skuName;
      this.edition.newQuantity = item.inventory.totalQuantity;
      this.edition.stockSecurity = item.inventory.stockSecurity;
      this.edition.reservedQuantity = item.inventory.reservedQuantity || 0;
      this.edition.newReservedQuantity = item.inventory.stockSecurity || 0;
      this.successText = '';
      this.errorText = '';
      this.$refs.manualInventoryEdition.show();
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterTable: function filterTable() {
      this.tabIndex = 0;
      this.$refs.mainTable.refresh();
    },
    itemProviderCSV: function itemProviderCSV(tableComponentInfoCSV) {
      var start = (tableComponentInfoCSV.currentPage - 1) * tableComponentInfoCSV.perPage;
      var end = tableComponentInfoCSV.perPage * tableComponentInfoCSV.currentPage;
      return this.csvInventoryElements.slice(start, end);
    },
    itemProvider: function itemProvider(tableFilterInfo) {
      var _this5 = this;

      this.tableFilterInfo = tableFilterInfo;
      this.inventoryListLoading = true;
      return this.getProducts(tableFilterInfo, this.filter).then(function (response) {
        _this5.inventoryListLoading = false;
        _this5.totalRows = parseInt(response.headers.get('X-Total-Count'));
        return response.body;
      }, function (error) {
        _this5.inventoryListLoading = false;
        _this5.errorText = error.body.message || 'Error obteniendo el inventario';
        return [];
      });
    }
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"product-list",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.successText),expression:"successText"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.successText)+"\n    ")]),_vm._v(" "),_c('b-row',{staticClass:"filter-row"},[_c('b-col',{attrs:{"md-":"12"}},[_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showFilters = !_vm.showFilters}}},[_c('i',{staticClass:"fa",class:{'fa-times': _vm.showFilters, 'fa-filter': !_vm.showFilters}}),_vm._v(" Filtros\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showDownloadCSVFileModal($event)}}},[_vm._v("\n          Exportar CSV\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.goToImportFilePage($event)}}},[_vm._v("\n          Importar CSV\n        ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"filters mt-3 p-3 mb-3"},[_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"3"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"id":"nombre","label-cols":4,"breakpoint":"md","label":"Buscar","invalid-feedback":!_vm.isValidText(_vm.filter.text, false)? 'No es un valor válido' : '',"state":_vm.isValidText(_vm.filter.text, false),"description":"Este campo de filtro realizará la busqueda en los nombres, id, UPC y SKU del inventario","label-for":"nameFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"state":_vm.isValidText(_vm.filter.text, false),"id":"nameFormatter","placeholder":"Texto a buscar"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"3"}},[_c('b-form-group',{attrs:{"id":"statusInput","label-cols":4,"breakpoint":"md","label":"Estado","label-for":"statusInput"}},[_c('b-form-select',{attrs:{"id":"statusInput","options":_vm.estados},model:{value:(_vm.filter.estado),callback:function ($$v) {_vm.$set(_vm.filter, "estado", $$v)},expression:"filter.estado"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"3"}},[_c('b-form-group',{attrs:{"id":"categoryInput","label-cols":4,"breakpoint":"md","label":"Categoría","label-for":"categoryFormatter"}},[_c('category-tree',{attrs:{"id":"selectCategory","categorySelected":_vm.filter.category},on:{"onCategorySelected":_vm.selectCategory}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-input-group-button',{staticClass:"float-right mt-3"},[_c('b-button',{attrs:{"disabled":_vm.inventoryListLoading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('b-input-group-button',{staticClass:"float-right mt-3 mr-3"},[_c('b-button',{attrs:{"disabled":_vm.inventoryListLoading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Mostrar Todo")])],1)],1)],1)],1)]),_vm._v(" "),_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"Inventario","active":""}},[_c('b-card',{staticClass:"mt-3",attrs:{"id":"mainCard","header-bg-variant":"primary","border-variant":"primary","header":"Listado de inventario actual (Click en la fila para editar manualmente)"}},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"id":"perPage","options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"col-md-auto",attrs:{"align-self":"start"}},[_vm._v("\n              Elementos de inventario encontrados "),_c('b',[_vm._v(_vm._s(_vm.totalRows))])])],1),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.inventoryListLoading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inventoryListLoading),expression:"!inventoryListLoading"}],ref:"mainTable",staticClass:"mt-3",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","stacked":"md","items":_vm.itemProvider,"foot-clone":"","fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":"true","empty-text":"No hay inventario para mostrar","empty-filtered-text":"No hay invetario para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"category",fn:function(row){return [_vm._v("\n              "+_vm._s(row.item.category.name)+"\n            ")]}},{key:"brand",fn:function(row){return [_vm._v("\n              "+_vm._s(row.item.brand.name)+"\n            ")]}},{key:"action",fn:function(row){return [(row.item.skus.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v("\n                "+_vm._s(row.detailsShowing ? 'Ocultar' : 'Ver')+" Variantes ("+_vm._s(row.item.skus.length)+")\n              ")]):_c('span',[_c('b',[_vm._v("No contiene variantes")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inventoryListLoading),expression:"!inventoryListLoading"}],ref:"variantTable",attrs:{"id":"productTable","show-empty":"","hover":"","items":row.item.skus,"fields":_vm.fieldsVariant,"responsive":"true","stacked":"xl","empty-text":"No hay variantes para mostrar","empty-filtered-text":"No hay variantes para mostrar"},on:{"row-clicked":_vm.variantClicked},scopedSlots:_vm._u([{key:"listPrice",fn:function(row){return [_vm._v("\n                    "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.listPrice)+"\n                  ")]}},{key:"inventory",fn:function(row){return [_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"inventoryContainer",attrs:{"title":"La cantidad entre parentesis es stock reservado"}},[_c('span',{staticClass:"inventoryTotal"},[_vm._v(_vm._s(row.item.inventory.totalQuantity))]),_vm._v(" "),_c('span',{staticClass:"inventoryReserved"},[_vm._v("("+_vm._s(row.item.inventory.reservedQuantity ? row.item.inventory.reservedQuantity : 0)+")")])])]}},{key:"price",fn:function(row){return [_vm._v("\n                    "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.price)+"\n                  ")]}},{key:"status",fn:function(data){return [(data.value === 'APPROVED')?_c('b',{staticClass:"text-success"},[_vm._v("\n                      "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                    ")]):_vm._e(),_vm._v(" "),(data.value === 'REJECTED')?_c('b',{staticClass:"text-danger"},[_vm._v("\n                      "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                    ")]):_vm._e(),_vm._v(" "),(data.value === 'PENDING_APPROVAL')?_c('b',{staticClass:"text-warning"},[_vm._v("\n                      "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                    ")]):_vm._e()]}}])})],1)]}}])}),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Alta de inventario por CSV"}},[_c('b-card',{staticClass:"mt-3",attrs:{"id":"csvCard","header-bg-variant":"primary","border-variant":"primary","header":"Listado de inventario que sera importado"}},[_c('p',[_vm._v("Archivo: "),_c('b',[_vm._v(_vm._s(_vm.csvInventoryFile? _vm.csvInventoryFile.name : 'No hay archivo seleccionado'))])]),_vm._v(" "),_c('p',[_vm._v("Cantidad de elementos: "),_c('b',[_vm._v(_vm._s(_vm.totalRowsCSV))])]),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRowsCSV,"per-page":_vm.perPageCSV},model:{value:(_vm.currentPageCSV),callback:function ($$v) {_vm.currentPageCSV=$$v},expression:"currentPageCSV"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptionsCSV},model:{value:(_vm.perPageCSV),callback:function ($$v) {_vm.perPageCSV=$$v},expression:"perPageCSV"}})],1)],1)],1),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.csvEditionInProgress,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.csvEditionInProgress),expression:"!csvEditionInProgress"}],ref:"inventoryTable",attrs:{"id":"","items":_vm.itemProviderCSV,"hover":"","fields":_vm.fieldsCSV,"small":true,"show-empty":"","current-page":_vm.currentPageCSV,"per-page":_vm.perPageCSV,"striped":"","hover":"","stacked":"md","foot-clone":"","empty-text":"No hay filas para mostrar"},scopedSlots:_vm._u([{key:"sku",fn:function(sku){return [_vm._v("\n                "+_vm._s(sku.value === '' ? '(new)' : sku.value)+"\n              ")]}},{key:"image",fn:function(image){return [_vm._v("\n                "+_vm._s(image.value.split('/').pop())+"\n              ")]}}])}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"disabled":!Boolean(_vm.csvInventoryFile) || _vm.errorText !== '',"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.processCSVFile($event)}}},[_vm._v("\n            procesar CSV\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.resetCSVList($event)}}},[_vm._v("\n            Limpiar\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"selectInventoryCSV",attrs:{"header-bg-variant":"primary","size":"lg","id":"selectInventoryCSV","centered":"","title":"Importar CSV"}},[_c('h5',[_vm._v("Seleccione el archivo CSV que desea importar")]),_vm._v(" "),_c('b-form-file',{ref:"inventoryCSVInput",attrs:{"id":"productFileInput","no-drop":true,"accept":".csv","placeholder":"Inventario CSV"},on:{"change":_vm.onInventoryFileChanged},nativeOn:{"click":function($event){_vm.$refs.inventoryCSVInput.reset()}},model:{value:(_vm.csvInventoryFile),callback:function ($$v) {_vm.csvInventoryFile=$$v},expression:"csvInventoryFile"}})],1),_vm._v(" "),_c('b-modal',{ref:"downloadInventoryCSV",attrs:{"header-bg-variant":"primary","size":"lg","id":"downloadInventoryCSV","centered":"","title":"Bajar modelo CSV"},on:{"ok":_vm.downloadCSVFile}},[_c('h5',[_vm._v("Confirma que desea bajar el modelo de inventario?")])]),_vm._v(" "),_c('b-modal',{ref:"manualInventoryEdition",attrs:{"header-bg-variant":"primary","size":"lg","id":"manualInventoryEdition","centered":"","title":"Editar inventario","ok-title":"Guardar","ok-disabled":!_vm.isValidInteger(_vm.edition.newQuantity),"cancel-title":"Cancelar"},on:{"ok":_vm.confirmationInventoryEdition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.manualEditionInProgress),expression:"!manualEditionInProgress"}]},[_c('p',[_vm._v("UPC: "),_c('b',[_vm._v(_vm._s(_vm.edition.upc))])]),_vm._v(" "),_c('p',[_vm._v("SKU: "),_c('b',[_vm._v(_vm._s(_vm.edition.sku))])]),_vm._v(" "),_c('p',[_vm._v("Producto: "),_c('b',[_vm._v(_vm._s(_vm.edition.name))])]),_vm._v(" "),_c('p',[_vm._v("Stock reservado: "),_c('b',[_vm._v(_vm._s(_vm.edition.reservedQuantity))])]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"newInventoryValueLabel","label-cols":4,"breakpoint":"md","label":"Nuevo valor de inventario","invalid-feedback":!_vm.isValidInteger(_vm.edition.newQuantity, true)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.edition.newQuantity, true),"label-for":"newInventoryValue"}},[_c('b-input-group',[_c('b-form-input',{ref:"inventoryInput",attrs:{"maxlength":"8","id":"newInventoryValue"},model:{value:(_vm.edition.newQuantity),callback:function ($$v) {_vm.$set(_vm.edition, "newQuantity", $$v)},expression:"edition.newQuantity"}})],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"newInventoryValueLabel","label-cols":4,"breakpoint":"md","label":"Stock de seguridad","invalid-feedback":!_vm.isValidInteger(_vm.edition.newReservedQuantity, true)? 'Stock de seguridad inválido' : '',"state":_vm.isValidInteger(_vm.edition.newReservedQuantity, true),"label-for":"newInventoryValue"}},[_c('b-input-group',[_c('b-form-input',{ref:"inventoryInput",attrs:{"maxlength":"8","id":"newInventoryValue"},model:{value:(_vm.edition.newReservedQuantity),callback:function ($$v) {_vm.$set(_vm.edition, "newReservedQuantity", $$v)},expression:"edition.newReservedQuantity"}})],1)],1)],1),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.manualEditionInProgress,"color":"#000","size":"30px"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inventory-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsView_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50cc9ede_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsView_vue__ = __webpack_require__(1021);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50cc9ede_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_reports_OrdersReport__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_reports_ProductsReport__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reports_InventoryReport__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reports_SalesReport__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(55);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reports-view',
  components: {
    OrdersReport: __WEBPACK_IMPORTED_MODULE_0__components_reports_OrdersReport__["a" /* default */],
    ProductsReport: __WEBPACK_IMPORTED_MODULE_1__components_reports_ProductsReport__["a" /* default */],
    InventoryReport: __WEBPACK_IMPORTED_MODULE_2__components_reports_InventoryReport__["a" /* default */],
    SalesReport: __WEBPACK_IMPORTED_MODULE_3__components_reports_SalesReport__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__["default"]
  },
  computed: {
    organizations: function organizations() {
      return this.$store.getters.organizations;
    }
  },
  methods: {
    tabChange: function tabChange() {
      this.errorText = '';
    },
    showError: function showError(errorText) {
      this.errorText = errorText;
    },
    clearParentFilters: function clearParentFilters() {
      this.rangeDate = null;
      this.account = null;
    }
  },
  data: function data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      errorText: '',
      lang: {
        formatLocale: {
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],

          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],

          weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],

          weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vier', 'Sab'],

          weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
        }
      },
      tabIndex: 0,
      rangeDate: null,
      account: null
    };
  }
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersReport_vue__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d55318d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersReport_vue__ = __webpack_require__(870);
function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d55318d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d55318d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CsvReportExportMixim_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ValidationsMixim_js__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'orders-report',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_3__CsvReportExportMixim_js__["a" /* CsvReportExportMixim */], __WEBPACK_IMPORTED_MODULE_4__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  props: ['rangeDate', 'account', 'liquidationReport'],
  watch: {
    rangeDate: function rangeDate(val, oldVal) {
      if (!val || !Array.isArray(val) || val.length < 2) {
        this.fromDate = null;
        this.toDate = null;
        return;
      }
      this.fromDate = val[0];
      this.toDate = val[1];
      this.$refs.mainTable.refresh();
    },
    account: function account(val, oldVal) {
      this.$refs.mainTable.refresh();
    }
  },
  data: function data() {
    var _this = this;

    return {
      fields: !this.liquidationReport ? [{ key: 'id', label: 'Número', 'class': 'text-left', sortable: true }, { key: 'accountName', label: 'Seller', 'class': 'text-left', sortable: true }, { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true }, { key: 'creationDate', label: 'Fecha', 'class': 'text-left', sortable: true }, { key: 'value', label: 'Total', 'class': 'text-left', sortable: true }, { key: 'status', label: 'Estado', 'class': 'text-left', sortable: true }, { key: 'tags', label: 'Etiquetas', 'class': 'text-left' }, { key: 'action', label: ' ', 'class': 'text-right', sortable: false }] : [{ key: 'id', label: 'Número', 'class': 'text-left', sortable: true }, { key: 'accountName', label: 'Seller', 'class': 'text-left', sortable: true }, { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true }, { key: 'liquidationDate', label: 'Fecha de liquidacion', 'class': 'text-left', sortable: false }, { key: 'invoiceNumber', label: 'Factura', 'class': 'text-left', sortable: false }, { key: 'liquidationValue', label: 'Monto de liquidacion', 'class': 'text-left', sortable: false }],
      fieldsNotAdmin: !this.liquidationReport ? [{ key: 'id', label: 'Número', 'class': 'text-left', sortable: true }, { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true }, { key: 'creationDate', label: 'Fecha', 'class': 'text-left', sortable: true }, { key: 'value', label: 'Total', 'class': 'text-left', sortable: true }, { key: 'status', label: 'Estado', 'class': 'text-left', sortable: true }, { key: 'tags', label: 'Etiquetas', 'class': 'text-left', sortable: false }, { key: 'action', label: ' ', 'class': 'text-right', sortable: false }] : [{ key: 'id', label: 'Número', 'class': 'text-left', sortable: true }, { key: 'clientProfileData', label: 'Cliente', 'class': 'text-left', sortable: true }, { key: 'liquidationDate', label: 'Fecha de liquidacion', 'class': 'text-left', sortable: false }, { key: 'invoiceNumber', label: 'Factura', 'class': 'text-left', sortable: false }, { key: 'liquidationValue', label: 'Monto de liquidacion', 'class': 'text-left', sortable: false }],
      promotionFields: [{ key: 'description', label: 'Nombre', formatter: function formatter(value) {
          return value === null ? 'Promo Ecommerce' : value;
        } }, { key: 'promotionUserType', label: 'Usuario', formatter: function formatter(value) {
          return value === null ? 'ECOMMERCE' : value;
        } }, { key: 'rawValue', label: 'Descuento', formatter: function formatter(value, key, item) {
          return item.isPorcentual ? value + '%' : _this.currency + ' ' + value;
        } }, { key: 'value', label: 'Total descuento', 'class': 'text-right', formatter: function formatter(value) {
          return _this.currency + ' ' + value;
        } }],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      locale: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.CURRENCY,
      filterTags: [],
      statusName: null,
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      },
      statusMapping: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.STATUS_MAPPING,
      statusMappingColors: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.STATUS_MAPPING_COLORS,
      tagsMapping: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.TAGS_MAPPING,
      showFilters: true,
      tableComponentInfo: null
    };
  },

  computed: {
    disableFilter: function disableFilter() {
      if (this.isEmptyData(this.filter) && this.liquidationReport) {
        return true;
      }

      if (!this.isValidText(this.filter)) {
        return true;
      }
      return false;
    },
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    getStatusColorClass: function getStatusColorClass(status) {
      return 'text-' + this.statusMappingColors[status] + ' h6';
    },
    rowClick: function rowClick(item) {
      this.$router.push('/orders/orderDetail/' + item.id);
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterTable: function filterTable() {
      this.$refs.mainTable.refresh();
    },
    exportCSV: function exportCSV() {
      var _this2 = this;

      this.loading = true;
      this.$emit('error', '');
      return this.getAllOrders(this.tableComponentInfo, true).then(function (csvFile) {
        var filename = _this2.filterTags.indexOf('LQ') !== -1 ? 'liquidatedReportCSV.csv' : 'orderReportCSV.csv';
        _this2.loading = false;
        _this2._exportCSV(csvFile, filename);
      }, function (error) {
        _this2.loading = false;
        var errorText = error.body.message || 'Error obteniendo el reporte de pedidos';
        _this2.$emit('error', errorText);
      });
    },
    itemProvider: function itemProvider(tableComponentInfo) {
      var _this3 = this;

      this.loading = true;

      if (this.liquidationReport) {
        this.filterTags = ['LQ'];
      }
      this.$emit('error', '');
      this.tableComponentInfo = tableComponentInfo;
      console.log(this.filters);
      return this.getAllOrders(tableComponentInfo).then(function (response) {
        var items = response.body;
        _this3.totalRows = parseInt(response.headers.get('X-Total-Count'));
        _this3.loading = false;
        return items;
      }, function (error) {
        _this3.loading = false;
        var errorText = error.body.message || 'Error obteniendo el reporte de pedidos';
        _this3.$emit('error', errorText);
        return [];
      });
    },
    showPromoDetail: function showPromoDetail(arrDetails) {
      var showDetail = false;
      arrDetails.forEach(function (itemDetail) {
        if (itemDetail.priceTags) {
          showDetail = true;
        }
      });
      return showDetail;
    }
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"order-list",attrs:{"fluid":""}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Filtros"}},[_c('b-row',[_c('b-col',{attrs:{"xl":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":"Busqueda","invalid-feedback":!_vm.isValidText(_vm.filter, false)? 'No es un valor válido' : '',"state":_vm.isValidText(_vm.filter, false),"description":"Ingrese el texto a buscar en cliente o número"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Texto a buscar"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"disabled":!_vm.filter},on:{"click":function($event){_vm.filter = ''}}},[_vm._v("Limpiar")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.liquidationReport !== true),expression:"liquidationReport !== true"}],attrs:{"xl":"3"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Estado","description":"Seleccione el estado del pedido"}},[_c('b-form-select',{attrs:{"options":_vm.statusMapping},model:{value:(_vm.statusName),callback:function ($$v) {_vm.statusName=$$v},expression:"statusName"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1)],1),_vm._v(" "),(_vm.liquidationReport !== true)?_c('b-row',[_c('b-col',{attrs:{"xl":"6","text-right":""}},[_c('b-form-group',{attrs:{"label":"Filtrar por TAGS","description":"Selecciones los tags de ordenes que desea filtrar en la busqueda"}},[_c('b-form-checkbox-group',{attrs:{"stacked":""},model:{value:(_vm.filterTags),callback:function ($$v) {_vm.filterTags=$$v},expression:"filterTags"}},[_vm._l((_vm.tagsMapping),function(tagElem){return [(!tagElem.isCt)?_c('b-form-checkbox',{key:tagElem.key,attrs:{"value":tagElem.key}},[_c('span',{staticClass:"tag-check p-1",class:tagElem.bg},[_vm._v(_vm._s(tagElem.text))])]):_vm._e()]})],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"xl":"6"}},[_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading || _vm.disableFilter,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading || _vm.disableFilter,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.exportCSV($event)}}},[_vm._v("Exportar CSV")])],1)],1):_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading || _vm.disableFilter,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.exportCSV($event)}}},[_vm._v("Exportar CSV")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('b',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" "+_vm._s(_vm.liquidationReport? _vm.totalRows > 1? 'liquidaciones encontradas' : 'liquidacion encontrada' : _vm.totalRows > 1? 'Pedidos encontrados' : 'Pedido encontrado')+"\n      ")])],1),_vm._v(" "),_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":_vm.liquidationReport ? 'Liquidaciones' : 'Listado de pedidos'}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","stacked":"xl","items":_vm.itemProvider,"foot-clone":"","fields":_vm.isAdmin ? _vm.fields: _vm.fieldsNotAdmin,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"empty-text":"No hay pedidos para mostrar","empty-filtered-text":"No hay pedidos para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-clicked":_vm.rowClick,"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"clientProfileData",fn:function(data){return [_vm._v("\n          "+_vm._s(data.value ? data.value.firstName : '')+" "+_vm._s(data.value ? data.value.lastName : '')+"\n        ")]}},{key:"liquidationDate",fn:function(row){return [_vm._v("\n          "+_vm._s(new Date(row.item.liquidated.date).toLocaleDateString(_vm.locale))+"\n        ")]}},{key:"invoiceNumber",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.liquidated.invoiceNumber)+"\n        ")]}},{key:"liquidationValue",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(row.item.liquidated.value)+"\n        ")]}},{key:"value",fn:function(value){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(value.value)+"\n        ")]}},{key:"status",fn:function(status){return [_c('span',{class:_vm.getStatusColorClass(status.value)},[_c('b',[_vm._v(_vm._s(_vm.statusMapping[status.value]))])])]}},{key:"creationDate",fn:function(creationDate){return [_vm._v("\n          "+_vm._s(new Date(creationDate.value).toLocaleDateString(_vm.locale))+"\n        ")]}},{key:"tags",fn:function(row){return _vm._l((row.item.tags),function(tagElemKey){return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"tag",class:_vm.tagsMapping[tagElemKey].bg,attrs:{"title":_vm.tagsMapping[tagElemKey].description}},[_vm._v("\n            "+_vm._s(tagElemKey)+"\n          ")])})}},{key:"action",fn:function(row){return [_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPromoDetail(row.item.items)),expression:"showPromoDetail(row.item.items)"}],attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v("\n            "+_vm._s(row.detailsShowing ? 'Ocultar' : 'Ver')+" promociones\n          ")])]}},{key:"row-details",fn:function(row){return [_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',_vm._l((row.item.items),function(item){return _c('div',{key:item.id},[_c('h5',[_vm._v("Producto: "+_vm._s(item.name)+" (sku: "+_vm._s(item.id)+")")]),_vm._v(" "),_c('b-table',{attrs:{"striped":"","items":item.priceTags,"hover":"","outlined":"","head-variant":"light","fields":_vm.promotionFields,"small":true}})],1)}))],1)],1)]}}])})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsReport_vue__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_682bafaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsReport_vue__ = __webpack_require__(874);
function injectStyle (ssrContext) {
  __webpack_require__(872)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-682bafaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductsReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_682bafaa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductsReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_catalog_CategoryTree__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CsvReportExportMixim_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim_js__ = __webpack_require__(10);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'orders-report',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__["a" /* default */], CategoryTree: __WEBPACK_IMPORTED_MODULE_1__components_catalog_CategoryTree__["a" /* default */] },
  props: ['rangeDate', 'account'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_3__CsvReportExportMixim_js__["a" /* CsvReportExportMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  watch: {
    rangeDate: function rangeDate(val, oldVal) {
      if (!val || !Array.isArray(val) || val.length < 2) {
        this.filter.fecha.desde = null;
        this.filter.fecha.hasta = null;
        return;
      }
      this.filter.fecha.desde = val[0];
      this.filter.fecha.hasta = val[1];
      this.$refs.mainTable.refresh();
    },
    account: function account(val, oldVal) {
      this.filter.seller = val;
      this.$refs.mainTable.refresh();
    }
  },
  data: function data() {
    return {
      fieldsVariant: [{ key: 'skuName', label: 'Nombre', 'class': 'text-left' }, { key: 'upc', label: 'UPC', 'class': 'text-left' }, { key: 'id', label: 'SKU', 'class': 'text-left' }, { key: 'refId', label: 'Identificador', 'class': 'text-left' }, { key: 'inventory', label: 'Inventario', 'class': 'text-left' }, { key: 'price', label: 'Precio', class: 'priceCol' }, { key: 'status', label: 'Estado', 'class': 'text-left' }],
      fieldsProduct: [{ key: 'id', label: 'Id', 'class': 'text-left', sortable: true }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'category', label: 'Categoría', 'class': 'text-left', sortable: true }, { key: 'brand', label: 'Marca', 'class': 'text-left', sortable: true }, { key: 'action', label: ' ', 'class': 'text-right', sortable: false }],
      estados: __WEBPACK_IMPORTED_MODULE_0__mixims_ProductServiceMixim_js__["a" /* PRODUCT_STATES */],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      sortBy: null,
      email: '',
      sortDesc: false,
      locale: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.CURRENCY,
      filter: {
        seller: null,
        name: null,
        estado: null,
        fecha: { desde: null, hasta: null },
        category: { id: null, text: null },
        text: null,
        useFilters: true
      },
      showFilters: false,
      tableComponentInfo: null,
      currentPageElement: [],
      loading: false,
      config: {
        format: 'YYYY-MM-DD',
        useCurrent: false
      }
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    },
    disableFilter: function disableFilter() {
      if (!this.isValidText(this.filter.name, false) || !this.isValidText(this.filter.text, false)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    cleanFilters: function cleanFilters() {
      this.filter = {
        seller: null,
        name: null,
        estado: null,
        fecha: { desde: null, hasta: null },
        category: { id: null, text: null },
        text: null,
        useFilters: true
      };
      this.$emit('clear-filters');
      this.$refs.mainTable.refresh();
    },
    selectCategory: function selectCategory(res) {
      this.filter.category = res;
    },
    rowClick: function rowClick(item) {
      this.$router.push('/catalog/details/' + item.id);
    },
    filterTable: function filterTable() {
      this.$refs.mainTable.refresh();
    },
    exportCSV: function exportCSV() {
      var _this = this;

      this.loading = true;
      this.$emit('error', '');
      return this.productsReport(null, this.filter, true).then(function (csvFile) {
        _this.loading = false;
        _this._exportCSV(csvFile, 'productsReportCSV.csv');
      }, function (error) {
        _this.loading = false;
        var errorText = error.body.message || 'Error obteniendo el reporte de pedidos';
        _this.$emit('error', errorText);
      });
    },
    itemProvider: function itemProvider(tableFilterInfo) {
      var _this2 = this;

      this.errorText = '';
      this.tableFilterInfo = tableFilterInfo;
      this.loading = true;
      return this.productsReport(tableFilterInfo, this.filter).then(function (response) {
        _this2.loading = false;
        _this2.totalRows = parseInt(response.headers.get('X-Total-Count'));
        return response.body;
      }, function (error) {
        _this2.loading = false;
        var errorText = error.body.message || 'Error obteniendo el inventario';
        _this2.$emit('error', errorText);
        return [];
      });
    }
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"product-list",attrs:{"fluid":""}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Filtros"}},[_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"upcHastaInput","horizontal":"","label-cols":4,"breakpoint":"md","invalid-feedback":_vm.isValidText(_vm.filter.text)? '':'',"state":!_vm.isValidText(_vm.filter.text),"label":"Filtro de texto","description":"Este campo de filtro realizará la busqueda en los nombres, id, UPC y SKU de los productos","label-for":"upcHastaFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"state":_vm.isValidText(_vm.filter.text),"placeholder":"Ingrese texto a buscar","id":"upcHastaInputFormatter"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"estadoInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Estado","label-for":"estadoFormatter"}},[_c('b-form-select',{attrs:{"id":"categoryFormatter","options":_vm.estados},model:{value:(_vm.filter.estado),callback:function ($$v) {_vm.$set(_vm.filter, "estado", $$v)},expression:"filter.estado"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"categoryInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Categoria","label-for":"categoryFormatter"}},[_c('category-tree',{attrs:{"id":"selectCategory","categorySelected":_vm.filter.category},on:{"onCategorySelected":_vm.selectCategory}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading || _vm.disableFilter,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Mostrar Todos")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading || _vm.disableFilter,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.exportCSV($event)}}},[_vm._v("Exportar CSV")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('b',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" productos encontrados\n      ")])],1),_vm._v(" "),_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Lista de productos"}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","items":_vm.itemProvider,"foot-clone":"","fields":_vm.fieldsProduct,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":"true","stacked":"xl","empty-text":"No hay productos para mostrar","empty-filtered-text":"No hay productos para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-clicked":_vm.rowClick},scopedSlots:_vm._u([{key:"category",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.category.name)+"\n        ")]}},{key:"brand",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.brand.name)+"\n        ")]}},{key:"action",fn:function(row){return [(row.item.skus.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v("\n            "+_vm._s(row.detailsShowing ? 'Ocultar' : 'Ver')+" Variantes ("+_vm._s(row.item.skus.length)+")\n          ")]):_c('span',[_c('b',[_vm._v("No contiene variantes")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"variantTable",attrs:{"id":"productTable","show-empty":"","hover":"","items":row.item.skus,"fields":_vm.fieldsVariant,"responsive":"true","stacked":"xl","empty-text":"No hay variantes para mostrar","empty-filtered-text":"No hay variantes para mostrar"},scopedSlots:_vm._u([{key:"listPrice",fn:function(row){return [_vm._v("\n                "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.listPrice)+"\n              ")]}},{key:"inventory",fn:function(row){return [_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"inventoryContainer",attrs:{"title":"La cantidad entre parentesis es stock reservado"}},[_c('span',{staticClass:"inventoryTotal"},[_vm._v(_vm._s(row.item.inventory.totalQuantity))]),_vm._v(" "),_c('span',{staticClass:"inventoryReserved"},[_vm._v("("+_vm._s(row.item.inventory.reservedQuantity ? row.item.inventory.reservedQuantity : 0)+")")])])]}},{key:"price",fn:function(row){return [_vm._v("\n                "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.listPrice)),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"discount",attrs:{"title":"Precio con descuento"}},[_vm._v("("+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.price)+")")]),_c('br'),_vm._v("\n                "+_vm._s(row.item.price.priceValidUntil)+"\n              ")]}},{key:"status",fn:function(data){return [(data.value === 'APPROVED')?_c('b',{staticClass:"text-success"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e(),_vm._v(" "),(data.value === 'REJECTED')?_c('b',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e(),_vm._v(" "),(data.value === 'PENDING_APPROVAL')?_c('b',{staticClass:"text-warning"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e()]}}])})],1)]}}])})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryReport_vue__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1c9107_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryReport_vue__ = __webpack_require__(879);
function injectStyle (ssrContext) {
  __webpack_require__(876)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f1c9107"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1c9107_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catalog_CategoryTree__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_InventoryServiceMixim_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_Utils__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim_js__ = __webpack_require__(10);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inventory-report',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__["a" /* default */], CategoryTree: __WEBPACK_IMPORTED_MODULE_1__catalog_CategoryTree__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_InventoryServiceMixim_js__["a" /* InventoryServiceMixim */], __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_Utils__["a" /* Utils */]],
  props: ['rangeDate', 'account'],
  watch: {
    rangeDate: function rangeDate(val, oldVal) {
      if (!val || !Array.isArray(val) || val.length < 2) {
        this.filter.fecha.desde = null;
        this.filter.fecha.hasta = null;
        return;
      }
      this.filter.fecha.desde = val[0];
      this.filter.fecha.hasta = val[1];
      this.$refs.productTable.refresh();
    },
    account: function account(val, oldVal) {
      this.filter.seller = val;
      this.$refs.productTable.refresh();
    }
  },
  data: function data() {
    return {
      fieldsVariant: [{ key: 'skuName', label: 'Nombre', 'class': 'text-left' }, { key: 'upc', label: 'UPC', 'class': 'text-left' }, { key: 'id', label: 'SKU', 'class': 'text-left' }, { key: 'price', label: 'Precio', 'class': 'priceCol text-left' }, { key: 'status', label: 'Estado', 'class': 'text-left' }, { key: 'inventory', label: 'Inventario', 'class': 'text-left' }],
      fieldsProduct: [{ key: 'id', label: 'Id', 'class': 'text-left', sortable: true }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'category', label: 'Categoría', 'class': 'text-left', sortable: true }, { key: 'brand', label: 'Marca', 'class': 'text-left', sortable: true }, { key: 'skus', label: 'Estado', 'class': 'text-left', sortable: true, formatter: this.productTableState }, { key: 'action', label: ' ', 'class': 'text-right', sortable: false }],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      sortBy: null,
      locale: __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.CURRENCY,
      sortDesc: false,
      filter: {
        sku: { desde: null, hasta: null },
        upc: { desde: null, hasta: null },
        fecha: { desde: null, hasta: null },
        category: { id: null, text: null },
        fromQuantity: null,
        toQuantity: null,
        account: null
      },
      tableFilterInfo: null,
      loading: false,
      estados: __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__["a" /* PRODUCT_STATES */]
    };
  },

  computed: {
    disableFilter: function disableFilter() {
      if (!this.isValidInteger(this.filter.sku.desde, false) || this.validIntegerCompare(this.filter.sku.hasta, this.filter.sku.desde, false) !== '' || !this.isValidInteger(this.filter.upc.desde, false) || this.validIntegerCompare(this.filter.upc.hasta, this.filter.upc.desde, false) !== '' || !this.isValidInteger(this.filter.fromQuantity, false) || this.validIntegerCompare(this.filter.toQuantity, this.filter.fromQuantity, false) !== '') {
        return true;
      }
      return false;
    },
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    productTableState: function productTableState(value, key, item) {
      var skus = item.skus;
      for (var sku in skus) {
        if (skus[sku].status !== __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim_js__["a" /* PRODUCT_STATES */][0].value) {
          return 'Ver SKUs';
        }
      }

      return 'Activo';
    },
    cleanFilters: function cleanFilters() {
      this.filter = {
        name: null,
        estado: null,
        sku: { desde: null, hasta: null },
        upc: { desde: null, hasta: null },
        fecha: { desde: null, hasta: null },
        category: { id: null, text: null },
        fromQuantity: null,
        toQuantity: null,
        account: null
      };
      this.$emit('clear-filters');
      this.$refs.productTable.refresh();
    },
    selectCategory: function selectCategory(res) {
      this.filter.category = res;
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterTable: function filterTable() {
      this.$refs.productTable.refresh();
    },
    exportCSV: function exportCSV() {
      var _this = this;

      this.loading = true;
      this.$emit('error', '');
      return this.getInventoryCSV(this.filter).then(function (csvFile) {
        _this.loading = false;
        _this._exportCSV(csvFile, 'inventoryReportCSV.csv');
      }, function (error) {
        _this.loading = false;
        var errorText = error.body.message || 'Error obteniendo el reporte de pedidos';
        _this.$emit('error', errorText);
      });
    },
    itemProvider: function itemProvider(tableFilterInfo) {
      var _this2 = this;

      this.tableFilterInfo = tableFilterInfo;
      this.loading = true;
      return this.getProducts(tableFilterInfo, this.filter).then(function (response) {
        _this2.loading = false;
        _this2.totalRows = parseInt(response.headers.get('X-Total-Count'));
        console.log(response.body);
        return response.body;
      }, function (error) {
        _this2.loading = false;
        var errorText = error.body.message || 'Error obteniendo el inventario';
        _this2.$emit('error', errorText);
        return [];
      });
    }
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Utils; });
var Utils = {
  methods: {
    _exportCSV: function _exportCSV(csvFile, filename) {
      var headers = csvFile.headers;
      var blob = new Blob([csvFile.body], {
        type: { type: headers.map['content-type'] }
      });
      var blobURL = window.URL.createObjectURL(blob);
      var tempLink = document.createElement('a');
      tempLink.style.display = 'none';
      tempLink.href = blobURL;
      tempLink.setAttribute('download', filename);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }
  }
};

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"px-0 product-list",attrs:{"fluid":""}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Filtros"}},[_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('label',[_c('strong',[_vm._v("SKU ID")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('label',[_c('strong',[_vm._v("UPC")])])]),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('label',[_c('strong',[_vm._v("Cantidad")])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"skuDesdeInputForm","horizontal":"","label-cols":4,"breakpoint":"md","invalid-feedback":!_vm.isValidInteger(_vm.filter.sku.desde, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filter.sku.desde, false),"label":"Desde","label-for":"skuDesdeFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"skuDesdeInputFormatter"},model:{value:(_vm.filter.sku.desde),callback:function ($$v) {_vm.$set(_vm.filter.sku, "desde", $$v)},expression:"filter.sku.desde"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"upcDesdeInput","horizontal":"","label-cols":4,"breakpoint":"md","invalid-feedback":!_vm.isValidInteger(_vm.filter.upc.desde, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filter.upc.desde, false),"label":"Desde","label-for":"upcDesdeFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"upcDesdeInputFormatter"},model:{value:(_vm.filter.upc.desde),callback:function ($$v) {_vm.$set(_vm.filter.upc, "desde", $$v)},expression:"filter.upc.desde"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"inventoryFromQuantityInput","horizontal":"","label-cols":4,"breakpoint":"md","invalid-feedback":!_vm.isValidInteger(_vm.filter.fromQuantity, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filter.fromQuantity, false),"label":"Desde","label-for":"inventoryFromQuantity"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"inventoryFromQuantity"},model:{value:(_vm.filter.fromQuantity),callback:function ($$v) {_vm.$set(_vm.filter, "fromQuantity", $$v)},expression:"filter.fromQuantity"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"skuHastaInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Hasta","invalid-feedback":_vm.validIntegerCompare(_vm.filter.sku.hasta, _vm.filter.sku.desde, false),"state":_vm.validIntegerCompare(_vm.filter.sku.hasta, _vm.filter.sku.desde, false) === '',"label-for":"skuHastaFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"skuHastaInputFormatter"},model:{value:(_vm.filter.sku.hasta),callback:function ($$v) {_vm.$set(_vm.filter.sku, "hasta", $$v)},expression:"filter.sku.hasta"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"upcHastaInput","horizontal":"","label-cols":4,"breakpoint":"md","invalid-feedback":_vm.validIntegerCompare(_vm.filter.upc.hasta, _vm.filter.upc.desde, false),"state":_vm.validIntegerCompare(_vm.filter.upc.hasta, _vm.filter.upc.desde, false) === '',"label":"Hasta","label-for":"upcHastaFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"upcHastaInputFormatter"},model:{value:(_vm.filter.upc.hasta),callback:function ($$v) {_vm.$set(_vm.filter.upc, "hasta", $$v)},expression:"filter.upc.hasta"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"inventoryToQuantityInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Hasta","invalid-feedback":_vm.validIntegerCompare(_vm.filter.toQuantity, _vm.filter.fromQuantity, false),"state":_vm.validIntegerCompare(_vm.filter.toQuantity, _vm.filter.fromQuantity, false) === '',"label-for":"inventoryToQuantity"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"inventoryToQuantity"},model:{value:(_vm.filter.toQuantity),callback:function ($$v) {_vm.$set(_vm.filter, "toQuantity", $$v)},expression:"filter.toQuantity"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"categoryInput","horizontal":"","label-cols":4,"breakpoint":"md","label":"Categoria","label-for":"categoryFormatter"}},[_c('category-tree',{attrs:{"id":"selectCategory","categorySelected":_vm.filter.category},on:{"onCategorySelected":_vm.selectCategory}})],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading || _vm.disableFilter,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Mostrar Todos")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":_vm.loading || _vm.disableFilter,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.exportCSV($event)}}},[_vm._v("Exportar CSV")])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"mt-3",attrs:{"id":"mainCard","header-bg-variant":"primary","border-variant":"primary","header":"Listado de inventario actual"}},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"col-md-auto",attrs:{"align-self":"start"}},[_vm._v("\n          Elementos de inventario encontrados "),_c('b',[_vm._v(_vm._s(_vm.totalRows))])])],1),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"productTable",staticClass:"mt-3",attrs:{"id":"productTable","show-empty":"","striped":"","hover":"","small":"","stacked":"lg","items":_vm.itemProvider,"foot-clone":"","fields":_vm.fieldsProduct,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":"true","empty-text":"No hay inventario para mostrar","empty-filtered-text":"No hay invetario para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"category",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.category.name)+"\n        ")]}},{key:"brand",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.brand.name)+"\n        ")]}},{key:"action",fn:function(row){return [(row.item.skus.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.stopPropagation();row.toggleDetails($event)}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!row.detailsShowing),expression:"!row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.detailsShowing),expression:"row.detailsShowing"}]},[_c('i',{staticClass:"fa fa-minus"})]),_vm._v("\n            "+_vm._s(row.detailsShowing ? 'Ocultar' : 'Ver')+" Variantes ("+_vm._s(row.item.skus.length)+")\n          ")]):_c('span',[_c('b',[_vm._v("No contiene variantes")])])]}},{key:"row-details",fn:function(row){return [_c('b-card',[_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"variantTable",attrs:{"id":"productTable","show-empty":"","hover":"","items":row.item.skus,"fields":_vm.fieldsVariant,"responsive":"true","stacked":"xl","empty-text":"No hay variantes para mostrar","empty-filtered-text":"No hay variantes para mostrar"},scopedSlots:_vm._u([{key:"inventory",fn:function(row){return [_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"inventoryContainer",attrs:{"title":"La cantidad entre parentesis es stock reservado"}},[_c('span',{staticClass:"inventoryTotal"},[_vm._v(_vm._s(row.item.inventory.totalQuantity))]),_vm._v(" "),_c('span',{staticClass:"inventoryReserved"},[_vm._v("("+_vm._s(row.item.inventory.reservedQuantity ? row.item.inventory.reservedQuantity : 0)+")")])])]}},{key:"price",fn:function(row){return [_vm._v("\n                "+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.listPrice)),_c('br'),_vm._v(" "),_c('span',{staticClass:"discount"},[_vm._v("("+_vm._s(_vm.currency)+" "+_vm._s(row.item.price.price)+")")]),_c('br'),_vm._v("\n                "+_vm._s(row.item.price.priceValidUntil)+"\n              ")]}},{key:"status",fn:function(data){return [(data.value === 'APPROVED')?_c('b',{staticClass:"text-success"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e(),_vm._v(" "),(data.value === 'REJECTED')?_c('b',{staticClass:"text-danger"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e(),_vm._v(" "),(data.value === 'PENDING_APPROVAL')?_c('b',{staticClass:"text-warning"},[_vm._v("\n                  "+_vm._s(_vm.estados.find(function (p) { return p.value === data.value; }).text)+"\n                ")]):_vm._e()]}}])})],1)]}}])}),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesReport_vue__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e47f016_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesReport_vue__ = __webpack_require__(882);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SalesReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e47f016_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SalesReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_OrdersServiceMixim_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CsvReportExportMixim_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sales-report',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixims_OrdersServiceMixim_js__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_2__CsvReportExportMixim_js__["a" /* CsvReportExportMixim */]],
  props: ['rangeDate', 'account'],
  watch: {
    rangeDate: function rangeDate(val, oldVal) {
      if (!val || !Array.isArray(val) || val.length < 2) {
        this.filter.fecha.desde = null;
        this.filter.fecha.hasta = null;
        return;
      }
      this.filter.fecha.desde = val[0];
      this.filter.fecha.hasta = val[1];
      this.getSalesRows();
    },
    account: function account(val, oldVal) {
      this.filter.account = val;
      this.getSalesRows();
    }
  },
  data: function data() {
    return {
      fields: [{ key: 'date', label: 'Fecha', 'class': 'text-left' }, { key: 'ordersQuantity', label: 'Ordenes', 'class': 'text-left' }, { key: 'itemsQuantity', label: 'Items', 'class': 'text-left' }, { key: 'totalCanceled', label: 'Total Canceladas', 'class': 'text-left' }, { key: 'totalSales', label: 'Total Ventas', 'class': 'text-left' }, { key: 'totalShipping', label: 'Total Envíos', 'class': 'text-left' }],
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      salesRows: [],
      filter: {
        fecha: {
          desde: null,
          hasta: null
        },
        account: null
      },
      disableFilterButton: false,
      tableFilterInfo: null,
      loading: false,
      locale: __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_3__config_applicationConfig_js___default.a.CURRENCY
    };
  },

  computed: {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    itemProvider: function itemProvider(tableComponentInfoCSV) {
      var start = (this.currentPage - 1) * this.perPage;
      var end = this.perPage * this.currentPage;
      return this.salesRows.slice(start, end);
    },
    exportCSV: function exportCSV() {
      var _this = this;

      this.loading = true;
      this.$emit('error', '');
      return this.getSalesReport(this.filter, true).then(function (csvFile) {
        _this.loading = false;
        _this._exportCSV(csvFile, 'salesReportCSV.csv');
      }, function (error) {
        _this.loading = false;
        var errorText = error.body.message || 'Error obteniendo el reporte de ventas';
        _this.$emit('error', errorText);
      });
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterTable: function filterTable() {
      this.$refs.mainTable.refresh();
    },
    getSalesRows: function getSalesRows() {
      var _this2 = this;

      this.disableFilterButton = true;
      this.loading = true;
      return this.getSalesReport(this.filter, false).then(function (response) {
        _this2.loading = false;
        _this2.totalRows = response.body.length;
        _this2.disableFilterButton = false;
        _this2.salesRows = response.body;
        _this2.currentPage = 1;
        _this2.$refs.mainTable.refresh();
      }, function (error) {
        _this2.loading = false;
        var errorText = error.body.message || 'Error obteniendo reporte de ventas';
        _this2.$emit('error', errorText);
        _this2.salesRows = [];
      });
    }
  },
  mounted: function mounted() {
    this.getSalesRows();
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-card',{staticClass:"mt-3",attrs:{"id":"mainCard","header-bg-variant":"primary","border-variant":"primary","header":"Listado de inventario actual"}},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-button',{staticClass:"float-right mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.exportCSV($event)}}},[_vm._v("Exportar CSV")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"col-md-auto",attrs:{"align-self":"start"}},[_vm._v("\n          Ventas encontrados "),_c('b',[_vm._v(_vm._s(_vm.totalRows))])])],1),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",staticClass:"mt-3",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","items":_vm.itemProvider,"foot-clone":"","stacked":"xl","fields":_vm.fields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":"true","empty-text":"No hay ventas para mostrar","empty-filtered-text":"No hay ventas para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"date",fn:function(row){return [_vm._v("\n          "+_vm._s(new Date(row.item.date).toLocaleDateString(_vm.locale))+"\n        ")]}},{key:"totalCanceled",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(row.item.totalCanceled)+"\n        ")]}},{key:"totalSales",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(row.item.totalSales)+"\n        ")]}},{key:"totalShipping",fn:function(row){return [_vm._v("\n          "+_vm._s(_vm.currency)+" "+_vm._s(row.item.totalShipping)+"\n        ")]}}])}),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{staticClass:"my-1",attrs:{"md":"6"}},[_c('b-pagination',{staticClass:"my-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"id":"dateFilterFromGroup","label":"Rango de fechas","description":"Se filtrara los reportes por el rango de fechas seleccionado","label-for":"filterRangeDate"}},[_c('date-picker',{ref:"filterBeginDate",attrs:{"id":"filterRangeDate","name":"filterRangeDate","format":"YYYY-MM-DD","valueType":"YYYY-MM-DD","confirm":true,"lang":_vm.lang,"confirm-text":"Seleccione rango","clearable":true,"range":""},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.rangeDate),callback:function ($$v) {_vm.rangeDate=$$v},expression:"rangeDate"}})],1)],1)],1),_vm._v(" "),_c('b-row',[(_vm.isAdmin)?_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Seller"}},[_c('b-form-select',{attrs:{"options":_vm.organizations},model:{value:(_vm.account),callback:function ($$v) {_vm.account=$$v},expression:"account"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-tabs',{staticClass:"mt-3",attrs:{"b-model":"tabIndex"}},[_c('b-tab',{attrs:{"title":"Ventas","active":""}},[_c('sales-report',{attrs:{"account":_vm.account,"rangeDate":_vm.rangeDate},on:{"error":_vm.showError}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Estado de pedidos"}},[_c('orders-report',{attrs:{"account":_vm.account,"rangeDate":_vm.rangeDate},on:{"error":_vm.showError}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Inventario de productos"}},[_c('inventory-report',{attrs:{"account":_vm.account,"rangeDate":_vm.rangeDate},on:{"error":_vm.showError,"clear-filters":_vm.clearParentFilters}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Catálogo de productos"}},[_c('products-report',{attrs:{"account":_vm.account,"rangeDate":_vm.rangeDate},on:{"error":_vm.showError,"clear-filters":_vm.clearParentFilters}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentsView_vue__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfb6e11_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentsView_vue__ = __webpack_require__(1032);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidentsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfb6e11_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncidentsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_IncidentsServices__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_incidents_IncidentsTable__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_incidents_incidentsModal__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_index_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__ = __webpack_require__(55);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'incidents-view',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_AdminServiceMixin__["a" /* AdminServiceMixin */], __WEBPACK_IMPORTED_MODULE_2__mixims_IncidentsServices__["a" /* IncidentsServices */], __WEBPACK_IMPORTED_MODULE_1__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  components: {
    incidentsTable: __WEBPACK_IMPORTED_MODULE_3__components_incidents_IncidentsTable__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_6_vue2_datepicker__["default"],
    incidentsModal: __WEBPACK_IMPORTED_MODULE_4__components_incidents_incidentsModal__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      incidentToEdit: null,
      showModal: false,
      isAdmin: this.$store.getters.isAdmin,
      errorText: '',
      successText: '',
      references: [{ value: null, text: 'Todas' }, { value: 'PRODUCT', text: 'Producto' }, { value: 'SKU', text: 'sku' }, { value: 'ORDER', text: 'Pedido' }],
      priorities: [{ value: null, text: 'Todas' }, { value: 'HIGH', text: 'Alta' }, { value: 'HALF', text: 'Media' }, { value: 'LOW', text: 'Baja' }],
      status: [{ value: null, text: 'Todos' }, { value: 'OPEN', text: 'Abierta' }, { value: 'CLOSE', text: 'Cerrada' }],
      lang: {
        formatLocale: {
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],

          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],

          weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],

          weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vier', 'Sab'],

          weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
        }
      },
      tabIndex: 0,
      rangeDate: null,
      filters: {
        fromDate: null,
        toDate: null,
        incidenceType: null,
        accountName: null,
        priority: null,
        status: null
      },
      filterHasBeenUsed: false,
      incidentToSolve: null
    };
  },


  watch: {
    rangeDate: function rangeDate(newValue) {
      this.filters.fromDate = newValue && newValue[0] ? newValue[0] : null;
      this.filters.toDate = newValue && newValue[1] ? newValue[1] : null;
    }
  },
  computed: {
    organizations: function organizations() {
      return this.$store.getters.organizations;
    }
  },
  methods: {
    filterShowAll: function filterShowAll() {
      this.filters.fromDate = null;
      this.filters.toDate = null;
      this.filters.incidenceType = null;
      this.filters.accountName = null;
      this.filters.priority = null;
      this.filters.status = null;
      this.filters.text = null;
      this.rangeDate = null;

      this.filterHasBeenUsed = false;
      this.$refs.indicentsTable.refresh();

      if (this.$route.query.ref) this.$router.push(this.$route.path);
    },
    filterApply: function filterApply() {
      this.$refs.indicentsTable.refresh();
      this.filterHasBeenUsed = true;
    },
    filterTable: function filterTable() {
      this.$refs.indicentsTable.refresh();
      this.filterHasBeenUsed = true;
    },
    selectIncident: function selectIncident(item) {
      this.incidentToEdit = item;
      this.openModal(false);
    },
    tabChange: function tabChange() {
      this.errorText = '';
    },
    showError: function showError(errorText) {
      this.errorText = errorText;
    },
    openModal: function openModal(resetIncident) {
      this.successText = '';
      if (resetIncident) {
        this.incidentToEdit = null;
        this.$refs.incidentModal.resetModal();
      }
      this.showModal = true;
    },
    newIncidentSaved: function newIncidentSaved(incident) {
      var displayName = incident.title || incident.id;
      this.successText = 'La incidencia ' + displayName + ' se ha registrado correctamente';
      this.showModal = false;
      this.$refs.indicentsTable.refresh();
    },
    newIncidentUpdated: function newIncidentUpdated(incident) {
      var displayName = incident.title || incident.id;
      this.successText = 'La incidencia ' + displayName + ' se ha actualizado correctamente';
      this.showModal = false;
      this.$refs.indicentsTable.refresh();
    },
    markAsSolved: function markAsSolved(incident) {
      this.incidentToSolve = incident;
      this.$refs.confirmationCloseIncidentModal.show();
    },
    solveIncident: function solveIncident(incident) {
      var _this = this;

      incident.status = 'CLOSE';
      this.updateIncident(incident.id, incident).then(function (response) {
        _this.$refs.indicentsTable.refresh();
      });
    }
  },
  mounted: function mounted() {
    if (this.$route.query.sku || this.$route.query.order || this.$route.query.product) {
      var reference = '';
      var incidentType = '';
      if (this.$route.query.sku) {
        reference = this.$route.query.sku;
        incidentType = 'SKU';
      }
      if (this.$route.query.order) {
        reference = this.$route.query.order;
        incidentType = 'ORDER';
      }
      if (this.$route.query.product) {
        reference = this.$route.query.product;
        incidentType = 'PRODUCT';
      }
      var incident = {
        creationDate: '',
        id: '',
        incidenceType: '',
        priority: '',
        reference: '',
        title: '',
        status: '',
        updateDate: '',
        populate: true
      };

      incident.incidenceType = incidentType;
      incident.reference = reference;
      this.incidentToEdit = incident;
      this.openModal();
    }
  },
  created: function created() {
    if (this.$route.query.ref) {
      this.filters.text = this.$route.query.ref;
      this.filterHasBeenUsed = true;
    }
  }
});

/***/ }),
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_incidentsModal_vue__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f03579_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_incidentsModal_vue__ = __webpack_require__(1031);
function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_incidentsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12f03579_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_incidentsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_OrdersServiceMixim__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_IncidentsServices__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_vue_autocomplete__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js__);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'incidents-modal',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_OrdersServiceMixim__["a" /* OrdersServiceMixim */], __WEBPACK_IMPORTED_MODULE_6__mixims_IncidentsServices__["a" /* IncidentsServices */]],
  props: ['show', 'incident', 'references', 'priorities'],
  components: {
    autocomplete: __WEBPACK_IMPORTED_MODULE_8__components_common_vue_autocomplete__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default.a
  },
  data: function data() {
    return {
      locale: __WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js___default.a.LOCALE,
      titlelimit: 30,
      errorText: '',
      filter: '',
      seller: '',
      incidentDetail: {
        creationDate: '',
        id: '',
        incidenceType: '',
        priority: '',
        reference: '',
        title: '',
        status: '',
        updateDate: '',
        payload: ''
      },
      orderIncidenceTypes: ['Devolución (DV)', 'Cambio físico (CF)', 'Venta (VT)', 'Recolección (RC)', 'Reenvío (RV)', 'Otra'],
      comment: {
        author: '',
        date: '',
        text: ''
      },
      referenceAux: null,
      referenceSkuAux: null,
      orderDetailAux: {},
      componentKey: 0,
      skuOrderList: [],
      orderDetailSkus: false
    };
  },

  watch: {
    filter: function filter() {
      if (this.filter !== undefined && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(this.filter) === 'object' && this.filter.length) {
        this.seller = this.filter[0].accountName;
      } else if (!this.filter.length) {
        this.seller = null;
      }
    },
    show: function show() {
      this.skuOrderList = [];
      this.orderDetailAux = { destination: null };
      if (this.incident && this.incident.id || this.incident && this.incident.populate) {
        this.incidentDetail = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.incident);
        if (this.incidentDetail.incidenceType === 'ORDER' && this.incidentDetail.payload) {
          var payload = JSON.parse(this.incidentDetail.payload);
          this.orderDetailAux = payload;
        }
      }
      if (this.incident && this.incident.populate && this.incident.incidenceType === 'ORDER' || this.incident && this.incident.id && this.incident.incidenceType === 'ORDER') {
        this._getOrderDetails(this.incident.reference);
      }
      this.show ? this.$refs.incidentsModal.show() : this.$refs.incidentsModal.hide();
    },
    referenceAux: function referenceAux() {
      if (this.referenceAux === null) return;
      if (this.referenceSkuAux && !this.hasSkuOptions) return;
      this.updateReference(this.referenceAux);
    },
    referenceSkuAux: function referenceSkuAux() {
      this.updateReferenceSku(this.referenceSkuAux);
    },

    orderDetailAux: {
      handler: function handler() {
        this.updateOrderDetail(this.orderDetailAux);
      },

      deep: true
    },
    orderIncidenceType: function orderIncidenceType() {
      this.updateOrderDetail(this.orderDetailAux);
    },
    guideStatus: function guideStatus() {
      this.updateOrderDetail(this.orderDetailAux);
    },

    incidentDetail: {
      handler: function handler() {
        if ((this.incidentDetail.incidenceType === 'SKU' || this.incidentDetail.incidenceType === 'PRODUCT') && this.incidentDetail.payload) {
          var payload = JSON.parse(this.incidentDetail.payload);
          if (payload.orderIncidenceType !== 'Otra') {
            this.incidentDetail.title = '';
          }
          this.incidentDetail.payload = null;
        }
        this.invalidFeedBackTitle();
        this.getReferenceState();
        this.getTitleState();
      },

      deep: true
    }
  },
  computed: {
    typeOfReference: function typeOfReference() {
      if (this.incident) {
        var reference = this.incident.incidenceType;
        return this.references.filter(function (referenceItem) {
          return referenceItem.value === reference;
        })[0].text;
      }

      return '';
    },
    typeOfPriority: function typeOfPriority() {
      if (this.incident && this.incident.priority) {
        var priority = this.incident.priority;
        return this.priorities.filter(function (priorityItem) {
          return priorityItem.value === priority;
        })[0].text;
      }

      return '';
    },
    userText: function userText() {
      return this.$store.state.user_data.firstName + ' ' + this.$store.state.user_data.lastName;
    },
    state: function state() {
      return {
        reference: this.getReferenceState(),
        priority: !this.isEmptyData(this.incidentDetail.priority),
        title: this.getTitleState(),
        description: this.incidentDetail.id ? true : this.isValidTextArea(this.comment.text, true, 1000),
        orderIncidenceType: this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' ? !this.isEmptyData(this.orderDetailAux.orderIncidenceType) : true,
        numGuia: this.validateOrderDetailGuide(this.orderDetailAux.guideNumber),
        tipoEnvio: this.validateOrderTipoEnvio(this.orderDetailAux.shippingType),
        tipoPaquetera: this.validateOrderTipoPaquetera(this.orderDetailAux.packagerType),

        estadoPedido: true,
        urlPdfGuia: this.validateOrderPdfGuia(this.orderDetailAux.urlPdfGuide),
        urlZplGuia: this.validateOrderZplGuia(this.orderDetailAux.urlZplGuide),
        orderSkus: this.validateOrderDetailSkus(this.orderDetailAux.skus),
        origin: this.validateOrderDetail(this.orderDetailAux.source),
        destination: this.validateOrderDetail(this.orderDetailAux.destination),
        store: true,
        proccessType: true
      };
    },
    referenceIsSelected: function referenceIsSelected() {
      return this.incidentDetail.incidenceType !== '';
    },
    hasSkuOptions: function hasSkuOptions() {
      return this.incidentDetail.incidenceType === 'SKU' && this.skuListOptions.length > 0;
    },
    skuListOptions: function skuListOptions() {
      if (this.referenceAux !== null) {
        return this.referenceAux.skus.map(function (sku) {
          return { text: sku.skuName, value: sku.id };
        });
      }

      return [];
    },
    orderIncidenceType: function orderIncidenceType() {
      if (this.orderDetailAux && this.orderDetailAux.orderIncidenceType) {
        return this.orderDetailAux.orderIncidenceType;
      }
    },
    guideStatus: function guideStatus() {
      if (this.orderDetailAux && this.orderDetailAux.guideStatus) {
        return this.orderDetailAux.guideStatus;
      }
    }
  },
  methods: {
    invalidFeedBackTitle: function invalidFeedBackTitle() {
      return !this.state.title ? this.incidentDetail.title !== undefined && this.incidentDetail.title !== null && this.incidentDetail.title.length > this.titlelimit ? 'El máximo número de caracteres es: ' + this.titlelimit : 'Ingrese un título' : '';
    },
    disableSave: function disableSave() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.state).includes(false);
    },
    resetModal: function resetModal() {
      this.errorText = '';
      this.referenceAux = null;
      this.referenceSkuAux = null;
      this.orderDetailAux = { destination: null };
      this.skuOrderList = [];

      if (this.incidentDetail.populate) this.$router.push(this.$route.path);
      this.incidentDetail = {};
      this.comment = {};
    },
    cancel: function cancel() {
      this.resetModal();
      this.$emit('update:show', false);
    },
    modalOk: function modalOk() {
      var _this = this;

      var thisDate = new Date();

      this.comment.date = thisDate;
      this.incidentDetail.updateDate = thisDate;

      var incidentFinal = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.incidentDetail, {
        comments: [this.comment],
        creationDate: thisDate,
        status: 'OPEN'
      });

      this.createIncident(incidentFinal).then(function (response) {
        _this.$emit('saved', response.data);
      }).catch(function (error) {
        _this.errorText = error.body.message || 'Ocurrió un error al crear la incidencia';
      });
    },
    updateIncidentDetail: function updateIncidentDetail() {
      var _this2 = this;

      this.updateIncident(this.incidentDetail.id, this.incidentDetail).then(function (response) {
        _this2.$emit('updated', response.data);
        _this2.cancel();
      }).catch(function (error) {
        _this2.errorText = error.body.message || 'Ocurrió un error al actualizar la incidencia';
      });
    },
    markAsSolved: function markAsSolved() {
      this.$emit('markAsSolved', this.incident);
    },
    updateReference: function updateReference(referenceAux) {
      if (this.incidentDetail.incidenceType === 'ORDER' || this.incidentDetail.incidenceType === 'PRODUCT') this.incidentDetail.reference = referenceAux.id;

      if (this.orderDetailAux && this.incidentDetail.incidenceType === 'ORDER' && !this.incident && this.referenceAux && this.referenceAux.id) {
        this.orderDetailAux.skus = [];
        this._getOrderDetails(this.referenceAux.id);
      }
    },
    updateOrderDetail: function updateOrderDetail(orderDetail) {
      if (!orderDetail) return;

      this.incidentDetail.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(orderDetail);

      if (this.incidentDetail.incidenceType === 'ORDER') {
        if (orderDetail.orderIncidenceType === 'Otra') {
          this.incidentDetail.title = '';
        } else {
          this.incidentDetail.title = orderDetail.orderIncidenceType || '';
        }
      }

      this.validateOrderDetailSkus();
    },
    getReferenceState: function getReferenceState() {
      if (this.incidentDetail.populate) return !this.isEmptyData(this.incidentDetail.reference);
      if (!this.incidentDetail.id && (this.incidentDetail.incidenceType === 'ORDER' || this.incidentDetail.incidenceType === 'PRODUCT')) return !this.isEmptyData(this.referenceAux);
      if (this.incident && this.incident.id) return !this.isEmptyData(this.incident.reference);
      return !this.isEmptyData(this.referenceSkuAux);
    },
    getTitleState: function getTitleState() {
      var requiresTitle = this.incidentDetail.incidenceType === 'PRODUCT' || this.incidentDetail.incidenceType === 'SKU' || this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType === 'Otra';

      return requiresTitle ? this.isValidText(this.incidentDetail.title, true, this.titlelimit) : true;
    },
    validateOrderDetail: function validateOrderDetail(field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? !this.isEmptyData(field) : true;
    },
    validateOrderDetailGuide: function validateOrderDetailGuide(field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 100) : true;
    },
    validateOrderTipoEnvio: function validateOrderTipoEnvio(field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, true, 10) : true;
    },
    validateOrderTipoPaquetera: function validateOrderTipoPaquetera(field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 100) : true;
    },
    validateOrderPdfGuia: function validateOrderPdfGuia(field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 500) : true;
    },
    validateOrderZplGuia: function validateOrderZplGuia(field) {
      return this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' && this.orderDetailAux && this.orderDetailAux.orderIncidenceType !== 'Otra' ? this.isValidText(field, false, 500) : true;
    },
    validateOrderDetailSkus: function validateOrderDetailSkus() {
      if (this.orderDetailAux && this.orderDetailAux.skus && this.orderDetailAux.skus.length > 0) {
        this.orderDetailSkus = true;
      } else {
        this.orderDetailSkus = false;
      }
      return this.orderDetailAux && this.orderDetailAux.skus && this.incidentDetail && this.incidentDetail.incidenceType === 'ORDER' ? this.orderDetailSkus : true;
    },
    handleChange: function handleChange() {
      this.referenceSkuAux = null;
      this.referenceAux = null;
      this.incidentDetail.reference = null;
      this.orderDetailAux = { destination: null };
    },
    _getOrderDetails: function _getOrderDetails(orderId) {
      var _this3 = this;

      this.getOrderDetails(orderId).then(function (response) {
        var orderDetail = response.body;
        _this3.skuOrderList = [];
        orderDetail.items.map(function (item) {
          return _this3.skuOrderList.push(item.id);
        });
      });
    }
  }
});

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"incidentsModal",attrs:{"id":"incidentsModal","size":"lg","header-bg-variant":"primary","centered":"","hide-footer":false,"title":_vm.incident && _vm.incident.id ? 'Detalle de incidencia' : 'Crear incidencia',"cancel-title":"Cerrar","ok-title":"Seleccionar"},on:{"hide":_vm.cancel,"cancel":_vm.cancel,"ok":_vm.modalOk}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.errorText = ''}}},[_vm._v("\n  "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),(_vm.incident && _vm.incident.id)?_c('b-form',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label":"Número"}},[_c('b-form-input',{attrs:{"disabled":true},model:{value:(_vm.incidentDetail.id),callback:function ($$v) {_vm.$set(_vm.incidentDetail, "id", $$v)},expression:"incidentDetail.id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label":"Seller","state":_vm.state.seller}},[_c('b-form-input',{attrs:{"disabled":true},model:{value:(_vm.incidentDetail.accountName),callback:function ($$v) {_vm.$set(_vm.incidentDetail, "accountName", $$v)},expression:"incidentDetail.accountName"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":!_vm.referenceIsSelected ? 12 : 6}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":!_vm.referenceIsSelected ? 2 : 4,"label":"Referencia"}},[_c('b-form-input',{attrs:{"value":_vm.typeOfReference,"disabled":true}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6"}},[_c('b-form-input',{attrs:{"disabled":true},model:{value:(_vm.incident.reference),callback:function ($$v) {_vm.$set(_vm.incident, "reference", $$v)},expression:"incident.reference"}})],1),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de incidencia","invalid-feedback":!_vm.state.orderIncidenceType? 'Selecione un tipo de incidencia': '',"state":_vm.state.orderIncidenceType}},[_c('b-form-select',{attrs:{"options":_vm.orderIncidenceTypes,"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.orderIncidenceType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "orderIncidenceType", $$v)},expression:"orderDetailAux.orderIncidenceType"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.incidentDetail.incidenceType === 'PRODUCT' || _vm.incidentDetail.incidenceType === 'SKU' || (_vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType === 'Otra')),expression:"incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU' || (orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType === 'Otra')"}],attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Título","invalid-feedback":_vm.invalidFeedBackTitle(),"state":_vm.state.title}},[_c('b-form-input',{attrs:{"disabled":_vm.incidentDetail.status === 'CLOSE' || _vm.incidentDetail.incidenceType === 'PRODUCT' || _vm.incidentDetail.incidenceType === 'SKU'},model:{value:(_vm.incidentDetail.title),callback:function ($$v) {_vm.$set(_vm.incidentDetail, "title", $$v)},expression:"incidentDetail.title"}})],1)],1),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Número de guía","invalid-feedback":!_vm.state.numGuia? 'Número de guía inválido': '',"state":_vm.state.numGuia}},[_c('b-form-input',{attrs:{"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.guideNumber),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "guideNumber", $$v)},expression:"orderDetailAux.guideNumber"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de envío","invalid-feedback":!_vm.state.tipoEnvio? 'Tipo de envío inválido': '',"state":_vm.state.tipoEnvio}},[_c('b-form-input',{attrs:{"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.shippingType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "shippingType", $$v)},expression:"orderDetailAux.shippingType"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de paquetera","invalid-feedback":!_vm.state.tipoPaquetera? 'Ingrese el tipo de paquetera': '',"state":_vm.state.tipoPaquetera}},[_c('b-form-input',{attrs:{"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.packagerType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "packagerType", $$v)},expression:"orderDetailAux.packagerType"}})],1)],1):_vm._e(),_vm._v(" "),( false)?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Estado de la guía","invalid-feedback":!_vm.state.estadoGuia? 'Ingrese el estado de la guía': '',"state":_vm.state.estadoGuia}},[_c('b-form-select',{attrs:{"options":['Nueva', 'Entregada (bloqueada)'],"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.guideStatus),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "guideStatus", $$v)},expression:"orderDetailAux.guideStatus"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Estado del pedido","invalid-feedback":!_vm.state.estadoPedido? 'Ingrese el estado del pedido': '',"state":_vm.state.estadoPedido}},[_c('b-form-select',{attrs:{"options":['', 'Enviado', 'Recibido'],"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.orderStatus),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "orderStatus", $$v)},expression:"orderDetailAux.orderStatus"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"URL del PDF de la guía","invalid-feedback":!_vm.state.urlPdfGuia? 'Ingrese la URL del PDF de la guía': '',"state":_vm.state.urlPdfGuia}},[_c('b-form-input',{attrs:{"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.urlPdfGuide),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "urlPdfGuide", $$v)},expression:"orderDetailAux.urlPdfGuide"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"URL del ZPL de la guía","invalid-feedback":!_vm.state.urlZplGuia? 'Ingrese la URL del ZPL de la guía': '',"state":_vm.state.urlZplGuia}},[_c('b-form-input',{attrs:{"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.urlZplGuide),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "urlZplGuide", $$v)},expression:"orderDetailAux.urlZplGuide"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.skuOrderList && _vm.skuOrderList.length > 0 && _vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Sku(s)","invalid-feedback":!_vm.state.orderSkus? 'Seleccione Sku(s)': '',"state":_vm.state.orderSkus}},[_c('multiselect',{ref:"autocompleteSku",staticClass:"sku_autocomplete",attrs:{"options":_vm.skuOrderList,"multiple":true,"searchable":false,"internal-search":false,"clear-on-select":true,"close-on-select":true,"options-limit":300,"limit":100,"placeholder":_vm.$t('Ingrese el texto para buscar'),"disabled":_vm.incidentDetail.status === 'CLOSE',"max-height":600,"selectLabel":_vm.$t('Enter para agregar Sku'),"show-no-results":true,"showPointer":true,"hideSelected":true},on:{"input":function($event){_vm.updateOrderDetail(_vm.orderDetailAux)}},model:{value:(_vm.orderDetailAux.skus),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "skus", $$v)},expression:"orderDetailAux.skus"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("No hay elementos para mostrar")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Origen","invalid-feedback":!_vm.state.origin? 'Seleccione el origen': '',"state":_vm.state.origin}},[_c('b-form-select',{attrs:{"options":[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}],"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.source),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "source", $$v)},expression:"orderDetailAux.source"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Destino","invalid-feedback":!_vm.state.destination? 'Seleccione el destino': '',"state":_vm.state.destination}},[_c('b-form-select',{attrs:{"options":[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}],"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.destination),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "destination", $$v)},expression:"orderDetailAux.destination"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tienda","invalid-feedback":!_vm.state.store? 'Ingrese la tienda': '',"state":_vm.state.store}},[_c('b-form-select',{attrs:{"options":[{text: '', value: ''}, {text: '4263 (tienda ecommerce)', value: '4263'}],"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.store),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "store", $$v)},expression:"orderDetailAux.store"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de proceso","invalid-feedback":!_vm.state.estadoPedido? 'Ingrese el tipo de proceso': '',"state":_vm.state.proccessType}},[_c('b-form-select',{attrs:{"options":[{text: '', value: ''}, {text: 'Devolución', value: 'Devolucion'}, {text: 'Reverse', value: 'Reverse'}, {text: 'Cancelación', value: 'Cancelacion'}, {text: 'Compra', value: 'Compra'}],"disabled":_vm.incidentDetail.status === 'CLOSE'},model:{value:(_vm.orderDetailAux.processType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "processType", $$v)},expression:"orderDetailAux.processType"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Prioridad","invalid-feedback":!_vm.state.priority? 'Selecione una prioridad': '',"state":_vm.state.priority}},[_c('b-form-select',{attrs:{"options":_vm.priorities,"disabled":true || _vm.incidentDetail.status === 'CLOSE' || (_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType === 'Otra') || _vm.incidentDetail.incidenceType === 'PRODUCT' || _vm.incidentDetail.incidenceType === 'SKU'},model:{value:(_vm.incidentDetail.priority),callback:function ($$v) {_vm.$set(_vm.incidentDetail, "priority", $$v)},expression:"incidentDetail.priority"}})],1)],1),_vm._v(" "),_c('hr',{staticClass:"w-100"}),_vm._v(" "),(_vm.incident.comments)?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('h6',{staticClass:"mt-2 mb-3"},[_vm._v("Historial")]),_vm._v(" "),_c('article',{staticClass:"historial-comments"},_vm._l((_vm.incident.comments),function(comments,index){return _c('div',{key:index,staticClass:"comment mb-2"},[_c('p',{staticClass:"my-0"},[_c('strong',[_vm._v(_vm._s(comments.author))])]),_vm._v(" "),_c('div',{staticClass:"message-blue"},[_c('p',{staticClass:"message-content"},[_vm._v(_vm._s(comments.text))]),_vm._v(" "),_c('div',{staticClass:"message-timestamp-left"},[_c('i',{staticClass:"far fa-calendar-check calendar-history-incidents text-primary"}),_vm._v(_vm._s(new Date(comments.date).toLocaleDateString(_vm.locale)))])])])}))]):_vm._e()],1)],1):_c('b-form',[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label":"Número"}},[_c('b-form-input',{attrs:{"disabled":true}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label":"Seller"}},[_c('b-form-input',{attrs:{"disabled":true,"value":_vm.referenceAux && _vm.referenceAux.accountName ? _vm.referenceAux.accountName : ''}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":_vm.hasSkuOptions ? 4 : 6}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":_vm.hasSkuOptions ? 6 : 4,"label":"Referencia","invalid-feedback":!_vm.state.reference? 'Seleccione una referencia': '',"state":_vm.state.reference}},[_c('b-form-select',{attrs:{"options":_vm.references,"disabled":_vm.incidentDetail.populate},on:{"change":_vm.handleChange},model:{value:(_vm.incidentDetail.incidenceType),callback:function ($$v) {_vm.$set(_vm.incidentDetail, "incidenceType", $$v)},expression:"incidentDetail.incidenceType"}})],1)],1),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.incidentDetail.populate && (_vm.incidentDetail.incidenceType === 'PRODUCT' || _vm.incidentDetail.incidenceType === 'SKU')),expression:"!incidentDetail.populate && (incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU')"}],attrs:{"cols":"12","sm":_vm.hasSkuOptions ? 4 : 6}},[_c('autocomplete',{staticClass:"autocomplete__incidentModal",class:{
            'hide-pannel': _vm.filter.length === 1
          },attrs:{"maxElements":100,"selectLabel":'Enter para agregar al detalle',"multiple":false,"provider":_vm.getSearchProducts},model:{value:(_vm.referenceAux),callback:function ($$v) {_vm.referenceAux=$$v},expression:"referenceAux"}})],1),_vm._v(" "),(!_vm.incidentDetail.populate && _vm.hasSkuOptions)?_c('b-col',{attrs:{"cols":"12","sm":"4"}},[_c('b-form-group',{attrs:{"horizontal":"","label":"SKU","state":_vm.state.reference}},[_c('b-form-select',{attrs:{"options":_vm.skuListOptions},model:{value:(_vm.referenceSkuAux),callback:function ($$v) {_vm.referenceSkuAux=$$v},expression:"referenceSkuAux"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(!_vm.incidentDetail.populate && _vm.incidentDetail.incidenceType === 'ORDER'),expression:"!incidentDetail.populate && incidentDetail.incidenceType === 'ORDER'"}],attrs:{"cols":"12","sm":"6"}},[_c('autocomplete',{staticClass:"autocomplete__incidentModal",attrs:{"maxElements":100,"provider":_vm.getSearchOrders,"label":'id',"selectLabel":'Enter para agregar la order',"multiple":false},model:{value:(_vm.referenceAux),callback:function ($$v) {_vm.referenceAux=$$v},expression:"referenceAux"}})],1),_vm._v(" "),(_vm.incidentDetail.populate)?_c('b-col',{attrs:{"cols":"12","sm":"6"}},[_c('b-form-input',{attrs:{"disabled":true},model:{value:(_vm.incident.reference),callback:function ($$v) {_vm.$set(_vm.incident, "reference", $$v)},expression:"incident.reference"}})],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de incidencia","invalid-feedback":!_vm.state.orderIncidenceType? 'Selecione un tipo de incidencia': '',"state":_vm.state.orderIncidenceType}},[_c('b-form-select',{attrs:{"options":_vm.orderIncidenceTypes,"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.orderIncidenceType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "orderIncidenceType", $$v)},expression:"orderDetailAux.orderIncidenceType"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.incidentDetail.incidenceType === 'PRODUCT' || _vm.incidentDetail.incidenceType === 'SKU' || (_vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType === 'Otra')),expression:"incidentDetail.incidenceType === 'PRODUCT' || incidentDetail.incidenceType === 'SKU' || (orderDetailAux && orderDetailAux.orderIncidenceType && orderDetailAux.orderIncidenceType === 'Otra')"}],attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Título","invalid-feedback":_vm.invalidFeedBackTitle(),"state":_vm.state.title}},[_c('b-form-input',{attrs:{"disabled":!_vm.referenceIsSelected},model:{value:(_vm.incidentDetail.title),callback:function ($$v) {_vm.$set(_vm.incidentDetail, "title", $$v)},expression:"incidentDetail.title"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Descripción","invalid-feedback":!_vm.state.description? 'Descripción inválida': '',"state":_vm.state.description}},[_c('b-form-textarea',{attrs:{"disabled":!_vm.referenceIsSelected,"rows":3,"max-rows":6},model:{value:(_vm.comment.text),callback:function ($$v) {_vm.$set(_vm.comment, "text", $$v)},expression:"comment.text"}})],1)],1),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Número de guía","invalid-feedback":!_vm.state.numGuia? 'Número de guía inválido': '',"state":_vm.state.numGuia}},[_c('b-form-input',{attrs:{"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.guideNumber),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "guideNumber", $$v)},expression:"orderDetailAux.guideNumber"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de envío","invalid-feedback":!_vm.state.tipoEnvio? 'Tipo de envío inválido': '',"state":_vm.state.tipoEnvio}},[_c('b-form-input',{attrs:{"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.shippingType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "shippingType", $$v)},expression:"orderDetailAux.shippingType"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de paquetera","invalid-feedback":!_vm.state.tipoPaquetera? 'Ingrese el tipo de paquetera': '',"state":_vm.state.tipoPaquetera}},[_c('b-form-input',{attrs:{"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.packagerType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "packagerType", $$v)},expression:"orderDetailAux.packagerType"}})],1)],1):_vm._e(),_vm._v(" "),( false)?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Estado de la guía","invalid-feedback":!_vm.state.estadoGuia? 'Ingrese el estado de la guía': '',"state":_vm.state.estadoGuia}},[_c('b-form-select',{attrs:{"options":['Nueva', 'Entregada (bloqueada)'],"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.guideStatus),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "guideStatus", $$v)},expression:"orderDetailAux.guideStatus"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Estado del pedido","invalid-feedback":!_vm.state.estadoPedido? 'Ingrese el estado del pedido': '',"state":_vm.state.estadoPedido}},[_c('b-form-select',{attrs:{"options":['', 'Enviado', 'Recibido'],"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.orderStatus),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "orderStatus", $$v)},expression:"orderDetailAux.orderStatus"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"URL del PDF de la guía","invalid-feedback":!_vm.state.urlPdfGuia? 'Ingrese la URL del PDF de la guía': '',"state":_vm.state.urlPdfGuia}},[_c('b-form-input',{attrs:{"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.urlPdfGuide),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "urlPdfGuide", $$v)},expression:"orderDetailAux.urlPdfGuide"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"URL del ZPL de la guía","invalid-feedback":!_vm.state.urlZplGuia? 'Ingrese la URL del ZPL de la guía': '',"state":_vm.state.urlZplGuia}},[_c('b-form-input',{attrs:{"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.urlZplGuide),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "urlZplGuide", $$v)},expression:"orderDetailAux.urlZplGuide"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.skuOrderList && _vm.skuOrderList.length > 0 && _vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Sku(s)","invalid-feedback":!_vm.state.orderSkus? 'Seleccione Sku(s)': '',"state":_vm.state.orderSkus}},[_c('multiselect',{ref:"autocompleteSku",staticClass:"sku_autocomplete",attrs:{"options":_vm.skuOrderList,"multiple":true,"searchable":false,"internal-search":false,"clear-on-select":true,"close-on-select":true,"options-limit":300,"limit":100,"placeholder":_vm.$t('Ingrese el texto para buscar'),"disabled":false,"max-height":600,"selectLabel":_vm.$t('Enter para agregar Sku'),"show-no-results":true,"showPointer":true,"hideSelected":true},on:{"input":function($event){_vm.updateOrderDetail(_vm.orderDetailAux)}},model:{value:(_vm.orderDetailAux.skus),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "skus", $$v)},expression:"orderDetailAux.skus"}},[_c('span',{attrs:{"slot":"noResult"},slot:"noResult"},[_vm._v("No hay elementos para mostrar")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Origen","invalid-feedback":!_vm.state.origin? 'Seleccione el origen': '',"state":_vm.state.origin}},[_c('b-form-select',{attrs:{"options":[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}],"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.source),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "source", $$v)},expression:"orderDetailAux.source"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Destino","invalid-feedback":!_vm.state.destination? 'Seleccione el destino': '',"state":_vm.state.destination}},[_c('b-form-select',{attrs:{"options":[{text: 'Tienda', value: 'T'}, {text: 'Seller', value: 'S'}, {text: 'Cliente', value: 'C'}],"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.destination),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "destination", $$v)},expression:"orderDetailAux.destination"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tienda","invalid-feedback":!_vm.state.store? 'Ingrese la tienda': '',"state":_vm.state.store}},[_c('b-form-select',{attrs:{"options":[{text: '', value: ''}, {text: '4263 (tienda ecommerce)', value: '4263'}],"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.store),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "store", $$v)},expression:"orderDetailAux.store"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.incidentDetail.incidenceType === 'ORDER' && _vm.orderDetailAux && _vm.orderDetailAux.orderIncidenceType && _vm.orderDetailAux.orderIncidenceType !== 'Otra')?_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Tipo de proceso","invalid-feedback":!_vm.state.estadoPedido? 'Ingrese el tipo de proceso': '',"state":_vm.state.proccessType}},[_c('b-form-select',{attrs:{"options":[{text: '', value: ''}, {text: 'Devolución', value: 'Devolucion'}, {text: 'Reverse', value: 'Reverse'}, {text: 'Cancelación', value: 'Cancelacion'}, {text: 'Compra', value: 'Compra'}],"disabled":!_vm.referenceIsSelected},model:{value:(_vm.orderDetailAux.processType),callback:function ($$v) {_vm.$set(_vm.orderDetailAux, "processType", $$v)},expression:"orderDetailAux.processType"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Prioridad","invalid-feedback":!_vm.state.priority? 'Selecione una prioridad': '',"state":_vm.state.priority}},[_c('b-form-select',{attrs:{"options":_vm.priorities,"disabled":!_vm.referenceIsSelected},model:{value:(_vm.incidentDetail.priority),callback:function ($$v) {_vm.$set(_vm.incidentDetail, "priority", $$v)},expression:"incidentDetail.priority"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"w-100"},[_c('b-button',{staticClass:"float-right mx-1",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.cancel()}}},[_vm._v(_vm._s(_vm.incident === null ? 'Cancelar' : 'Cerrar'))]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.incident === null || _vm.incidentDetail.populate),expression:"incident === null || incidentDetail.populate"}],staticClass:"float-right mx-1",attrs:{"disabled":_vm.disableSave(),"variant":"primary"},on:{"click":_vm.modalOk}},[_vm._v("Crear")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.incident !== null && _vm.incidentDetail.status !== 'CLOSE' && !_vm.incidentDetail.populate),expression:"incident !== null && incidentDetail.status !== 'CLOSE' && !incidentDetail.populate"}],staticClass:"mb-2 mx-1 float-right",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.markAsSolved($event)}}},[_vm._v("\n          Marcar como solucionado\n        ")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.incident && _vm.incidentDetail.status !== 'CLOSE' && !_vm.incidentDetail.populate && _vm.incidentDetail.payload),expression:"incident && incidentDetail.status !== 'CLOSE' && !incidentDetail.populate && incidentDetail.payload"}],staticClass:"mb-2 mx-1 float-right",attrs:{"variant":"primary","disabled":_vm.disableSave()},on:{"click":function($event){$event.stopPropagation();_vm.updateIncidentDetail($event)}}},[_vm._v("\n          Actualizar\n        ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-modal',{ref:"confirmationCloseIncidentModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationCloseIncidentModal","centered":"","title":_vm.$t('Cerrar incidencia'),"cancel-title":_vm.$t('Cancelar')},on:{"ok":function($event){_vm.solveIncident(_vm.incidentToSolve)}}},[_c('span',[_vm._v(_vm._s(_vm.$t('¿Confirma que desea marcar la incidencia como CERRADA?')))])]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.successText !== '',"variant":"success","dismissible":""}},[_vm._v("\n      "+_vm._s(_vm.successText)+"\n     ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"mb-2 mx-1 float-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.openModal(true)}}},[_vm._v("Crear Incidencia")])],1)],1),_vm._v(" "),_c('incidentsModal',{ref:"incidentModal",attrs:{"show":_vm.showModal,"incident":_vm.incidentToEdit,"references":_vm.references,"priorities":_vm.priorities},on:{"update:show":function($event){_vm.showModal=$event},"saved":_vm.newIncidentSaved,"updated":_vm.newIncidentUpdated,"markAsSolved":_vm.markAsSolved}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',{staticClass:"filter-row"},[_c('b-col',{attrs:{"lg":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('Buscar'),"invalid-feedback":!_vm.isValidText(_vm.filters.text, false)? _vm.$t('No es un valor válido') : '',"state":_vm.isValidText(_vm.filters.text, false),"description":_vm.$t('Ingrese el texto a buscar')}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":_vm.$t('Texto a buscar')},model:{value:(_vm.filters.text),callback:function ($$v) {_vm.$set(_vm.filters, "text", $$v)},expression:"filters.text"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{on:{"click":_vm.filterTable}},[_vm._v(_vm._s(_vm.$t('Buscar')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('b-form-group',{attrs:{"id":"dateFilterFromGroup","label":"Rango de fechas","description":"Se filtrara los reportes por el rango de fechas seleccionado","label-for":"filterRangeDate"}},[_c('date-picker',{ref:"filterBeginDate",attrs:{"id":"filterRangeDate","name":"filterRangeDate","format":"YYYY-MM-DD","valueType":"YYYY-MM-DD","confirm":true,"lang":_vm.lang,"confirm-text":"Seleccione rango","clearable":true,"range":""},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.rangeDate),callback:function ($$v) {_vm.rangeDate=$$v},expression:"rangeDate"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"6","md":"3","lg":"3"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Referencia"}},[_c('b-form-select',{attrs:{"options":_vm.references},model:{value:(_vm.filters.incidenceType),callback:function ($$v) {_vm.$set(_vm.filters, "incidenceType", $$v)},expression:"filters.incidenceType"}})],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('b-col',{attrs:{"cols":"12","sm":"6","md":"3","lg":"3"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Seller"}},[_c('b-form-select',{attrs:{"options":_vm.organizations},model:{value:(_vm.filters.accountName),callback:function ($$v) {_vm.$set(_vm.filters, "accountName", $$v)},expression:"filters.accountName"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6","md":"3","lg":"3"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Prioridad"}},[_c('b-form-select',{attrs:{"options":_vm.priorities},model:{value:(_vm.filters.priority),callback:function ($$v) {_vm.$set(_vm.filters, "priority", $$v)},expression:"filters.priority"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","sm":"6","md":"3","lg":"3"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Estado"}},[_c('b-form-select',{attrs:{"options":_vm.status},model:{value:(_vm.filters.status),callback:function ($$v) {_vm.$set(_vm.filters, "status", $$v)},expression:"filters.status"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',[_c('b-button',{staticClass:"mb-2 mx-1 float-right",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterApply($event)}}},[_vm._v("Filtrar")]),_vm._v(" "),_c('b-button',{staticClass:"mb-2 mx-1 float-right",attrs:{"variant":"primary","disabled":!_vm.filterHasBeenUsed},on:{"click":function($event){$event.stopPropagation();_vm.filterShowAll($event)}}},[_vm._v("Borrar filtros")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',[_c('incidents-table',{ref:"indicentsTable",attrs:{"filters":_vm.filters,"addReferenceLink":true},on:{"error":_vm.showError,"selected":_vm.selectIncident}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAdminView_vue__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c0b518_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAdminView_vue__ = __webpack_require__(1044);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAdminView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c0b518_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAdminView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_UsersList__ = __webpack_require__(1035);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users-view',
  components: {
    UsersList: __WEBPACK_IMPORTED_MODULE_0__components_user_UsersList__["a" /* default */]
  }
});

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersList_vue__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce2fcc1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersList_vue__ = __webpack_require__(1043);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce2fcc1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserForm__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OrganizationsCheckbox__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RolesCheckbox__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim__ = __webpack_require__(10);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users-list',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__["a" /* default */], UserForm: __WEBPACK_IMPORTED_MODULE_3__UserForm__["a" /* default */], OrganizationsCheckbox: __WEBPACK_IMPORTED_MODULE_4__OrganizationsCheckbox__["a" /* default */], RolesCheckbox: __WEBPACK_IMPORTED_MODULE_5__RolesCheckbox__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__["a" /* AdminServiceMixin */], __WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__["c" /* RoleService */], __WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__["b" /* OrganizationService */], __WEBPACK_IMPORTED_MODULE_6__mixims_ValidationsMixim__["a" /* ValidationsMixim */]],
  data: function data() {
    return {
      success: null,
      errorText: '',
      loading: true,
      fields: [{ key: 'firstName', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'lastName', label: 'Apellido', 'class': 'text-left', sortable: true }, { key: 'email', label: 'Correo', 'class': 'text-left', sortable: true }, { key: 'seller', label: 'Seller', 'class': 'text-left', sortable: false }, { key: 'roles', label: 'Permisos', sortable: false }],
      selectedUser: {
        firstName: null,
        lastName: null,
        email: null,
        id: null,
        roles: [],
        organizations: this.$store.getters.isAdmin ? [] : this.$store.state.user_data.organizations
      },
      roleOptions: [],
      allOrganizations: [],
      showFilters: false,
      filterRules: {
        user: {
          text: null,
          firstName: null,
          lastName: null,
          email: null,
          roles: [],
          accountNames: [],
          sortBy: 'firstName',
          sortOrder: true,
          size: 10,
          from: 1
        }
      },
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      timeout: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getRoles().then(function (roles) {
      _this.roleOptions = roles.body;
    });
    this.getAllOrganizations().then(function (orgs) {
      _this.allOrganizations = orgs;
    });
  },

  methods: {
    resetFilters: function resetFilters() {
      this.filterRules = {
        user: {
          text: null,
          firstName: null,
          lastName: null,
          email: null,
          roles: [],
          accountNames: [],
          sortBy: 'firstName',
          sortOrder: true,
          size: 10,
          from: 1
        }
      };
      this.$refs.mainTable.refresh();
    },
    cancelModal: function cancelModal() {
      this.$refs.userInfo.hide();
      this.resetModal();
    },
    filter: function filter() {
      return this.filterRules;
    },
    addIfNotPresent: function addIfNotPresent(list, item) {
      if (!list.includes(item)) list.push(item);
    },
    itemSort: function itemSort(sortBy) {
      return function (a, b) {
        return a[sortBy] > b[sortBy] ? 1 : -1;
      };
    },
    handleResetPassword: function handleResetPassword() {
      var _this2 = this;

      this.resetPassword(this.selectedUser.id).then(function () {
        _this2.success = true;
        _this2.$refs.userInfo.hide();
      }).catch(function (er) {
        _this2.errorText = er.body.message || 'Ocurrió un error al reestablecer una contraseña';
      });
    },
    handleSave: function handleSave() {
      var _this3 = this;

      this.loading = true;
      this.$refs.userInfo.hide();
      this.$refs.userForm.save(function (user) {
        var save = user.id ? _this3.updateUser : _this3.createUser;
        save(user).then(function () {
          _this3.loading = false;
          _this3.success = true;
          _this3.$refs.mainTable.refresh();
        }).catch(function (er) {
          _this3.loading = false;
          _this3.errorText = er.body.message || 'Ocurrió un error al crear el usuario';
          if (_this3.errorText.length > 64) _this3.errorText = 'Ocurrió un error al crear el usuario';
        });
      });
    },
    openUserModal: function openUserModal(user) {
      this.resetModal();
      this.selectedUser = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user);
      this.$refs.userInfo.show();
    },
    resetModal: function resetModal() {
      this.selectedUser.firstName = null;
      this.selectedUser.lastName = null;
      this.selectedUser.email = null;
      this.selectedUser.id = null;
      this.selectedUser.roles = [];
      this.selectedUser.organizations = this.$store.getters.isAdmin ? [] : this.$store.state.user_data.organizations;
    },
    itemProvider: function itemProvider(ctx) {
      var _this4 = this;

      var filter = ctx.filter().user;
      filter.sortBy = 'firstName.keyword';
      this.loading = true;
      return this.getUsers(filter).then(function (response) {
        _this4.totalRows = parseInt(response.headers.get('X-Total-Count'));
        _this4.loading = false;
        return response.body;
      }, function (error) {
        _this4.errorText = error.body.message || 'Error obteniendo el listado de usuarios';
        _this4.loading = false;
        return [];
      });
    },
    validateNotNumbers: function validateNotNumbers(e) {
      if (e.which <= 57 && e.which >= 48) {
        e.preventDefault();
        return false;
      }
    }
  },
  computed: {
    enableFilter: function enableFilter() {
      return Boolean(this.filterRules.user.text);
    }
  }
});

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OrganizationsCheckbox__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RolesCheckbox__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_vue_autocomplete__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Switch__ = __webpack_require__(68);










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__["c" /* RoleService */], __WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__["a" /* AdminServiceMixin */], __WEBPACK_IMPORTED_MODULE_1__mixims_AdminServiceMixin__["b" /* OrganizationService */], __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim__["a" /* ValidationsMixim */]],
  components: { OrganizationsCheckbox: __WEBPACK_IMPORTED_MODULE_2__OrganizationsCheckbox__["a" /* default */], RolesCheckbox: __WEBPACK_IMPORTED_MODULE_4__RolesCheckbox__["a" /* default */], autocomplete: __WEBPACK_IMPORTED_MODULE_5__components_common_vue_autocomplete__["a" /* default */], cSwitch: __WEBPACK_IMPORTED_MODULE_6__components_common_Switch__["a" /* default */] },
  props: ['user', 'roleOptions', 'allOrganizations'],
  data: function data() {
    return {
      emailValidation: true,
      emailFeedBack: '',
      timeout: null,
      prev: '',
      verifyInProgress: false,
      isAdmin: this.$store.getters.isAdmin
    };
  },

  methods: {
    save: function save(saveAction) {
      var _this = this;

      this.getRoles().then(function (res) {
        return res.body;
      }).then(function (r) {
        saveAction(_this.user);
      });
    },
    handleInvalidFeedback: function handleInvalidFeedback() {
      if (!this.user.email || this.user.email === '') this.emailFeedBack = 'El email es obligatorio';else if (!this.validateEmail(this.user.email, true)) this.emailFeedBack = 'Email inválido';else this.emailFeedBack = '';
    },
    alertInvalidFeedBack: function alertInvalidFeedBack() {
      var commonAlert = 'Se debe seleccionar';
      return !this.user.organizations.length ? commonAlert + ' al menos un Seller' : !this.selectedIsMarketAdmin && this.user.organizations.length > 1 ? commonAlert + ' solo un Seller' : '';
    },
    routeProfile: function routeProfile(nombre) {
      return this.$route.name === nombre;
    }
  },
  computed: {
    selectedIsMarketAdmin: function selectedIsMarketAdmin() {
      return this.user.roles.some(function (r) {
        return r.roleName === 'ADMIN_USER';
      });
    },
    disableSave: function disableSave() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.state).includes(false);
    },
    state: function state() {
      return {
        firstName: this.isValidText(this.user.firstName, true, 20),
        lastName: this.isValidText(this.user.lastName, true, 20),
        email: Boolean(this.user.email) && !this.emailFeedBack,
        roles: Boolean(this.user.roles) && this.user.roles.length > 1,
        sellers: !this.selectedIsMarketAdmin ? this.alertInvalidFeedBack() === '' : true
      };
    },

    email: {
      set: function set(newVal) {
        var _this2 = this;

        this.user.email = newVal;
        if (this.user.id && this.prev === newVal) {
          this.emailValidation = true;
          clearTimeout(this.timeout);
          return;
        }
        this.emailValidation = false;
        this.handleInvalidFeedback();
        if (this.validateEmail(newVal, true)) {
          this.verifyInProgress = true;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            _this2.existEmail(_this2.user.email || '').then(function (res) {
              _this2.emailValidation = !res.body;
              _this2.verifyInProgress = false;
              if (!_this2.emailValidation) _this2.emailFeedBack = 'el correo ingresado se encuentra en uso';
            });
          }, 2000);
        }
      },
      get: function get() {
        this.handleInvalidFeedback();
        return this.user.email;
      }
    }
  },
  watch: {
    user: function user(newUser, oldUser) {
      if (newUser.id !== oldUser.id) {
        this.prev = newUser.email;
      }
    },
    'user.roles': function userRoles(newVal, oldVal) {
      if (newVal && newVal.some(function (r) {
        return r.roleName === 'ADMIN_USER';
      })) {
        this.user.organizations = [];
      }
    }
  }
});

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'options'],
  methods: {
    convertToOptions: function convertToOptions(list) {
      var self = this;
      return list.map(function (i) {
        self.user.organizations.push(i);
        return { text: i.name, value: i };
      });
    }
  },
  computed: {
    organizationOptions: function organizationOptions() {
      return this.convertToOptions(this.options);
    },

    organizations: {
      set: function set(newVal) {
        if (!newVal) this.value.organizations = [];else if (!Array.isArray(newVal)) this.value.organizations = [newVal];else this.value.organizations = newVal;
      },
      get: function get() {
        return this.value.organizations;
      }
    },
    invalidFeedback: function invalidFeedback() {
      if (this.organizations && this.organizations.length > 0) return 'Ocurrio un error al obtener los sellers';else return 'Campo obligatorio';
    },
    state: function state() {
      return Boolean(this.organizations && this.organizations.length > 0);
    }
  }
});

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Sellers","invalid-feedback":_vm.invalidFeedback,"state":_vm.state}},[_c('b-form-select',{staticClass:"mb-3",attrs:{"state":_vm.state,"options":_vm.organizationOptions,"multiple":"","select-size":4,"disabled":!(_vm.$store.getters.signedRoles.includes('ADMIN_USER'))},model:{value:(_vm.organizations),callback:function ($$v) {_vm.organizations=$$v},expression:"organizations"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_common_Switch__ = __webpack_require__(68);





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['value', 'options'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_AdminServiceMixin__["c" /* RoleService */]],
  components: {
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__components_common_Switch__["a" /* default */]
  },
  methods: {
    permitions: function permitions(r) {
      return ['CATALOG_USER', 'ORDERS_USER', 'INVENTORY_USER', 'CARRIERS_USER', 'REPORTS_USER'].includes(r.roleName);
    },
    containsRole: function containsRole(role) {
      return Boolean(this.roles && this.roles.find(function (r) {
        return r.roleName === role;
      }));
    }
  },
  computed: {
    getAlertMesage: function getAlertMesage() {
      if (this.marketplaceUser) {
        if (this.admin) {
          return 'Usuario Administrador, este usuario tendra la capacidad de poder crear usuarios Seller y Administradores';
        } else {
          return 'Usuario básico';
        }
      } else {
        if (this.admin) {
          return 'Usuario Administrador Seller, este usuario tendra la capacidad de poder crear usuarios Seller solo con los Sellers habilitados por el Administrador';
        } else {
          return 'Usuario standard';
        }
      }
    },
    rolesOptions: function rolesOptions() {
      var _this = this;

      return this.sortValidRoles(this.options).filter(this.permitions).map(function (r) {
        return { text: _this.roleProperties[r.roleName].name, value: r };
      });
    },

    roles: {
      set: function set(newVal) {
        var _this2 = this;

        if (!newVal) this.value.roles = [this.standardOption];else if (!Array.isArray(newVal)) this.value.roles = [newVal];else this.value.roles = newVal;
        if (this.value.roles.filter(function (r) {
          return !_this2.permitions(r);
        }).length === 0) {
          this.value.roles.push(this.standardOption);
        }
        if (!newVal) this.marketplaceUser = false;
      },
      get: function get() {
        return this.value.roles;
      }
    },
    marketplaceUser: {
      set: function set(newType) {
        if (newType) {
          this.adminOption = this.options.find(function (r) {
            return r.roleName === 'ADMIN_USER';
          });
          this.standardOption = this.options.find(function (r) {
            return r.roleName === 'STANDARD_USER';
          });
        } else {
          this.adminOption = this.options.find(function (r) {
            return r.roleName === 'ORGANIZATION_ADMIN_USER';
          });
          this.standardOption = this.options.find(function (r) {
            return r.roleName === 'ORGANIZATION_STANDARD_USER';
          });
        }
      },
      get: function get() {
        return this.containsRole('ADMIN_USER') || this.containsRole('STANDARD_USER');
      }
    },
    adminOption: {
      set: function set(newVal) {
        var _this3 = this;

        if (this.admin) {
          this.roles = this.roles.map(function (r) {
            if (r.roleName === _this3.adminOption.roleName) return newVal;else return r;
          });
        }
      },
      get: function get() {
        return this.marketplaceUser ? this.options.find(function (r) {
          return r.roleName === 'ADMIN_USER';
        }) : this.options.find(function (r) {
          return r.roleName === 'ORGANIZATION_ADMIN_USER';
        });
      }
    },
    standardOption: {
      set: function set(newVal) {
        var _this4 = this;

        if (!this.admin) {
          this.roles = this.roles && Array.isArray(this.roles) && this.roles.length > 0 ? this.roles.map(function (r) {
            if (r.roleName === _this4.standardOption.roleName) return newVal;else return r;
          }) : [newVal];
        }
      },
      get: function get() {
        return this.marketplaceUser ? this.options.find(function (r) {
          return r.roleName === 'STANDARD_USER';
        }) : this.options.find(function (r) {
          return r.roleName === 'ORGANIZATION_STANDARD_USER';
        });
      }
    },
    admin: {
      set: function set(newVal) {
        var _this5 = this;

        if (newVal) {
          this.roles = this.roles.map(function (r) {
            if (r.roleName === 'ORGANIZATION_STANDARD_USER' || r.roleName === 'STANDARD_USER') return _this5.adminOption;else return r;
          });
        } else {
          this.roles = this.roles.map(function (r) {
            if (r.roleName === 'ORGANIZATION_ADMIN_USER' || r.roleName === 'ADMIN_USER') return _this5.standardOption;else return r;
          });
        }
      },
      get: function get() {
        return this.containsRole('ADMIN_USER') || this.containsRole('ORGANIZATION_ADMIN_USER');
      }
    }
  }
});

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":""}},[_c('i',{staticClass:"fa fa-bell mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.getAlertMesage))]),_vm._v(" "),(_vm.$store.getters.signedRoles.includes('ADMIN_USER'))?_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label":"¿Es Marketplace user?"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.marketplaceUser),callback:function ($$v) {_vm.marketplaceUser=$$v},expression:"marketplaceUser"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.signedRoles.includes('ADMIN_USER'))?_c('hr'):_vm._e(),_vm._v(" "),(_vm.$store.getters.signedRoles.includes('ADMIN_USER') || _vm.$store.getters.signedRoles.includes('ORGANIZATION_ADMIN_USER'))?_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label":"¿Es Administrador?"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.admin),callback:function ($$v) {_vm.admin=$$v},expression:"admin"}})],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.$store.getters.signedRoles.includes('ADMIN_USER') || _vm.$store.getters.signedRoles.includes('ORGANIZATION_ADMIN_USER'))?_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label":"Permisos"}},[_c('b-form-checkbox-group',{attrs:{"size":"md","stacked":"","disabled":!(_vm.$store.getters.signedRoles.includes('ADMIN_USER') || _vm.$store.getters.signedRoles.includes('ORGANIZATION_ADMIN_USER')),"options":_vm.rolesOptions},model:{value:(_vm.roles),callback:function ($$v) {_vm.roles=$$v},expression:"roles"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"mb-3"},[_vm._v("Datos del usuario")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Nombre","invalid-feedback":!_vm.state.firstName? 'El nombre es invalido': '',"state":_vm.state.firstName}},[_c('b-form-input',{model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Apellido","invalid-feedback":!_vm.state.lastName? 'El apellido es invalido': '',"state":_vm.state.lastName}},[_c('b-form-input',{model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label":"Correo","label-cols":2,"description":Boolean(_vm.verifyInProgress) ? 'Verificando el correo, espere...' : '',"invalid-feedback":_vm.emailFeedBack,"state":_vm.state.email}},[_c('b-form-input',{model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[(!_vm.selectedIsMarketAdmin)?_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Sellers","description":_vm.selectedIsMarketAdmin ? '' : 'Solo un usuario administrador del Marketplace puede seleccionar más de un Seller',"invalid-feedback":_vm.alertInvalidFeedBack(),"state":_vm.state.sellers && _vm.user.id === null}},[_c('autocomplete',{staticClass:"input_class optional",attrs:{"id":"inputSellers","name":"inputSellers","maxElements":_vm.isAdmin && _vm.selectedIsMarketAdmin ? 100 : 1,"disabled":!_vm.isAdmin,"placeholder":"Ingrese una marca...","provider":_vm.getSearchSeller,"showSelectAll":_vm.selectedIsMarketAdmin,"seletecAll":true},model:{value:(_vm.user.organizations),callback:function ($$v) {_vm.$set(_vm.user, "organizations", $$v)},expression:"user.organizations"}})],1):_vm._e()],1)],1),_vm._v(" "),(_vm.routeProfile('Usuario'))?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('hr'),_vm._v(" "),_c('h5',{staticClass:"mb-3"},[_vm._v("Notificaciones")]),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":3,"label":"Quiero recibir correos electrónicos"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.user.sendEmail),callback:function ($$v) {_vm.$set(_vm.user, "sendEmail", $$v)},expression:"user.sendEmail"}})],1),_vm._v(" "),_c('hr')],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('roles-checkbox',{attrs:{"value":_vm.user,"options":_vm.roleOptions}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"animated fadeIn",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.errorText = ''}}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"alert alert-success",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.success=false}}},[_vm._v("\n    La acción fue completada con éxito\n  ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('button',{staticClass:"btn btn-primary float-right",on:{"click":function($event){_vm.openUserModal(_vm.selectedUser)}}},[_vm._v("Crear usuario")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{"collapse2":true}}],staticClass:"btn btn-primary float-right mr-2",on:{"click":function($event){_vm.showFilters = !_vm.showFilters}}},[_vm._v("Filtros")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-collapse',{attrs:{"id":"collapse2"}},[_c('b-card',{staticClass:"filters mt-3 p-3"},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"breakpoint":"md","label":"Buscar","label-for":"nameLabelFormater"}},[_c('b-form-input',{attrs:{"type":"text","id":"nameLabelFormater"},nativeOn:{"keypress":function($event){_vm.validateNotNumbers($event)}},model:{value:(_vm.filterRules.user.text),callback:function ($$v) {_vm.$set(_vm.filterRules.user, "text", $$v)},expression:"filterRules.user.text"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":!_vm.enableFilter || _vm.loading},on:{"click":function($event){_vm.$refs.mainTable.refresh()}}},[_vm._v("Filtrar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.loading},on:{"click":_vm.resetFilters}},[_vm._v("Mostrar Todos")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.filterRules.user.size},model:{value:(_vm.filterRules.user.from),callback:function ($$v) {_vm.$set(_vm.filterRules.user, "from", $$v)},expression:"filterRules.user.from"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.filterRules.user.size),callback:function ($$v) {_vm.$set(_vm.filterRules.user, "size", $$v)},expression:"filterRules.user.size"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"mt-1",attrs:{"align-self":"start"}},[_c('b',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" usuarios encontrados\n    ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Lista de Usuarios"}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",attrs:{"id":"mainTable","responsive":"true","stacked":"xl","empty-text":"No hay usuarios para mostrar","empty-filtered-text":"No hay usuarios para mostrar","show-empty":"","striped":"","hover":"","foot-clone":"","sort-by":_vm.filterRules.user.sortBy,"sort-desc":_vm.filterRules.user.sortOrder,"per-page":_vm.filterRules.user.size,"current-page":_vm.filterRules.user.from,"items":_vm.itemProvider,"fields":_vm.fields,"filter":_vm.filter},on:{"update:sortBy":function($event){_vm.$set(_vm.filterRules.user, "sortBy", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filterRules.user, "sortOrder", $event)},"row-clicked":_vm.openUserModal},scopedSlots:_vm._u([{key:"seller",fn:function(row){return _vm._l((row.item.organizations),function(seller){return _c('b-badge',{key:seller.id,staticClass:"mr-1",attrs:{"pill":"","variant":"primary"}},[_vm._v(" "+_vm._s(seller.name)+" ")])})}},{key:"roles",fn:function(row){return _vm._l((_vm.sortValidRoles(row.item.roles)),function(role){return _c('b-badge',{key:role.id,staticClass:"mr-1",attrs:{"pill":"","variant":_vm.roleProperties[role.roleName].variant}},[_vm._v(" "+_vm._s(_vm.roleProperties[role.roleName].name)+" ")])})}}])})],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"userInfo",attrs:{"header-bg-variant":"primary","centered":"","title":_vm.selectedUser.id ? 'Guardar usuario' : 'Crear usuario',"size":"lg"}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('user-form',{ref:"userForm",attrs:{"user":_vm.selectedUser,"roleOptions":_vm.roleOptions,"allOrganizations":_vm.allOrganizations}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-row',[_c('b-col',{staticClass:"px-4"},[(_vm.selectedUser.id)?_c('button',{staticClass:"btn btn-primary mb-2 mx-1",on:{"click":function($event){_vm.handleResetPassword()}}},[_vm._v("Reiniciar clave")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2 mx-1 float-right",on:{"click":_vm.cancelModal}},[_vm._v("Cancelar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2 mx-1 float-right",attrs:{"disabled":this.$refs.userForm ? this.$refs.userForm.disableSave : true},on:{"click":_vm.handleSave}},[_vm._v(_vm._s(_vm.selectedUser.id ? 'Guardar' : 'Crear'))])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('users-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileView_vue__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc594a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileView_vue__ = __webpack_require__(1047);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dc594a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_user_UserForm__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_AdminServiceMixin__ = __webpack_require__(26);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile-view',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_AdminServiceMixin__["a" /* AdminServiceMixin */], __WEBPACK_IMPORTED_MODULE_3__mixims_AdminServiceMixin__["c" /* RoleService */], __WEBPACK_IMPORTED_MODULE_3__mixims_AdminServiceMixin__["b" /* OrganizationService */]],
  components: {
    UserForm: __WEBPACK_IMPORTED_MODULE_2__components_user_UserForm__["a" /* default */]
  },
  data: function data() {
    return {
      errorText: '',
      success: false,
      password: {
        old: null,
        newVal: null,
        repeated: null
      },
      user: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$store.state.user_data),
      roleOptions: [],
      organizationOptions: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$store.state.user_data);
    this.user.organizations = this.$store.state.user_data.organizations;
    var signedRoles = this.$store.getters.signedRoles;
    var admin = signedRoles.includes('ADMIN_USER') || signedRoles.includes('ORGANIZATION_ADMIN_USER');
    if (admin) {
      this.getRoles().then(function (rs) {
        _this.roleOptions = rs.body;
      });
      this.getOrganizations().then(function (os) {
        _this.organizationOptions = os.body;
      });
    } else {
      this.roleOptions = this.$store.state.user_data.roles;
      this.organizationOptions = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.$store.state.user_data.organizations));
    }
  },

  methods: {
    successed: function successed() {
      this.success = true;
    },
    catchError: function catchError(defaultMessage) {
      var _this2 = this;

      return function (er) {
        _this2.errorText = er.body.message || defaultMessage;
      };
    },
    handleUpdateUser: function handleUpdateUser() {
      var _this3 = this;

      var self = this;
      this.updateUser(this.user).then(function () {
        self.$store.dispatch('setUserData', self.user);
        self.successed();
      }).catch(function (er) {
        console.log(er);
        _this3.errorText = 'Ocurrio un error, el usuario no se fue guardado';
      });
    },
    handleChangePassword: function handleChangePassword() {
      this.changePassword(this.user.id, {
        code: this.password.old,
        password: this.password.newVal
      }).then(this.successed).catch(this.catchError('Ocurrio un error, el usuario no se fue guardado'));
    },
    resetUser: function resetUser() {
      this.user = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.$store.state.user_data);
    }
  }
});

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"profile-info animated fadeIn",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.errorText = ''}}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"alert alert-success",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.success=false}}},[_vm._v("\n    La acción fue completada con éxito\n  ")]),_vm._v(" "),_c('b-card',[_c('user-form',{ref:"userForm",attrs:{"user":_vm.user,"roleOptions":_vm.roleOptions,"allOrganizations":_vm.organizationOptions}}),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4"},[_c('b-button',{staticClass:"mb-2 float-right",on:{"click":_vm.resetUser}},[_vm._v("Reestablecer")]),_vm._v(" "),_c('b-button',{staticClass:"mb-2 mr-2 float-right",attrs:{"disabled":this.$refs.userForm ? this.$refs.userForm.disableSave : true},on:{"click":_vm.handleUpdateUser}},[_vm._v("Actualizar")])],1)],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',[_c('h4',[_vm._v("Contraseña")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-col',{attrs:{"md":"4","offset-md":"4"}},[_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.pass-modal",modifiers:{"pass-modal":true}}],staticClass:"w-100"},[_vm._v("Cambiar clave de acceso")])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{attrs:{"id":"pass-modal","centered":"","title":"Cambiar clave","ok-title":"Cambiar","cancel-title":"Cancelar","ok-disabled":!(Boolean(_vm.password.old) && Boolean(_vm.password.newVal) && _vm.password.newVal.length > 5 && _vm.password.newVal === _vm.password.repeated)},on:{"hidden":function($event){_vm.password={}},"ok":_vm.handleChangePassword}},[_c('b-container',{staticClass:"mt-3 pw-info animated fadeIn",attrs:{"fluid":""}},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label":"Clave actual"}},[_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.password.old),callback:function ($$v) {_vm.$set(_vm.password, "old", $$v)},expression:"password.old"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label":"Clave nueva","invalid-feedback":"Debe contener al menos 6 caracteres","state":!Boolean(_vm.password.newVal) || _vm.password.newVal.length > 5}},[_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.password.newVal),callback:function ($$v) {_vm.$set(_vm.password, "newVal", $$v)},expression:"password.newVal"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":4,"label":"Repetir clave nueva","invalid-feedback":"Las claves no coinciden","state":!Boolean(_vm.password.repeated) || _vm.password.newVal === _vm.password.repeated}},[_c('b-form-input',{attrs:{"type":"password"},model:{value:(_vm.password.repeated),callback:function ($$v) {_vm.$set(_vm.password, "repeated", $$v)},expression:"password.repeated"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationsView_vue__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec56a18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationsView_vue__ = __webpack_require__(1054);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationsView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec56a18_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationsView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_OrganizationList__ = __webpack_require__(1050);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'organizations-view',
  components: {
    OrganizationList: __WEBPACK_IMPORTED_MODULE_0__components_user_OrganizationList__["a" /* default */]
  }
});

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationList_vue__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4952ac6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationList_vue__ = __webpack_require__(1053);
function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrganizationList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4952ac6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrganizationList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js__);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_AdminServiceMixin__["b" /* OrganizationService */], __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_2__mixims_AdminServiceMixin__["a" /* AdminServiceMixin */]],
  data: function data() {
    return {
      SellerSelected: [],
      success: null,
      errorText: '',
      loading: false,
      fields: [{ key: 'accountName', label: 'Cuenta Vtex', 'class': 'text-left', sortable: true }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'description', label: 'Descripción', 'class': 'text-left', sortable: true }],
      modal: {},
      selected: {},
      allSellers: null,
      file: null,
      filterRules: {
        sortBy: 'accountName',
        sortOrder: true,
        size: 10,
        from: 1,
        text: null
      },
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],

      verifyEmailInProgress: false,
      uniqueEmail: true,
      emailFeedback: '',
      emailTimeout: null,
      prevEmail: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    selectrSellers: function selectrSellers(rid) {
      var indexOfItem = this.SellerSelected.indexOf(rid);
      if (indexOfItem !== -1) {
        this.SellerSelected.splice(indexOfItem, 1);
      } else if (indexOfItem === -1) {
        this.SellerSelected.push(rid);
      }
    },
    filter: function filter() {
      return this.filterRules;
    },
    handleSave: function handleSave() {
      var _this2 = this;

      var toSave = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.selected);
      var imgData = this.file ? { img: this.file } : null;

      this.saveOrganization(toSave).then(function (res) {
        if (imgData) {
          return _this2.uploadImage(res.body.id, imgData.img).then(function () {
            _this2.success = true;
            _this2.$refs.mainTable.refresh();
          });
        } else {
          _this2.success = true;
          _this2.$refs.mainTable.refresh();
        }
      }, function (error) {
        _this2.errorText = error.body.message || 'Ocurrió un error el guardar la seller';
      });
    },
    openOrganizationModal: function openOrganizationModal(org) {
      var _this3 = this;

      this.loading = true;
      var _this = this;
      this.errorText = '';
      this.success = false;

      this.getAllOrganizations().then(function (sellers) {
        _this.loading = false;
        _this.allSellers = sellers;
        _this.selected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, org);
        _this.$refs.orgInfo.show();
      }, function () {
        _this3.errorText = 'Error obteniendo el listado actualizado de Sellers';
      });
    },
    resetModal: function resetModal() {
      this.selected = {};
      this.file = null;
      this.allSellers = null;
      this.$refs.fileinput.reset();

      this.uniqueEmail = true;
      this.verifyEmailInProgress = false;
      this.emailFeedback = '';
      clearTimeout(this.emailTimeout);
      this.prevEmail = '';
    },
    filterTable: function filterTable() {
      this.$refs.mainTable.refresh();
    },
    itemProvider: function itemProvider(ctx) {
      var _this4 = this;

      this.loading = true;
      var filter = ctx.filter();
      return this.getOrganizations(filter).then(function (response) {
        _this4.totalRows = parseInt(response.headers.get('X-Total-Count'));
        _this4.loading = false;
        return response.body;
      }, function (error) {
        _this4.errorText = error.body.message || 'Error obteniendo el listado de sellers';
        _this4.loading = false;
        return [];
      });
    },

    uploadImage: function uploadImage(id, img) {
      var _this5 = this;

      var formData = new FormData();
      var endPoint = __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default.a.API_END_POINT + '/admin/organization/' + id + '/image';
      formData.append('file', img);
      return this.$http.post(endPoint, formData, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).catch(function () {
        _this5.errorText = 'Ocurrio un error al cargar la imagen';
      });
    },
    existsSeller: function existsSeller(seller) {
      return this.allSellers.find(function (itemSeller) {
        return itemSeller.accountName === seller;
      });
    }
  },
  computed: {
    disableSave: function disableSave() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.state).includes(false) || this.loading;
    },

    emailSeller: {
      set: function set(newVal) {
        var _this6 = this;

        this.uniqueEmail = false;
        this.selected.email = newVal;

        if (this.selected.id && this.prevEmail === newVal) {
          this.uniqueEmail = true;
          clearTimeout(this.emailTimeout);
          return;
        }

        if (!newVal || newVal === '') {
          this.emailFeedback = 'El email es obligatorio';
          return;
        }
        if (!this.validateEmail(newVal, true)) {
          this.emailFeedback = 'Email inválido';
          return;
        }

        this.verifyEmailInProgress = true;
        clearTimeout(this.emailTimeout);
        this.emailTimeout = setTimeout(function () {
          _this6.existEmail(newVal || '').then(function (res) {
            _this6.verifyEmailInProgress = false;
            var emailExists = res.body;
            if (emailExists) {
              _this6.emailFeedback = 'El correo ingresado se encuentra en uso';
              _this6.uniqueEmail = false;
            } else {
              _this6.emailFeedback = '';
              _this6.uniqueEmail = true;
            }
          }).catch(function () {
            _this6.verifyEmailInProgress = false;
            _this6.emailFeedback = 'Error al verificar el email';
            _this6.uniqueEmail = false;
          });
        }, 2000);
      },
      get: function get() {
        return this.selected.email;
      }
    },
    state: function state() {
      return {
        name: this.isValidText(this.selected.name, true, 41),
        accountName: Boolean(this.selected.id) || this.isValidTextOneWord(this.selected.accountName, true, 41) && !this.existsSeller(this.selected.accountName),
        description: this.isValidTextArea(this.selected.description, true, 500),
        terms: this.isValidTextArea(this.selected.terms, false),
        address: this.isValidText(this.selected.address, false),
        businnesName: this.isValidTextWithoutAccents(this.selected.corporateName, true, 25),
        rfc: this.isValidText(this.selected.corporateDocument, true, 25),
        street: this.isValidText(this.selected.street, true, 50),
        CP: this.isValidText(this.selected.postalCode, true, 5) && this.selected.postalCode.length === 5,
        colonia: this.isValidTextWithoutAccents(this.selected.neighborhood, true, 50),
        estate: this.isValidTextWithoutAccents(this.selected.state, true, 50),
        location: this.isValidText(this.selected.location, true, 50),
        municipality: this.isValidTextWithoutAccents(this.selected.city, true, 50),
        noExterior: this.isValidText(this.selected.numExt, true, 25),
        noInterior: this.isValidText(this.selected.numInt, false, 25),
        country: this.isValidText(this.selected.country, true, 25),
        TaxRegime: this.isValidText(this.selected.regimenFiscal, true, 25),
        serie: this.isValidText(this.selected.serie, true, 20) && this.isValidMinLength(this.selected.serie, 2),
        email: this.validateEmail(this.selected.email, true) && this.isValidTextWithoutAccents(this.selected.email, true) && this.uniqueEmail,
        phone: !isNaN(this.selected.phone) && this.isValidText(this.selected.phone, true, 20)
      };
    }
  },
  watch: {
    selected: function selected(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        this.prevEmail = newVal.email;
      }
    }
  }
});

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"animated fadeIn",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.errorText = ''}}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"alert alert-success",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.success=false}}},[_vm._v("\n    La acción fue completada con éxito\n  ")]),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3",attrs:{"md":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"id":"nombre","horizontal":"","label-cols":4,"breakpoint":"md","label":"Buscar","invalid-feedback":!_vm.isValidText(_vm.filterRules.text, false)? 'No es un valor válido' : '',"state":_vm.isValidText(_vm.filterRules.text, false),"description":"Este campo de filtro realizará la búsqueda en los nombres de los sellers","label-for":"nameFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"state":_vm.isValidText(_vm.filterRules.text, false),"id":"nameFormatter","placeholder":"Texto a buscar"},model:{value:(_vm.filterRules.text),callback:function ($$v) {_vm.$set(_vm.filterRules, "text", $$v)},expression:"filterRules.text"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"disabled":!_vm.isValidText(_vm.filterRules.text, false)},on:{"click":_vm.filterTable}},[_vm._v("Buscar")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('button',{staticClass:"btn btn-primary float-right mr-2",on:{"click":function($event){_vm.openOrganizationModal(_vm.selected)}}},[_vm._v("Crear seller")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.filterRules.size},model:{value:(_vm.filterRules.from),callback:function ($$v) {_vm.$set(_vm.filterRules, "from", $$v)},expression:"filterRules.from"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.filterRules.size),callback:function ($$v) {_vm.$set(_vm.filterRules, "size", $$v)},expression:"filterRules.size"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3 pb-3"},[_c('b-col',{staticClass:"b-col__select-sellers",attrs:{"align-self":"start"}},[_c('b-form-checkbox'),_vm._v(" Seleccionar todos los sellers\n    ")],1),_vm._v(" "),_c('b-col',{staticClass:"mt-1",staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('b',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" sellers encontrados\n    ")])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Lista de sellers"}},[_c('moon-loader',{staticClass:"mb-2",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","foot-clone":"","sort-by":_vm.filterRules.sortBy,"sort-desc":_vm.filterRules.sortOrder,"per-page":_vm.filterRules.size,"current-page":_vm.filterRules.from,"items":_vm.itemProvider,"fields":_vm.fields,"filter":_vm.filter,"fixed":true,"responsive":"true","stacked":"xl","empty-text":"No hay sellers para mostrar","empty-filtered-text":"No hay sellers para mostrar"},on:{"update:sortBy":function($event){_vm.$set(_vm.filterRules, "sortBy", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filterRules, "sortOrder", $event)},"row-clicked":_vm.openOrganizationModal}})],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"orgInfo",attrs:{"header-bg-variant":"primary","centered":"","title":_vm.selected.id ? 'Guardar seller' : 'Crear seller',"size":"lg","cancel-title":"Cancelar","ok-title":_vm.selected.id ? 'Guardar' : 'Crear',"ok-disabled":_vm.disableSave},on:{"hidden":_vm.resetModal,"ok":_vm.handleSave}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Nombre","invalid-feedback":!_vm.state.name? 'El nombre es inválido' : '',"state":_vm.state.name}},[_c('b-form-input',{model:{value:(_vm.selected.name),callback:function ($$v) {_vm.$set(_vm.selected, "name", $$v)},expression:"selected.name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Cuenta Vtex","invalid-feedback":!_vm.state.accountName? 'La cuenta es inválida o ya existe' : '',"state":_vm.state.accountName}},[_c('b-form-input',{attrs:{"disabled":Boolean(_vm.selected.id)},model:{value:(_vm.selected.accountName),callback:function ($$v) {_vm.$set(_vm.selected, "accountName", $$v)},expression:"selected.accountName"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Descripción","invalid-feedback":!_vm.state.description? 'La descripción es inválida' : '',"state":_vm.state.description}},[_c('b-form-textarea',{attrs:{"rows":3,"max-rows":6},model:{value:(_vm.selected.description),callback:function ($$v) {_vm.$set(_vm.selected, "description", $$v)},expression:"selected.description"}})],1),_vm._v(" "),_c('p',{staticClass:"counter"},[_vm._v("Caracteres: "+_vm._s(_vm.selected.description? _vm.selected.description.length : 0)+" / 500")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Razón social","invalid-feedback":!_vm.state.businnesName? 'Caracteres inválidos ' : '',"state":_vm.state.businnesName}},[_c('b-form-input',{model:{value:(_vm.selected.corporateName),callback:function ($$v) {_vm.$set(_vm.selected, "corporateName", $$v)},expression:"selected.corporateName"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"RFC","invalid-feedback":!_vm.state.rfc? 'Caracteres inválidos ' : '',"state":_vm.state.rfc}},[_c('b-form-input',{model:{value:(_vm.selected.corporateDocument),callback:function ($$v) {_vm.$set(_vm.selected, "corporateDocument", $$v)},expression:"selected.corporateDocument"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Régimen fiscal","invalid-feedback":!_vm.state.TaxRegime? 'Caracteres inválidos ' : '',"state":_vm.state.TaxRegime}},[_c('b-form-input',{model:{value:(_vm.selected.regimenFiscal),callback:function ($$v) {_vm.$set(_vm.selected, "regimenFiscal", $$v)},expression:"selected.regimenFiscal"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Serie","invalid-feedback":!_vm.state.serie? 'Serie inválida (Use 2-20 caracteres) ' : '',"state":_vm.state.serie}},[_c('b-form-input',{model:{value:(_vm.selected.serie),callback:function ($$v) {_vm.$set(_vm.selected, "serie", $$v)},expression:"selected.serie"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Email","description":Boolean(_vm.verifyEmailInProgress) ? 'Verificando el correo, espere...' : '',"invalid-feedback":_vm.emailFeedback,"state":_vm.state.email && _vm.uniqueEmail}},[_c('b-form-input',{model:{value:(_vm.emailSeller),callback:function ($$v) {_vm.emailSeller=$$v},expression:"emailSeller"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Teléfono","invalid-feedback":!_vm.state.phone? 'Ingresa un Teléfono válido' : '',"state":_vm.state.phone}},[_c('b-form-input',{model:{value:(_vm.selected.phone),callback:function ($$v) {_vm.$set(_vm.selected, "phone", $$v)},expression:"selected.phone"}})],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',{staticClass:"mb-3"},[_vm._v("Domicilio fiscal")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Calle","invalid-feedback":!_vm.state.street? 'Caracteres inválidos ' : '',"state":_vm.state.street}},[_c('b-form-input',{model:{value:(_vm.selected.street),callback:function ($$v) {_vm.$set(_vm.selected, "street", $$v)},expression:"selected.street"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Código Postal","invalid-feedback":!_vm.state.CP? 'Código postal diferente a 5 dígitos' : '',"state":_vm.state.CP}},[_c('b-form-input',{model:{value:(_vm.selected.postalCode),callback:function ($$v) {_vm.$set(_vm.selected, "postalCode", $$v)},expression:"selected.postalCode"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Colonia","invalid-feedback":!_vm.state.colonia? 'Caracteres inválidos ' : '',"state":_vm.state.colonia}},[_c('b-form-input',{model:{value:(_vm.selected.neighborhood),callback:function ($$v) {_vm.$set(_vm.selected, "neighborhood", $$v)},expression:"selected.neighborhood"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Estado","invalid-feedback":!_vm.state.estate? 'Caracteres inválidos ' : '',"state":_vm.state.estate}},[_c('b-form-input',{model:{value:(_vm.selected.state),callback:function ($$v) {_vm.$set(_vm.selected, "state", $$v)},expression:"selected.state"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Localidad","invalid-feedback":!_vm.state.location? 'Caracteres inválidos ' : '',"state":_vm.state.location}},[_c('b-form-input',{model:{value:(_vm.selected.location),callback:function ($$v) {_vm.$set(_vm.selected, "location", $$v)},expression:"selected.location"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Municipio","invalid-feedback":!_vm.state.municipality? 'Caracteres inválidos ' : '',"state":_vm.state.municipality}},[_c('b-form-input',{model:{value:(_vm.selected.city),callback:function ($$v) {_vm.$set(_vm.selected, "city", $$v)},expression:"selected.city"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"No Exterior","invalid-feedback":!_vm.state.noExterior? 'Caracteres inválidos ' : '',"state":_vm.state.noExterior}},[_c('b-form-input',{model:{value:(_vm.selected.numExt),callback:function ($$v) {_vm.$set(_vm.selected, "numExt", $$v)},expression:"selected.numExt"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"No Interior","invalid-feedback":!_vm.state.noInterior? 'Caracteres inválidos ' : '',"state":_vm.state.noInterior}},[_c('b-form-input',{model:{value:(_vm.selected.numInt),callback:function ($$v) {_vm.$set(_vm.selected, "numInt", $$v)},expression:"selected.numInt"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"País","invalid-feedback":!_vm.state.country? 'Caracteres inválidos ' : '',"state":_vm.state.country}},[_c('b-form-input',{model:{value:(_vm.selected.country),callback:function ($$v) {_vm.$set(_vm.selected, "country", $$v)},expression:"selected.country"}})],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"offset-md":"2"}},[(Boolean(_vm.selected.imageFile))?_c('b-img',{staticClass:"m-3 float-right",attrs:{"id":"logo","thumbnail":"","rounded":"","fluid":"","src":_vm.selected.imageFile}}):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","id":"imageToUpload","label-cols":2,"breakpoint":"md","label":!Boolean(_vm.selected.imageFile) ? 'Logo' : 'Cambiar Logo'}},[_c('b-form-file',{ref:"fileinput",attrs:{"accept":"image/*","placeholder":"Seleccione una imagen..."},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Términos y legales","invalid-feedback":!_vm.state.terms? 'Los Términos y legales son obligatorios' : '',"state":_vm.state.terms}},[_c('b-form-textarea',{attrs:{"rows":3,"max-rows":6},model:{value:(_vm.selected.terms),callback:function ($$v) {_vm.$set(_vm.selected, "terms", $$v)},expression:"selected.terms"}})],1)],1)],1),_vm._v(" "),(false)?_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"label":"Dirección","invalid-feedback":!_vm.state.address? 'La dirección es inválida' : '',"state":_vm.state.address}},[_c('b-form-input',{model:{value:(_vm.selected.address),callback:function ($$v) {_vm.$set(_vm.selected, "address", $$v)},expression:"selected.address"}})],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('organization-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarriersView_vue__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_817186bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarriersView_vue__ = __webpack_require__(1064);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarriersView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_817186bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarriersView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_carrier_CarrierList__ = __webpack_require__(1057);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'carriers',
  components: {
    CarrierList: __WEBPACK_IMPORTED_MODULE_0__components_carrier_CarrierList__["a" /* default */]
  }
});

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarrierList_vue__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6efa216_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarrierList_vue__ = __webpack_require__(1063);
function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarrierList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6efa216_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarrierList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_CarrierServiceMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_user_OrganizationsCheckbox__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarrierForm__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_vue_autocomplete__ = __webpack_require__(53);















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'carrier-list',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_MoonLoader_vue__["a" /* default */], OrganizationsCheckbox: __WEBPACK_IMPORTED_MODULE_8__components_user_OrganizationsCheckbox__["a" /* default */], CarrierForm: __WEBPACK_IMPORTED_MODULE_9__CarrierForm__["a" /* default */], autocomplete: __WEBPACK_IMPORTED_MODULE_11__components_common_vue_autocomplete__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixims_CarrierServiceMixin__["a" /* CarrierServiceMixin */], __WEBPACK_IMPORTED_MODULE_6__mixims_AdminServiceMixin__["b" /* OrganizationService */], __WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim__["a" /* ValidationsMixim */]],
  data: function data() {
    return {
      success: null,
      errorText: '',
      errorTextModal: '',
      successTextModal: '',
      loading: true,
      loadingModal: false,
      showFilters: false,
      isAdmin: this.$store.getters.isAdmin,
      fields: [{ key: 'slaType', label: 'Tipo SLA', 'class': 'text-left', sortable: false }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: false }, { key: 'isActive', label: 'Estado', 'class': 'text-left', sortable: false }],
      fieldsAdmin: [{ key: 'slaType', label: 'Tipo SLA', 'class': 'text-left', sortable: false }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: false }, { key: 'actions', label: 'Seller', 'class': 'text-left', sortable: false }],
      selectedCarrier: {
        name: '',
        slaType: null,
        selectedCarrierBase: null,
        isActive: false,
        factorCubicWeight: null

      },
      carrierFilterRules: {
        text: '',
        slaType: null
      },
      slaFilterOptions: [{ value: null, text: 'Todos los tipos de SLA' }].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js___default.a.SLA_LIST)),
      organizationOptions: this.$store.state.user_data.sellers,
      selSeller: [],
      filterRules: {
        sortBy: 'name',
        sortOrder: false,
        size: 10,
        from: 0,
        text: ''
      },
      pageOptions: [10, 15, 25, 50, 100],
      fieldsSeller: [{ key: 'name', label: 'Cuenta', 'class': 'text-left', sortable: true }, { key: 'actions', label: ' ', 'class': 'text-right' }],
      totalRowsSeller: 0,
      selectedEditCarrier: {},
      guiaOptions: [{ text: 'Guía manual', value: 'MANUAL' }, { text: 'Guía automática', value: 'AUTOMATIC' }],
      shippingsExcluded: __WEBPACK_IMPORTED_MODULE_10__config_applicationConfig_js___default.a.SHIPPING_EXCLUDED,
      sellersItems: null
    };
  },

  methods: {
    resetFilters: function resetFilters() {
      this.carrierFilterRules = {
        text: '',
        slaType: null
      };
      this.$refs.mainTable.refresh();
    },
    filter: function filter() {
      return this.carrierFilterRules;
    },
    addIfNotPresent: function addIfNotPresent(list, item) {
      if (!list.includes(item)) list.push(item);
    },
    handleSave: function handleSave() {
      var _this = this;

      if (this.selectedCarrier.id) {
        this.updateCarrier(this.selectedCarrier).then(function () {
          _this.success = true;
          _this.$refs.mainTable.refresh();
          _this.$refs.carrierInfo.hide();
        }).catch(function (er) {
          _this.errorText = er.body.message || 'Ocurrió un error al modificar la transportadora';
        });
      } else {
        this.createCarrier(this.selectedCarrier).then(function () {
          _this.success = true;
          _this.$refs.mainTable.refresh();
          _this.$refs.carrierInfo.hide();
        }).catch(function (er) {
          _this.errorText = er.body.message || 'Ocurrió un error al crear la transportadora';
        });
      }
    },
    resetModal: function resetModal() {
      this.selectedCarrier = {
        name: '',
        slaType: null,
        selectedCarrierBase: null
      };
    },
    openCarrierModal: function openCarrierModal(carrier) {
      this.selectedCarrier = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, carrier);

      this.selectedCarrier.selectedCarrierBase = this.selectedCarrier.name.split('_')[1] ? this.selectedCarrier.name.split('_')[1] : null;

      if (this.$store.state.user_data.organizations.length === 1) this.selectedCarrier.accountName = this.$store.state.user_data.organizations[0].accountName;
      this.$refs.carrierInfo.show();
    },
    itemProvider: function itemProvider(ctx) {
      var _this2 = this;

      this.loading = true;
      var filter = ctx.filter();
      return this.getCarriers(filter).then(function (response) {
        _this2.loading = false;
        _this2.$store.dispatch('setCarrierData', response.body);
        return response.body;
      }, function (error) {
        _this2.errorText = error.body.message || 'Error obteniendo el listado de transportadoras';
        _this2.loading = false;
        return [];
      });
    },
    showSellerModal: function showSellerModal(item) {
      var _this3 = this;

      this.loadingModal = false;
      this.errorTextModal = '';
      this.successTextModal = '';
      this.selectedEditCarrier = item;

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.shippingsExcluded).find(function (key) {
        return _this3.shippingsExcluded[key] === _this3.selectedEditCarrier.item.name;
      })) {
        this.fieldsSeller = [{ key: 'name', label: 'Cuenta', 'class': 'text-left', sortable: true }, { key: 'guide', label: ' ', 'class': 'guide-width' }, { key: 'actions', label: ' ', 'class': 'text-right' }];
      }
      this.$refs.sellersTable.refresh();
      this.selSeller.splice(0, this.selSeller.length);
      this.$refs.sellerModal.show();
    },
    selectedSeller: function selectedSeller(seller) {
      this.selSeller = seller;
    },
    addSeller: function addSeller() {
      var _this4 = this;

      this.loadingModal = true;
      this.successTextModal = '';
      this.errorTextModal = '';
      var carrierSeller = {
        'accountName': this.selSeller[0].accountName,
        'carrierId': this.selectedEditCarrier.item.id,
        'isActive': true
      };
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.shippingsExcluded).find(function (key) {
        return _this4.shippingsExcluded[key] === _this4.selectedEditCarrier.item.name;
      })) {
        if (!carrierSeller.integrationType) {
          carrierSeller.integrationType = 'MANUAL';
        }
      }
      this.addSellerToCarrier(this.selectedEditCarrier.item.id, carrierSeller).then(function (response) {
        _this4.loadingModal = false;
        _this4.successTextModal = 'El seller fue agregado con exito';
        _this4.selSeller.splice(0, _this4.selSeller.length);
        _this4.$refs.sellersTable.refresh();
      }, function () {
        _this4.selSeller.splice(0, _this4.selSeller.length);
        _this4.loadingModal = false;
        _this4.errorTextModal = 'Error agregando el seller';
      });
    },
    onChangeSeller: function onChangeSeller(item, option) {
      var _this5 = this;

      var intType = option;
      this.loadingModal = true;
      this.successTextModal = '';
      this.errorTextModal = '';
      var carrierSeller = {
        'accountName': item.accountName,
        'carrierId': this.selectedEditCarrier.item.id,
        'isActive': true,
        'integrationType': intType
      };
      this.addSellerToCarrier(this.selectedEditCarrier.item.id, carrierSeller).then(function (response) {
        _this5.loadingModal = false;
        _this5.successTextModal = 'El seller fue modificado con exito';
        _this5.$refs.sellersTable.refresh();
      }, function () {
        _this5.loadingModal = false;
        _this5.errorTextModal = 'Error al modificar el seller';
      });
    },
    sellerProvider: function sellerProvider(tableFilter) {
      var _this6 = this;

      this.loadingModal = true;
      if (!this.selectedEditCarrier.item) return [];
      return this.getSellersFromCarrier(this.selectedEditCarrier.item.id, tableFilter).then(function (response) {
        _this6.loadingModal = false;
        _this6.sellersItems = response.body;
        return response.body;
      }, function () {
        _this6.loadingModal = false;
        _this6.errorTextModal = 'Error obteniendo el listado de sellers';
        return [];
      });
    },
    removeSeller: function removeSeller(carrierSeller) {
      var _this7 = this;

      this.loadingModal = true;
      this.successTextModal = '';
      this.errorTextModal = '';
      this.delSellerToCarrier(this.selectedEditCarrier.item.id, carrierSeller.id).then(function (response) {
        _this7.loadingModal = false;
        _this7.selSeller.splice(0, _this7.selSeller.length);
        _this7.successTextModal = 'El seller fue eliminado con exito';
        _this7.$refs.sellersTable.refresh();
      }, function () {
        _this7.loadingModal = false;
        _this7.selSeller.splice(0, _this7.selSeller.length);
        _this7.errorTextModal = 'Error eliminando el sellers';
      });
    }
  },
  computed: {
    filterState: function filterState() {
      return {
        name: Boolean(this.carrierFilterRules.text),
        slaType: Boolean(this.carrierFilterRules.slaType)
      };
    },
    disableSave: function disableSave() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.state).includes(false);
    },
    state: function state() {
      return {
        name: this.isValidText(this.selectedCarrier.name, true),
        slaType: this.isValidText(this.selectedCarrier.slaType, true),
        factorCubicWeight: this.isValidFloat(this.selectedCarrier.factorCubicWeight, false, true)
      };
    }
  }
});

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarrierForm_vue__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a775bae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarrierForm_vue__ = __webpack_require__(1062);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarrierForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a775bae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarrierForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_AdminServiceMixin__ = __webpack_require__(26);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_ValidationsMixim__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_2__mixims_AdminServiceMixin__["b" /* OrganizationService */]],
  props: ['value', 'organizationOptions'],
  data: function data() {
    return {
      carrierList: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.CARRIER_LIST.concat([{ value: null, text: 'seleccione transportadora', disabled: true }]),
      slaList: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.SLA_LIST.concat([{ value: null, text: 'seleccione tipo de SLA', disabled: true }]),
      selectedSeller: null,
      sellerOptions: [],
      isAdmin: this.$store.getters.isAdmin
    };
  },

  methods: {
    handleAccountName: function handleAccountName(seller) {
      this.selectedSeller = seller;
      this.value.accountName = seller.accountName;
    },
    removeAccountName: function removeAccountName() {
      this.value.accountName = null;
      this.selectedSeller = null;
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      this.selectedSeller = newVal.accountName && this.organizationOptions ? this.organizationOptions.find(function (org) {
        return org.accountName === newVal.accountName;
      }) : null;
    }
  }
});

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","oncontextmenu":"return false;","label-cols":2,"invalid-feedback":!_vm.isValidText(_vm.value.name, true) ? 'Ingrese un nombre' : '',"state":_vm.isValidText(_vm.value.name, true),"label":"Nombre"}},[_c('b-form-input',{attrs:{"disabled":_vm.value.type === 'ADMIN' && !_vm.isAdmin ? true : false},model:{value:(_vm.value.name),callback:function ($$v) {_vm.$set(_vm.value, "name", $$v)},expression:"value.name"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"id":"slaType","horizontal":"","oncontextmenu":"return false;","label-cols":2,"breakpoint":"md","label":"Tipo SLA","label-for":"slaListInput","invalid-feedback":!_vm.isValidText(_vm.value.slaType, true)? 'Seleccione un tipo de SLA' : '',"state":_vm.isValidText(_vm.value.slaType, true)}},[_c('b-form-select',{attrs:{"id":"slaListInput","options":_vm.slaList,"disabled":_vm.value.type === 'ADMIN' && !_vm.isAdmin ? true : false},model:{value:(_vm.value.slaType),callback:function ($$v) {_vm.$set(_vm.value, "slaType", $$v)},expression:"value.slaType"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"id":"factorCubicWeight","horizontal":"","oncontextmenu":"return false;","label-cols":2,"breakpoint":"md","description":"El peso volumétrico de un envío es el cálculo que refleja la densidad de un paquete. Un artículo menos denso generalmente ocupa menos volumen de espacio, comparado con el peso real. El peso volumétrico o dimensional se calcula y compara con el peso real de cada pieza del envío para determinar cuál es mayor.","label":"Factor peso volumétrico","label-for":"slaListInput","invalid-feedback":!_vm.isValidFloat(_vm.value.factorCubicWeight, false, true)? 'El factor de peso volumetrico es inválido' : '',"state":_vm.isValidFloat(_vm.value.factorCubicWeight, false, true)}},[_c('b-form-input',{attrs:{"id":"factorCubicWeightInput","disabled":_vm.value.type === 'ADMIN' && !_vm.isAdmin ? true : false},model:{value:(_vm.value.factorCubicWeight),callback:function ($$v) {_vm.$set(_vm.value, "factorCubicWeight", $$v)},expression:"value.factorCubicWeight"}})],1)],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdmin),expression:"!isAdmin"}]},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"horizontal":"","oncontextmenu":"return false;","label-cols":2,"label":"Activo"}},[_c('b-form-checkbox',{staticClass:"mt-1",model:{value:(_vm.value.isActive),callback:function ($$v) {_vm.$set(_vm.value, "isActive", $$v)},expression:"value.isActive"}})],1)],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.value.type === 'ADMIN' && !_vm.isAdmin ? true : false),expression:"value.type === 'ADMIN' && !isAdmin ? true : false"}]},[_c('b-col',{attrs:{"md":"12"}},[_vm._v("\n      Transportadora gestionada por el administrador, los valores no se pueden modificar.\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"animated fadeIn",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.errorText = ''}}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"alert alert-success",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.success=false}}},[_vm._v("\n    La acción fue completada con éxito\n  ")]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('button',{staticClass:"btn btn-primary float-right mb-3 mr-2",on:{"click":function($event){_vm.openCarrierModal(_vm.selectedCarrier)}}},[_vm._v("Crear transportadora")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{"collapse2":true}}],staticClass:"btn btn-primary float-right mb-3 mr-2",on:{"click":function($event){_vm.showFilters = !_vm.showFilters}}},[_c('i',{staticClass:"fa",class:{'fa-times': _vm.showFilters, 'fa-filter': !_vm.showFilters}}),_vm._v("Filtros\n      ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-collapse',{attrs:{"id":"collapse2"}},[_c('b-card',{staticClass:"filters mt-3 p-3"},[_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"breakpoint":"md","label":"Nombre","label-for":"nameLabelFormater"}},[_c('b-form-input',{attrs:{"type":"text","id":"nameLabelFormater"},nativeOn:{"keydown":function($event){_vm.textInputValidation($event)}},model:{value:(_vm.carrierFilterRules.text),callback:function ($$v) {_vm.$set(_vm.carrierFilterRules, "text", $$v)},expression:"carrierFilterRules.text"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"horizontal":"","label-cols":2,"breakpoint":"md","label":"Tipo SLA","label-for":"slaLabelFormater"}},[_c('b-form-select',{attrs:{"options":_vm.slaFilterOptions},model:{value:(_vm.carrierFilterRules.slaType),callback:function ($$v) {_vm.$set(_vm.carrierFilterRules, "slaType", $$v)},expression:"carrierFilterRules.slaType"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('button',{staticClass:"btn btn-primary float-right",attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.$refs.mainTable.refresh()}}},[_vm._v("Filtrar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"disabled":_vm.loading},on:{"click":_vm.resetFilters}},[_vm._v("Mostrar Todos")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Lista de transportadoras"}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",attrs:{"id":"mainTable","responsive":"true","stacked":"xl","empty-text":"No hay transportadoras para mostrar","empty-filtered-text":"No hay transportadoras para mostrar","show-empty":"","striped":"","hover":"","foot-clone":"","items":_vm.itemProvider,"fields":_vm.isAdmin ? _vm.fieldsAdmin : _vm.fields,"filter":_vm.filter},on:{"row-clicked":_vm.openCarrierModal},scopedSlots:_vm._u([{key:"actions",fn:function(row){return [_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.showSellerModal(row)}}},[_vm._v("Editar")])]}},{key:"isActive",fn:function(row){return [_vm._v("\n              "+_vm._s(row.item.isActive ? 'Activa' : 'Inactiva')+"\n            ")]}}])})],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"carrierInfo",attrs:{"header-bg-variant":"primary","centered":"","title":_vm.selectedCarrier.id ? 'Guardar transportadora' : 'Crear transportadora',"size":"lg"},on:{"hide":_vm.resetModal}},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('carrier-form',{attrs:{"value":_vm.selectedCarrier,"organizationOptions":_vm.organizationOptions}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-row',[_c('b-col',{staticClass:"px-4"},[_c('b-button',{staticClass:"mb-2 mx-1 float-right",on:{"click":function($event){_vm.$refs.carrierInfo.hide()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('b-button',{staticClass:"mb-2 mx-1 float-right",attrs:{"disabled":_vm.disableSave},on:{"click":_vm.handleSave}},[_vm._v(_vm._s(_vm.selectedCarrier.id ? 'Guardar' : 'Crear'))])],1)],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"sellerModal",attrs:{"id":"sellerModal","header-bg-variant":"primary","centered":"","title":"Editar Sellers","size":"lg","ok-disabled":_vm.sellersItems &&  Object.keys(_vm.shippingsExcluded).find(function (key) { return _vm.shippingsExcluded[key] === _vm.selectedEditCarrier.item.name; }) ? _vm.sellersItems.find(function (o) { return !o.integrationType; }) ? true: false : false},on:{"hide":_vm.resetModal}},[_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":_vm.errorTextModal !== '',"fade":"","dismissible":"","variant":"danger"}},[_vm._v(_vm._s(_vm.errorTextModal))]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.successTextModal !== '',"variant":"success","dismissible":""}},[_vm._v(_vm._s(_vm.successTextModal))]),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.loadingModal,"color":"#000","size":"30px"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"id":"inputSellersGroup","horizontal":"","label-cols":2,"breakpoint":"md","label":"Sellers","label-for":"inputSellers"}},[_c('autocomplete',{attrs:{"id":"inputSellers","name":"inputSellers","maxElements":1,"provider":_vm.searchOrganization,"disabled":_vm.loading},model:{value:(_vm.selSeller),callback:function ($$v) {_vm.selSeller=$$v},expression:"selSeller"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-button',{staticClass:"ml-auto addSpec primary",attrs:{"disabled":_vm.selSeller.length === 0},on:{"click":function($event){_vm.addSeller()}}},[_vm._v("Agregar Seller")])],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRowsSeller,"per-page":_vm.filterRules.size},model:{value:(_vm.filterRules.from),callback:function ($$v) {_vm.$set(_vm.filterRules, "from", $$v)},expression:"filterRules.from"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":""}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.filterRules.size),callback:function ($$v) {_vm.$set(_vm.filterRules, "size", $$v)},expression:"filterRules.size"}})],1)],1)],1),_vm._v(" "),_c('b-table',{ref:"sellersTable",attrs:{"id":"sellersTable","show-empty":"","striped":"","hover":"","sort-by":_vm.filterRules.sortBy,"sort-desc":_vm.filterRules.sortOrder,"per-page":_vm.filterRules.size,"current-page":_vm.filterRules.from,"items":_vm.sellerProvider,"fields":_vm.fieldsSeller,"filter":_vm.filter,"fixed":true,"small":"","responsive":"true","stacked":"xl","empty-text":"No hay sellers para mostrar","empty-filtered-text":"No hay sellers para mostrar"},on:{"update:sortBy":function($event){_vm.$set(_vm.filterRules, "sortBy", $event)},"update:sortDesc":function($event){_vm.$set(_vm.filterRules, "sortOrder", $event)}},scopedSlots:_vm._u([{key:"guide",fn:function(row){return [(Object.keys(_vm.shippingsExcluded).find(function (key) { return _vm.shippingsExcluded[key] === _vm.selectedEditCarrier.item.name; }))?_c('b-form-group',{staticClass:"my-1 radio-guia",attrs:{"label-cols":6,"invalid-feedback":!row.item.integrationType ? 'Ingrese un tipo de guía' : '',"state":row.item.integrationType}},[_c('b-form-radio-group',{attrs:{"value":row.item.integrationType,"options":_vm.guiaOptions},on:{"change":function($event){_vm.onChangeSeller(row.item, $event)}},model:{value:(row.item.integrationType),callback:function ($$v) {_vm.$set(row.item, "integrationType", $$v)},expression:"row.item.integrationType"}})],1):_vm._e()]}},{key:"actions",fn:function(row){return [_c('b-button',{on:{"click":function($event){_vm.removeSeller(row.item)}}},[_c('i',{staticClass:"fa fa-trash",attrs:{"aria-hidden":"true"}})])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carrier-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingGratesView_vue__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfbd4fd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingGratesView_vue__ = __webpack_require__(1072);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingGratesView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bfbd4fd6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingGratesView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_carrier_ShippingGratesList__ = __webpack_require__(1067);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shipping-grates-view',
  components: {
    ShippingGratesList: __WEBPACK_IMPORTED_MODULE_0__components_carrier_ShippingGratesList__["a" /* default */]
  }
});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingGratesList_vue__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114501fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingGratesList_vue__ = __webpack_require__(1071);
function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-114501fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingGratesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114501fe_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingGratesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_CarrierServiceMixin__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_Switch__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_input_tag__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_input_tag__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'shipping-grates-list',
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_MoonLoader_vue__["a" /* default */], cSwitch: __WEBPACK_IMPORTED_MODULE_6__components_common_Switch__["a" /* default */], InputTag: __WEBPACK_IMPORTED_MODULE_7_vue_input_tag___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixims_CarrierServiceMixin__["a" /* CarrierServiceMixin */], __WEBPACK_IMPORTED_MODULE_5__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  computed: {
    validZipCommas: function validZipCommas() {
      var ret = true;
      if (!this.isEmptyData(this.newPriceModel.zipCodeCommas)) {
        ret = true;
        var zips = [];
        if (this.newPriceModel.zipCodeCommas) zips = this.newPriceModel.zipCodeCommas.split(',');
        var self = this;
        zips.forEach(function (zip) {
          ret = ret && self.isValidCP(zip);
        });
      }
      return ret;
    },
    rangeLabel: function rangeLabel() {
      return 'Plazo de entrega <b>' + this.newPriceModel.timeCost + ' d\xEDas </b>';
    },
    organizations: function organizations() {
      return this.$store.getters.organizations;
    },
    filterDisabled: function filterDisabled() {
      if (this.isAdmin) {
        if (!this.isEmptyData(this.filters.weight) && !this.isValidInteger(this.filters.weight, false) || !this.isEmptyData(this.filters.maxVolume) && !this.isValidInteger(this.filters.maxVolume, false) || !this.isEmptyData(this.filters.zipCode) && !this.isValidCP(this.filters.zipCode, false)) {
          return true;
        }
      }
      if (this.isEmptyData(this.filters.weight) && this.isEmptyData(this.filters.maxVolume) && this.isEmptyData(this.filters.zipCode)) {
        return true;
      }

      if (!this.isEmptyData(this.filters.weight) && !this.isValidInteger(this.filters.weight, false) || !this.isEmptyData(this.filters.maxVolume) && !this.isValidInteger(this.filters.maxVolume, false) || !this.isEmptyData(this.filters.zipCode) && !this.isValidCP(this.filters.zipCode, false)) {
        return true;
      }

      return false;
    },
    saveDisabled: function saveDisabled() {
      if (this.isEmptyData(this.newPriceModel.carrier) || this.isEmptyData(this.newPriceModel.country)) {
        return true;
      }

      if (!this.isValidFloat(this.newPriceModel.absoluteMoneyCost, true) || !this.isValidInteger(this.newPriceModel.maxVolume, true) || !this.isValidFloat(this.newPriceModel.priceByExtraWeight, true) || !this.isValidFloat(this.newPriceModel.pricePercent, true) || !this.isValidInteger(this.newPriceModel.timeCost, true) || !this.isValidInteger(this.newPriceModel.weightEnd, true) || !this.isValidInteger(this.newPriceModel.weightStart, true)) {
          return true;
        }

      if (this.validIntegerCompare(this.newPriceModel.weightEnd, this.newPriceModel.weightStart, true) !== '') {
        return true;
      }

      if (!this.isEmptyData(this.newPriceModel.zipCodeEnd) && !this.isEmptyData(this.newPriceModel.zipCodeStart) && this.validCPCompare(this.newPriceModel.zipCodeEnd, this.newPriceModel.zipCodeStart, true) !== '') {
        return true;
      }

      if (!this.isEmptyData(this.newPriceModel.zipCodeEnd) && !this.isValidCP(this.newPriceModel.zipCodeEnd, true)) {
        return true;
      }

      if (!this.isEmptyData(this.newPriceModel.zipCodeStart) && !this.isValidCP(this.newPriceModel.zipCodeStart, true)) {
        return true;
      }

      if (!this.isEmptyData(this.newPriceModel.zipCodeStart) && this.isEmptyData(this.newPriceModel.zipCodeEnd)) {
        return true;
      }

      if (this.isEmptyData(this.newPriceModel.zipCodeStart) && !this.isEmptyData(this.newPriceModel.zipCodeEnd)) {
        return true;
      }

      if (!this.isEmptyData(this.newPriceModel.zipCodeCommas) && !this.validZipCommas) {
        return true;
      }

      if (this.isEmptyData(this.newPriceModel.zipCodeEnd) && this.isEmptyData(this.newPriceModel.zipCodeStart) && this.isEmptyData(this.newPriceModel.zipCodeCommas)) {
        return true;
      }

      return false;
    }
  },
  data: function data() {
    return {
      comaMode: false,
      locale: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.LOCALE,
      currency: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.CURRENCY,
      countries: __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.COUNTRY_CODES,
      isAdmin: this.$store.getters.isAdmin,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      success: null,
      errorText: '',
      loading: true,
      toDelete: null,
      disableFilterButton: false,
      showFilters: false,
      carrierList: null,
      tags: [],
      newPriceModel: {
        id: null,
        absoluteMoneyCost: null,
        accountName: null,
        carrier: {
          id: null,
          name: null,
          slaType: null,
          accountName: null
        },
        country: null,
        maxVolume: null,
        minimumValueInsurance: 0,
        priceByExtraWeight: null,
        pricePercent: null,
        timeCost: 0,
        weightEnd: null,
        weightStart: null,
        zipCodeEnd: null,
        zipCodeStart: null,
        zipCodeCommas: null,
        zipCodes: []
      },
      filters: {
        accountName: null,
        zipCode: null,
        weight: null,
        maxVolume: null
      },
      sortBy: null,
      sortDesc: true,
      selected: [],
      currentPageElement: [],
      fieldsNotAdmin: [{ key: 'selected', label: ' ', 'class': 'text-left', sortable: false }, { key: 'carrier', label: 'Transportadora', 'class': 'text-left', sortable: false }, { key: 'zipCodeStart', label: 'Cód. Postal', 'class': 'text-left', sortable: false, thClass: 'zipCodesTh' }, { key: 'weightStart', label: 'Rango Peso', 'class': 'text-left', sortable: false }, { key: 'country', label: 'País', 'class': 'text-left', sortable: true }, { key: 'absoluteMoneyCost', label: 'Costo', 'class': 'text-left', sortable: true }, { key: 'timeCost', label: 'Plazo de entrega', 'class': 'text-left', sortable: true }, { key: 'actions', label: 'Acciones', _showDetails: false, sortable: false }],
      fieldsAdmin: [{ key: 'selected', label: ' ', 'class': 'text-left', sortable: false }, { key: 'carrier', label: 'Transportadora', 'class': 'text-left', sortable: false }, { key: 'zipCodeStart', label: 'Cód. Postal', 'class': 'text-left', sortable: false, thClass: 'zipCodesTh' }, { key: 'weightStart', label: 'Rango Peso', 'class': 'text-left', sortable: false }, { key: 'country', label: 'País', 'class': 'text-left', sortable: true }, { key: 'absoluteMoneyCost', label: 'Costo', 'class': 'text-left', sortable: true }, { key: 'timeCost', label: 'Plazo de entrega', 'class': 'text-left', sortable: true }],
      productGroupSelection: {
        options: [{ text: 'Seleccione una opción', value: null, disabled: true }, { text: 'Ninguno', value: 'Ninguno' }, { text: 'Todos en esta pagina', value: 'Todos en esta pagina' }, { text: 'Todos', value: 'Todos' }],
        current: null
      },
      currentActionGroupSelection: null,
      groupAction: null
    };
  },

  methods: {
    confirmationModalCancelHandler: function confirmationModalCancelHandler() {
      this.currentActionGroupSelection = null;
    },
    showActionModal: function showActionModal(action) {
      this.groupAction = action;
      this.$refs.confirmationModal.show();
    },
    confirmationModalOkHandler: function confirmationModalOkHandler() {
      this.successText = '';
      this.errorText = '';
      this.loading = true;
      switch (this.groupAction) {
        case 'Eliminar':
          this.deleteSelectedItems();
          break;
        case 'Activar':
          this.activateSelectedItems();
          break;
        case 'Rechazar':
          this.rejectSelectedItems();
          break;
        default:
          break;
      }
      this.currentActionGroupSelection = null;
    },
    handleRowCheckbox: function handleRowCheckbox() {
      this.productGroupSelection.current = null;
    },
    _execDelete: function _execDelete() {
      var _this2 = this;

      this.loading = true;
      this.deleteShippingrates(this.toDelete).then(function () {
        _this2.loading = false;
        _this2.$refs.mainTable.refresh();
      }, function (error) {
        _this2.errorText = error.body.message || 'Error eliminando el precio';
        _this2.loading = false;
      });
    },
    showDeteleModal: function showDeteleModal(context) {
      this.errorText = '';
      this.toDelete = context.item.id;
      this.$refs.deleteModal.show();
    },
    showCreateModal: function showCreateModal() {
      this.comaMode = false;
      this.newPriceModel.id = null;
      this.newPriceModel.absoluteMoneyCost = null;
      this.newPriceModel.carrier = {};
      this.newPriceModel.country = __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig_js___default.a.DEFAULT_COUNTRY;
      this.newPriceModel.maxVolume = null;
      this.newPriceModel.minimumValueInsurance = 0;
      this.newPriceModel.priceByExtraWeight = null;
      this.newPriceModel.pricePercent = null;
      this.newPriceModel.timeCost = 0;
      this.newPriceModel.weightEnd = null;
      this.newPriceModel.weightStart = null;
      this.newPriceModel.zipCodeEnd = null;
      this.newPriceModel.zipCodeStart = null;
      this.newPriceModel.zipCodeCommas = null;
      this.newPriceModel.zipCodes = null;
      this.tags = [];
      this.$refs.newPriceModal.show();
    },
    createPrice: function createPrice() {
      var _this3 = this;

      this.loading = true;
      this.newPriceModel.accountName = this.newPriceModel.carrier.accountName;
      if (this.newPriceModel.zipCodeCommas) {
        this.newPriceModel.zipCodes = this.newPriceModel.zipCodeCommas.split(',');
      }
      this.postShippingrates(this.newPriceModel).then(function () {
        _this3.loading = false;
        _this3.$refs.mainTable.refresh();
      }, function (error) {
        _this3.errorText = error.body.message || 'Error obteniendo el listado de precios';
        _this3.loading = false;
      });
    },
    rowDbClick: function rowDbClick(item) {
      this.comaMode = false;
      this.newPriceModel.id = item.id;
      this.newPriceModel.absoluteMoneyCost = item.absoluteMoneyCost;
      this.newPriceModel.accountName = item.accountName;
      this.newPriceModel.country = item.country;
      this.newPriceModel.maxVolume = item.maxVolume;
      this.newPriceModel.minimumValueInsurance = item.minimumValueInsurance;
      this.newPriceModel.priceByExtraWeight = item.priceByExtraWeight;
      this.newPriceModel.pricePercent = item.pricePercent;
      this.newPriceModel.timeCost = item.timeCost;
      this.newPriceModel.weightEnd = item.weightEnd;
      this.newPriceModel.weightStart = item.weightStart;
      this.newPriceModel.zipCodeEnd = item.zipCodeEnd;
      this.newPriceModel.zipCodeStart = item.zipCodeStart;
      this.newPriceModel.zipCodeCommas = null;
      this.newPriceModel.zipCodes = null;
      if (item.zipCodes) {
        this.newPriceModel.zipCodeCommas = item.zipCodes.toString();
        this.tags = this.newPriceModel.zipCodeCommas.split(',');
      } else {
        this.tags = [];
      }
      this.newPriceModel.carrier = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item.carrier);
      this.$refs.newPriceModal.show();
    },
    rowClick: function rowClick(item) {
      console.log(item);
    },
    productGroupSelectionHandler: function productGroupSelectionHandler(selectionType) {
      var _this4 = this;

      this.selected.splice(0, this.selected.length);
      var _this = this;
      switch (selectionType) {
        case 'Ninguno':
          break;
        case 'Todos en esta pagina':
          this.currentPageElement.forEach(function (item) {
            if (item.type !== 'ADMIN' || _this4.isAdmin) _this4.selected.push(item.id);
          });
          break;
        case 'Todos':
          this.loading = true;
          var tableinfo = { currentPage: 1, perPage: 100 };
          this.getShippinGrates(tableinfo, this.filters).then(function (response) {
            response.body.forEach(function (item) {
              if (item.type !== 'ADMIN' || _this4.isAdmin) _this.selected.push(item.id);
            });
            _this4.loading = false;
          });
          break;
        default:
          break;
      }
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    filterTable: function filterTable() {
      console.log('Filtros actuales:', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filters)));
      this.$refs.mainTable.refresh();
      this.errorText = '';
    },
    cleanFilters: function cleanFilters() {
      this.filters.accountName = null;
      this.filters.zipCode = null;
      this.filters.zipCodeEnd = null;
      this.filters.weight = null;
      this.filters.weightEnd = null;
      this.filters.maxVolume = null;
      this.filters.carrierId = null;
      this.$refs.mainTable.refresh();
    },
    itemProvider: function itemProvider(ctx) {
      var _this5 = this;

      this.loading = true;
      return this.getShippinGrates(ctx, this.filters).then(function (response) {
        _this5.loading = false;
        _this5.totalRows = parseInt(response.headers.get('X-Total-Count'));
        _this5.currentPageElement = response.body;
        return response.body;
      }, function (error) {
        _this5.errorText = error.body.message || 'Error obteniendo el listado de precios volumetricos';
        _this5.loading = false;
        return [];
      });
    },
    deleteSelectedItems: function deleteSelectedItems() {
      var _this6 = this;

      this.loading = true;
      this.deleteMultipleShippingrates(this.selected).then(function (response) {
        _this6.loading = false;
        _this6.selected = [];
        _this6.$refs.mainTable.refresh();
        return response.body;
      }, function (error) {
        _this6.errorText = error.body.message || 'Error obteniendo el listado de precios volumetricos';
        _this6.loading = false;
        return [];
      });
    },
    updateZipCodeComma: function updateZipCodeComma() {
      this.newPriceModel.zipCodeCommas = this.tags.join();
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    this.loading = true;
    var filter = {};
    if (!this.isAdmin) {
      filter.type = 'SELLER';
    }
    this.getCarriers(filter).then(function (carriers) {
      _this7.loading = false;
      _this7.carrierList = [{ text: 'Seleccione una transportadora', value: null, disabled: true }];
      _this7.carrierList = _this7.carrierList.concat(carriers.body.map(function (item) {
        return {
          'text': item.name,
          'value': {
            'id': item.id,
            'name': item.name,
            'accountName': item.accountName,
            'slaType': item.slaType,
            'factorCubicWeight': item.factorCubicWeight,
            'type': item.type,
            'isActive': item.isActive
          }
        };
      }).filter(function (a) {
        return a.value.isActive;
      }));
    }, function (error) {
      _this7.errorText = error.body.message || 'Error obteniendo el listado de precios volumetricos';
      _this7.loading = false;
    });
  }
});

/***/ }),
/* 1070 */,
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"animated fadeIn",attrs:{"fluid":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert","dismissible":""},on:{"dismised":function($event){_vm.errorText = ''}}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('button',{staticClass:"btn btn-primary float-right",attrs:{"type":"button"},on:{"click":_vm.showCreateModal}},[_vm._v("Crear nuevo precio")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showFilters = !_vm.showFilters}}},[_c('i',{staticClass:"fa",class:{'fa-times': _vm.showFilters, 'fa-filter': !_vm.showFilters}}),_vm._v(" Filtros\n      ")])])],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"filters mt-3 p-3 mb-3"},[_c('b-row',[(_vm.isAdmin)?_c('b-col',{attrs:{"md":"4"}},[_c('b-form-group',{staticClass:"mb-3",attrs:{"label":"Seller"}},[_c('b-form-select',{attrs:{"options":_vm.organizations},model:{value:(_vm.filters.accountName),callback:function ($$v) {_vm.$set(_vm.filters, "accountName", $$v)},expression:"filters.accountName"}},[_c('option',{attrs:{"slot":"first"},domProps:{"value":null},slot:"first"},[_vm._v("Todos")])])],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"zipCodeStartGroup","label-cols":4,"breakpoint":"md","description":"Se buscaran precios que sean aplicables al codigo postal ingresado","invalid-feedback":!_vm.isValidInteger(_vm.filters.zipCode, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filters.zipCode, false),"label":"Codigo Postal","label-for":"zipCodeStartInput"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"zipCodeStartInput"},model:{value:(_vm.filters.zipCode),callback:function ($$v) {_vm.$set(_vm.filters, "zipCode", $$v)},expression:"filters.zipCode"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"weightStartGroup","label-cols":4,"breakpoint":"md","label":"Peso","description":"Se buscaran precios que sean aplicables al peso ingresado","invalid-feedback":!_vm.isValidInteger(_vm.filters.weight, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filters.weight, false),"label-for":"weightStartInput"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"weightStartInput"},model:{value:(_vm.filters.weight),callback:function ($$v) {_vm.$set(_vm.filters, "weight", $$v)},expression:"filters.weight"}})],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"px-4 py-2",attrs:{"lg":"4"}},[_c('b-form-group',{attrs:{"id":"maxVolumeGroup","label-cols":4,"breakpoint":"md","description":"Se buscaran precios que sean aplicables al volumen ingresado","invalid-feedback":!_vm.isValidInteger(_vm.filters.maxVolume, false)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.filters.maxVolume, false),"label":"Volumen del paquete","label-for":"maxVolumeInput"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"maxVolumeInput"},model:{value:(_vm.filters.maxVolume),callback:function ($$v) {_vm.$set(_vm.filters, "maxVolume", $$v)},expression:"filters.maxVolume"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-input-group-button',{staticClass:"float-right mt-3"},[_c('b-button',{attrs:{"disabled":_vm.loading || _vm.filterDisabled,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('b-input-group-button',{staticClass:"float-right mt-3 mr-3"},[_c('b-button',{attrs:{"disabled":_vm.loading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Mostrar Todos")])],1)],1)],1)],1)]),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"md":"10"}},[_c('b',[_vm._v(_vm._s(_vm.totalRows))]),_vm._v(" precios encontrados  "+_vm._s(_vm.selected.length != 0 ? ("(" + (_vm.selected.length) + " seleccionados)") : "")+"\n    ")]),_vm._v(" "),_c('b-col',[_c('button',{staticClass:"btn btn-primary float-right mr-2",attrs:{"type":"button","disabled":_vm.selected.length === 0},on:{"click":function($event){_vm.showActionModal('Eliminar')}}},[_vm._v("Eliminar")])])],1),_vm._v(" "),_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Listado de precios para envíos"}},[_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-col',{staticClass:"my-2 pl-0",attrs:{"md":"3"}},[_c('b-form-select',{staticClass:"action-form-select",attrs:{"id":"selectProductGroup","options":_vm.productGroupSelection.options,"required":""},on:{"change":_vm.productGroupSelectionHandler},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.productGroupSelection.current),callback:function ($$v) {_vm.$set(_vm.productGroupSelection, "current", $$v)},expression:"productGroupSelection.current"}})],1),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","stacked":"xl","items":_vm.itemProvider,"foot-clone":"","fields":_vm.isAdmin ? _vm.fieldsAdmin: _vm.fieldsNotAdmin,"current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"empty-text":"No hay precios para mostrar","empty-filtered-text":"No hay precios para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-clicked":_vm.rowClick,"row-dblclicked":_vm.rowDbClick,"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"selected",fn:function(row){return [(row.item.type !== 'ADMIN' || _vm.isAdmin)?_c('b-form-checkbox',{staticClass:"ml-4",attrs:{"value":row.item.id},on:{"change":_vm.handleRowCheckbox},nativeOn:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e()]}},{key:"accountName",fn:function(row){return [_vm._v("\n          "+_vm._s(row.item.accountName? row.item.accountName : 'No definido')+"\n       ")]}},{key:"carrier",fn:function(row){return [_vm._v("\n         "+_vm._s(row.item.carrier.name)+" - "+_vm._s(row.item.carrier.slaType)+"\n       ")]}},{key:"zipCodeStart",fn:function(row){return [(row.item.zipCodeStart)?_c('span',[_vm._v(_vm._s(row.item.zipCodeStart)+" - "+_vm._s(row.item.zipCodeEnd))]):_c('span',[_vm._v(_vm._s(row.item.zipCodes.join(' ')))])]}},{key:"weightStart",fn:function(row){return [_vm._v("\n         "+_vm._s(row.item.weightStart)+" - "+_vm._s(row.item.weightEnd)+"\n       ")]}},{key:"absoluteMoneyCost",fn:function(row){return [_vm._v("\n         "+_vm._s(_vm.currency)+" "+_vm._s(row.item.absoluteMoneyCost)+"\n       ")]}},{key:"timeCost",fn:function(row){return [_vm._v("\n         "+_vm._s(row.item.timeCost)+" días\n       ")]}},{key:"actions",fn:function(row){return [(row.item.type !== 'ADMIN' || _vm.isAdmin)?_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){$event.stopPropagation();_vm.showDeteleModal(row)}}},[_vm._v("Eliminar")]):_vm._e()]}}])})],1),_vm._v(" "),_c('b-modal',{ref:"newPriceModal",attrs:{"ok-title":this.newPriceModel.id ? 'Guardar' : 'Crear',"ok-disabled":_vm.saveDisabled || (_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin),"header-bg-variant":"primary","size":"lg","id":"newPriceModal","centered":"","title":this.newPriceModel.id ? 'Editar precio' : 'Nuevo precio'},on:{"ok":_vm.createPrice}},[_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"carrier","label":"Transportadora"}},[_c('b-form-select',{attrs:{"oncontextmenu":"return false;","options":_vm.carrierList,"disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.carrier),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "carrier", $$v)},expression:"newPriceModel.carrier"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"country","label":"País"}},[_c('b-form-select',{attrs:{"oncontextmenu":"return false;","options":_vm.countries,"disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.country),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "country", $$v)},expression:"newPriceModel.country"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-3",attrs:{"lg":"12"}},[_c('b',[_vm._v("Costo de envío")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"absoluteMoneyCost","label-cols":2,"breakpoint":"md","description":"Tasa de envío según el rango y el peso del código postal","invalid-feedback":!_vm.isValidFloat(_vm.newPriceModel.absoluteMoneyCost, true)? 'No es un valor válido' : '',"state":_vm.isValidFloat(_vm.newPriceModel.absoluteMoneyCost, true),"label":"Precio","label-for":"zipCodeStartInput"}},[_c('b-form-input',{attrs:{"id":"absoluteMoneyCostInput","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.absoluteMoneyCost),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "absoluteMoneyCost", $$v)},expression:"newPriceModel.absoluteMoneyCost"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"timeCost","label-cols":2,"breakpoint":"md","label":_vm.rangeLabel,"invalid-feedback":!_vm.newPriceModel.timeCost? 'El plazo de entrega es obligatorio' : '',"state":_vm.newPriceModel.timeCost? true : false,"label-for":"timeCostInput"}},[_c('b-form-input',{attrs:{"id":"timeCostInput","type":"range","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin,"max":5},model:{value:(_vm.newPriceModel.timeCost),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "timeCost", $$v)},expression:"newPriceModel.timeCost"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"maxVolume","label-cols":2,"breakpoint":"md","invalid-feedback":!_vm.isValidInteger(_vm.newPriceModel.maxVolume, true)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.newPriceModel.maxVolume, true),"label":"Volumen máximo (Alto x Ancho x Largo - cm3)","label-for":"maxVolumeInput"}},[_c('b-form-input',{attrs:{"id":"timeCostInput","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.maxVolume),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "maxVolume", $$v)},expression:"newPriceModel.maxVolume"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"priceByExtraWeight","label-cols":2,"breakpoint":"md","label":"Valor adicional por peso (cobro extra por gramo)","description":"Se agregará un cobro adicional por gramo al producto. Por ejemplo se agrega $1 adicional por peso y el producto pesa 10 gramos, se agregara $10 al total.","invalid-feedback":!this.isValidFloat(_vm.newPriceModel.priceByExtraWeight, true)? 'No es un valor válido' : '',"state":this.isValidFloat(_vm.newPriceModel.priceByExtraWeight, true),"label-for":"priceByExtraWeightInput"}},[_c('b-form-input',{attrs:{"id":"timeCostInput","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.priceByExtraWeight),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "priceByExtraWeight", $$v)},expression:"newPriceModel.priceByExtraWeight"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"pricePercent","label-cols":2,"breakpoint":"md","label":"Valor adicional (% del valor del producto)","description":"Un porcentaje del valor del producto que se agregará al valor de flete. Ejemplo: si el valor del producto es $100 y el 1% adicional, se agregará $1 al valor de flete.","invalid-feedback":!this.isValidFloat(_vm.newPriceModel.pricePercent, true)? 'No es un valor válido' : '',"state":this.isValidFloat(_vm.newPriceModel.pricePercent, true),"label-for":"pricePercentInput"}},[_c('b-form-input',{attrs:{"id":"timeCostInput","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.pricePercent),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "pricePercent", $$v)},expression:"newPriceModel.pricePercent"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-3 separator pt-3",attrs:{"lg":"6"}},[_c('b',[_vm._v("Código postal")])]),_vm._v(" "),_c('b-col',{staticClass:"my-3 separator pt-3",attrs:{"lg":"6"}},[(false)?_c('b-form-group',{attrs:{"id":"commaModeGroup","label-cols":2,"breakpoint":"md","label":"¿Codigos postales separados por coma?"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"size":"m","id":"s0"},model:{value:(_vm.comaMode),callback:function ($$v) {_vm.comaMode=$$v},expression:"comaMode"}})],1):_vm._e()],1),_vm._v(" "),(!_vm.comaMode || true)?_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"zipCodeStart","label-cols":2,"breakpoint":"md","label":"Desde","invalid-feedback":!_vm.isEmptyData(_vm.newPriceModel.zipCodeStart) && !_vm.isValidCP(_vm.newPriceModel.zipCodeStart, true)? 'No es un valor válido' : '',"state":!_vm.isEmptyData(_vm.newPriceModel.zipCodeStart) && _vm.isValidCP(_vm.newPriceModel.zipCodeStart, true),"label-for":"zipCodeStartInput"}},[_c('b-form-input',{attrs:{"id":"zipStartEndInput","maxlength":"6","size":"6","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.zipCodeStart),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "zipCodeStart", $$v)},expression:"newPriceModel.zipCodeStart"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.comaMode || true)?_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"zipCodeEnd","label-cols":2,"breakpoint":"md","label":"Hasta","invalid-feedback":!_vm.isEmptyData(_vm.newPriceModel.zipCodeEnd) ? _vm.validCPCompare(_vm.newPriceModel.zipCodeEnd, _vm.newPriceModel.zipCodeStart, true) : '',"state":!_vm.isEmptyData(_vm.newPriceModel.zipCodeEnd) && _vm.validCPCompare(_vm.newPriceModel.zipCodeEnd, _vm.newPriceModel.zipCodeStart, true) === '',"label-for":"zipCodeEndInput"}},[_c('b-form-input',{attrs:{"id":"zipCodeEndInput","maxlength":"6","size":"6","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.zipCodeEnd),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "zipCodeEnd", $$v)},expression:"newPriceModel.zipCodeEnd"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.comaMode || true)?_c('b-col',{attrs:{"lg":"12"}},[_c('b-form-group',{attrs:{"id":"zipCodeCommas","label-cols":2,"breakpoint":"md","invalid-feedback":!_vm.validZipCommas ? 'Revisar los valores de los CP, uno a varios son incorrectos' : '',"state":_vm.validZipCommas,"label-for":"zipCodeCommaInput"}},[_c('b-form-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"zipCodeCommaInput","size":"6","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.zipCodeCommas),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "zipCodeCommas", $$v)},expression:"newPriceModel.zipCodeCommas"}}),_vm._v(" "),((_vm.isEmptyData(_vm.newPriceModel.zipCodeStart) && !_vm.isEmptyData(_vm.newPriceModel.zipCodeEnd)) || (!_vm.isEmptyData(_vm.newPriceModel.zipCodeStart) && _vm.isEmptyData(_vm.newPriceModel.zipCodeEnd)))?_c('div',{staticClass:"invalid-feedback d-block mb-3 mt-0",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v("El rango desde/hasta no debe contener valores vacíos")]):_vm._e(),_vm._v(" "),_c('div',[_c('p',{staticClass:"mb-0 mt-2",staticStyle:{"line-height":"16px"}},[_vm._v("Códigos individuales")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Escribir el código y presionar enter, coma o tab para agregarlo")]),_vm._v(" "),_c('input-tag',{staticClass:"w-100",staticStyle:{"min-height":"30px"},attrs:{"placeholder":"Agregar CP","validate":"digits","add-tag-on-keys":[13,188,9],"read-only":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},on:{"input":_vm.updateZipCodeComma},model:{value:(_vm.tags),callback:function ($$v) {_vm.tags=$$v},expression:"tags"}})],1),_vm._v(" "),(_vm.isEmptyData(_vm.newPriceModel.zipCodeCommas) && _vm.isEmptyData(_vm.newPriceModel.zipCodeStart) && _vm.isEmptyData(_vm.newPriceModel.zipCodeEnd))?_c('div',{staticClass:"invalid-feedback d-block mt-3",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v("Ingresar rango o códigos postales individuales")]):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"my-3 separator pt-3",attrs:{"lg":"12"}},[_c('b',[_vm._v("Rango de peso (gramos)")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"weightStart","label-cols":2,"breakpoint":"md","label":"Desde","invalid-feedback":!_vm.isValidInteger(_vm.newPriceModel.weightStart, true)? 'No es un valor válido' : '',"state":_vm.isValidInteger(_vm.newPriceModel.weightStart, true),"label-for":"weightStartInput"}},[_c('b-form-input',{attrs:{"id":"weightStartInput","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.weightStart),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "weightStart", $$v)},expression:"newPriceModel.weightStart"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"id":"weightEnd","label-cols":2,"breakpoint":"md","label":"Hasta","invalid-feedback":_vm.validIntegerCompare(_vm.newPriceModel.weightEnd, _vm.newPriceModel.weightStart, true),"state":_vm.validIntegerCompare(_vm.newPriceModel.weightEnd, _vm.newPriceModel.weightStart, true) === '',"label-for":"weightEndInput"}},[_c('b-form-input',{attrs:{"id":"weightEndInput","disabled":_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin},model:{value:(_vm.newPriceModel.weightEnd),callback:function ($$v) {_vm.$set(_vm.newPriceModel, "weightEnd", $$v)},expression:"newPriceModel.weightEnd"}})],1)],1)],1),_vm._v(" "),_c('b-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.newPriceModel.carrier.type === 'ADMIN' && !_vm.isAdmin ? true : false),expression:"newPriceModel.carrier.type === 'ADMIN' && !isAdmin ? true : false"}]},[_c('b-col',{attrs:{"md":"12"}},[_vm._v("\n        Transportadora gestionada por el administrador, los valores no se pueden modificar.\n      ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"deleteModal",attrs:{"centered":"","header-bg-variant":"primary","id":"deleteModal","size":"lg","title":"Confirmar eliminar precio","o-close-on-backdrop":"true","cancel-title":"Cancelar","ok-title":"Eliminar"},on:{"ok":_vm._execDelete}},[_vm._v("\n    Confirma que desea eliminar este precio?\n  ")]),_vm._v(" "),_c('b-modal',{ref:"confirmationModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationModal","centered":"","title":"Confirmación","cancel-title":"Cancelar"},on:{"ok":_vm.confirmationModalOkHandler,"cancel":_vm.confirmationModalCancelHandler}},[(_vm.selected.length > 0)?[(_vm.selected.length > 1)?_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.groupAction)+" los "+_vm._s(_vm.selected.length)+" precios seleccionados?")]):_vm._e(),_vm._v(" "),(_vm.selected.length == 1)?_c('p',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.groupAction)+" el precio seleccionado?")]):_vm._e()]:_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('shipping-grates-list')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPricesCSVView_vue__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25dc4449_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPricesCSVView_vue__ = __webpack_require__(1079);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPricesCSVView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25dc4449_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPricesCSVView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_carrier_AddPricesCSV__ = __webpack_require__(1075);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-prices-csv-view',
  components: {
    AddPricesCSV: __WEBPACK_IMPORTED_MODULE_0__components_carrier_AddPricesCSV__["a" /* default */]
  }
});

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPricesCSV_vue__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f79b54b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPricesCSV_vue__ = __webpack_require__(1078);
function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f79b54b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPricesCSV_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f79b54b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPricesCSV_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_papaparse__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_papaparse__);








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_3__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */]],
  methods: {
    resetCSVPricesFile: function resetCSVPricesFile() {
      this.$refs.filePricestInput.reset();
    },
    itemProvider: function itemProvider(tableComponentInfo) {
      var start = (tableComponentInfo.currentPage - 1) * tableComponentInfo.perPage;
      var end = tableComponentInfo.perPage * tableComponentInfo.currentPage;
      return this.csvElements.slice(start, end);
    },
    showProcessConfirm: function showProcessConfirm() {
      this.$refs.processCSVModal.show();
    },
    processAltaPrecios: function processAltaPrecios() {
      this.uploadPricesFile();
    },
    downloadPriceFile: function downloadPriceFile() {
      var _this = this;

      this.errorText = '';
      this.getShippingRatesPriceList().then(function (csvFile) {
        var headers = csvFile.headers;
        var blob = new Blob([csvFile.body], {
          type: { type: headers.map['content-type'] }
        });
        var blobURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', 'shippingRatesPriceList.csv');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
      }, function () {
        _this.errorText = 'Error procesando la descarga';
      });
    },
    uploadPricesFile: function uploadPricesFile() {
      var _this2 = this;

      this.inProgress = true;
      this.success = false;
      this.errorText = '';
      var formData = new FormData();
      formData.append('file', this.csvPricesFile);
      this.uploadCsvShippingRatesPriceList(formData, this.delimiter).then(function () {
        _this2.inProgress = false;
        _this2.success = true;
      }, function (error) {
        _this2.inProgress = false;
        _this2.errorText = error.body.message || 'Error procesando el archivo CSV - ' + _this2.csvPricesFile.name;

        _this2.csvElements.forEach(function (elem, index) {
          elem._rowVariant = 'danger';
        });
        _this2.$refs.productsTable.refresh();
      });
    },
    onFileAttrChanged: function onFileAttrChanged(evt) {
      this.errorText = '';
      this.success = false;
    },
    onFileChanged: function onFileChanged(evt) {
      var _this3 = this;

      var self = this;
      this.errorText = '';
      this.success = false;
      this.csvElements = [];
      self.$refs.productsTable.refresh();
      var file = evt.target.files[0];
      if (!file) {
        return;
      }

      var reader = new FileReader();

      reader.onload = function (evt) {
        try {
          self.tabIndex = 1;
          var rowError = false;
          var parsedData = __WEBPACK_IMPORTED_MODULE_4_papaparse___default.a.parse(evt.target.result.trim(), {
            delimiter: '',
            skipEmptyLines: true,
            encoding: 'ISO-8859-1'
          });

          if (parsedData.errors.length > 0) {
            self.errorText = 'El archivo tiene un formato que no es soportado';
            self.$refs.fileProductInput.reset();
            return;
          }

          self.delimiter = parsedData.meta.delimiter;

          var header = parsedData.data.shift();
          if (header.length !== 13) {
            self.errorText += 'La cabecera del archivo CSV debe tener 13 columnas.';
            self.errorText += '<ul>';
            self.errorText += '<li>Verificar que la cabecera es "Id","Código postal desde", "Código postal hasta", "Peso desde", "Peso hasta", "Precio","Valor adicional (% del valor del producto)", "Valor adicional por peso", "Volumen máximo", "Plazo de entrega", "País", "Transportadora", "Códigos Postales"</li>';
            self.errorText += '</ul>';

            return;
          }

          if (parsedData.data.length === 0) {
            self.errorText = 'El archivo CSV está vacío. Debe contener al menos un precio para procesar.';
            self.$refs.filePricestInput.reset();
            self.csvPricesFile = null;
            self.tabIndex = 0;
            return;
          }

          _this3.productsCount = parsedData.data.length;
          parsedData.data.forEach(function (elem, index) {
            var newRowElem = {
              'id': elem[0],
              'zcFrom': elem[1],
              'zcTO': elem[2],
              'weightFrom': elem[3],
              'weightTo': elem[4],
              'price': elem[5],
              'addicionalValue': elem[6],
              'weightaddicionalValue': elem[7],
              'maxVolume': elem[8],
              'deliveryWindow': elem[9],
              'country': elem[10],
              'carrier': elem[11],
              'zcCommas': elem[12],
              '_cellVariants': null
            };
            if (elem.length !== 13) {
              rowError = true;
              newRowElem = { '_cellVariants': null };
              newRowElem.sku = 'Faltan ' + (13 - elem.length) + ' campos';
            } else {
              newRowElem._cellVariants = {};
              var hasEmptyFields = _this3.testEmptyFields(elem, newRowElem);

              rowError = hasEmptyFields || _this3.testZipCodes(elem[1], elem[2], elem[12], newRowElem) || _this3.testPrices(elem[5], elem[6], elem[7], newRowElem) || _this3.testWeight(elem[3], elem[4], newRowElem) || !_this3.isValidInteger(elem[8]) || !_this3.isValidInteger(elem[9]) || _this3.isValidInteger(elem[9]) && elem[9] > 5 || _this3.testCountry(elem[10], newRowElem) || _this3.testCarrier(elem[11], newRowElem);
            }
            if (rowError) {
              self.errorText = 'Hay filas con errores en el archivo CSV';
              self.errorText += '<ul>';
              self.errorText += '<li>Verifique que las filas tengan 13 items igual que la cabecera.</li>';
              self.errorText += '<li>Verifique que las fechas tengan formtato YYYY-MM-DD.</li>';
              self.errorText += '<li>Verifique que los precios sean números válidos.</li>';
              if (_this3.testCarrier(elem[11], newRowElem)) {
                self.errorText += '<li>Verifique que las transportadoras sean válidas.</li>';
              }
              if (_this3.isValidInteger(elem[9]) && elem[9] > 5) {
                newRowElem._cellVariants.deliveryWindow = 'danger';
                self.errorText += '<li>Verifique que el plazo de entrega no sea mayor a 5.</li>';
              }
              if (!_this3.isValidInteger(elem[9])) {
                newRowElem._cellVariants.deliveryWindow = 'danger';
                self.errorText += '<li>Verifique que el plazo de entrega sea un numéro válido.</li>';
              }
              self.errorText += '</ul>';

              if (newRowElem._cellVariants === null) {
                newRowElem._rowVariant = 'danger';
              }
            } else {
              newRowElem._rowVariant = 'success';
            }
            self.csvElements.push(newRowElem);
          });
          _this3.$refs.productsTable.refresh();
        } catch (err) {
          console.log(err);
          _this3.errorText = 'El archivo CSV de precios tiene fallas';
        }
      };
      reader.readAsText(file, 'ISO-8859-1');
    },
    testEmptyFields: function testEmptyFields(elem, newRowElem) {
      var hasError = false;

      if (!elem[0] || elem[0].trim() === '') {
        newRowElem._cellVariants.id = 'danger';
        hasError = true;
      }

      var hasRange = elem[1] && elem[1].trim() !== '' && elem[2] && elem[2].trim() !== '';
      var hasIndividual = elem[12] && elem[12].trim() !== '';

      if (!hasRange && !hasIndividual) {
        newRowElem._cellVariants.zcFrom = 'danger';
        newRowElem._cellVariants.zcTO = 'danger';
        newRowElem._cellVariants.zcCommas = 'danger';
        hasError = true;
      }

      if (!elem[3] || elem[3].trim() === '') {
        newRowElem._cellVariants.weightFrom = 'danger';
        hasError = true;
      }

      if (!elem[4] || elem[4].trim() === '') {
        newRowElem._cellVariants.weightTo = 'danger';
        hasError = true;
      }

      if (!elem[5] || elem[5].trim() === '') {
        newRowElem._cellVariants.price = 'danger';
        hasError = true;
      }

      if (!elem[6] || elem[6].trim() === '') {
        newRowElem._cellVariants.addicionalValue = 'danger';
        hasError = true;
      }

      if (!elem[7] || elem[7].trim() === '') {
        newRowElem._cellVariants.weightaddicionalValue = 'danger';
        hasError = true;
      }

      if (!elem[8] || elem[8].trim() === '') {
        newRowElem._cellVariants.maxVolume = 'danger';
        hasError = true;
      }

      if (!elem[9] || elem[9].trim() === '') {
        newRowElem._cellVariants.deliveryWindow = 'danger';
        hasError = true;
      }

      if (!elem[10] || elem[10].trim() === '') {
        newRowElem._cellVariants.country = 'danger';
        hasError = true;
      }

      if (!elem[11] || elem[11].trim() === '') {
        newRowElem._cellVariants.carrier = 'danger';
        hasError = true;
      }

      return hasError;
    },
    testCarrier: function testCarrier(carrier, newRowElem) {
      var ret = true;
      var isAdmin = this.$store.getters.isAdmin;
      this.$store.getters.carriers.forEach(function (item, index) {
        if (item.name === carrier && item.isActive) {
          ret = false;
          if (item.isActive && item.type === 'ADMIN' && !isAdmin) {
            ret = true;
          } else return false;
        }
      });
      if (ret) {
        newRowElem._cellVariants.carrier = 'danger';
        return true;
      }
      return false;
    },
    testCountry: function testCountry(country, newRowElem) {
      var ret = true;
      __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.COUNTRY_CODES.forEach(function (elem, index) {
        if (elem.value === country) {
          ret = false;
          return false;
        }
      });
      if (ret) {
        newRowElem._cellVariants.country = 'danger';
        return true;
      }
      return false;
    },
    testZipCodes: function testZipCodes(zcFrom, zcTO, zcCommas, newRowElem) {
      var _this4 = this;

      var ret = false;
      if (this.isValidCP(zcFrom) && this.isValidCP(zcTO)) {
        return false;
      } else {
        var zips = zcCommas.split('|');
        zips.forEach(function (elem, index) {
          if (!_this4.isValidCP(elem)) {
            ret = true;
            return true;
          }
        });
      }
      if (ret) {
        newRowElem._cellVariants.zcFrom = 'danger';
        newRowElem._cellVariants.zcTO = 'danger';
        newRowElem._cellVariants.zcCommas = 'danger';
        return true;
      }
    },
    testWeight: function testWeight(weightFrom, weightTo, newRowElem) {
      if (!this.isValidFloat(weightFrom, true, false)) {
        newRowElem._cellVariants.weightTo = 'danger';
        return true;
      }
      if (!this.isValidFloat(weightTo, true, false)) {
        newRowElem._cellVariants.weightTo = 'danger';
        return true;
      }
      if (Number(weightTo) < Number(weightFrom)) {
        newRowElem._cellVariants.weightTo = 'danger';
        return true;
      }
      return false;
    },
    testPrices: function testPrices(price, addicionalValue, weightaddicionalValue, newRowElem) {
      if (isNaN(price) || Number(price) < 0) {
        newRowElem._cellVariants.price = 'danger';
        return true;
      }

      if (isNaN(addicionalValue) || Number(addicionalValue) < 0 || Number(addicionalValue) > 100) {
        newRowElem._cellVariants.addicionalValue = 'danger';
        return true;
      }

      if (isNaN(weightaddicionalValue) || Number(weightaddicionalValue) < 0) {
        newRowElem._cellVariants.weightaddicionalValue = 'danger';
        return true;
      }

      return false;
    }
  },
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 70, 100, 1000],
      tabIndex: 0,
      success: false,
      inProgress: false,
      productsCount: 0,
      errorText: '',
      debugFileExtencion: '',
      delimiter: null,
      csvPricesFile: null,
      csvElements: [],
      csvFields: [{ key: 'id', label: 'Id' }, { key: 'zcFrom', label: 'CP desde' }, { key: 'zcTO', label: 'CP hasta' }, { key: 'weightFrom', label: 'Peso desde' }, { key: 'weightTo', label: 'Peso hasta' }, { key: 'price', label: 'Precio' }, { key: 'addicionalValue', label: 'Valor adicional (%)' }, { key: 'weightaddicionalValue', label: 'Valor adicional por peso' }, { key: 'maxVolume', label: 'Volumen Máximo' }, { key: 'deliveryWindow', label: 'Plazo de entrega' }, { key: 'country', label: 'Pais' }, { key: 'carrier', label: 'Transportadora' }, { key: 'zcCommas', label: 'CP commas' }]
    };
  }
});

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v("\n    "+_vm._s(_vm.errorText)+"\n  ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.success),expression:"success"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n    Los precios fueron cambiados con éxito\n  ")]),_vm._v(" "),_c('b-modal',{ref:"processCSVModal",attrs:{"header-bg-variant":"primary","centered":"","id":"processCSVModal","size":"lg","title":"Guardar los cambios de precio","o-close-on-backdrop":"true","cancel-title":"Cancelar"},on:{"ok":_vm.processAltaPrecios}},[_vm._v("\n    ¿Desea guardar los cambios de precios seleccionados?\n  ")]),_vm._v(" "),_c('h4',[_vm._v("Actualización masiva de precios")]),_vm._v(" "),_c('b-row',{staticClass:"my-3"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-button',{staticClass:"float-right mr-2",attrs:{"disabled":!Boolean(_vm.csvPricesFile) || _vm.errorText !== '',"variant":"primary"},on:{"click":_vm.showProcessConfirm}},[_vm._v("Procesar")]),_vm._v(" "),_c('b-button',{staticClass:"float-right mr-2",attrs:{"variant":"primary"},on:{"click":_vm.downloadPriceFile}},[_vm._v("Obtener listado actual de precios CSV")])],1)],1),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.inProgress,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"Seleccione un archivo","active":""}},[_c('h5',[_vm._v("Subir archivo CSV a procesar")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!Boolean(_vm.csvPricesFile)),expression:"!Boolean(csvPricesFile)"}],staticClass:"alert alert-warning"},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("Se debe seleccionar un CSV para continuar.")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(Boolean(_vm.csvPricesFile)),expression:"Boolean(csvPricesFile)"}]},[_vm._v("Archivo CSV seleccionado: "),_c('strong',[_vm._v(_vm._s(_vm.csvPricesFile && _vm.csvPricesFile.name))])]),_vm._v(" "),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-file',{ref:"filePricestInput",attrs:{"id":"csvPricesFile","no-drop":true,"accept":".csv","placeholder":"Lista Precios CSV"},on:{"change":_vm.onFileChanged},nativeOn:{"click":function($event){_vm.$refs.filePricestInput.reset()}},model:{value:(_vm.csvPricesFile),callback:function ($$v) {_vm.csvPricesFile=$$v},expression:"csvPricesFile"}})],1)],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Previsualización de datos","disabled":!Boolean(_vm.csvPricesFile)}},[_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.productsCount,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Previsualizacion"}},[_c('h5',[_vm._v("Previsualización de precios a actualizar")]),_vm._v(" "),_c('p',[_vm._v("Cantidad de Precios: "),_c('strong',[_vm._v(_vm._s(_vm.productsCount))])]),_vm._v(" "),_c('div',{staticClass:"w-100 overflow-x-auto"},[_c('b-table',{ref:"productsTable",attrs:{"items":_vm.itemProvider,"current-page":_vm.currentPage,"per-page":_vm.perPage,"hover":"","fields":_vm.csvFields,"small":true,"show-empty":"","striped":"","empty-text":"No hay precios para mostrar","hover":"","stacked":"lg","foot-clone":""}})],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-prices-c-s-v')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAndBrandUpdaterView_vue__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4335bd5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAndBrandUpdaterView_vue__ = __webpack_require__(1087);
function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4335bd5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAndBrandUpdaterView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4335bd5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAndBrandUpdaterView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_catalog_CategoryAndBrandUpdater__ = __webpack_require__(1083);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'category-and-brand-updater-view',
  components: {
    CategoryAndBrandUpdater: __WEBPACK_IMPORTED_MODULE_0__components_catalog_CategoryAndBrandUpdater__["a" /* default */]
  },
  mixins: [],
  methods: {},
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAndBrandUpdater_vue__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a00a93_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAndBrandUpdater_vue__ = __webpack_require__(1086);
function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38a00a93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryAndBrandUpdater_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38a00a93_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryAndBrandUpdater_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__ = __webpack_require__(14);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'category-and-brand-updater',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_ProductServiceMixim_js__["c" /* ProductServiceMixim */]],
  methods: {
    migrate: function migrate(item) {
      var _this = this;

      this.inProgress = true;
      this.errorText = '';
      this.successText = '';
      var endpoint = __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/' + item + '/migrate';

      return this.$http.post(endpoint, {}, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).then(function () {
        _this.inProgress = false;
        _this.successText = 'La actualizaci\xF3n de ' + (item === 'brands' ? 'Marcas' : 'Catagorías') + ' ha comenzado, validar en 15 minutos (aprox.)';
        if (item === 'brands') {
          _this.disableBrands = true;
        } else {
          _this.disableCategories = true;
        }
      }, function (error) {
        _this.inProgress = false;
        _this.errorText = error.body.message || 'Error migrando los datos para ' + (item === 'brands' ? 'Marcas' : 'Catagorías') + ' a Seller Center';
      });
    }
  },
  data: function data() {
    return {
      inProgress: false,
      successText: '',
      errorText: '',
      disableBrands: false,
      disableCategories: false
    };
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.successText !== ''),expression:"successText !== ''"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.successText)+"\n    ")])]),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.inProgress,"color":"#666","size":"30px"}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('p',[_vm._v("Actualizar marcas")]),_vm._v(" "),_c('b-button',{staticClass:"float-left ml-5 pr-5 pl-5",attrs:{"disabled":_vm.inProgress || _vm.disableBrands,"variant":"primary"},on:{"click":function($event){_vm.migrate('brands')}}},[_vm._v("Actualizar")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-5"},[_c('p',[_vm._v("Actualizar categorías")]),_vm._v(" "),_c('b-button',{staticClass:"float-left ml-5 pr-5 pl-5",attrs:{"disabled":_vm.inProgress || _vm.disableCategories,"variant":"primary"},on:{"click":function($event){_vm.migrate('categories')}}},[_vm._v("Actualizar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('category-and-brand-updater')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributesUpdaterView_vue__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80406c8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributesUpdaterView_vue__ = __webpack_require__(1095);
function injectStyle (ssrContext) {
  __webpack_require__(1089)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80406c8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributesUpdaterView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80406c8a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributesUpdaterView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_catalog_AttributesUpdater__ = __webpack_require__(1091);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'attributes-updater-view',
  components: {
    AttributesUpdater: __WEBPACK_IMPORTED_MODULE_0__components_catalog_AttributesUpdater__["a" /* default */]
  },
  mixins: [],
  methods: {},
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributesUpdater_vue__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d286d2c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributesUpdater_vue__ = __webpack_require__(1094);
function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d286d2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributesUpdater_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d286d2c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributesUpdater_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'attributes-updater',
  components: {
    MoonLoader: __WEBPACK_IMPORTED_MODULE_1_vue_spinner_src_MoonLoader_vue__["a" /* default */]
  },
  mixins: [],
  methods: {
    migrate: function migrate(item) {
      var _this = this;

      this.inProgress = true;
      this.errorText = '';
      this.successText = '';
      var endpoint = __WEBPACK_IMPORTED_MODULE_0__config_applicationConfig_js___default.a.API_END_POINT + '/specifications/migrate?isStockKeepingUnit=' + (item === 'products' ? 'false' : 'true');
      console.log(this.$store.state.access_token);
      return this.$http.get(endpoint, {
        headers: {
          Authorization: 'Bearer ' + this.$store.state.access_token
        }
      }).then(function () {
        _this.inProgress = false;
        _this.successText = 'La actualizaci\xF3n de ' + (item === 'products' ? 'productos (atributos)' : 'variantes (atributos)') + ' ha comenzado, validar en 15 minutos (aprox.)';
        if (item === 'product') {
          _this.disableProduct = true;
        } else {
          _this.disableVariants = true;
        }
      }, function (error) {
        _this.inProgress = false;
        _this.errorText = error.body.message || 'Error migrando los datos para ' + (item === 'products' ? 'Productos' : 'Variantes') + ' a Seller Center';
      });
    }
  },
  data: function data() {
    return {
      inProgress: false,
      successText: '',
      errorText: '',
      disableProducts: false,
      disableVariants: false
    };
  }
});

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorText !== ''),expression:"errorText !== ''"}],staticClass:"alert alert-danger",attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.successText !== ''),expression:"successText !== ''"}],staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n      "+_vm._s(_vm.successText)+"\n    ")])]),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.inProgress,"color":"#666","size":"30px"}}),_vm._v(" "),_c('b-row',[_c('b-col',[_c('p',[_vm._v("Especificaciones productos")]),_vm._v(" "),_c('b-button',{staticClass:"float-left ml-5 pr-5 pl-5",attrs:{"disabled":_vm.inProgress || _vm.disableProducts,"variant":"primary"},on:{"click":function($event){_vm.migrate('products')}}},[_vm._v("Actualizar")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-5"},[_c('p',[_vm._v("Especificaciones variantes")]),_vm._v(" "),_c('b-button',{staticClass:"float-left ml-5 pr-5 pl-5",attrs:{"disabled":_vm.inProgress || _vm.disableVariants,"variant":"primary"},on:{"click":function($event){_vm.migrate('variants')}}},[_vm._v("Actualizar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('attributes-updater')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoList_vue__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6fbfb0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoList_vue__ = __webpack_require__(1103);
function injectStyle (ssrContext) {
  __webpack_require__(1097)
  __webpack_require__(1098)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e6fbfb0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e6fbfb0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_promotion_PromoDetails_vue__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixims_PromotionsServiceMixim__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_vue_autocomplete__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_datepicker_index_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_datepicker__ = __webpack_require__(55);

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoList',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixims_ProductServiceMixim__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_7__mixims_ValidationsMixim_js__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_AdminServiceMixin__["b" /* OrganizationService */], __WEBPACK_IMPORTED_MODULE_6__mixims_PromotionsServiceMixim__["a" /* PromotionsServiceMixim */]],
  components: {
    autocomplete: __WEBPACK_IMPORTED_MODULE_9__components_common_vue_autocomplete__["a" /* default */],
    MoonLoader: __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_MoonLoader_vue__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_12_vue2_datepicker__["default"],
    PromoDetails: __WEBPACK_IMPORTED_MODULE_3__components_promotion_PromoDetails_vue__["a" /* default */]
  },
  props: [],
  data: function data() {
    return {
      lang: {
        formatLocale: {
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],

          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],

          weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],

          weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vier', 'Sab'],

          weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
        }
      },
      currency: __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default.a.CURRENCY,
      locale: __WEBPACK_IMPORTED_MODULE_8__config_applicationConfig_js___default.a.LOCALE,
      isAdmin: this.$store.getters.isAdmin,
      loading: false,
      modalTitle: '',
      errorText: '',
      showFilters: false,
      successText: '',
      cancelation: {
        text: '',
        title: '',
        confirm: ''
      },
      promo: {
        id: null,
        name: null,
        description: null,
        isActive: false,
        beginDate: null,
        endDate: null,
        promoType: 'Nominal',
        promoValue: null,
        nominalDiscountValue: 0,
        percentualDiscountValue: 0,
        sellers: [],
        marketplaces: [],
        brands: [],
        products: [],
        categories: [],
        userType: null
      },
      filter: {
        text: null,
        isActive: null,
        range: [],
        brands: [],
        products: [],
        categories: [],
        sellers: [],
        marketplaces: []
      },
      fields: [{ key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'nominalDiscountValue', label: 'Nominal', 'class': 'text-left', sortable: true }, { key: 'description', label: 'Descripción', 'class': 'text-left', sortable: false }, { key: 'percentualDiscountValue', label: 'Descuento %', 'class': 'text-left', sortable: true }, { key: 'name', label: 'Nombre', 'class': 'text-left', sortable: true }, { key: 'beginDate', label: 'Inicio', 'class': 'text-left', sortable: true }, { key: 'endDate', label: 'Fin', 'class': 'text-left', sortable: true }, { key: 'userType', label: 'Usuario', 'class': 'text-left', sortable: true }, { key: 'isActive', label: 'Activa', 'class': 'text-left', sortable: true }, { key: 'actions', label: ' ', 'class': 'text-right' }],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      sortBy: 'id',
      sortDesc: true
    };
  },

  methods: {
    refreshTable: function refreshTable(data) {
      this.$refs.mainTable.refresh();
      if (data.key === 'successText') {
        this.successText = data.value;
      } else {
        this.errorText = data.value;
      }
    },
    showDeleteConfirm: function showDeleteConfirm(promo) {
      var _this2 = this;

      this.cancelation.text = '\xBFEsta seguro de elimina la promoci\xF3n <b>' + promo.name + '</b>?';
      this.cancelation.title = 'Eliminar ' + promo.name;
      this.errorText = '';
      this.successText = '';
      this.cancelation.confirm = function () {
        _this2.loading = true;
        _this2.deletePromotion(promo.id).then(function () {
          _this2.successText = '\xBFLa promoci\xF3n  <b>' + promo.name + '</b> fue eliminada con exito?';
          _this2.loading = false;
          _this2.$refs.mainTable.refresh();
        }, function () {
          _this2.errorText = 'No se pudo eliminar <b>' + promo.name + '</b>?';
          _this2.loading = false;
        });
      };
      this.$refs.confirmationdDeleteModal.show();
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.disableEditionlength;
      this.currentPage = 1;
    },
    itemProvider: function itemProvider(tableFilterInfo) {
      var _this3 = this;

      this.successText = '';
      this.errorText = '';
      this.tableFilterInfo = tableFilterInfo;
      this.loading = true;
      return this.getPromotionsCatalog(tableFilterInfo, this.filter).then(function (response) {
        _this3.loading = false;
        _this3.totalRows = parseInt(response.headers.get('X-Total-Count'));
        return response.body;
      }, function (error) {
        _this3.loading = false;
        _this3.errorText = error.body.message || 'Error obteniendo las promociones';
        return [];
      });
    },
    filterTable: function filterTable() {
      this.$refs.mainTable.refresh();
    },
    cleanFilters: function cleanFilters() {
      this.filter.text = '';
      this.filter.isActive = null;
      this.filter.range.splice(0, this.filter.range.length);
      this.filter.brands.splice(0, this.filter.brands.length);
      this.filter.products.splice(0, this.filter.products.length);
      this.filter.categories.splice(0, this.filter.categories.length);
      this.filter.sellers.splice(0, this.filter.sellers.length);
      this.filter.marketplaces.splice(0, this.filter.marketplaces.length);
      this.filterTable();
    },
    promoClicked: function promoClicked(item) {
      this.errorText = '';
      this.successText = '';
      this.showModal(JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item)));
    },
    showModal: function showModal(item) {
      var _this = this;
      if (item && item.id) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(item).forEach(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          if (Array.isArray(value)) {
            _this.promo[key] = item[key].slice(0, item[key].length);
          } else {
            if (['brands', 'categories', 'products', 'sellers', 'marketplaces'].includes(key)) {
              _this.promo[key].splice(0, _this.promo[key]);
            } else {
              _this.promo[key] = value;
            }
          }
        });
        if (item.nominalDiscountValue > 0) {
          this.promo.promoValue = item.nominalDiscountValue;
          this.promo.promoType = 'Nominal';
        } else {
          this.promo.promoValue = item.percentualDiscountValue;
          this.promo.promoType = 'Porcentual';
        }
      } else {
        this.promo.id = null;
        this.promo.name = null;
        this.promo.isActive = false;
        this.promo.beginDate = null;
        this.promo.endDate = null;
        this.promo.description = null;
        this.promo.promoType = 'Nominal';
        this.promo.nominalDiscountValue = 0;
        this.promo.percentualDiscountValue = 0;
        this.promo.promoValue = null;
        this.promo.userType = null;
        this.promo.brands.splice(0, this.promo.brands.length);
        this.promo.products.splice(0, this.promo.products.length);
        this.promo.categories.splice(0, this.promo.categories.length);
        this.promo.sellers.splice(0, this.promo.sellers.length);
        this.promo.marketplaces.splice(0, this.promo.marketplaces.length);
      }
      this.$refs.promoDetails.showModal();
    }
  }
});

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoDetails_vue__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c10159b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoDetails_vue__ = __webpack_require__(1102);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c10159b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixims_ProductServiceMixim__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_AdminServiceMixin__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixims_PromotionsServiceMixim__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_common_vue_autocomplete__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_index_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Switch__ = __webpack_require__(68);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promo-details',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixims_ProductServiceMixim__["c" /* ProductServiceMixim */], __WEBPACK_IMPORTED_MODULE_4__mixims_ValidationsMixim__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_2__mixims_AdminServiceMixin__["b" /* OrganizationService */], __WEBPACK_IMPORTED_MODULE_3__mixims_PromotionsServiceMixim__["a" /* PromotionsServiceMixim */]],
  components: {
    autocomplete: __WEBPACK_IMPORTED_MODULE_6__components_common_vue_autocomplete__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__["default"],
    cSwitch: __WEBPACK_IMPORTED_MODULE_9__components_common_Switch__["a" /* default */]
  },
  props: ['promo'],
  data: function data() {
    return {
      lang: {
        formatLocale: {
          months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],

          monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],

          weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],

          weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vier', 'Sab'],

          weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
        }
      },
      currency: __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default.a.CURRENCY,
      locale: __WEBPACK_IMPORTED_MODULE_5__config_applicationConfig_js___default.a.LOCALE,
      isAdmin: this.$store.getters.isAdmin,
      modalTitle: '',
      okButtonText: 'Guardar',
      errorText: ''
    };
  },

  computed: {
    haveErrors: function haveErrors() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.promoStates).includes(false);
    },
    promoStates: function promoStates() {
      return {
        name: this.isValidText(this.promo.name, true, 25),
        description: this.isValidTextArea(this.promo.description, true),
        promoValue: this.isValidFloat(this.promo.promoValue, true, true),
        beginDate: this.validateDateBegin(this.promo.beginDate),
        endDate: this.validateDateEnd(this.promo.beginDate, this.promo.endDate)
      };
    },
    disableEdition: function disableEdition() {
      if (this.promo.userType === 'ADMIN' && !this.isAdmin) {
        return true;
      }
      return false;
    }
  },
  methods: {
    validateDateBegin: function validateDateBegin(dateBegin) {
      var mandatory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!dateBegin) return !mandatory;
      return true;
    },
    validateDateEnd: function validateDateEnd(dateBegin, dateEnd) {
      var mandatory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!dateEnd) return !mandatory;

      var dBegin = new Date(dateBegin);
      var dEnd = new Date(dateEnd);
      if (dEnd <= dBegin) {
        return false;
      }
      return true;
    },
    handleSave: function handleSave(evt) {
      var _this = this;

      evt.preventDefault();
      this.errorText = '';
      this.okButtonText = 'Espere...';

      if (this.promo.id) {
        this.processPromotion();
      } else {
        this.getPromotionByName(this.promo.name).then(function (response) {
          if (!_this.hasSamePromoName(response.body)) {
            _this.processPromotion();
          } else {
            document.getElementById('promoModal').scroll(0, 0);
            _this.errorText = 'Ya existe una promoci\xF3n con el mismo nombre';
            _this.okButtonText = 'Guardar';
          }
        }, function (error) {
          _this.loading = false;
          _this.errorText = error.body.message || 'Error obteniendo las promociones';
          return [];
        });
      }
    },
    processPromotion: function processPromotion() {
      var _this2 = this;

      this.savePromotion(this.promo).then(function () {
        var successText = _this2.promo.id !== null ? 'La promoción fue modificada con exito' : 'La promoción fue creada con exito';
        _this2.$emit('done', { key: 'successText', value: successText });
        _this2.$refs.promoModal.hide();
        _this2.okButtonText = 'Guardar';
      }, function () {
        var errorText = 'Ocurri\xF3 un error el ' + (_this2.promo.id ? 'actualizar' : 'crear') + ' la promoci\xF3n';
        _this2.$emit('done', { key: 'errorText', value: errorText });
        _this2.$refs.promoModal.hide();
        _this2.okButtonText = 'Guardar';
      });
    },
    hasSamePromoName: function hasSamePromoName(names) {
      var _this3 = this;

      var hasSameName = false;

      names.forEach(function (promo) {
        if (promo.name === _this3.promo.name) {
          hasSameName = true;
        }
      });

      return hasSameName;
    },
    promoTypeChange: function promoTypeChange(type) {
      if (type === 'Nominal') {
        this.promo.nominalDiscountValue = this.promo.promoValue;
        this.promo.percentualDiscountValue = 0;
      } else {
        this.promo.nominalDiscountValue = 0;
        this.promo.percentualDiscountValue = this.promo.promoValue;
      }
    },
    valuePromoChange: function valuePromoChange(value) {
      if (this.promo.promoType === 'Nominal') {
        this.promo.nominalDiscountValue = value;
        this.promo.percentualDiscountValue = 0;
      } else {
        this.promo.nominalDiscountValue = 0;
        this.promo.percentualDiscountValue = value;
      }
    },
    showModal: function showModal(item) {
      this.errorText = '';
      this.okButtonText = 'Guardar';
      if (this.promo.id) {
        this.modalTitle = 'Actualizar promoción';
      } else {
        this.modalTitle = 'Crear promoción';
      }
      this.$refs.promoModal.show();
    }
  }
});

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"promotions",attrs:{"fluid":""}},[_c('b-modal',{ref:"promoModal",attrs:{"header-bg-variant":"note","size":"lg","id":"promoModal","centered":"","title":_vm.modalTitle,"cancel-title":"Cancelar","ok-title":_vm.okButtonText,"ok-disabled":_vm.disableEdition || _vm.haveErrors},on:{"ok":_vm.handleSave}},[_c('b-form',[_c('b-card',{attrs:{"header":"Datos generales de la promoción"}},[_c('b-alert',{attrs:{"show":_vm.disableEdition,"variant":"warning"}},[_c('b',[_vm._v("Promoción gestionada por el administrador, los valores no se pueden modificar")])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":_vm.errorText !== '',"fade":"","variant":"danger","dismissible":""},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v(_vm._s(_vm.errorText))]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"nameInputGroup","label-cols":2,"breakpoint":"md","invalid-feedback":!_vm.promoStates.name? 'No es un valor válido' : '',"state":_vm.promoStates.name,"description":"Nombre de la promoción","label":"Nombre"}},[_c('b-form-input',{attrs:{"disabled":_vm.disableEdition,"state":_vm.promoStates.name},model:{value:(_vm.promo.name),callback:function ($$v) {_vm.$set(_vm.promo, "name", $$v)},expression:"promo.name"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"activeInputGroup","label-cols":2,"breakpoint":"md","label":"¿La promoción esta activa?"}},[_c('c-switch',{attrs:{"inputType":"checkbox","type":"text","variant":"success","on":"Si","off":"No","pill":true,"disabled":_vm.disableEdition,"size":"m","id":"s0"},model:{value:(_vm.promo.isActive),callback:function ($$v) {_vm.$set(_vm.promo, "isActive", $$v)},expression:"promo.isActive"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"descriptionGroup","label-cols":2,"breakpoint":"md","label":"Descripción","description":"Descripción de la promoción","invalid-feedback":!_vm.promoStates.description ? 'La descripción no es un texto válido' : '',"state":_vm.promoStates.description,"label-for":"inputDescription"}},[_c('b-form-textarea',{attrs:{"id":"inputDescription","disabled":_vm.disableEdition,"state":_vm.promoStates.description,"placeholder":"Ingrese el texto de la descripción.","rows":3,"max-rows":6},model:{value:(_vm.promo.description),callback:function ($$v) {_vm.$set(_vm.promo, "description", $$v)},expression:"promo.description"}})],1)],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"header":"Validez de la promoción"}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"dateFromGroup","breakpoint":"md","label":"Desde","invalid-feedback":!_vm.promoStates.beginDate ? 'Fecha invalida' : '',"state":_vm.promoStates.beginDate,"label-for":"fromDate"}},[_c('date-picker',{attrs:{"disabled":_vm.disableEdition,"id":"fromDate","value":_vm.promo.beginDate,"format":"YYYY-MM-DD HH:mm:ss","valueType":"YYYY-MM-DD HH:mm:ss","clearable":true,"confirm":true,"lang":_vm.lang,"type":"datetime"},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.promo.beginDate),callback:function ($$v) {_vm.$set(_vm.promo, "beginDate", $$v)},expression:"promo.beginDate"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"dateToGroup","breakpoint":"md","label":"Hasta","invalid-feedback":!_vm.promoStates.endDate ? 'Fecha invalida' : '',"state":_vm.promoStates.endDate,"label-for":"toDate"}},[_c('date-picker',{attrs:{"disabled":_vm.disableEdition  || !_vm.promoStates.beginDate,"id":"toDate","format":"YYYY-MM-DD HH:mm:ss","valueType":"YYYY-MM-DD HH:mm:ss","clearable":true,"confirm":true,"lang":_vm.lang,"type":"datetime"},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.promo.endDate),callback:function ($$v) {_vm.$set(_vm.promo, "endDate", $$v)},expression:"promo.endDate"}})],1)],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"header":"Montos y tipo de descuento de la promoción"}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-cols":4,"description":"Defina el tipo de promoción, puede ser nominal o descuento","label":"Seleccione el tipo de promoción"}},[_c('b-form-radio-group',{attrs:{"disabled":_vm.disableEdition,"options":['Nominal', 'Porcentual']},on:{"change":_vm.promoTypeChange},model:{value:(_vm.promo.promoType),callback:function ($$v) {_vm.$set(_vm.promo, "promoType", $$v)},expression:"promo.promoType"}})],1)],1),_vm._v(" "),_c('b-col',[_c('b-form-group',{attrs:{"id":"promoValueInputGroup","label-cols":2,"breakpoint":"md","invalid-feedback":!_vm.promoStates.promoValue? 'No es un valor válido' : '',"state":_vm.promoStates.promoValue,"description":_vm.promo.promoType === 'Nominal' ?  'Ingrese el valor exacto de descuento que se aplicara en la promoción' : 'Ingrese el valor porcentual de descuento que se aplicara en la promoción',"label":_vm.promo.promoType === 'Nominal' ?  'Descuento exacto que se aplicara' : 'Descuento porcentual que se aplicara'}},[_c('b-form-input',{attrs:{"disabled":_vm.disableEdition,"state":_vm.promoStates.promoValue},on:{"input":_vm.valuePromoChange},model:{value:(_vm.promo.promoValue),callback:function ($$v) {_vm.$set(_vm.promo, "promoValue", $$v)},expression:"promo.promoValue"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Valor nominal: "),_c('b',[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.promo.nominalDiscountValue))])]),_vm._v(" "),_c('p',[_vm._v("Valor descuento: "),_c('b',[_vm._v(_vm._s(_vm.promo.percentualDiscountValue)+"%")])])],1)],1)],1),_vm._v(" "),_c('b-card',{attrs:{"header":"¿A qué elementos se aplica la promoción?"}},[(_vm.promo.sellers.length === 0 && _vm.promo.userType === 'ADMIN')?_c('p',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('b',[_c('i',{staticClass:"far fa-bell mr-2"}),_vm._v("Promocion aplicada a todos los Sellers.")])])],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-form-group',{attrs:{"id":"inputBrandGroup","label-cols":2,"breakpoint":"md","label":"Marcas a la cual aplica la promocion","label-for":"inputBrand"}},[_c('autocomplete',{attrs:{"id":"inputBrand","name":"inputBrand","maxElements":100,"provider":_vm.getSearchBrands,"disabled":_vm.disableEdition},model:{value:(_vm.promo.brands),callback:function ($$v) {_vm.$set(_vm.promo, "brands", $$v)},expression:"promo.brands"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_c('b-form-group',{attrs:{"id":"inputProductGroup","label-cols":2,"breakpoint":"md","label":"Productos a la cual aplica la promocion","label-for":"inputProduct"}},[_c('autocomplete',{attrs:{"id":"inputProduct","name":"inputProduct","maxElements":100,"provider":_vm.getSearchProducts,"disabled":_vm.disableEdition},model:{value:(_vm.promo.products),callback:function ($$v) {_vm.$set(_vm.promo, "products", $$v)},expression:"promo.products"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"inputCategoriesGroup","label-cols":2,"breakpoint":"md","label":"Categorias a la cual aplica la promocion","label-for":"inputCategories"}},[_c('autocomplete',{attrs:{"id":"inputCategories","name":"inputCategories","maxElements":100,"provider":_vm.getSearchCategories,"disabled":_vm.disableEdition},model:{value:(_vm.promo.categories),callback:function ($$v) {_vm.$set(_vm.promo, "categories", $$v)},expression:"promo.categories"}})],1)],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"id":"inputSellersGroup","label-cols":2,"breakpoint":"md","label":"Sellers a los cuales aplica la promocion","label-for":"inputSellers"}},[_c('autocomplete',{attrs:{"id":"inputSellers","name":"inputSellers","maxElements":100,"provider":_vm.getSearchSeller,"disabled":_vm.disableEdition},model:{value:(_vm.promo.sellers),callback:function ($$v) {_vm.$set(_vm.promo, "sellers", $$v)},expression:"promo.sellers"}})],1)],1)],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"promotions",attrs:{"fluid":""}},[_c('h5',[_vm._v("Gestión de promociones")]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.errorText !== '',"fade":"","variant":"danger","dismissible":""},domProps:{"innerHTML":_vm._s(_vm.errorText)}},[_vm._v(_vm._s(_vm.errorText))]),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.successText !== '',"variant":"success","dismissible":""},domProps:{"innerHTML":_vm._s(_vm.successText)}},[_vm._v(_vm._s(_vm.successText))]),_vm._v(" "),_c('moon-loader',{attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-row',{staticClass:"filter-row"},[_c('b-col',{attrs:{"md-":"12"}},[_c('button',{staticClass:"btn btn-primary float-right ml-2",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.showFilters = !_vm.showFilters}}},[_c('i',{staticClass:"fa",class:{'fa-times': _vm.showFilters, 'fa-filter': !_vm.showFilters}}),_vm._v(" Filtros\n      ")]),_vm._v(" "),_c('b-col',[_c('button',{staticClass:"btn btn-primary float-right mr-3",attrs:{"disabled":_vm.loading,"type":"button"},on:{"click":_vm.showModal}},[_vm._v("\n          Crear Promocion\n        ")])])],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"filters mt-3 p-3 mb-3"},[_c('b-row',[_c('b-col',{staticClass:"col-md-auto"},[_c('b-form-group',{attrs:{"id":"dateFilterFromGroup","breakpoint":"md","label":"Filtro fecha","label-for":"filterBeginDate"}},[_c('date-picker',{ref:"filterBeginDate",attrs:{"id":"filterBeginDate","format":"YYYY-MM-DD","valueType":"YYYY-MM-DD","confirm":true,"lang":_vm.lang,"confirm-text":"Seleccione rango","clearable":true,"range":""},on:{"input":_vm.filterTable},nativeOn:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();},"keydown":function($event){$event.stopPropagation();$event.preventDefault();}},model:{value:(_vm.filter.range),callback:function ($$v) {_vm.$set(_vm.filter, "range", $$v)},expression:"filter.range"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"id":"nombre","label-cols":4,"breakpoint":"md","label":"Buscar","invalid-feedback":!_vm.isValidText(_vm.filter.text, false)? 'No es un texto válido' : '',"state":_vm.isValidText(_vm.filter.text, false),"description":"Este campo de filtro realizará la busqueda en los varios campos, como el nombre, el id, la marca etc.","label-for":"nameFormatter"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"id":"nameFormatter","placeholder":"Texto a buscar"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}}),_vm._v(" "),_c('b-input-group-button',[_c('b-btn',{attrs:{"disabled":!_vm.isValidText(_vm.filter.text, false)},on:{"click":_vm.filterTable}},[_vm._v("Buscar")])],1)],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"md-auto"},[_c('b-form-group',{attrs:{"label-cols":4,"description":"Fliltrar por el estado de las promociones","label":"Seleccione por el estado de la promocion"}},[_c('b-form-radio-group',{attrs:{"options":[
                { text: 'Activas', value: true },
                { text: 'Desactivadas', value: false },
                { text: 'Todas', value: null }
              ]},model:{value:(_vm.filter.isActive),callback:function ($$v) {_vm.$set(_vm.filter, "isActive", $$v)},expression:"filter.isActive"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"inputBrandGroup","label-cols":2,"breakpoint":"md","label":"Marcas","label-for":"inputBrand"}},[_c('autocomplete',{attrs:{"id":"inputBrand","name":"inputBrand","maxElements":100,"provider":_vm.getSearchBrands,"disabled":_vm.loading},model:{value:(_vm.filter.brands),callback:function ($$v) {_vm.$set(_vm.filter, "brands", $$v)},expression:"filter.brands"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"inputProductosGroup","label-cols":2,"breakpoint":"md","label":"Productos","label-for":"inputProducts"}},[_c('autocomplete',{attrs:{"id":"inputProducts","name":"inputProducts","maxElements":100,"provider":_vm.getSearchProducts,"disabled":_vm.loading},model:{value:(_vm.filter.products),callback:function ($$v) {_vm.$set(_vm.filter, "products", $$v)},expression:"filter.products"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"inputCategoryGroup","label-cols":2,"breakpoint":"md","label":"Categorias","label-for":"inputCategory"}},[_c('autocomplete',{attrs:{"id":"inputCategory","name":"inputCategory","maxElements":100,"provider":_vm.getSearchCategories,"disabled":_vm.loading},model:{value:(_vm.filter.categories),callback:function ($$v) {_vm.$set(_vm.filter, "categories", $$v)},expression:"filter.categories"}})],1)],1),_vm._v(" "),(_vm.isAdmin)?_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"id":"inputSellersGroup","label-cols":2,"breakpoint":"md","label":"Sellers","label-for":"inputSellers"}},[_c('autocomplete',{attrs:{"id":"inputSellers","name":"inputSellers","maxElements":100,"provider":_vm.getSearchSeller,"disabled":_vm.loading},model:{value:(_vm.filter.sellers),callback:function ($$v) {_vm.$set(_vm.filter, "sellers", $$v)},expression:"filter.sellers"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-input-group-button',{staticClass:"float-right mt-3"},[_c('b-button',{attrs:{"disabled":_vm.loading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.filterTable($event)}}},[_vm._v("Filtrar")])],1),_vm._v(" "),_c('b-input-group-button',{staticClass:"float-right mt-3 mr-3"},[_c('b-button',{attrs:{"disabled":_vm.loading,"block":true,"variant":"primary"},on:{"click":function($event){$event.stopPropagation();_vm.cleanFilters($event)}}},[_vm._v("Mostrar Todo")])],1)],1)],1)],1),_vm._v(">\n  ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto per-page"},[_c('b-form-group',{attrs:{"id":"perPage","horizontal":"","label":"Mostrar por página"}},[_c('b-form-select',{attrs:{"id":"perPage","options":_vm.pageOptions},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"col-md-auto",attrs:{"align-self":"start"}},[_vm._v("\n      "+_vm._s(_vm.totalRows > 0 ? 'Promociones encontradas:' + _vm.totalRows : 'No se encontraron promociones')+"\n    ")])],1),_vm._v(" "),_c('b-table',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],ref:"mainTable",staticClass:"mt-3",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","stacked":"md","items":_vm.itemProvider,"foot-clone":"","fields":_vm.fields,"small":"","current-page":_vm.currentPage,"per-page":_vm.perPage,"sort-by":_vm.sortBy,"sort-desc":_vm.sortDesc,"responsive":"true","empty-text":"No hay promociones para mostrar","empty-filtered-text":"No hay promociones para mostrar"},on:{"update:sortBy":function($event){_vm.sortBy=$event},"update:sortDesc":function($event){_vm.sortDesc=$event},"row-dblclicked":_vm.promoClicked,"filtered":_vm.onFiltered},scopedSlots:_vm._u([{key:"beginDate",fn:function(beginDate){return [_vm._v("\n      "+_vm._s(new Date(beginDate.value).toLocaleDateString(_vm.locale))),_c('br'),_vm._v("\n      "+_vm._s(new Date(beginDate.value).toLocaleTimeString(_vm.locale))+"\n    ")]}},{key:"endDate",fn:function(endDate){return [_vm._v("\n      "+_vm._s(new Date(endDate.value).toLocaleDateString(_vm.locale))),_c('br'),_vm._v("\n      "+_vm._s(new Date(endDate.value).toLocaleTimeString(_vm.locale))+"\n    ")]}},{key:"lastModified",fn:function(lastModified){return [_vm._v("\n      "+_vm._s(new Date(lastModified.value).toLocaleDateString(_vm.locale))),_c('br'),_vm._v("\n      "+_vm._s(new Date(lastModified.value).toLocaleTimeString(_vm.locale))+"\n    ")]}},{key:"nominalDiscountValue",fn:function(nominalDiscountValue){return [_vm._v("\n      "+_vm._s(_vm.currency)+" "+_vm._s(nominalDiscountValue.value)+"\n    ")]}},{key:"percentualDiscountValue",fn:function(nominalDiscountValue){return [_vm._v("\n      "+_vm._s(nominalDiscountValue.value)+"%\n    ")]}},{key:"isActive",fn:function(isActive){return [_vm._v("\n      "+_vm._s(isActive.value ? 'Activa' : 'No Activa')+"\n    ")]}},{key:"name",fn:function(name){return [_c('i',{staticClass:"fas fa-tag mr-2"}),_vm._v(_vm._s(name.value)+"\n    ")]}},{key:"userType",fn:function(userType){return [_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"userType",class:userType.value !== 'ADMIN' ? 'bg-primary' : 'bg-warning',attrs:{"title":userType.value === 'ADMIN' ? 'Promoción creada por un Administrador' : 'Promoción creada por un Venderor'}},[_vm._v(_vm._s(userType.value === 'ADMIN' ? 'Administrador' : 'Seller'))])]}},{key:"actions",fn:function(row){return [_c('b-button',{attrs:{"disabled":row.item.userType === 'ADMIN' && !_vm.isAdmin,"variant":"primary","size":"sm"},on:{"click":function($event){_vm.showDeleteConfirm(row.item)}}},[_vm._v("Eliminar")])]}}])}),_vm._v(" "),_c('b-modal',{ref:"confirmationdDeleteModal",attrs:{"header-bg-variant":"primary","size":"lg","id":"confirmationDeleteModal","centered":"","title":_vm.cancelation.title,"cancel-title":"Cancelar"},on:{"ok":_vm.cancelation.confirm}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.cancelation.text)}},[_vm._v(_vm._s(_vm.cancelation.text))])]),_vm._v(" "),_c('promo-details',{ref:"promoDetails",attrs:{"promo":_vm.promo},on:{"done":_vm.refreshTable}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticesView_vue__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_989e76fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticesView_vue__ = __webpack_require__(1119);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticesView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_989e76fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticesView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_notices_NoticesList_vue__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_notices_NoticeModal_vue__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notices_NoticeDeleteModal_vue__ = __webpack_require__(1115);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'noticesView',
  components: { NoticesList: __WEBPACK_IMPORTED_MODULE_0__components_notices_NoticesList_vue__["a" /* default */], NoticeModal: __WEBPACK_IMPORTED_MODULE_1__components_notices_NoticeModal_vue__["a" /* default */], NoticeDeleteModal: __WEBPACK_IMPORTED_MODULE_2__components_notices_NoticeDeleteModal_vue__["a" /* default */] },
  data: function data() {
    return {
      notice: {
        title: '',
        message: '',
        date: ''
      },
      action: 'create'
    };
  },

  methods: {
    handleShowNoticeModal: function handleShowNoticeModal(value) {
      this.notice = value.notice;
      this.action = value.action;
      this.$refs.noticeModal.show();
    },
    handleDeleteNoticeModal: function handleDeleteNoticeModal(notice) {
      this.notice = notice;
      this.$refs.noticeDeleteModal.show();
    },
    handleAlertNotice: function handleAlertNotice(value) {
      this.$refs.noticesList.showAlertNoticesList(value.text, value.variant);
    }
  }
});

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticesList_vue__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b21cb6be_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticesList_vue__ = __webpack_require__(1109);
function injectStyle (ssrContext) {
  __webpack_require__(1107)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b21cb6be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b21cb6be_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixims_NotificationServiceMixim_js__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(9);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { MoonLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_MoonLoader_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixims_NotificationServiceMixim_js__["a" /* NotificationServiceMixim */]],
  data: function data() {
    return {
      fields: [{ key: 'text', label: 'Mensaje', 'class': 'text-left', sortable: false }, { key: 'notifyDate', label: 'Fecha/Hora', 'class': 'text-left', sortable: true }, { key: 'status', label: 'Estado', 'class': 'text-left', sortable: true }, { key: 'actions', label: 'Acciones', 'class': 'text-left', sortable: false }],
      displayTableOptions: {
        sortDesc: true,
        sortBy: 'notifyDate',
        size: 10,
        from: 1
      },
      filters: {
        type: 'MESSAGE_NOTIFICATION',
        mode: 'INBOX'
      },
      totalRows: 0,
      pageOptions: [10, 15, 25, 50, 100],
      loading: false,
      showAlert: false,
      alertVariant: 'success',
      alertText: '',
      locale: __WEBPACK_IMPORTED_MODULE_1__config_applicationConfig_js___default.a.LOCALE
    };
  },

  methods: {
    handleCreateNotice: function handleCreateNotice() {
      this.showAlert = false;
      this.$emit('showNoticeModal', { notice: { mode: 'INBOX', type: 'MESSAGE_NOTIFICATION' }, action: 'create' });
    },
    openNoticeModal: function openNoticeModal(notice) {
      this.showAlert = false;
      this.$emit('showNoticeModal', { notice: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, notice), action: 'edit' });
    },
    openConfirmationModal: function openConfirmationModal(notice) {
      this.showAlert = false;
      this.$emit('showDeleteNoticeModal', notice);
    },
    handleCopyAction: function handleCopyAction(notice) {
      this.showAlert = false;
      this.$emit('showNoticeModal', { notice: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, notice), action: 'copy' });
    },
    itemProvider: function itemProvider(tableFilterInfo) {
      var _this = this;

      this.loading = true;
      return this.getNotificationsNotices(tableFilterInfo, this.filters).then(function (response) {
        _this.loading = false;
        _this.totalRows = parseInt(response.headers.get('X-Total-Count'));
        return response.body;
      }, function (error) {
        _this.loading = false;
        var errorText = error.body.message || 'Error obteniendo las notificaciones';
        _this.$emit('error', errorText);
        return [];
      });
    },
    showAlertNoticesList: function showAlertNoticesList(text, variant) {
      this.$refs.mainTable.refresh();
      this.showAlert = true;
      this.alertVariant = variant;
      this.alertText = text;
    }
  }
});

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noticesList"},[_c('b-alert',{attrs:{"show":_vm.showAlert,"variant":_vm.alertVariant,"role":"alert","dismissible":""}},[_vm._v("\n    "+_vm._s(_vm.alertText)+"\n  ")]),_vm._v(" "),_c('b-row',{staticClass:"mb-4"},[_c('b-col',{attrs:{"cols":"12"}},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.handleCreateNotice}},[_vm._v("Crear aviso")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{staticClass:"col-md-auto d-flex align-items-center"},[_c('b-pagination',{staticClass:"mb-3",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.displayTableOptions.size},model:{value:(_vm.displayTableOptions.from),callback:function ($$v) {_vm.$set(_vm.displayTableOptions, "from", $$v)},expression:"displayTableOptions.from"}})],1),_vm._v(" "),_c('b-col',{staticClass:"col-md-auto d-flex flex-row mb-3"},[_c('div',{staticClass:"d-flex align-items-center mr-2"},[_vm._v("\n        Mostrar por página\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('b-form-select',{attrs:{"options":_vm.pageOptions},model:{value:(_vm.displayTableOptions.size),callback:function ($$v) {_vm.$set(_vm.displayTableOptions, "size", $$v)},expression:"displayTableOptions.size"}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"header-bg-variant":"primary","border-variant":"primary","header":"Lista de Avisos"}},[_c('moon-loader',{staticClass:"mb-2",attrs:{"loading":_vm.loading,"color":"#000","size":"30px"}}),_vm._v(" "),_c('b-table',{ref:"mainTable",attrs:{"id":"mainTable","show-empty":"","striped":"","hover":"","sort-by":_vm.displayTableOptions.sortBy,"sort-desc":_vm.displayTableOptions.sortDesc,"per-page":_vm.displayTableOptions.size,"current-page":_vm.displayTableOptions.from,"items":_vm.itemProvider,"fields":_vm.fields,"fixed":true,"responsive":"true","stacked":"xl","empty-text":"No hay avisos para mostrar","empty-filtered-text":"No hay avisos para mostrar"},on:{"update:sortBy":function($event){_vm.$set(_vm.displayTableOptions, "sortBy", $event)},"update:sortDesc":function($event){_vm.$set(_vm.displayTableOptions, "sortDesc", $event)},"row-clicked":_vm.openNoticeModal},scopedSlots:_vm._u([{key:"text",fn:function(row){return [_c('span',[_vm._v(_vm._s(row.item.text.length > 50 ? row.item.text.substring(0,50) + '...' : row.item.text))])]}},{key:"notifyDate",fn:function(row){return [_c('span',{directives:[{name:"show",rawName:"v-show",value:(row.item.notifyDate),expression:"row.item.notifyDate"}]},[_vm._v("\n              "+_vm._s(new Date(row.item.notifyDate).toLocaleDateString(_vm.locale))+"\n              "+_vm._s(new Date(row.item.notifyDate).toLocaleTimeString(_vm.locale))+"\n            ")])]}},{key:"status",fn:function(row){return [_c('h5',[_c('b-badge',{staticClass:"badgeState",attrs:{"variant":row.item.status === 'SENT' ? 'success' : 'warning'}},[_vm._v(_vm._s(row.item.status === 'SENT' ? 'Enviado' : 'Pendiente'))])],1)]}},{key:"actions",fn:function(row){return [_c('b-button',{staticStyle:{"color":"black"},attrs:{"variant":"link"},on:{"click":function($event){$event.stopPropagation();_vm.openConfirmationModal(row.item)}}},[_c('h5',[_c('i',{staticClass:"far fa-trash-alt"})])]),_vm._v(" "),_c('b-button',{staticStyle:{"color":"black"},attrs:{"variant":"link"},on:{"click":function($event){$event.stopPropagation();_vm.handleCopyAction(row.item)}}},[_c('h5',[_c('i',{staticClass:"far fa-copy"})])])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticeModal_vue__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b21d88c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticeModal_vue__ = __webpack_require__(1114);
function injectStyle (ssrContext) {
  __webpack_require__(1111)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b21d88c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b21d88c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker_index_css__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_locale_es__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixims_ValidationsMixim__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixims_NotificationServiceMixim_js__ = __webpack_require__(64);








/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['notice', 'action'],
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixims_ValidationsMixim__["a" /* ValidationsMixim */], __WEBPACK_IMPORTED_MODULE_5__mixims_NotificationServiceMixim_js__["a" /* NotificationServiceMixim */]],
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__["default"]
  },
  data: function data() {
    return {
      maxCharacters: 500
    };
  },

  computed: {
    titleModal: function titleModal() {
      if (this.action === 'edit') {
        return 'Editar aviso';
      }
      return 'Crear aviso';
    },
    currentCharacters: function currentCharacters() {
      return this.notice.text ? this.notice.text.length : 0;
    },
    state: function state() {
      return {
        message: this.isValidTextArea(this.notice.text, true, this.maxCharacters),
        date: Boolean(this.notice.notifyDate)
      };
    },
    disableSave: function disableSave() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.state).includes(false);
    }
  },
  methods: {
    disableDateBeforeToday: function disableDateBeforeToday(date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    show: function show() {
      this.$refs.noticeModal.show();
    },
    handleOkClick: function handleOkClick() {
      var _this = this;

      if (this.action === 'edit') {
        this.editNotification(this.notice.id, this.notice).then(function (response) {
          _this.$emit('showAlertNotice', { text: 'Se modific\xF3 la notificaci\xF3n ' + _this.notice.text, variant: 'success' });
        }, function () {
          _this.$emit('showAlertNotice', { text: 'Error al modificar la notificaci\xF3n ' + _this.notice.text, variant: 'danger' });
        });
      }
      if (this.action === 'create' || this.action === 'copy') {
        this.createNotification(this.notice).then(function (response) {
          _this.$emit('showAlertNotice', { text: 'La notificaci\xF3n se cre\xF3 con \xE9xito', variant: 'success' });
        }, function () {
          _this.$emit('showAlertNotice', { text: 'Error al crear la notificaci\xF3n', variant: 'danger' });
        });
      }
    }
  }
});

/***/ }),
/* 1113 */,
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noticeModalContainer"},[_c('b-modal',{ref:"noticeModal",attrs:{"header-bg-variant":"primary","centered":"","size":"lg","title":_vm.titleModal,"o-close-on-backdrop":"true","cancel-title":"Cancelar","ok-title":"Aceptar","ok-disabled":_vm.disableSave},on:{"ok":_vm.handleOkClick}},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Mensaje","invalid-feedback":_vm.state.message ? '' : 'No es un mensaje válido',"state":_vm.state.message}},[_c('b-form-textarea',{attrs:{"placeholder":"Ingrese el mensaje","rows":"3","max-rows":"6","aria-describedby":"message-helper-text"},model:{value:(_vm.notice.text),callback:function ($$v) {_vm.$set(_vm.notice, "text", $$v)},expression:"notice.text"}}),_vm._v(" "),_c('b-form-text',{staticClass:"text-right",attrs:{"id":"message-helper-text"}},[_vm._v("Cantidad de Caracteres "+_vm._s(_vm.currentCharacters)+"/"+_vm._s(_vm.maxCharacters))])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-form-group',{attrs:{"label":"Fecha y hora de aviso","invalid-feedback":_vm.state.date ? '' : 'La fecha y hora son obligatorios',"state":_vm.state.date}},[_c('date-picker',{attrs:{"type":"datetime","placeholder":"Seleccione fecha y hora","disabled-date":_vm.disableDateBeforeToday,"value-type":'YYYY-MM-DDTHH:mm:ss',"format":'DD/MM/YYYY HH:mm:ss',"show-minute":false,"show-second":false},model:{value:(_vm.notice.notifyDate),callback:function ($$v) {_vm.$set(_vm.notice, "notifyDate", $$v)},expression:"notice.notifyDate"}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticeDeleteModal_vue__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_645029a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticeDeleteModal_vue__ = __webpack_require__(1118);
function injectStyle (ssrContext) {
  __webpack_require__(1116)
}
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-645029a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NoticeDeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_645029a0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NoticeDeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixims_NotificationServiceMixim_js__ = __webpack_require__(64);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['notice'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixims_NotificationServiceMixim_js__["a" /* NotificationServiceMixim */]],
  methods: {
    disableDateBeforeToday: function disableDateBeforeToday(date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    show: function show() {
      this.$refs.noticeDeleteModal.show();
    },
    deleteNotice: function deleteNotice() {
      var _this = this;

      this.deleteNotification(this.notice.id).then(function (response) {
        _this.$emit('showAlertNotice', { text: 'Se elimin\xF3 la notificaci\xF3n ' + _this.notice.id, variant: 'success' });
      }, function () {
        _this.$emit('showAlertNotice', { text: 'Error al eliminar la notificaci\xF3n ' + _this.notice.id, variant: 'danger' });
      });
    }
  }
});

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noticeModalContainer"},[_c('b-modal',{ref:"noticeDeleteModal",attrs:{"centered":"","headerBgVariant":"primary","id":"noticeDeleteModal","size":"lg","title":"Confirmar eliminar aviso","o-close-on-backdrop":"true","cancel-title":"Cancelar","ok-title":"Eliminar"},on:{"ok":_vm.deleteNotice}},[_vm._v("\n    ¿Confirma que desea eliminar este aviso?\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"noticesView",attrs:{"fluid":""}},[_c('notices-list',{ref:"noticesList",on:{"showNoticeModal":_vm.handleShowNoticeModal,"showDeleteNoticeModal":_vm.handleDeleteNoticeModal}}),_vm._v(" "),_c('notice-modal',{ref:"noticeModal",attrs:{"notice":_vm.notice,"action":_vm.action},on:{"showAlertNotice":_vm.handleAlertNotice}}),_vm._v(" "),_c('notice-delete-modal',{ref:"noticeDeleteModal",attrs:{"notice":_vm.notice},on:{"showAlertNotice":_vm.handleAlertNotice}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1120 */,
/* 1121 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(1123);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])()],
  state: {
    category_data: null,
    access_token: null,
    organization: null,
    brand_data: null,
    carrier_data: null,
    user_data: null,
    notification: null,
    brands: [],
    notifications: {
      actives: 0,
      items: []
    }
  },
  mutations: {
    setNotifications: function setNotifications(state, data) {
      state.notifications.items = data;
    },
    pushNotifications: function pushNotifications(state, data) {
      state.notifications.items = state.notifications.items.concat(data);
    },
    setNewNotifications: function setNewNotifications(state, data) {
      state.notifications.actives = data;
    },
    markAsReaded: function markAsReaded(state, data) {
      for (var index = 0; index < state.notifications.items.length; index++) {
        if (state.notifications.items[index].id === data) {
          state.notifications.items[index].read = true;
        }
      }
    },
    setLoginData: function setLoginData(state, data) {
      state.access_token = data.access_token;
      state.organization = data.organization;
    },
    setUserData: function setUserData(state, data) {
      state.user_data = data;
    },
    logout: function logout(state) {
      state.category_data = null;
      state.access_token = null;
      state.organization = null;
      state.brand_data = null;
      state.carrier_data = null;
      state.user_data = null;
    },
    setCategoryData: function setCategoryData(state, data) {
      state.category_data = data;
      state.category_data_plain = [];

      var createNodeList = function createNodeList(items) {
        return items.map(function (item) {
          if (item.children && item.children.length > 0) {
            state.category_data_plain.push(item.namePath);
            createNodeList(item.children);
          } else {
            state.category_data_plain.push(item.namePath);
          }
        });
      };
      createNodeList(data);
    },
    setBrandData: function setBrandData(state, data) {
      state.brand_data = data;
    },
    setCarrierData: function setCarrierData(state, data) {
      state.carrier_data = data;
    },
    setImputabilityCauses: function setImputabilityCauses(state, data) {
      var drowDownData = [];
      drowDownData.push({
        'text': 'Seleccione un motivo de cancelación',
        'value': null,
        'disabled': true
      });
      data.forEach(function (item) {
        drowDownData.push({
          'text': item.description,
          'value': item.id
        });
      });
      state.imputability_causes = drowDownData;
    },
    setNotificationData: function setNotificationData(state, data) {
      state.notification = data;
    },
    addBrand: function addBrand(state, data) {
      state.brands.push(data);
    }
  },
  actions: {
    setNotifications: function setNotifications(context, data) {
      context.commit('setNotifications', data);
    },
    pushNotifications: function pushNotifications(context, data) {
      context.commit('pushNotifications', data);
    },
    setNewNotifications: function setNewNotifications(context, data) {
      context.commit('setNewNotifications', data);
    },
    markAsReaded: function markAsReaded(context, data) {
      context.commit('markAsReaded', data);
    },
    setLoginData: function setLoginData(context, loginData) {
      context.commit('setLoginData', loginData);
    },
    setUserData: function setUserData(context, userData) {
      context.commit('setUserData', userData);
    },
    setCategoryData: function setCategoryData(context, categoryData) {
      context.commit('setCategoryData', categoryData);
    },
    setBrandData: function setBrandData(context, brandData) {
      context.commit('setBrandData', brandData);
    },
    setCarrierData: function setCarrierData(context, carrierData) {
      context.commit('setCarrierData', carrierData);
    },
    setImputabilityCauses: function setImputabilityCauses(context, imputabilityCauses) {
      context.commit('setImputabilityCauses', imputabilityCauses);
    },
    setNotificationData: function setNotificationData(context, notificationData) {
      context.commit('setNotificationData', notificationData);
    },
    logout: function logout(context) {
      context.commit('logout');
    },
    addBrand: function addBrand(context, data) {
      context.commit('addBrand', data);
    }
  },
  getters: {
    notifications: function notifications(state) {
      return state.notifications;
    },
    isLogged: function isLogged(state) {
      return sessionStorage.getItem('vue-session-key') !== null && sessionStorage.getItem('vue-session-key') !== '{}';
    },

    userWelcome: function userWelcome(state) {
      if (state.user_data) {
        return 'Bienvenido ' + state.user_data.firstName + ' ' + state.user_data.lastName;
      }
      return '';
    },

    isAdmin: function isAdmin(state) {
      if (!state.user_data) return false;
      var admin = state.user_data.roles.find(function (role) {
        return role.roleName === 'ADMIN_USER' || role.roleName === 'STANDARD_USER';
      });
      return !!admin;
    },
    isAdminSeller: function isAdminSeller(state) {
      if (!state.user_data) return false;
      var admin = state.user_data.roles.find(function (role) {
        return role.roleName === 'ORGANIZATION_ADMIN_USER';
      });
      return !!admin;
    },
    categories: function categories(state) {
      return state.category_data;
    },
    categoriesPlain: function categoriesPlain(state) {
      return state.category_data_plain;
    },
    brands: function brands(state) {
      return state.brand_data;
    },
    carriers: function carriers(state) {
      return state.carrier_data;
    },
    imputabilityCauses: function imputabilityCauses(state) {
      return state.imputability_causes;
    },
    organizations: function organizations(state) {
      var orgs = {};
      state.user_data.organizations.forEach(function (element) {
        orgs[element.accountName] = element.name;
      });
      return orgs;
    },
    signedRoles: function signedRoles(state) {
      return state.user_data.roles.map(function (r) {
        return r.roleName;
      });
    },
    notification: function notification(state) {
      return state.notification;
    },
    cacheBrands: function cacheBrands(state) {
      return state.brands;
    },
    userData: function userData(state) {
      return state.user_data;
    }
  }
});

/***/ }),
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lang_vue__ = __webpack_require__(1128);
var normalizeComponent = __webpack_require__(4)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lang_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_ar_json__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es_ar_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__es_ar_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_gr_json__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en_gr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__en_gr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_applicationConfig__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var url = document.location.href;
url = url.replace('#', '');
url = new URL(url);
var urlLocale = new URLSearchParams(url.search).get('locale');
console.log(urlLocale);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: urlLocale !== null ? urlLocale : __WEBPACK_IMPORTED_MODULE_4__config_applicationConfig___default.a.LOCALE,
  messages: {
    'es-ar': __WEBPACK_IMPORTED_MODULE_2__es_ar_json___default.a,
    'es-CO': __WEBPACK_IMPORTED_MODULE_2__es_ar_json___default.a,
    'es-mx': __WEBPACK_IMPORTED_MODULE_2__es_ar_json___default.a,
    'en-gr': __WEBPACK_IMPORTED_MODULE_3__en_gr_json___default.a
  }
}));

/***/ }),
/* 1129 */,
/* 1130 */
/***/ (function(module, exports) {

module.exports = {"Bienvenido a Seller Center":"Bienvenido a Seller Center","Ingrese sus datos para ingresar a Seller Center.":"Ingrese sus datos para ingresar a Seller Center.","Nombre":"Nombre","Ingresando a Seller Center...":"Ingresando a Seller Center...","Contraseña":"Contraseña","Ingrese el email con que fue creada su cuenta":"Ingrese el email con que fue creada su cuenta","Fecha":"Fecha","Desde":"Desde","Hasta":"Hasta","Ordenes":"Pedidos","Fecha de inicio para filtrar datos":"Fecha de inicio para el filtrado de datos","Fecha final para filtrar datos":"Fecha final para el filtrado datos","Dashboard de ordenes":"Dashboard de pedidos","espere..":"aguarde un momento","Ordenes creadas":"Pedidos creados","Estado":"Estado","Estado de ordenes":"Estado de pedidos","Error obteniendo las estadisticas":"Error obteniendo las estadisticas","Fecha seleccionada es mayor al día de hoy":"La fecha seleccionada es mayor al día de hoy","La fecha final es menor a la fecha inicial":"La fecha final es menor a la fecha inicial","Se muestran las últimas 10 ordenes dentro del rango seleccionado.":"Se muestran los últimos 10 pedidos dentro del rango seleccionado.","Listado de ordenes":"Listado de pedidos","No hay informacion sobre ordenes disponible para graficar":"No hay informacion sobre pedidos disponible para graficar","Para manejo":"Para manejo","Para envío":"Para envío","Enviada":"Enviada","Envío incompleto":"Envío incompleto","Parcialmente entregada":"Parcialmente entregada","Entregada":"Entregada","Cancelada":"Cancelada","No pagada":"No pagada","Esperando desición":"Esperando desición","{count} ordenes encontradas":"No se encontraron pedidos | Se encontro un pedido | Se encontraron {count} pedidos","error actualizando el estado de la controversia":"error actualizando el estado de la controversia","Orden {orderId} ({accountName})":"Pedido {orderId} ({accountName})","Cliente":"Cliente","Todos":"Todos","Dirección de entrega":"Dirección de entrega","Controversia":"Controversia","Buscar":"Buscar","Ingrese el texto a buscar":"Ingrese el texto a buscar","Seleccione el estado de la orden":"Seleccione el estado del pedido","Mostrar por página":"Mostrar por página","Número":"Número","Dashboard":"Dashboard","Ventas":"Ventas","Penalizaciones CSV":"Penalizaciones CSV","Liquidaciones CSV":"Liquidaciones CSV","Catálogo":"Catálogo","Administrar Productos":"Administrar Productos","Reportes":"Reportes","Administración":"Administración","Usuarios":"Usuarios","Actualizaciónes":"Actualizaciónes","Sellers":"Vendedores","Catalogo y Marcas":"Catalogo y Marcas","Atributos":"Atributos","No hay ordenes para mostrar":"No hay pedidos para mostrar","Seller":"Vendedor","Etiquetas":"Etiquetas","Filtros":"Filtros","Confirmar entrega":"Confirmar entrega","Cancelar":"Cancelar","Confirmar":"Confirmar","Entrega confirmada":"Entrega confirmada","Factura":"Factura","Productos":"Productos","{count} items":"No hay elementos | Un elemento | {count} elementos","Paquetes que seran confirmados de entrega":"Paquetes que seran confirmados de entrega","Regresar":"Volver","Enviar":"Enviar","Iniciar Manejo":"Iniciar Manejo","Entregar":"Entregar","Total de los items":"Total de los items","Datos de envío":"Datos de envío","Forma de entrega":"Forma de entrega","Tiempo Estimado":"Tiempo Estimado","días hábiles":" días hábiles","Paquete":"Paquete","Empresa de mensajería":"Empresa de mensajería","Número guía":"Número guía","URL guía":"URL guía","El estado de la orden es":"El estado del pedido es","no dispone en este estado datos de envío.":"no dispone en este estado datos de envío.","Transportadora que fue asignada en el checkout de VTEX con el cual se calculó y se cobro el envío, el Seller puede cambiar luego el courier.":"Transportadora que fue asignada en el checkout de VTEX con el cual se calculó y se cobro el envío, el Seller puede cambiar luego el courier.","Orden no pagado":"Pedido no pagado","Orden pagada":"Pedido pagado","Atender":"Atender","Eliminar":"Eliminar","Agregar Nota":"Agregar Nota","Detalles":"Detalles","Penalizacion":"Penalizacion","Liquidado":"Liquidado","DNI":"DNI","Aceptar":"Aceptar","Total":"Total","Items":"Elementos","Ordenes / Detalle":"Pedidos / Detalle","Home":"Principal","Ver Reportes":"Ver Reportes"}

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports = {"Bienvenido a Seller Center":"Welcome to Seller Center","Ingrese sus datos para ingresar a Seller Center.":"Type your credentials to enter.","Nombre":"Name","Ingresando a Seller Center...":"Loading Seller Center..","Ingrese el email con que fue creada su cuenta":"Enter the email you registered","Contraseña":"Password","Fecha":"Date","Desde":"From","Hasta":"To","Ordenes":"Orders","Fecha de inicio para filtrar datos":"Start range date to filter data","Fecha final para filtrar datos":"End range date to filtrado data","Dashboard de ordenes":"Order Dashboard","espere..":"wait..","Ordenes creadas":"Orders created","Estado":"Status","Estado de ordenes":"Orders status","Error obteniendo las estadisticas":"Error obteniendo las estadisticas","La fecha seleccionada es mayor al día de hoy":"La fecha seleccionada es mayor al día de hoy","La fecha final es menor a la fecha inicial":"La fecha final es menor a la fecha inicial","Se muestran las últimas 10 ordenes dentro del rango seleccionado.":"Se muestran los últimos 10 pedidos dentro del rango seleccionado.","Listado de ordenes":"Order list","No hay informacion sobre ordenes disponible para graficar":"No hay informacion sobre pedidos disponible para graficar","{count} ordenes encontradas":"There is no orders | We found one order | We found {count} orders","error actualizando el estado de la controversia":"error actualizando el estado de la controversia","Orden {orderId} ({accountName})":"Order {orderId} ({accountName})","Cliente":"Client","Todos":"All","Dirección de entrega":"Shipping address","Para manejo":"Ready for handling","No pagada":"Payment pending","Para envío":"Handling","Enviada":"Invoiced","Entregada":"Delivered","Cancelada":"Canceled","Controversia":"Controversy","Envío incompleto":"Incomplete Delivey","Esperando desición":"Waiting desition","Parcialmente entregada":"Parcially delivered","Buscar":"Search","Ingrese el texto a buscar":"Enter the text to search","Seleccione el estado de la orden":"Select the order status to search","Mostrar por página":"Show items per page","Número":"Number","Dashboard":"Dashboard","Ventas":"Sales","Penalizaciones CSV":"CSV Penalizations","Liquidaciones CSV":"CSV Liquidations","Catálogo":"Catalog","Administrar Productos":"Products Administration","Reportes":"Reports","Administración":"Administration","Usuarios":"Usres","Actualizaciónes":"Actualizations","Sellers":"Sellers","Catalogo y Marcas":"Catalog and Brands","Atributos":"Atributes","No hay ordenes para mostrar":"There is no orders yo show","Seller":"Seller","Etiquetas":"Tags","Filtros":"Filters","Confirmar entrega":"Confirmar entrega","Cancelar":"Cancelar","Confirmar":"Confirmar","Entrega confirmada":"Entrega confirmada","Factura":"Factura","Productos":"Productos","{count} items":"No hay elementos | Un elemento | {count} elementos","Paquetes que seran confirmados de entrega":"Paquetes que seran confirmados de entrega","Regresar":"Devolver","Enviar":"Enviar","Iniciar Manejo":"Iniciar Manejo","Entregar":"Entregar","Total de los items":"Total de los items","Datos de envío":"Datos de envío","Forma de entrega":"Forma de entrega","Tiempo Estimado":"Tiempo Estimado","días hábiles":" días hábiles","Paquete":"Paquete","Empresa de mensajería":"Empresa de mensajería","Número guía":"Número guía","URL guía":"URL guía","El estado de la orden es":"El estado del pedido es","no dispone en este estado datos de envío.":"no dispone en este estado datos de envío.","Transportadora que fue asignada en el checkout de VTEX con el cual se calculó y se cobro el envío, el Seller puede cambiar luego el courier.":"Transportadora que fue asignada en el checkout de VTEX con el cual se calculó y se cobro el envío, el Seller puede cambiar luego el courier.","Orden no pagada":"Pedido no pagado","Orden pagada":"Pedido pagado","Atender":"Atender","Eliminar":"Eliminar","Agregar Nota":"Agregar Nota","Detalles":"Detalles","Penalizacion":"Penalizacion","Liquidado":"Liquidado","DNI":"DNI","Aceptar":"Aceptar","Total":"Total","Items":"Elementos","Ordenes / Detalle":"Pedidos / Detalle","Home":"Home","Ver Reportes":"See Reports"}

/***/ })
],[371]);


// WEBPACK FOOTER //
// static/js/app.13ccad7ab812b4420deb.js